(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["uwr"] = factory();
	else
		root["uwr"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpuwr"];
/******/ 	window["webpackJsonpuwr"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		"main": 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".uwr.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 80);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v1.12.1
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-02-22T19:07Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//"use strict";
var deletedIds = [];

var document = window.document;

var slice = deletedIds.slice;

var concat = deletedIds.concat;

var push = deletedIds.push;

var indexOf = deletedIds.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	version = "1.12.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1, IE<9
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: deletedIds.sort,
	splice: deletedIds.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var src, copyIsArray, copy, name, options, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	// See test/unit/core.js for details concerning isFunction.
	// Since version 1.3, DOM methods and functions like alert
	// aren't supported. They return false on IE (#2968).
	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray || function( obj ) {
		return jQuery.type( obj ) === "array";
	},

	isWindow: function( obj ) {
		/* jshint eqeqeq: false */
		return obj != null && obj == obj.window;
	},

	isNumeric: function( obj ) {

		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		var realStringObj = obj && obj.toString();
		return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	isPlainObject: function( obj ) {
		var key;

		// Must be an Object.
		// Because of IE, we also have to check the presence of the constructor property.
		// Make sure that DOM nodes and window objects don't pass through, as well
		if ( !obj || jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		try {

			// Not own constructor property must be Object
			if ( obj.constructor &&
				!hasOwn.call( obj, "constructor" ) &&
				!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
				return false;
			}
		} catch ( e ) {

			// IE8,9 Will throw exceptions on certain host objects #9897
			return false;
		}

		// Support: IE<9
		// Handle iteration over inherited properties before own properties.
		if ( !support.ownFirst ) {
			for ( key in obj ) {
				return hasOwn.call( obj, key );
			}
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		for ( key in obj ) {}

		return key === undefined || hasOwn.call( obj, key );
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Workarounds based on findings by Jim Driscoll
	// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
	globalEval: function( data ) {
		if ( data && jQuery.trim( data ) ) {

			// We use execScript on Internet Explorer
			// We use an anonymous function so that context is window
			// rather than jQuery in Firefox
			( window.execScript || function( data ) {
				window[ "eval" ].call( window, data ); // jscs:ignore requireDotNotation
			} )( data );
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1, IE<9
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		var len;

		if ( arr ) {
			if ( indexOf ) {
				return indexOf.call( arr, elem, i );
			}

			len = arr.length;
			i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;

			for ( ; i < len; i++ ) {

				// Skip accessing in sparse arrays
				if ( i in arr && arr[ i ] === elem ) {
					return i;
				}
			}
		}

		return -1;
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		while ( j < len ) {
			first[ i++ ] = second[ j++ ];
		}

		// Support: IE<9
		// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
		if ( len !== len ) {
			while ( second[ j ] !== undefined ) {
				first[ i++ ] = second[ j++ ];
			}
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var args, proxy, tmp;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: function() {
		return +( new Date() );
	},

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

// JSHint would error on this code due to the Symbol not being defined in ES5.
// Defining this global in .jshintrc would create a danger of using the global
// unguarded in another place, it seems safer to just disable JSHint for these
// three lines.
/* jshint ignore: start */
if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = deletedIds[ Symbol.iterator ];
}
/* jshint ignore: end */

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.1
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-10-17
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, nidselect, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
					while ( i-- ) {
						groups[i] = nidselect + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( (parent = document.defaultView) && parent.top !== parent ) {
		// Support: IE 11
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( document.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				return m ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( (oldCache = uniqueCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		} );

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( jQuery.inArray( elem, qualifier ) > -1 ) !== not;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i,
			ret = [],
			self = this,
			len = self.length;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// init accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector.charAt( 0 ) === "<" &&
				selector.charAt( selector.length - 1 ) === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					if ( elem && elem.parentNode ) {

						// Handle the case where IE and Opera return items
						// by name instead of ID
						if ( elem.id !== match[ 2 ] ) {
							return rootjQuery.find( selector );
						}

						// Otherwise, we inject the element directly into the jQuery object
						this.length = 1;
						this[ 0 ] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return typeof root.ready !== "undefined" ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var i,
			targets = jQuery( target, this ),
			len = targets.length;

		return this.filter( function() {
			for ( i = 0; i < len; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

				// Always skip document fragments
				if ( cur.nodeType < 11 && ( pos ?
					pos.index( cur ) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector( cur, selectors ) ) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within
	// the matched set of elements
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// index in selector
		if ( typeof elem === "string" ) {
			return jQuery.inArray( this[ 0 ], jQuery( elem ) );
		}

		// Locate the position of the desired element
		return jQuery.inArray(

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem, this );
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	do {
		cur = cur[ dir ];
	} while ( cur && cur.nodeType !== 1 );

	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return jQuery.nodeName( elem, "iframe" ) ?
			elem.contentDocument || elem.contentWindow.document :
			jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var ret = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			ret = jQuery.filter( selector, ret );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				ret = jQuery.uniqueSort( ret );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				ret = ret.reverse();
			}
		}

		return this.pushStack( ret );
	};
} );
var rnotwhite = ( /\S+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = true;
				if ( !memory ) {
					self.disable();
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];

							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this === promise ? newDefer.promise() : this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add( function() {

					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 ||
				( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred.
			// If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );

					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.progress( updateFunc( i, progressContexts, progressValues ) )
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject );
				} else {
					--remaining;
				}
			}
		}

		// if we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
} );


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {

	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
} );

/**
 * Clean-up method for dom ready events
 */
function detach() {
	if ( document.addEventListener ) {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );

	} else {
		document.detachEvent( "onreadystatechange", completed );
		window.detachEvent( "onload", completed );
	}
}

/**
 * The ready event handler and self cleanup method
 */
function completed() {

	// readyState === "complete" is good enough for us to call the dom ready in oldIE
	if ( document.addEventListener ||
		window.event.type === "load" ||
		document.readyState === "complete" ) {

		detach();
		jQuery.ready();
	}
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE6-10
		// Older IE sometimes signals "interactive" too soon
		if ( document.readyState === "complete" ||
			( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout( jQuery.ready );

		// Standards-based browsers support DOMContentLoaded
		} else if ( document.addEventListener ) {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed );

		// If IE event model is used
		} else {

			// Ensure firing before onload, maybe late but safe also for iframes
			document.attachEvent( "onreadystatechange", completed );

			// A fallback to window.onload, that will always work
			window.attachEvent( "onload", completed );

			// If IE and not a frame
			// continually check to see if the document is ready
			var top = false;

			try {
				top = window.frameElement == null && document.documentElement;
			} catch ( e ) {}

			if ( top && top.doScroll ) {
				( function doScrollCheck() {
					if ( !jQuery.isReady ) {

						try {

							// Use the trick by Diego Perini
							// http://javascript.nwbox.com/IEContentLoaded/
							top.doScroll( "left" );
						} catch ( e ) {
							return window.setTimeout( doScrollCheck, 50 );
						}

						// detach all dom ready events
						detach();

						// and execute any waiting functions
						jQuery.ready();
					}
				} )();
			}
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Support: IE<9
// Iteration over object's inherited properties before its own
var i;
for ( i in jQuery( support ) ) {
	break;
}
support.ownFirst = i === "0";

// Note: most support tests are defined in their respective modules.
// false until the test is run
support.inlineBlockNeedsLayout = false;

// Execute ASAP in case we need to set body.style.zoom
jQuery( function() {

	// Minified: var a,b,c,d
	var val, div, body, container;

	body = document.getElementsByTagName( "body" )[ 0 ];
	if ( !body || !body.style ) {

		// Return for frameset docs that don't have a body
		return;
	}

	// Setup
	div = document.createElement( "div" );
	container = document.createElement( "div" );
	container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
	body.appendChild( container ).appendChild( div );

	if ( typeof div.style.zoom !== "undefined" ) {

		// Support: IE<8
		// Check if natively block-level elements act like inline-block
		// elements when setting their display to 'inline' and giving
		// them layout
		div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";

		support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
		if ( val ) {

			// Prevent IE 6 from affecting layout for positioned elements #11048
			// Prevent IE from shrinking the body in IE 7 mode #12869
			// Support: IE<8
			body.style.zoom = 1;
		}
	}

	body.removeChild( container );
} );


( function() {
	var div = document.createElement( "div" );

	// Support: IE<9
	support.deleteExpando = true;
	try {
		delete div.test;
	} catch ( e ) {
		support.deleteExpando = false;
	}

	// Null elements to avoid leaks in IE.
	div = null;
} )();
var acceptData = function( elem ) {
	var noData = jQuery.noData[ ( elem.nodeName + " " ).toLowerCase() ],
		nodeType = +elem.nodeType || 1;

	// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
	return nodeType !== 1 && nodeType !== 9 ?
		false :

		// Nodes accept data unless otherwise specified; rejection can be conditional
		!noData || noData !== true && elem.getAttribute( "classid" ) === noData;
};




var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /([A-Z])/g;

function dataAttr( elem, key, data ) {

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {

		var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();

		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :

					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			jQuery.data( elem, key, data );

		} else {
			data = undefined;
		}
	}

	return data;
}

// checks a cache object for emptiness
function isEmptyDataObject( obj ) {
	var name;
	for ( name in obj ) {

		// if the public data object is empty, the private is still empty
		if ( name === "data" && jQuery.isEmptyObject( obj[ name ] ) ) {
			continue;
		}
		if ( name !== "toJSON" ) {
			return false;
		}
	}

	return true;
}

function internalData( elem, name, data, pvt /* Internal Use Only */ ) {
	if ( !acceptData( elem ) ) {
		return;
	}

	var ret, thisCache,
		internalKey = jQuery.expando,

		// We have to handle DOM nodes and JS objects differently because IE6-7
		// can't GC object references properly across the DOM-JS boundary
		isNode = elem.nodeType,

		// Only DOM nodes need the global jQuery cache; JS object data is
		// attached directly to the object so GC can occur automatically
		cache = isNode ? jQuery.cache : elem,

		// Only defining an ID for JS objects if its cache already exists allows
		// the code to shortcut on the same path as a DOM node with no cache
		id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;

	// Avoid doing any more work than we need to when trying to get data on an
	// object that has no data at all
	if ( ( !id || !cache[ id ] || ( !pvt && !cache[ id ].data ) ) &&
		data === undefined && typeof name === "string" ) {
		return;
	}

	if ( !id ) {

		// Only DOM nodes need a new unique ID for each element since their data
		// ends up in the global cache
		if ( isNode ) {
			id = elem[ internalKey ] = deletedIds.pop() || jQuery.guid++;
		} else {
			id = internalKey;
		}
	}

	if ( !cache[ id ] ) {

		// Avoid exposing jQuery metadata on plain JS objects when the object
		// is serialized using JSON.stringify
		cache[ id ] = isNode ? {} : { toJSON: jQuery.noop };
	}

	// An object can be passed to jQuery.data instead of a key/value pair; this gets
	// shallow copied over onto the existing cache
	if ( typeof name === "object" || typeof name === "function" ) {
		if ( pvt ) {
			cache[ id ] = jQuery.extend( cache[ id ], name );
		} else {
			cache[ id ].data = jQuery.extend( cache[ id ].data, name );
		}
	}

	thisCache = cache[ id ];

	// jQuery data() is stored in a separate object inside the object's internal data
	// cache in order to avoid key collisions between internal data and user-defined
	// data.
	if ( !pvt ) {
		if ( !thisCache.data ) {
			thisCache.data = {};
		}

		thisCache = thisCache.data;
	}

	if ( data !== undefined ) {
		thisCache[ jQuery.camelCase( name ) ] = data;
	}

	// Check for both converted-to-camel and non-converted data property names
	// If a data property was specified
	if ( typeof name === "string" ) {

		// First Try to find as-is property data
		ret = thisCache[ name ];

		// Test for null|undefined property data
		if ( ret == null ) {

			// Try to find the camelCased property
			ret = thisCache[ jQuery.camelCase( name ) ];
		}
	} else {
		ret = thisCache;
	}

	return ret;
}

function internalRemoveData( elem, name, pvt ) {
	if ( !acceptData( elem ) ) {
		return;
	}

	var thisCache, i,
		isNode = elem.nodeType,

		// See jQuery.data for more information
		cache = isNode ? jQuery.cache : elem,
		id = isNode ? elem[ jQuery.expando ] : jQuery.expando;

	// If there is already no cache entry for this object, there is no
	// purpose in continuing
	if ( !cache[ id ] ) {
		return;
	}

	if ( name ) {

		thisCache = pvt ? cache[ id ] : cache[ id ].data;

		if ( thisCache ) {

			// Support array or space separated string names for data keys
			if ( !jQuery.isArray( name ) ) {

				// try the string as a key before any manipulation
				if ( name in thisCache ) {
					name = [ name ];
				} else {

					// split the camel cased version by spaces unless a key with the spaces exists
					name = jQuery.camelCase( name );
					if ( name in thisCache ) {
						name = [ name ];
					} else {
						name = name.split( " " );
					}
				}
			} else {

				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = name.concat( jQuery.map( name, jQuery.camelCase ) );
			}

			i = name.length;
			while ( i-- ) {
				delete thisCache[ name[ i ] ];
			}

			// If there is no data left in the cache, we want to continue
			// and let the cache object itself get destroyed
			if ( pvt ? !isEmptyDataObject( thisCache ) : !jQuery.isEmptyObject( thisCache ) ) {
				return;
			}
		}
	}

	// See jQuery.data for more information
	if ( !pvt ) {
		delete cache[ id ].data;

		// Don't destroy the parent cache unless the internal data object
		// had been the only thing left in it
		if ( !isEmptyDataObject( cache[ id ] ) ) {
			return;
		}
	}

	// Destroy the cache
	if ( isNode ) {
		jQuery.cleanData( [ elem ], true );

	// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
	/* jshint eqeqeq: false */
	} else if ( support.deleteExpando || cache != cache.window ) {
		/* jshint eqeqeq: true */
		delete cache[ id ];

	// When all else fails, undefined
	} else {
		cache[ id ] = undefined;
	}
}

jQuery.extend( {
	cache: {},

	// The following elements (space-suffixed to avoid Object.prototype collisions)
	// throw uncatchable exceptions if you attempt to set expando properties
	noData: {
		"applet ": true,
		"embed ": true,

		// ...but Flash objects (which have this classid) *can* handle expandos
		"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
	},

	hasData: function( elem ) {
		elem = elem.nodeType ? jQuery.cache[ elem[ jQuery.expando ] ] : elem[ jQuery.expando ];
		return !!elem && !isEmptyDataObject( elem );
	},

	data: function( elem, name, data ) {
		return internalData( elem, name, data );
	},

	removeData: function( elem, name ) {
		return internalRemoveData( elem, name );
	},

	// For internal use only.
	_data: function( elem, name, data ) {
		return internalData( elem, name, data, true );
	},

	_removeData: function( elem, name ) {
		return internalRemoveData( elem, name, true );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Special expections of .data basically thwart jQuery.access,
		// so implement the relevant behavior ourselves

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = jQuery.data( elem );

				if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					jQuery._data( elem, "parsedAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				jQuery.data( this, key );
			} );
		}

		return arguments.length > 1 ?

			// Sets one value
			this.each( function() {
				jQuery.data( this, key, value );
			} ) :

			// Gets one value
			// Try to fetch any internally stored data first
			elem ? dataAttr( elem, key, jQuery.data( elem, key ) ) : undefined;
	},

	removeData: function( key ) {
		return this.each( function() {
			jQuery.removeData( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = jQuery._data( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = jQuery._data( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// not intended for public consumption - generates a queueHooks object,
	// or returns the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return jQuery._data( elem, key ) || jQuery._data( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				jQuery._removeData( elem, type + "queue" );
				jQuery._removeData( elem, key );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = jQuery._data( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );


( function() {
	var shrinkWrapBlocksVal;

	support.shrinkWrapBlocks = function() {
		if ( shrinkWrapBlocksVal != null ) {
			return shrinkWrapBlocksVal;
		}

		// Will be changed later if needed.
		shrinkWrapBlocksVal = false;

		// Minified: var b,c,d
		var div, body, container;

		body = document.getElementsByTagName( "body" )[ 0 ];
		if ( !body || !body.style ) {

			// Test fired too early or in an unsupported environment, exit.
			return;
		}

		// Setup
		div = document.createElement( "div" );
		container = document.createElement( "div" );
		container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
		body.appendChild( container ).appendChild( div );

		// Support: IE6
		// Check if elements with layout shrink-wrap their children
		if ( typeof div.style.zoom !== "undefined" ) {

			// Reset CSS: box-sizing; display; margin; border
			div.style.cssText =

				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
				"box-sizing:content-box;display:block;margin:0;border:0;" +
				"padding:1px;width:1px;zoom:1";
			div.appendChild( document.createElement( "div" ) ).style.width = "5px";
			shrinkWrapBlocksVal = div.offsetWidth !== 3;
		}

		body.removeChild( container );

		return shrinkWrapBlocksVal;
	};

} )();
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {

		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" ||
			!jQuery.contains( elem.ownerDocument, elem );
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() { return tween.cur(); } :
			function() { return jQuery.css( elem, prop, "" ); },
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		length = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < length; i++ ) {
				fn(
					elems[ i ],
					key,
					raw ? value : value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			length ? fn( elems[ 0 ], key ) : emptyGet;
};
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([\w:-]+)/ );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );

var rleadingWhitespace = ( /^\s+/ );

var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|" +
		"details|dialog|figcaption|figure|footer|header|hgroup|main|" +
		"mark|meter|nav|output|picture|progress|section|summary|template|time|video";



function createSafeFragment( document ) {
	var list = nodeNames.split( "|" ),
		safeFrag = document.createDocumentFragment();

	if ( safeFrag.createElement ) {
		while ( list.length ) {
			safeFrag.createElement(
				list.pop()
			);
		}
	}
	return safeFrag;
}


( function() {
	var div = document.createElement( "div" ),
		fragment = document.createDocumentFragment(),
		input = document.createElement( "input" );

	// Setup
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";

	// IE strips leading whitespace when .innerHTML is used
	support.leadingWhitespace = div.firstChild.nodeType === 3;

	// Make sure that tbody elements aren't automatically inserted
	// IE will insert them into empty tables
	support.tbody = !div.getElementsByTagName( "tbody" ).length;

	// Make sure that link elements get serialized correctly by innerHTML
	// This requires a wrapper element in IE
	support.htmlSerialize = !!div.getElementsByTagName( "link" ).length;

	// Makes sure cloning an html5 element does not cause problems
	// Where outerHTML is undefined, this still works
	support.html5Clone =
		document.createElement( "nav" ).cloneNode( true ).outerHTML !== "<:nav></:nav>";

	// Check if a disconnected checkbox will retain its checked
	// value of true after appended to the DOM (IE6/7)
	input.type = "checkbox";
	input.checked = true;
	fragment.appendChild( input );
	support.appendChecked = input.checked;

	// Make sure textarea (and checkbox) defaultValue is properly cloned
	// Support: IE6-IE11+
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// #11217 - WebKit loses check when the name is after the checked attribute
	fragment.appendChild( div );

	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input = document.createElement( "input" );
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
	// old WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<9
	// Cloned elements keep attachEvent handlers, we use addEventListener on IE9+
	support.noCloneEvent = !!div.addEventListener;

	// Support: IE<9
	// Since attributes and properties are the same in IE,
	// cleanData must set properties to undefined rather than use removeAttribute
	div[ jQuery.expando ] = 1;
	support.attributes = !div.getAttribute( jQuery.expando );
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {
	option: [ 1, "<select multiple='multiple'>", "</select>" ],
	legend: [ 1, "<fieldset>", "</fieldset>" ],
	area: [ 1, "<map>", "</map>" ],

	// Support: IE8
	param: [ 1, "<object>", "</object>" ],
	thead: [ 1, "<table>", "</table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
	// unless wrapped in a div with non-breaking characters in front of it.
	_default: support.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>" ]
};

// Support: IE8-IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {
	var elems, elem,
		i = 0,
		found = typeof context.getElementsByTagName !== "undefined" ?
			context.getElementsByTagName( tag || "*" ) :
			typeof context.querySelectorAll !== "undefined" ?
				context.querySelectorAll( tag || "*" ) :
				undefined;

	if ( !found ) {
		for ( found = [], elems = context.childNodes || context;
			( elem = elems[ i ] ) != null;
			i++
		) {
			if ( !tag || jQuery.nodeName( elem, tag ) ) {
				found.push( elem );
			} else {
				jQuery.merge( found, getAll( elem, tag ) );
			}
		}
	}

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], found ) :
		found;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var elem,
		i = 0;
	for ( ; ( elem = elems[ i ] ) != null; i++ ) {
		jQuery._data(
			elem,
			"globalEval",
			!refElements || jQuery._data( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/,
	rtbody = /<tbody/i;

function fixDefaultChecked( elem ) {
	if ( rcheckableType.test( elem.type ) ) {
		elem.defaultChecked = elem.checked;
	}
}

function buildFragment( elems, context, scripts, selection, ignored ) {
	var j, elem, contains,
		tmp, tag, tbody, wrap,
		l = elems.length,

		// Ensure a safe fragment
		safe = createSafeFragment( context ),

		nodes = [],
		i = 0;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || safe.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;

				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Manually add leading whitespace removed by IE
				if ( !support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
					nodes.push( context.createTextNode( rleadingWhitespace.exec( elem )[ 0 ] ) );
				}

				// Remove IE's autoinserted <tbody> from table fragments
				if ( !support.tbody ) {

					// String was a <table>, *may* have spurious <tbody>
					elem = tag === "table" && !rtbody.test( elem ) ?
						tmp.firstChild :

						// String was a bare <thead> or <tfoot>
						wrap[ 1 ] === "<table>" && !rtbody.test( elem ) ?
							tmp :
							0;

					j = elem && elem.childNodes.length;
					while ( j-- ) {
						if ( jQuery.nodeName( ( tbody = elem.childNodes[ j ] ), "tbody" ) &&
							!tbody.childNodes.length ) {

							elem.removeChild( tbody );
						}
					}
				}

				jQuery.merge( nodes, tmp.childNodes );

				// Fix #12392 for WebKit and IE > 9
				tmp.textContent = "";

				// Fix #12392 for oldIE
				while ( tmp.firstChild ) {
					tmp.removeChild( tmp.firstChild );
				}

				// Remember the top-level container for proper cleanup
				tmp = safe.lastChild;
			}
		}
	}

	// Fix #11356: Clear elements from fragment
	if ( tmp ) {
		safe.removeChild( tmp );
	}

	// Reset defaultChecked for any radios and checkboxes
	// about to be appended to the DOM in IE 6/7 (#8060)
	if ( !support.appendChecked ) {
		jQuery.grep( getAll( nodes, "input" ), fixDefaultChecked );
	}

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}

			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( safe.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	tmp = null;

	return safe;
}


( function() {
	var i, eventName,
		div = document.createElement( "div" );

	// Support: IE<9 (lack submit/change bubble), Firefox (lack focus(in | out) events)
	for ( i in { submit: true, change: true, focusin: true } ) {
		eventName = "on" + i;

		if ( !( support[ i ] = eventName in window ) ) {

			// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
			div.setAttribute( eventName, "t" );
			support[ i ] = div.attributes[ eventName ].expando === false;
		}
	}

	// Null elements to avoid leaks in IE.
	div = null;
} )();


var rformElems = /^(?:input|select|textarea)$/i,
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE9
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {
		var tmp, events, t, handleObjIn,
			special, eventHandle, handleObj,
			handlers, type, namespaces, origType,
			elemData = jQuery._data( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" &&
					( !e || jQuery.event.triggered !== e.type ) ?
					jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
					undefined;
			};

			// Add elem as a property of the handle fn to prevent a memory leak
			// with IE non-native events
			eventHandle.elem = elem;
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener/attachEvent if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					// Bind the global event handler to the element
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );

					} else if ( elem.attachEvent ) {
						elem.attachEvent( "on" + type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

		// Nullify elem to prevent memory leaks in IE
		elem = null;
	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {
		var j, handleObj, tmp,
			origCount, t, events,
			special, handlers, type,
			namespaces, origType,
			elemData = jQuery.hasData( elem ) && jQuery._data( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			delete elemData.handle;

			// removeData also checks for emptiness and clears the expando if empty
			// so use it instead of delete
			jQuery._removeData( elem, "events" );
		}
	},

	trigger: function( event, data, elem, onlyHandlers ) {
		var handle, ontype, cur,
			bubbleType, special, tmp, i,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] &&
				jQuery._data( cur, "handle" );

			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if (
				( !special._default ||
				 special._default.apply( eventPath.pop(), data ) === false
				) && acceptData( elem )
			) {

				// Call a native DOM method on the target with the same name name as the event.
				// Can't use an .isFunction() check here because IE6/7 fails that test.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && elem[ type ] && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					try {
						elem[ type ]();
					} catch ( e ) {

						// IE<9 dies on focus/blur to hidden element (#1486,#12518)
						// only reproducible on winXP IE8 native, not IE9 in IE8 mode
					}
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( jQuery._data( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Support (at least): Chrome, IE9
		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		//
		// Support: Firefox<=42+
		// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
		if ( delegateCount && cur.nodeType &&
			( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {

			/* jshint eqeqeq: false */
			for ( ; cur != this; cur = cur.parentNode || this ) {
				/* jshint eqeqeq: true */

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push( { elem: cur, handlers: matches } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: IE<9
		// Fix target property (#1925)
		if ( !event.target ) {
			event.target = originalEvent.srcElement || document;
		}

		// Support: Safari 6-8+
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		// Support: IE<9
		// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
		event.metaKey = !!event.metaKey;

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
		"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split( " " ),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: ( "button buttons clientX clientY fromElement offsetX offsetY " +
			"pageX pageY screenX screenY toElement" ).split( " " ),
		filter: function( event, original ) {
			var body, eventDoc, doc,
				button = original.button,
				fromElement = original.fromElement;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX +
					( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
					( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY +
					( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
					( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add relatedTarget, if necessary
			if ( !event.relatedTarget && fromElement ) {
				event.relatedTarget = fromElement === event.target ?
					original.toElement :
					fromElement;
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					try {
						this.focus();
						return false;
					} catch ( e ) {

						// Support: IE<9
						// If we error on focus to hidden element (#1486, #12518),
						// let .trigger() run the handlers
					}
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( jQuery.nodeName( this, "input" ) && this.type === "checkbox" && this.click ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	},

	// Piggyback on a donor event to simulate a different one
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true

				// Previously, `originalEvent: {}` was set here, so stopPropagation call
				// would not be triggered on donor event, since in our own
				// jQuery.event.stopPropagation function we had a check for existence of
				// originalEvent.stopPropagation method, so, consequently it would be a noop.
				//
				// Guard for simulated events was moved to jQuery.event.stopPropagation function
				// since `originalEvent` should point to the original event for the
				// constancy with other events and for more focused logic
			}
		);

		jQuery.event.trigger( e, null, elem );

		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

jQuery.removeEvent = document.removeEventListener ?
	function( elem, type, handle ) {

		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	} :
	function( elem, type, handle ) {
		var name = "on" + type;

		if ( elem.detachEvent ) {

			// #8545, #7054, preventing memory leaks for custom events in IE6-8
			// detachEvent needed property on element, by name of that event,
			// to properly expose it to GC
			if ( typeof elem[ name ] === "undefined" ) {
				elem[ name ] = null;
			}

			elem.detachEvent( name, handle );
		}
	};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: IE < 9, Android < 4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;
		if ( !e ) {
			return;
		}

		// If preventDefault exists, run it on the original event
		if ( e.preventDefault ) {
			e.preventDefault();

		// Support: IE
		// Otherwise set the returnValue property of the original event to false
		} else {
			e.returnValue = false;
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( !e || this.isSimulated ) {
			return;
		}

		// If stopPropagation exists, run it on the original event
		if ( e.stopPropagation ) {
			e.stopPropagation();
		}

		// Support: IE
		// Set the cancelBubble property of the original event to true
		e.cancelBubble = true;
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && e.stopImmediatePropagation ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://code.google.com/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

// IE submit delegation
if ( !support.submit ) {

	jQuery.event.special.submit = {
		setup: function() {

			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Lazy-add a submit handler when a descendant form may potentially be submitted
			jQuery.event.add( this, "click._submit keypress._submit", function( e ) {

				// Node name check avoids a VML-related crash in IE (#9807)
				var elem = e.target,
					form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ?

						// Support: IE <=8
						// We use jQuery.prop instead of elem.form
						// to allow fixing the IE8 delegated submit issue (gh-2332)
						// by 3rd party polyfills/workarounds.
						jQuery.prop( elem, "form" ) :
						undefined;

				if ( form && !jQuery._data( form, "submit" ) ) {
					jQuery.event.add( form, "submit._submit", function( event ) {
						event._submitBubble = true;
					} );
					jQuery._data( form, "submit", true );
				}
			} );

			// return undefined since we don't need an event listener
		},

		postDispatch: function( event ) {

			// If form was submitted by the user, bubble the event up the tree
			if ( event._submitBubble ) {
				delete event._submitBubble;
				if ( this.parentNode && !event.isTrigger ) {
					jQuery.event.simulate( "submit", this.parentNode, event );
				}
			}
		},

		teardown: function() {

			// Only need this for delegated form submit events
			if ( jQuery.nodeName( this, "form" ) ) {
				return false;
			}

			// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
			jQuery.event.remove( this, "._submit" );
		}
	};
}

// IE change delegation and checkbox/radio fix
if ( !support.change ) {

	jQuery.event.special.change = {

		setup: function() {

			if ( rformElems.test( this.nodeName ) ) {

				// IE doesn't fire change on a check/radio until blur; trigger it on click
				// after a propertychange. Eat the blur-change in special.change.handle.
				// This still fires onchange a second time for check/radio after blur.
				if ( this.type === "checkbox" || this.type === "radio" ) {
					jQuery.event.add( this, "propertychange._change", function( event ) {
						if ( event.originalEvent.propertyName === "checked" ) {
							this._justChanged = true;
						}
					} );
					jQuery.event.add( this, "click._change", function( event ) {
						if ( this._justChanged && !event.isTrigger ) {
							this._justChanged = false;
						}

						// Allow triggered, simulated change events (#11500)
						jQuery.event.simulate( "change", this, event );
					} );
				}
				return false;
			}

			// Delegated event; lazy-add a change handler on descendant inputs
			jQuery.event.add( this, "beforeactivate._change", function( e ) {
				var elem = e.target;

				if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "change" ) ) {
					jQuery.event.add( elem, "change._change", function( event ) {
						if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
							jQuery.event.simulate( "change", this.parentNode, event );
						}
					} );
					jQuery._data( elem, "change", true );
				}
			} );
		},

		handle: function( event ) {
			var elem = event.target;

			// Swallow native change events from checkbox/radio, we already triggered them above
			if ( this !== elem || event.isSimulated || event.isTrigger ||
				( elem.type !== "radio" && elem.type !== "checkbox" ) ) {

				return event.handleObj.handler.apply( this, arguments );
			}
		},

		teardown: function() {
			jQuery.event.remove( this, "._change" );

			return !rformElems.test( this.nodeName );
		}
	};
}

// Support: Firefox
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome, Safari
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = jQuery._data( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				jQuery._data( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = jQuery._data( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					jQuery._removeData( doc, fix );
				} else {
					jQuery._data( doc, fix, attaches );
				}
			}
		};
	} );
}

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	},

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
	rnoshimcache = new RegExp( "<(?:" + nodeNames + ")[\\s/>]", "i" ),
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,

	// Support: IE 10-11, Edge 10240+
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
	safeFragment = createSafeFragment( document ),
	fragmentDiv = safeFragment.appendChild( document.createElement( "div" ) );

// Support: IE<8
// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName( "tbody" )[ 0 ] ||
			elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( jQuery.find.attr( elem, "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );
	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}
	return elem;
}

function cloneCopyEvent( src, dest ) {
	if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
		return;
	}

	var type, i, l,
		oldData = jQuery._data( src ),
		curData = jQuery._data( dest, oldData ),
		events = oldData.events;

	if ( events ) {
		delete curData.handle;
		curData.events = {};

		for ( type in events ) {
			for ( i = 0, l = events[ type ].length; i < l; i++ ) {
				jQuery.event.add( dest, type, events[ type ][ i ] );
			}
		}
	}

	// make the cloned public data object a copy from the original
	if ( curData.data ) {
		curData.data = jQuery.extend( {}, curData.data );
	}
}

function fixCloneNodeIssues( src, dest ) {
	var nodeName, e, data;

	// We do not need to do anything for non-Elements
	if ( dest.nodeType !== 1 ) {
		return;
	}

	nodeName = dest.nodeName.toLowerCase();

	// IE6-8 copies events bound via attachEvent when using cloneNode.
	if ( !support.noCloneEvent && dest[ jQuery.expando ] ) {
		data = jQuery._data( dest );

		for ( e in data.events ) {
			jQuery.removeEvent( dest, e, data.handle );
		}

		// Event data gets referenced instead of copied if the expando gets copied too
		dest.removeAttribute( jQuery.expando );
	}

	// IE blanks contents when cloning scripts, and tries to evaluate newly-set text
	if ( nodeName === "script" && dest.text !== src.text ) {
		disableScript( dest ).text = src.text;
		restoreScript( dest );

	// IE6-10 improperly clones children of object elements using classid.
	// IE10 throws NoModificationAllowedError if parent is null, #12132.
	} else if ( nodeName === "object" ) {
		if ( dest.parentNode ) {
			dest.outerHTML = src.outerHTML;
		}

		// This path appears unavoidable for IE9. When cloning an object
		// element in IE9, the outerHTML strategy above is not sufficient.
		// If the src has innerHTML and the destination does not,
		// copy the src.innerHTML into the dest.innerHTML. #10324
		if ( support.html5Clone && ( src.innerHTML && !jQuery.trim( dest.innerHTML ) ) ) {
			dest.innerHTML = src.innerHTML;
		}

	} else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {

		// IE6-8 fails to persist the checked state of a cloned checkbox
		// or radio button. Worse, IE6-7 fail to give the cloned element
		// a checked appearance if the defaultChecked value isn't also set

		dest.defaultChecked = dest.checked = src.checked;

		// IE6-7 get confused and end up setting the value of a cloned
		// checkbox/radio button to an empty string instead of "on"
		if ( dest.value !== src.value ) {
			dest.value = src.value;
		}

	// IE6-8 fails to return the selected option to the default selected
	// state when cloning options
	} else if ( nodeName === "option" ) {
		dest.defaultSelected = dest.selected = src.defaultSelected;

	// IE6-8 fails to set the defaultValue to the correct value when
	// cloning other types of input fields
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var first, node, hasScripts,
		scripts, doc, fragment,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android<4.1, PhantomJS<2
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!jQuery._data( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							jQuery.globalEval(
								( node.text || node.textContent || node.innerHTML || "" )
									.replace( rcleanScript, "" )
							);
						}
					}
				}
			}

			// Fix #11809: Avoid leaking memory
			fragment = first = null;
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		elems = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = elems[ i ] ) != null; i++ ) {

		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var destElements, node, clone, i, srcElements,
			inPage = jQuery.contains( elem.ownerDocument, elem );

		if ( support.html5Clone || jQuery.isXMLDoc( elem ) ||
			!rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {

			clone = elem.cloneNode( true );

		// IE<=8 does not properly clone detached, unknown element nodes
		} else {
			fragmentDiv.innerHTML = elem.outerHTML;
			fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
		}

		if ( ( !support.noCloneEvent || !support.noCloneChecked ) &&
				( elem.nodeType === 1 || elem.nodeType === 11 ) && !jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			// Fix all IE cloning issues
			for ( i = 0; ( node = srcElements[ i ] ) != null; ++i ) {

				// Ensure that the destination node is not null; Fixes #9587
				if ( destElements[ i ] ) {
					fixCloneNodeIssues( node, destElements[ i ] );
				}
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0; ( node = srcElements[ i ] ) != null; i++ ) {
					cloneCopyEvent( node, destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		destElements = srcElements = node = null;

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems, /* internal */ forceAcceptData ) {
		var elem, type, id, data,
			i = 0,
			internalKey = jQuery.expando,
			cache = jQuery.cache,
			attributes = support.attributes,
			special = jQuery.event.special;

		for ( ; ( elem = elems[ i ] ) != null; i++ ) {
			if ( forceAcceptData || acceptData( elem ) ) {

				id = elem[ internalKey ];
				data = id && cache[ id ];

				if ( data ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Remove cache only if it was not already removed by jQuery.event.remove
					if ( cache[ id ] ) {

						delete cache[ id ];

						// Support: IE<9
						// IE does not allow us to delete expando properties from nodes
						// IE creates expando attributes along with the property
						// IE does not have a removeAttribute function on Document nodes
						if ( !attributes && typeof elem.removeAttribute !== "undefined" ) {
							elem.removeAttribute( internalKey );

						// Webkit & Blink performance suffers when deleting properties
						// from DOM nodes, so set to undefined instead
						// https://code.google.com/p/chromium/issues/detail?id=378607
						} else {
							elem[ internalKey ] = undefined;
						}

						deletedIds.push( id );
					}
				}
			}
		}
	}
} );

jQuery.fn.extend( {

	// Keep domManip exposed until 3.0 (gh-2225)
	domManip: domManip,

	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().append(
					( this[ 0 ] && this[ 0 ].ownerDocument || document ).createTextNode( value )
				);
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {

			// Remove element nodes and prevent memory leaks
			if ( elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem, false ) );
			}

			// Remove any remaining nodes
			while ( elem.firstChild ) {
				elem.removeChild( elem.firstChild );
			}

			// If this is a select, ensure that it displays empty (#12336)
			// Support: IE<9
			if ( elem.options && jQuery.nodeName( elem, "select" ) ) {
				elem.options.length = 0;
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined ) {
				return elem.nodeType === 1 ?
					elem.innerHTML.replace( rinlinejQuery, "" ) :
					undefined;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				( support.htmlSerialize || !rnoshimcache.test( value )  ) &&
				( support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {

						// Remove element nodes and prevent memory leaks
						elem = this[ i ] || {};
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			i = 0,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );


var iframe,
	elemdisplay = {

		// Support: Firefox
		// We have to pre-define these values for FF (#10227)
		HTML: "block",
		BODY: "block"
	};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */

// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		display = jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
				.appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = ( iframe[ 0 ].contentWindow || iframe[ 0 ].contentDocument ).document;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var documentElement = document.documentElement;



( function() {
	var pixelPositionVal, pixelMarginRightVal, boxSizingReliableVal,
		reliableHiddenOffsetsVal, reliableMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	div.style.cssText = "float:left;opacity:.5";

	// Support: IE<9
	// Make sure that element opacity exists (as opposed to filter)
	support.opacity = div.style.opacity === "0.5";

	// Verify style float existence
	// (IE uses styleFloat instead of cssFloat)
	support.cssFloat = !!div.style.cssFloat;

	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container = document.createElement( "div" );
	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	div.innerHTML = "";
	container.appendChild( div );

	// Support: Firefox<29, Android 2.3
	// Vendor-prefix box-sizing
	support.boxSizing = div.style.boxSizing === "" || div.style.MozBoxSizing === "" ||
		div.style.WebkitBoxSizing === "";

	jQuery.extend( support, {
		reliableHiddenOffsets: function() {
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return reliableHiddenOffsetsVal;
		},

		boxSizingReliable: function() {

			// We're checking for pixelPositionVal here instead of boxSizingReliableVal
			// since that compresses better and they're computed together anyway.
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return boxSizingReliableVal;
		},

		pixelMarginRight: function() {

			// Support: Android 4.0-4.3
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return pixelMarginRightVal;
		},

		pixelPosition: function() {
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return pixelPositionVal;
		},

		reliableMarginRight: function() {

			// Support: Android 2.3
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return reliableMarginRightVal;
		},

		reliableMarginLeft: function() {

			// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
			if ( pixelPositionVal == null ) {
				computeStyleTests();
			}
			return reliableMarginLeftVal;
		}
	} );

	function computeStyleTests() {
		var contents, divStyle,
			documentElement = document.documentElement;

		// Setup
		documentElement.appendChild( container );

		div.style.cssText =

			// Support: Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";

		// Support: IE<9
		// Assume reasonable values in the absence of getComputedStyle
		pixelPositionVal = boxSizingReliableVal = reliableMarginLeftVal = false;
		pixelMarginRightVal = reliableMarginRightVal = true;

		// Check for getComputedStyle so that this code is not run in IE<9.
		if ( window.getComputedStyle ) {
			divStyle = window.getComputedStyle( div );
			pixelPositionVal = ( divStyle || {} ).top !== "1%";
			reliableMarginLeftVal = ( divStyle || {} ).marginLeft === "2px";
			boxSizingReliableVal = ( divStyle || { width: "4px" } ).width === "4px";

			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = ( divStyle || { marginRight: "4px" } ).marginRight === "4px";

			// Support: Android 2.3 only
			// Div with explicit width and no margin-right incorrectly
			// gets computed margin-right based on width of container (#3333)
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			contents = div.appendChild( document.createElement( "div" ) );

			// Reset CSS: box-sizing; display; margin; border; padding
			contents.style.cssText = div.style.cssText =

				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
				"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
			contents.style.marginRight = contents.style.width = "0";
			div.style.width = "1px";

			reliableMarginRightVal =
				!parseFloat( ( window.getComputedStyle( contents ) || {} ).marginRight );

			div.removeChild( contents );
		}

		// Support: IE6-8
		// First check that getClientRects works as expected
		// Check if table cells still have offsetWidth/Height when they are set
		// to display:none and there are still other visible table cells in a
		// table row; if so, offsetWidth/Height are not reliable for use when
		// determining if an element has been hidden directly using
		// display:none (it is still safe to use offsets if a parent element is
		// hidden; don safety goggles and see bug #4512 for more information).
		div.style.display = "none";
		reliableHiddenOffsetsVal = div.getClientRects().length === 0;
		if ( reliableHiddenOffsetsVal ) {
			div.style.display = "";
			div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
			contents = div.getElementsByTagName( "td" );
			contents[ 0 ].style.cssText = "margin:0;border:0;padding:0;display:none";
			reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
			if ( reliableHiddenOffsetsVal ) {
				contents[ 0 ].style.display = "";
				contents[ 1 ].style.display = "none";
				reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
			}
		}

		// Teardown
		documentElement.removeChild( container );
	}

} )();


var getStyles, curCSS,
	rposition = /^(top|right|bottom|left)$/;

if ( window.getComputedStyle ) {
	getStyles = function( elem ) {

		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

	curCSS = function( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;

		computed = computed || getStyles( elem );

		// getPropertyValue is only needed for .css('filter') in IE9, see #12537
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;

		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		if ( computed ) {

			// A tribute to the "awesome hack by Dean Edwards"
			// Chrome < 17 and Safari 5.0 uses "computed value"
			// instead of "used value" for margin-right
			// Safari 5.1.7 (at least) returns percentage for a larger set of values,
			// but width seems to be reliably pixels
			// this is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;

				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;

				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}

		// Support: IE
		// IE returns zIndex value as an integer.
		return ret === undefined ?
			ret :
			ret + "";
	};
} else if ( documentElement.currentStyle ) {
	getStyles = function( elem ) {
		return elem.currentStyle;
	};

	curCSS = function( elem, name, computed ) {
		var left, rs, rsLeft, ret,
			style = elem.style;

		computed = computed || getStyles( elem );
		ret = computed ? computed[ name ] : undefined;

		// Avoid setting ret to empty string here
		// so we don't default to auto
		if ( ret == null && style && style[ name ] ) {
			ret = style[ name ];
		}

		// From the awesome hack by Dean Edwards
		// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291

		// If we're not dealing with a regular pixel number
		// but a number that has a weird ending, we need to convert it to pixels
		// but not position css attributes, as those are
		// proportional to the parent element instead
		// and we can't measure the parent instead because it
		// might trigger a "stacking dolls" problem
		if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {

			// Remember the original values
			left = style.left;
			rs = elem.runtimeStyle;
			rsLeft = rs && rs.left;

			// Put in the new values to get a computed value out
			if ( rsLeft ) {
				rs.left = elem.currentStyle.left;
			}
			style.left = name === "fontSize" ? "1em" : ret;
			ret = style.pixelLeft + "px";

			// Revert the changed values
			style.left = left;
			if ( rsLeft ) {
				rs.left = rsLeft;
			}
		}

		// Support: IE
		// IE returns zIndex value as an integer.
		return ret === undefined ?
			ret :
			ret + "" || "auto";
	};
}




function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

		ralpha = /alpha\([^)]*\)/i,
	ropacity = /opacity\s*=\s*([^)]*)/i,

	// swappable if display is none or starts with table except
	// "table", "table-cell", or "table-caption"
	// see here for display values:
	// https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;


// return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// check for vendor prefixed names
	var capName = name.charAt( 0 ).toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = jQuery._data( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {

			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] =
					jQuery._data( elem, "olddisplay", defaultDisplay( elem.nodeName ) );
			}
		} else {
			hidden = isHidden( elem );

			if ( display && display !== "none" || !hidden ) {
				jQuery._data(
					elem,
					"olddisplay",
					hidden ? display : jQuery.css( elem, "display" )
				);
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

function setPositiveNumber( elem, value, subtract ) {
	var matches = rnumsplit.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?

		// If we already have the right measurement, avoid augmentation
		4 :

		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {

		// both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// at this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// at this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// at this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = support.boxSizing &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Support: IE11 only
	// In IE 11 fullscreen elements inside of an iframe have
	// 100x too small dimensions (gh-1764).
	if ( document.msFullscreenElement && window.top !== window ) {

		// Support: IE11 only
		// Running getBoundingClientRect on a disconnected node
		// in IE throws an error.
		if ( elem.getClientRects().length ) {
			val = Math.round( elem.getBoundingClientRect()[ name ] * 100 );
		}
	}

	// some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// we need the check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {

		// normalize float css property
		"float": support.cssFloat ? "cssFloat" : "styleFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// gets hook for the prefixed version
		// followed by the unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set. See: #7116
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
			// but it would mean to define eight
			// (for every problematic property) identical functions
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				// Support: IE
				// Swallow errors from 'invalid' CSS values (#5509)
				try {
					style[ name ] = value;
				} catch ( e ) {}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var num, val, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// gets hook for the prefixed version
		// followed by the unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		//convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Return, converting to number if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// certain elements can have dimension info if we invisibly show them
				// however, it must have a current display style that would benefit from this
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
					elem.offsetWidth === 0 ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var styles = extra && getStyles( elem );
			return setPositiveNumber( elem, value, extra ?
				augmentWidthOrHeight(
					elem,
					name,
					extra,
					support.boxSizing &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				) : 0
			);
		}
	};
} );

if ( !support.opacity ) {
	jQuery.cssHooks.opacity = {
		get: function( elem, computed ) {

			// IE uses filters for opacity
			return ropacity.test( ( computed && elem.currentStyle ?
				elem.currentStyle.filter :
				elem.style.filter ) || "" ) ?
					( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
					computed ? "1" : "";
		},

		set: function( elem, value ) {
			var style = elem.style,
				currentStyle = elem.currentStyle,
				opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
				filter = currentStyle && currentStyle.filter || style.filter || "";

			// IE has trouble with opacity if it does not have layout
			// Force it by setting the zoom level
			style.zoom = 1;

			// if setting opacity to 1, and no other filters exist -
			// attempt to remove filter attribute #6652
			// if value === "", then remove inline opacity #12685
			if ( ( value >= 1 || value === "" ) &&
					jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
					style.removeAttribute ) {

				// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
				// if "filter:" is present at all, clearType is disabled, we want to avoid this
				// style.removeAttribute is IE Only, but so apparently is this code path...
				style.removeAttribute( "filter" );

				// if there is no filter style applied in a css rule
				// or unset inline opacity, we are done
				if ( value === "" || currentStyle && !currentStyle.filter ) {
					return;
				}
			}

			// otherwise, set new filter values
			style.filter = ralpha.test( filter ) ?
				filter.replace( ralpha, opacity ) :
				filter + " " + opacity;
		}
	};
}

jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return (
				parseFloat( curCSS( elem, "marginLeft" ) ) ||

				// Support: IE<=11+
				// Running getBoundingClientRect on a disconnected node in IE throws an error
				// Support: IE8 only
				// getClientRects() errors on disconnected elems
				( jQuery.contains( elem.ownerDocument, elem ) ?
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} ) :
					0
				)
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails
			// so, simple values such as "10px" are parsed to Float.
			// complex values such as "rotate(1rad)" are returned as is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// use step hook for back compat - use cssHook if its there - use .style if its
			// available and use plain properties where available
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9
// Panic based approach to setting things on disconnected nodes

Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		attrs = { height: type },
		i = 0;

	// if we include width, step value is 1 to do all cssExpand values,
	// if we don't include width, step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// we're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = jQuery._data( elem, "fxshow" );

	// handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// doing this makes sure that the complete handler will be called
			// before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {

		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE does not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			jQuery._data( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {

			// inline-level elements accept inline-block;
			// block-level elements need to be inline with layout
			if ( !support.inlineBlockNeedsLayout || defaultDisplay( elem.nodeName ) === "inline" ) {
				style.display = "inline-block";
			} else {
				style.zoom = 1;
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		if ( !support.shrinkWrapBlocks() ) {
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show
				// and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = jQuery._data( elem, "fxshow", {} );
		}

		// store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done( function() {
				jQuery( elem ).hide();
			} );
		}
		anim.done( function() {
			var prop;
			jQuery._removeData( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		} );
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// not quite $.extend, this wont overwrite keys already present.
			// also - reusing 'index' from above because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// if we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// resolve when we played the last frame
				// otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnotwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
		opt.duration in jQuery.fx.speeds ?
			jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || jQuery._data( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = jQuery._data( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// start the next in the queue if the last step wasn't forced
			// timers currently will call their complete callbacks, which will dequeue
			// but only if they were gotoEnd
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = jQuery._data( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// enable finishing flag on private data
			data.finish = true;

			// empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		timers = jQuery.timers,
		i = 0;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;

jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	window.clearInterval( timerId );
	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var a,
		input = document.createElement( "input" ),
		div = document.createElement( "div" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	// Setup
	div = document.createElement( "div" );
	div.setAttribute( "className", "t" );
	div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	a = div.getElementsByTagName( "a" )[ 0 ];

	// Support: Windows Web Apps (WWA)
	// `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "checkbox" );
	div.appendChild( input );

	a = div.getElementsByTagName( "a" )[ 0 ];

	// First batch of tests.
	a.style.cssText = "top:1px";

	// Test setAttribute on camelCase class.
	// If it works, we need attrFixes when doing get/setAttribute (ie6/7)
	support.getSetAttribute = div.className !== "t";

	// Get the style information from getAttribute
	// (IE uses .cssText instead)
	support.style = /top/.test( a.getAttribute( "style" ) );

	// Make sure that URLs aren't manipulated
	// (IE normalizes it by default)
	support.hrefNormalized = a.getAttribute( "href" ) === "/a";

	// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
	support.checkOn = !!input.value;

	// Make sure that a selected-by-default option has a working selected property.
	// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
	support.optSelected = opt.selected;

	// Tests for enctype support on a form (#6743)
	support.enctype = !!document.createElement( "form" ).enctype;

	// Make sure that the options inside disabled selects aren't marked as disabled
	// (WebKit marks them as disabled)
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE8 only
	// Check if we can trust getAttribute("value")
	input = document.createElement( "input" );
	input.setAttribute( "value", "" );
	support.input = input.getAttribute( "value" ) === "";

	// Check if an input maintains its value after becoming a radio
	input.value = "t";
	input.setAttribute( "type", "radio" );
	support.radioValue = input.value === "t";
} )();


var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if (
					hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?

					// handle most common string cases
					ret.replace( rreturn, "" ) :

					// handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";
			} else if ( typeof val === "number" ) {
				val += "";
			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {
				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					jQuery.trim( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// oldIE doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ?
								!option.disabled :
								option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					if ( jQuery.inArray( jQuery.valHooks.option.get( option ), values ) >= 0 ) {

						// Support: IE6
						// When new option element is added to select box we need to
						// force reflow of newly added node in order to workaround delay
						// of initialization properties
						try {
							option.selected = optionSet = true;

						} catch ( _ ) {

							// Will be executed only in IE6
							option.scrollHeight;
						}

					} else {
						option.selected = false;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}

				return options;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




var nodeHook, boolHook,
	attrHandle = jQuery.expr.attrHandle,
	ruseDefault = /^(?:checked|selected)$/i,
	getSetAttribute = support.getSetAttribute,
	getSetInput = support.input;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {

					// Setting the type on a radio button after the value resets the value in IE8-9
					// Reset value to default in case type is set after value during creation
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {

					// Set corresponding property to false
					if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
						elem[ propName ] = false;

					// Support: IE<9
					// Also clear defaultChecked/defaultSelected (if appropriate)
					} else {
						elem[ jQuery.camelCase( "default-" + name ) ] =
							elem[ propName ] = false;
					}

				// See #9699 for explanation of this approach (setting first, then removal)
				} else {
					jQuery.attr( elem, name, "" );
				}

				elem.removeAttribute( getSetAttribute ? name : propName );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {

			// IE<8 needs the *property* name
			elem.setAttribute( !getSetAttribute && jQuery.propFix[ name ] || name, name );

		} else {

			// Support: IE<9
			// Use defaultChecked and defaultSelected for oldIE
			elem[ jQuery.camelCase( "default-" + name ) ] = elem[ name ] = true;
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {

				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} else {
		attrHandle[ name ] = function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem[ jQuery.camelCase( "default-" + name ) ] ?
					name.toLowerCase() :
					null;
			}
		};
	}
} );

// fix oldIE attroperties
if ( !getSetInput || !getSetAttribute ) {
	jQuery.attrHooks.value = {
		set: function( elem, value, name ) {
			if ( jQuery.nodeName( elem, "input" ) ) {

				// Does not return so that setAttribute is also used
				elem.defaultValue = value;
			} else {

				// Use nodeHook if defined (#1954); otherwise setAttribute is fine
				return nodeHook && nodeHook.set( elem, value, name );
			}
		}
	};
}

// IE6/7 do not support getting/setting some attributes with get/setAttribute
if ( !getSetAttribute ) {

	// Use this for any attribute in IE6/7
	// This fixes almost every IE6/7 issue
	nodeHook = {
		set: function( elem, value, name ) {

			// Set the existing or create a new attribute node
			var ret = elem.getAttributeNode( name );
			if ( !ret ) {
				elem.setAttributeNode(
					( ret = elem.ownerDocument.createAttribute( name ) )
				);
			}

			ret.value = value += "";

			// Break association with cloned elements by also using setAttribute (#9646)
			if ( name === "value" || value === elem.getAttribute( name ) ) {
				return value;
			}
		}
	};

	// Some attributes are constructed with empty-string values when not defined
	attrHandle.id = attrHandle.name = attrHandle.coords =
		function( elem, name, isXML ) {
			var ret;
			if ( !isXML ) {
				return ( ret = elem.getAttributeNode( name ) ) && ret.value !== "" ?
					ret.value :
					null;
			}
		};

	// Fixing value retrieval on a button requires this module
	jQuery.valHooks.button = {
		get: function( elem, name ) {
			var ret = elem.getAttributeNode( name );
			if ( ret && ret.specified ) {
				return ret.value;
			}
		},
		set: nodeHook.set
	};

	// Set contenteditable to false on removals(#10429)
	// Setting to empty string throws an error as an invalid value
	jQuery.attrHooks.contenteditable = {
		set: function( elem, value, name ) {
			nodeHook.set( elem, value === "" ? false : value, name );
		}
	};

	// Set width and height to auto instead of 0 on empty string( Bug #8150 )
	// This is for removals
	jQuery.each( [ "width", "height" ], function( i, name ) {
		jQuery.attrHooks[ name ] = {
			set: function( elem, value ) {
				if ( value === "" ) {
					elem.setAttribute( name, "auto" );
					return value;
				}
			}
		};
	} );
}

if ( !support.style ) {
	jQuery.attrHooks.style = {
		get: function( elem ) {

			// Return undefined in the case of empty string
			// Note: IE uppercases css property names, but if we were to .toLowerCase()
			// .cssText, that would destroy case sensitivity in URL's, like in "background"
			return elem.style.cssText || undefined;
		},
		set: function( elem, value ) {
			return ( elem.style.cssText = value + "" );
		}
	};
}




var rfocusable = /^(?:input|select|textarea|button|object)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		name = jQuery.propFix[ name ] || name;
		return this.each( function() {

			// try/catch handles cases where IE balks (such as removing a property on window)
			try {
				this[ name ] = undefined;
				delete this[ name ];
			} catch ( e ) {}
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				return tabindex ?
					parseInt( tabindex, 10 ) :
					rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) && elem.href ?
							0 :
							-1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Some attributes require a special call on IE
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !support.hrefNormalized ) {

	// href/src property should get the full normalized URL (#10299/#12915)
	jQuery.each( [ "href", "src" ], function( i, name ) {
		jQuery.propHooks[ name ] = {
			get: function( elem ) {
				return elem.getAttribute( name, 4 );
			}
		};
	} );
}

// Support: Safari, IE9+
// mis-reports the default selected property of an option
// Accessing the parent's selectedIndex property fixes it
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;

			if ( parent ) {
				parent.selectedIndex;

				// Make sure that it also works with optgroups, see #5701
				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
			return null;
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );

// IE6/7 call enctype encoding
if ( !support.enctype ) {
	jQuery.propFix.enctype = "encoding";
}




var rclass = /[\t\r\n\f]/g;

function getClass( elem ) {
	return jQuery.attr( elem, "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						jQuery.attr( elem, "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						jQuery.attr( elem, "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnotwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// store className if set
					jQuery._data( this, "__className__", className );
				}

				// If the element has a class name or if we're passed "false",
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				jQuery.attr( this, "class",
					className || value === false ?
					"" :
					jQuery._data( this, "__className__" ) || ""
				);
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + getClass( elem ) + " " ).replace( rclass, " " )
					.indexOf( className ) > -1
			) {
				return true;
			}
		}

		return false;
	}
} );




// Return jQuery for attributes-only inclusion


jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );


var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;

jQuery.parseJSON = function( data ) {

	// Attempt to parse using the native JSON parser first
	if ( window.JSON && window.JSON.parse ) {

		// Support: Android 2.3
		// Workaround failure to string-cast null input
		return window.JSON.parse( data + "" );
	}

	var requireNonComma,
		depth = null,
		str = jQuery.trim( data + "" );

	// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
	// after removing valid tokens
	return str && !jQuery.trim( str.replace( rvalidtokens, function( token, comma, open, close ) {

		// Force termination if we see a misplaced comma
		if ( requireNonComma && comma ) {
			depth = 0;
		}

		// Perform no more replacements after returning to outermost depth
		if ( depth === 0 ) {
			return token;
		}

		// Commas must not follow "[", "{", or ","
		requireNonComma = open || comma;

		// Determine new depth
		// array/object open ("[" or "{"): depth += true - false (increment)
		// array/object close ("]" or "}"): depth += false - true (decrement)
		// other cases ("," or primitive): depth += true - true (numeric cast)
		depth += !close - !open;

		// Remove this token
		return "";
	} ) ) ?
		( Function( "return " + str ) )() :
		jQuery.error( "Invalid JSON: " + data );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, tmp;
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	try {
		if ( window.DOMParser ) { // Standard
			tmp = new window.DOMParser();
			xml = tmp.parseFromString( data, "text/xml" );
		} else { // IE
			xml = new window.ActiveXObject( "Microsoft.XMLDOM" );
			xml.async = "false";
			xml.loadXML( data );
		}
	} catch ( e ) {
		xml = undefined;
	}
	if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,

	// IE leaves an \r character at EOL
	rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Document location
	ajaxLocation = location.href,

	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType.charAt( 0 ) === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var deep, key,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {
	var firstDataType, ct, finalDataType, type,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s[ "throws" ] ) { // jscs:ignore requireDotNotation
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: ajaxLocation,
		type: "GET",
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var

			// Cross-domain detection vars
			parts,

			// Loop variable
			i,

			// URL without anti-cache param
			cacheURL,

			// Response headers as string
			responseHeadersString,

			// timeout handle
			timeoutTimer,

			// To know if global events are to be dispatched
			fireGlobals,

			transport,

			// Response headers
			responseHeaders,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// The jqXHR state
			state = 0,

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {

								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || ajaxLocation ) + "" )
			.replace( rhash, "" )
			.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when we have a protocol:host:port mismatch
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( state === 2 ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );

				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// We extract error from statusText
				// then normalize statusText and status for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapAll( html.call( this, i ) );
			} );
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			var wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
					elem = elem.firstChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function() {
		return this.parent().each( function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		} ).end();
	}
} );


function getDisplay( elem ) {
	return elem.style && elem.style.display || jQuery.css( elem, "display" );
}

function filterHidden( elem ) {
	while ( elem && elem.nodeType === 1 ) {
		if ( getDisplay( elem ) === "none" || elem.type === "hidden" ) {
			return true;
		}
		elem = elem.parentNode;
	}
	return false;
}

jQuery.expr.filters.hidden = function( elem ) {

	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	return support.reliableHiddenOffsets() ?
		( elem.offsetWidth <= 0 && elem.offsetHeight <= 0 &&
			!elem.getClientRects().length ) :
			filterHidden( elem );
};

jQuery.expr.filters.visible = function( elem ) {
	return !jQuery.expr.filters.hidden( elem );
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {

			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is(":disabled") so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} ) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


// Create the request object
// (This is still attached to ajaxSettings for backward compatibility)
jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?

	// Support: IE6-IE8
	function() {

		// XHR cannot access local files, always use ActiveX for that case
		if ( this.isLocal ) {
			return createActiveXHR();
		}

		// Support: IE 9-11
		// IE seems to error on cross-domain PATCH requests when ActiveX XHR
		// is used. In IE 9+ always use the native XHR.
		// Note: this condition won't catch Edge as it doesn't define
		// document.documentMode but it also doesn't support ActiveX so it won't
		// reach this code.
		if ( document.documentMode > 8 ) {
			return createStandardXHR();
		}

		// Support: IE<9
		// oldIE XHR does not support non-RFC2616 methods (#13240)
		// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
		// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
		// Although this check for six methods instead of eight
		// since IE also does not support "trace" and "connect"
		return /^(get|post|head|put|delete|options)$/i.test( this.type ) &&
			createStandardXHR() || createActiveXHR();
	} :

	// For all other browsers, use the standard XMLHttpRequest object
	createStandardXHR;

var xhrId = 0,
	xhrCallbacks = {},
	xhrSupported = jQuery.ajaxSettings.xhr();

// Support: IE<10
// Open requests must be manually aborted on unload (#5280)
// See https://support.microsoft.com/kb/2856746 for more info
if ( window.attachEvent ) {
	window.attachEvent( "onunload", function() {
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]( undefined, true );
		}
	} );
}

// Determine support properties
support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
xhrSupported = support.ajax = !!xhrSupported;

// Create transport if the browser can provide an xhr
if ( xhrSupported ) {

	jQuery.ajaxTransport( function( options ) {

		// Cross domain only allowed if supported through XMLHttpRequest
		if ( !options.crossDomain || support.cors ) {

			var callback;

			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr(),
						id = ++xhrId;

					// Open the socket
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);

					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}

					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}

					// Set headers
					for ( i in headers ) {

						// Support: IE<9
						// IE's ActiveXObject throws a 'Type Mismatch' exception when setting
						// request header to a null-value.
						//
						// To keep consistent with other XHR implementations, cast the value
						// to string and ignore `undefined`.
						if ( headers[ i ] !== undefined ) {
							xhr.setRequestHeader( i, headers[ i ] + "" );
						}
					}

					// Do send the request
					// This may raise an exception which is actually
					// handled in jQuery.ajax (so no try/catch here)
					xhr.send( ( options.hasContent && options.data ) || null );

					// Listener
					callback = function( _, isAbort ) {
						var status, statusText, responses;

						// Was never called and is aborted or complete
						if ( callback && ( isAbort || xhr.readyState === 4 ) ) {

							// Clean up
							delete xhrCallbacks[ id ];
							callback = undefined;
							xhr.onreadystatechange = jQuery.noop;

							// Abort manually if needed
							if ( isAbort ) {
								if ( xhr.readyState !== 4 ) {
									xhr.abort();
								}
							} else {
								responses = {};
								status = xhr.status;

								// Support: IE<10
								// Accessing binary-data responseText throws an exception
								// (#11426)
								if ( typeof xhr.responseText === "string" ) {
									responses.text = xhr.responseText;
								}

								// Firefox throws an exception when accessing
								// statusText for faulty cross-domain requests
								try {
									statusText = xhr.statusText;
								} catch ( e ) {

									// We normalize with Webkit giving an empty statusText
									statusText = "";
								}

								// Filter status for non standard behaviors

								// If the request is local and we have data: assume a success
								// (success with no data won't get notified, that's the best we
								// can do given current implementations)
								if ( !status && options.isLocal && !options.crossDomain ) {
									status = responses.text ? 200 : 404;

								// IE - #1450: sometimes returns 1223 when it should be 204
								} else if ( status === 1223 ) {
									status = 204;
								}
							}
						}

						// Call complete if needed
						if ( responses ) {
							complete( status, statusText, responses, xhr.getAllResponseHeaders() );
						}
					};

					// Do send the request
					// `xhr.send` may raise an exception, but it will be
					// handled in jQuery.ajax (so no try/catch here)
					if ( !options.async ) {

						// If we're in sync mode we fire the callback
						callback();
					} else if ( xhr.readyState === 4 ) {

						// (IE6 & IE7) if it's in cache and has been
						// retrieved directly we need to fire the callback
						window.setTimeout( callback );
					} else {

						// Register the callback, but delay it in case `xhr.send` throws
						// Add to the list of active xhr callbacks
						xhr.onreadystatechange = xhrCallbacks[ id ] = callback;
					}
				},

				abort: function() {
					if ( callback ) {
						callback( undefined, true );
					}
				}
			};
		}
	} );
}

// Functions to create xhrs
function createStandardXHR() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
}

function createActiveXHR() {
	try {
		return new window.ActiveXObject( "Microsoft.XMLHTTP" );
	} catch ( e ) {}
}




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and global
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
		s.global = false;
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {

		var script,
			head = document.head || jQuery( "head" )[ 0 ] || document.documentElement;

		return {

			send: function( _, callback ) {

				script = document.createElement( "script" );

				script.async = true;

				if ( s.scriptCharset ) {
					script.charset = s.scriptCharset;
				}

				script.src = s.url;

				// Attach handlers for all browsers
				script.onload = script.onreadystatechange = function( _, isAbort ) {

					if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {

						// Handle memory leak in IE
						script.onload = script.onreadystatechange = null;

						// Remove the script
						if ( script.parentNode ) {
							script.parentNode.removeChild( script );
						}

						// Dereference the script
						script = null;

						// Callback if not abort
						if ( !isAbort ) {
							callback( 200, "success" );
						}
					}
				};

				// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
				// Use native DOM manipulation to avoid our domManip AJAX trickery
				head.insertBefore( script, head.firstChild );
			},

			abort: function() {
				if ( script ) {
					script.onload( undefined, true );
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8+
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	if ( !document.implementation.createHTMLDocument ) {
		return false;
	}
	var doc = document.implementation.createHTMLDocument( "" );
	doc.body.innerHTML = "<form></form><form></form>";
	return doc.body.childNodes.length === 2;
} )();


// data: string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	// document.implementation stops scripts or inline event handlers from
	// being executed immediately
	context = context || ( support.createHTMLDocument ?
		document.implementation.createHTMLDocument( "" ) :
		document );

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = jQuery.trim( url.slice( off, url.length ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( self, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};





/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ?
		elem :
		elem.nodeType === 9 ?
			elem.defaultView || elem.parentWindow :
			false;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			jQuery.inArray( "auto", [ curCSSTop, curCSSLeft ] ) > -1;

		// need to be able to calculate position if either top or left
		// is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;
		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );
		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win,
			box = { top: 0, left: 0 },
			elem = this[ 0 ],
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		// If we don't have gBCR, just use 0,0 rather than error
		// BlackBerry 5, iOS 3 (original iPhone)
		if ( typeof elem.getBoundingClientRect !== "undefined" ) {
			box = elem.getBoundingClientRect();
		}
		win = getWindow( doc );
		return {
			top: box.top  + ( win.pageYOffset || docElem.scrollTop )  - ( docElem.clientTop  || 0 ),
			left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			parentOffset = { top: 0, left: 0 },
			elem = this[ 0 ];

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// we assume that getBoundingClientRect is available when computed position is fixed
			offset = elem.getBoundingClientRect();
		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top  += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		// note: when an element has margin: auto the offsetLeft and marginLeft
		// are the same in Safari causing offset.left to incorrectly be 0
		return {
			top:  offset.top  - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) ) {
				offsetParent = offsetParent.offsetParent;
			}
			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = /Y/.test( prop );

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? ( prop in win ) ? win[ prop ] :
					win.document.documentElement[ method ] :
					elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : jQuery( win ).scrollLeft(),
					top ? val : jQuery( win ).scrollTop()
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
} );

// Support: Safari<7-8+, Chrome<37-44+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// getComputedStyle returns percent when specified for top/left/bottom/right
// rather than make the css module depend on the offset module, we just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// if curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
	function( defaultExtra, funcName ) {

		// margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					// unfortunately, this causes bug #3838 in IE6/8 only,
					// but there is currently no good, small way to fix it.
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	return this.length;
};

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}



var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in
// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}

return jQuery;
}));


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = Observable;
/* harmony export (immutable) */ __webpack_exports__["e"] = ObservableValue;
/* harmony export (immutable) */ __webpack_exports__["p"] = shouldBeInitialized;
/* harmony export (immutable) */ __webpack_exports__["q"] = markInitialized;
/* harmony export (immutable) */ __webpack_exports__["z"] = unmarkInitialized;
/* harmony export (immutable) */ __webpack_exports__["b"] = invoke;
/* harmony export (immutable) */ __webpack_exports__["S"] = isString;
/* harmony export (immutable) */ __webpack_exports__["C"] = stringToObject;
/* harmony export (immutable) */ __webpack_exports__["D"] = objectToString;
/* harmony export (immutable) */ __webpack_exports__["a"] = isTouchDevice;
/* harmony export (immutable) */ __webpack_exports__["m"] = isIe7;
/* harmony export (immutable) */ __webpack_exports__["c"] = isIe8;
/* harmony export (immutable) */ __webpack_exports__["u"] = isIe9;
/* harmony export (immutable) */ __webpack_exports__["I"] = isIe;
/* unused harmony export sanitizeReferenceString */
/* harmony export (immutable) */ __webpack_exports__["f"] = resolveReference;
/* harmony export (immutable) */ __webpack_exports__["j"] = sign;
/* harmony export (immutable) */ __webpack_exports__["h"] = data;
/* harmony export (immutable) */ __webpack_exports__["g"] = intData;
/* harmony export (immutable) */ __webpack_exports__["B"] = jsonData;
/* harmony export (immutable) */ __webpack_exports__["F"] = resolveReferencedObject;
/* harmony export (immutable) */ __webpack_exports__["v"] = resolveConfig;
/* harmony export (immutable) */ __webpack_exports__["o"] = addClass;
/* harmony export (immutable) */ __webpack_exports__["d"] = hasClass;
/* harmony export (immutable) */ __webpack_exports__["n"] = removeClass;
/* harmony export (immutable) */ __webpack_exports__["G"] = copyAttributesIfExist;
/* harmony export (immutable) */ __webpack_exports__["w"] = hasFocus;
/* harmony export (immutable) */ __webpack_exports__["r"] = isNodeDetached;
/* harmony export (immutable) */ __webpack_exports__["Q"] = fixEvent;
/* unused harmony export createEvent */
/* harmony export (immutable) */ __webpack_exports__["k"] = dispatchEvent;
/* harmony export (immutable) */ __webpack_exports__["l"] = addEventListener;
/* harmony export (immutable) */ __webpack_exports__["N"] = removeEventListener;
/* harmony export (immutable) */ __webpack_exports__["H"] = forwardEvents;
/* harmony export (immutable) */ __webpack_exports__["E"] = getEventTarget;
/* harmony export (immutable) */ __webpack_exports__["s"] = stopPropagation;
/* harmony export (immutable) */ __webpack_exports__["M"] = preventDefault;
/* harmony export (immutable) */ __webpack_exports__["t"] = cancelEvent;
/* harmony export (immutable) */ __webpack_exports__["R"] = generateUUID;
/* harmony export (immutable) */ __webpack_exports__["K"] = forEach;
/* harmony export (immutable) */ __webpack_exports__["L"] = filter;
/* harmony export (immutable) */ __webpack_exports__["x"] = textContent;
/* harmony export (immutable) */ __webpack_exports__["O"] = trim;
/* unused harmony export indexOf */
/* harmony export (immutable) */ __webpack_exports__["J"] = map;
/* unused harmony export omit */
/* harmony export (immutable) */ __webpack_exports__["A"] = initWidget;
/* harmony export (immutable) */ __webpack_exports__["y"] = unwrapMarkup;
/* harmony export (immutable) */ __webpack_exports__["P"] = getBoundingClientRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


/**
 * Instances of the Observer class can be observed by other objects. The observed object can raise its own
 * events and observer objects can attach event handlers to the observed object. Triggering an event by
 * the observed object means the execution of all event handlers attached to that particular event.
 *
 * Event names are strings. Event handlers are functions with one argument, the data sent by the observed object.
 * Within event handlers the 'this' is mapped to the observed object.
 */
function Observable() {
    var handlers = {};

    this.on = function (name, func) {
        if (!handlers[name]) {
            handlers[name] = [];
        }
        handlers[name].push(func);
    };

    this.trigger = function (name, data) {
        if (handlers[name] && handlers[name].length > 0) {
            for (var i = 0, l = handlers[name].length; i < l; i++) {
                handlers[name][i].call(null, data);
            }
        }
    };

    this.off = function (name, func) {
        var l = arguments.length;
        if (l === 0) {
            handlers = {};
        } else if (l === 1 && handlers[name]) {
            delete handlers[name];
        } else if (l === 2 && handlers[name] && handlers[name].length > 0) {
            for (var i = 0, k = handlers[name].length; i < k; i++) {
                if (handlers[name][i] === func) {
                    delete handlers[name][i];
                    return;
                }
            }
        }
    };
}

/**
 * A class which is a wrapper of a single value. It extends the Observable class, so it throws a 'change:value'
 * event on value changed.
 *
 * @param val The initial value of this class.
 * @param changeCallback The callback method which is invoked on value change. This can define additional effect
 * associated to the change event.
 */
function ObservableValue(val, changeCallback) {
    var self = this;

    this.value = function () {
        if (arguments.length) {
            var newVal = arguments[0];
            if (newVal !== val) {
                val = newVal;
                self.trigger('change:value', val);
                if (typeof changeCallback === 'function') {
                    invoke(changeCallback, val);
                }
            }
        } else {
            return val;
        }
    };

    Observable.call(this);
}

function shouldBeInitialized(widget) {
    return !widget.hasAttribute('data-uwr-ready');
}

function markInitialized(widget) {
    widget.setAttribute('data-uwr-ready', '');
}

function unmarkInitialized(widget) {
    widget.removeAttribute('data-uwr-ready');
}
/**
 * Invokes a function passed in as the first argument. If there are more arguments passed in, they will be used
 * as parameters for the function being invoked.
 * If the first parameter is not a function, then nothing will be done.
 *
 * @param First param is the function to invoke, any further params will be passed in to that function.
 *     If the first parameter is not a function, then nothing will be done.
 */
function invoke(fn) {
    if (typeof fn === 'function') {
        return fn.apply(null, Array.prototype.slice.call(arguments, 1));
    }
}

function isString(value) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.type(value) === 'string';
}

function stringToObject(str) {
    if (isString(str)) {
        str = JSON.parse(str);
    }
    return str;
}

function objectToString(obj) {
    if (isString(obj)) {
        return obj;
    }
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isPlainObject(obj)) {
        return JSON.stringify(obj);
    }
    return '' + obj;
}

function runOnArrayOrString(arrayOrString, callable) {
    var i;
    if (typeof arrayOrString === 'string') {
        arrayOrString = [arrayOrString];
    }
    for (i = 0; i < arrayOrString.length; i++) {
        callable.call(arrayOrString[i]);
    }
}

function isTouchExplorer() {
    return (navigator.userAgent.indexOf('MSIE') > -1 || navigator.userAgent.indexOf('rv:11.0') > -1)
            && navigator.userAgent.indexOf('Touch') > -1;
}

/**
 * This function checks if we are on a touch device (usually a tablet or a smart phone)
 */
function isTouchDevice() {
    return isTouchExplorer() ? true : !!('ontouchstart' in window);
}

function isIe7() {
    return isIe(7);
}

function isIe8() {
    return isIe(8);
}

function isIe9() {
    return isIe(9);
}

/**
 * Is the browser based on an IE version or not.
 * @param version Optional IE version string.
 * @returns {boolean}
 */
function isIe(version, userAgentString) {
    userAgentString = userAgentString || navigator.userAgent;

    var versionString = version || '',
        match = userAgentString.match(
            new RegExp('(msie ' + versionString + '|trident.*rv[ :]' + versionString + ')', 'i')
        );
    return match !== null;
}

/**
 * @param {string} A JS reference string.
 * @return The reference string cleaned up. No javascript calls, functions and statements are allowed
 *         in this reference - not allowed characters are removed.
 */
function sanitizeReferenceString(reference) {
    return reference.replace(/[^\w\.\[\]\'\"-]/g, '');
}

/**
 * @param {string} A JS expression string.
 * @return The reference of JS expression string.
 */
function resolveReference(str) {
    var reference;
    if (str) {
        reference = eval(sanitizeReferenceString(str)); // eslint-disable-line
    }
    return reference;
}

/**
 * The missing signum function of Math. Value should be a number.
 */
function sign(value) {
    return value > 0 ? 1 : value < 0 ? -1 : 0;
}

/**
 * Extract HTMLElement if it is wrapped by jQuery or it gives back the original object
 */
function extractHtmlElement(elementObject) {
    return (elementObject && elementObject instanceof __WEBPACK_IMPORTED_MODULE_0_jquery___default.a) ? elementObject.get(0) : elementObject;
}

/**
 * Get data attribute of the elem and format it.
 *
 * @param elementObject A jQuery object or a pure HTML element which data attribute should be retrieved.
 * @param name The name of the data attribute. (without data- prefix).
 * @param defaultValue The default value if no data attribute found.
 * @param formatter Optional, to format value.
 * @return The value of the data attribute or the defaultValue if no data attribute found.
 */
function data(elementObject, name, defaultValue, formatter) {
    var elem = extractHtmlElement(elementObject),
        attributeName = 'data-' + name,
        elemData = (elem && elem.hasAttribute(attributeName))
            ? elem.getAttribute(attributeName)
            : undefined,
        value = elemData !== undefined ? elemData : defaultValue;

    return formatter ? formatter(value) : value;
}

/**
 * Get data attribute of the elem as integer.
 *
 * @param $elem The jQuery elem which data is retrieved.
 * @param name The name of the data attribute.
 * @param defaultValue The default value if no data attribute found.
 * @return The integer value of the data attribute or the defaultValue if no data attribute found.
 */
function intData($elem, name, defaultValue) {
    return data($elem, name, defaultValue, parseInt);
}

/**
 * Get data attribute of the elem as JSON object.
 *
 * @param $elem The jQuery elem of which data is retrieved.
 * @param name The name of the data attribute.
 * @param defaultValue The default value if no data attribute found or the data is not valid JSON.
 *        It can be of any type.
 * @return The JSON object of the data attribute or the given defaultValue if no data attribute found
 *         or the data is not valid JSON.
 */
function jsonData($elem, name, defaultValue) {
    return data($elem, name, defaultValue, function (val) {
        var json;
        try {
            json = stringToObject(val);
        /* eslint-disable no-empty */
        } catch (e) {}
        /* eslint-enable no-empty */
        if (!json) {
            json = defaultValue;
        }
        return json;
    });
}

/**
 * Resolve an object based on the reference string.
 * @param referenceString The name of the variable holding the object.
 * @param args The optional arguments array of the object provider function.
 * @return {*} The referenced object or if the referenced object is a function object then it gives back the return
 * value of that function.
 */
function resolveReferencedObject(referenceString, args) {
    var referencedObj = resolveReference(referenceString),
        resolvedObject;
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(referencedObj)) {
        resolvedObject = referencedObj.apply(undefined, args || []);
    } else {
        // Clone so that we don't modify the client's original object
        resolvedObject = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(true, {}, referencedObj);
    }
    return resolvedObject;
}

/**
 * Get the configuration from the HTML element attribute.
 *
 * @param $elem The jQuery elem of which attribute content is retrived.
 * @param attributeName The name of the data attribute (without the data- prefix).
 * @param args The optional arguments array of the configuration provider function.
 * @return {*} The JSON configuration object which is provided based on the attribute's value.
 */
function resolveConfig($elem, attributeName, args) {
    var obj = jsonData($elem, attributeName, data($elem, attributeName)),
        config = {};

    if (obj) {
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isPlainObject(obj)) {
            config = obj;
        } else {
            config = resolveReferencedObject(String(obj), args);
        }
    }

    return config;
}

/**
 * Adds class to HTML element
 *
 * @param element The element to add class to.
 * @param className The name of the class.
 */
function addClass(element, className) {
    if (element.classList) {
        element.classList.add(className);
    } else {
        element.className += ' ' + className;
    }
}

/**
 * Check if an HTML element has a specific class set.
 *
 * @param element The element to check the class on.
 * @param className The name of the class to check for.
 * @return The result of the check, either true or false.
 */
function hasClass(element, className) {
    if (element.classList) {
        return element.classList.contains(className);
    }

    return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
}

/**
 * Remove class from HTML element
 *
 * @param element The element to remove class from.
 * @param className The name of the class.
 */
function removeClass(element, className) {
    if (element.classList) {
        element.classList.remove(className);
    } else {
        element.className = element.className.replace(new RegExp('(^|\\b)' +
            className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ').trim();
    }
}

/**
 * Copies one or more attributes from a HTML element to another if these attributes exist on the source element.
 */
function copyAttributesIfExist(fromElement, toElement, attributeNames) {
    runOnArrayOrString(attributeNames, function copyAttribute() {
        if (fromElement.hasAttribute(this)) {
            toElement.setAttribute(this, fromElement.getAttribute(this));
        }
    });
}

/**
 * Check if an HTML element is in focus or not.
 *
 * @param element The element to check is in focus.
 * @return Is the element in focus or not.
 */
function hasFocus(element) {
    return document.activeElement === element;
}

function isNodeDetached(node) {
    var currentNode = node;
    while(currentNode !== null && currentNode !== document.body) {
        currentNode = currentNode.parentNode;
    }
    return currentNode !== document.body;
}

/**
 * @return The event object regardless of event subscription type
 * If you assign an event handler using the DOM0 property way (using onclick)
 * the instance of the 'event' object will be not passed to the handler.
 * In this case it should be taken from the global 'window' object
 */
function fixEvent(event) {
    return event || window.event;
}

/**
 * Create a new event with IE fallbacks.
 * @param eventType Event type to create.
 * @returns {*} The new event object.
 */
function createEvent(eventType, eventInit) {
    var event;
    if (typeof Event === 'function') { // Latest API
        event = new Event(eventType, eventInit);
    } else if (document.createEvent) { // Modern IE
        event = document.createEvent('Event');
        eventInit = eventInit || {};
        event.initEvent(eventType, !!eventInit.bubbles, !!eventInit.cancelable);
    } else { // IE fallback
        event = document.createEventObject();
        event.type = eventType;
    }
    return event;
}

/**
 * Fire an event on a defined HTML element using the browser's infrastructure.
 * @param eventOrType The type of the event (like change or click) or the Event object itself.
 * @param element The HTML element which is the target of the event.
 *
 * Please notice, that an already existing event (for example what you would like to forward) cannot be
 * dispatched again. You should create a new event for dispatching every time.
 *
 * Backported to UW4.
 */
function dispatchEvent(eventOrType, element) {
    var event = typeof eventOrType === 'string' ? createEvent(eventOrType) : eventOrType;

    if (element.dispatchEvent) {
        element.dispatchEvent(event);
    } else { // before IE9 (IE8)
        try {
            element.fireEvent('on' + event.type, event);
        /* eslint-disable no-empty */
        } catch (e) {}
        /* eslint-enable no-empty */
    }
}

/**
 * An IE8 Element.prototype.addEventListener shim
 * on the specified element.
 * @param eventTypes One or more event type(s) to add listener.
 * @param element The element on which the event type should be added.
 * @param listener The listener function which should be added.
 */
function addEventListener(eventTypes, element, listener) {
    runOnArrayOrString(eventTypes, function () {
        if (element.addEventListener) {
            element.addEventListener(this, listener);
        } else {
            element.attachEvent('on' + this, listener);
        }
    });
}

/**
 * An IE8+ Element.prototype.removeEventListener shim
 * @param eventTypes One or more event type(s) to remove listener.
 * @param element The element from which the event type should be removed.
 * @param listener The listener function which should be removed.
 */
function removeEventListener(eventTypes, element, listener) {
    runOnArrayOrString(eventTypes, function () {
        if (element.removeEventListener) {
            element.removeEventListener(this, listener);
        } else {
            element.detachEvent('on' + this, listener);
        }
    });
}

/**
 * Forward event from an HTML element to another.
 * @param eventTypes One or more event type names to forward.
 * @param from The HTML element where the event was dispatched originally.
 * @param to The HTML element where the event is dispatched to.
 */
function forwardEvents(eventTypes, from, to) {
    addEventListener(eventTypes, from, function (event) {
        var copiedEvent = createEvent(event.type);
        dispatchEvent(copiedEvent, to);
    });
}

/**
 * IE8 Event.target polyfill
 * @return The event's target in jQuery object regardless of browser type
 */
function getEventTarget(event, asHtmlElement) {
    var ev = fixEvent(event);
    return asHtmlElement
        ? ev.target || ev.srcElement
        : __WEBPACK_IMPORTED_MODULE_0_jquery___default()(ev.target || ev.srcElement);
}

/**
 * IE8 Event.prototype.stopPropagation polyfill
 * Stops the propagation of the event in a backward compatible way.
 */
function stopPropagation(ev) {
    if (ev.stopPropagation) {
        ev.stopPropagation();
    } else {
        window.event.cancelBubble = true;
    }
}

// IE8 Event.prototype.preventDefault polyfill
function preventDefault(event) {
    event = fixEvent(event);

    if (event.preventDefault) {
        event.preventDefault();
    } else {
        event.returnValue = false;
    }
}

/**
 * @deprecated Please use common.stopPropagation() + common.preventDefault() instead
 * Cancels the event in a backward compatible way.
 */
function cancelEvent(ev) {
    ev.stopPropagation(); // prevent bubbling of event to any parent incl. the background
    ev.preventDefault(); // prevent the default action on event, e.g., scrolling
    ev.returnValue = false; // for backward compatibility
    return false; // for backward compatibility
}

/**
 * Generates UUID for UWR elements
 * Based on https://jsfiddle.net/briguy37/2MVFd/
 */
function generateUUID() {
    /* eslint-disable */
    var d = new Date().getTime();
    var uuid = 'uuid-xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r&0x3|0x8)).toString(16);
    });
    return uuid;
    /* eslint-enable */
}

// IE8 Array.prototype.forEach polyfill
// Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Polyfill
// License: CC0 1.0 https://creativecommons.org/publicdomain/zero/1.0/
function forEach() {
    /* eslint-disable */

    if (Array.prototype.forEach) {
        return Array.prototype.forEach.apply(this, arguments);
    }

    var callback = arguments[0],
        thisArg = arguments[1],
        T,
        k,
        O,
        len,
        kValue;

    if (this === null) {
        throw new TypeError(' this is null or not defined');
    }

    O = Object(this);
    len = O.length >>> 0;

    if (typeof callback !== 'function') {
        throw new TypeError(callback + ' is not a function');
    }

    if (arguments.length > 1) {
        T = thisArg;
    }

    k = 0;

    while (k < len) {
        if (k in O) {
            kValue = O[k];
            callback.call(T, kValue, k, O);
        }
        k++;
    }
    /* eslint-enable */
}

// IE8 Array.prototype.filter polyfill
// Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter#Polyfill
// License: CC0 1.0 https://creativecommons.org/publicdomain/zero/1.0/
// eslint-disable-next-line complexity
function filter() {
    /* eslint-disable */

    var fun = arguments[0],
        t,
        len,
        res,
        thisArg,
        i,
        val;

    if (Array.prototype.filter) {
        return Array.prototype.filter.apply(this, arguments);
    }

    if (this === void 0 || this === null) {
        throw new TypeError();
    }

    t = Object(this);
    len = t.length >>> 0;
    if (typeof fun !== 'function') {
        throw new TypeError();
    }

    res = [];
    thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (i = 0; i < len; i++) {
        if (i in t) {
            val = t[i];

            if (fun.call(thisArg, val, i, t)) {
                res.push(val);
            }
        }
    }

    return res;
    /* eslint-enable */
}

// IE8 Element.prototype.textContent polyfill
function textContent(element, text) {
    if (arguments.length === 1) {
        return element.textContent || element.innerText;
    }

    if (element.textContent) {
        element.textContent = text;
    } else {
        element.innerText = text;
    }

}

// IE8 String.prototype.trim polyfill
// Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
// License: CC0 1.0 https://creativecommons.org/publicdomain/zero/1.0/
function trim() {
    if (String.prototype.trim) {
        return String.prototype.trim.apply(this, arguments);
    }

    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}

/** IE8 Array.prototype.indexOf polyfill
 * Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf#Polyfill
 * License: CC0 1.0 https://creativecommons.org/publicdomain/zero/1.0/
 */
// eslint-disable-next-line complexity
function indexOf(searchElement, fromIndex) {
    if (Array.prototype.indexOf) {
        return Array.prototype.indexOf.call(this, searchElement, fromIndex);
    }

    /* eslint-disable */
    var k;

    // 1. Let o be the result of calling ToObject passing
    //    the this value as the argument.
    if (this == null) {
        throw new TypeError('"this" is null or not defined');
    }

    var o = Object(this);

    // 2. Let lenValue be the result of calling the Get
    //    internal method of o with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    var len = o.length >>> 0;

    // 4. If len is 0, return -1.
    if (len === 0) {
        return -1;
    }

    // 5. If argument fromIndex was passed let n be
    //    ToInteger(fromIndex); else let n be 0.
    var n = fromIndex | 0;

    // 6. If n >= len, return -1.
    if (n >= len) {
        return -1;
    }

    // 7. If n >= 0, then Let k be n.
    // 8. Else, n<0, Let k be len - abs(n).
    //    If k is less than 0, then let k be 0.
    k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

    // 9. Repeat, while k < len
    while (k < len) {
        // a. Let Pk be ToString(k).
        //   This is implicit for LHS operands of the in operator
        // b. Let kPresent be the result of calling the
        //    HasProperty internal method of o with argument Pk.
        //   This step can be combined with c
        // c. If kPresent is true, then
        //    i.  Let elementK be the result of calling the Get
        //        internal method of o with the argument ToString(k).
        //   ii.  Let same be the result of applying the
        //        Strict Equality Comparison Algorithm to
        //        searchElement and elementK.
        //  iii.  If same is true, return k.
        if (k in o && o[k] === searchElement) {
            return k;
        }
        k++;
    }
    return -1;
    /* eslint-enable */
}

// IE8 Array.prototype.map polyfill
// Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map#Polyfill
// License: CC0 1.0 https://creativecommons.org/publicdomain/zero/1.0/
// Production steps of ECMA-262, Edition 5, 15.4.4.19
// Reference: http://es5.github.io/#x15.4.4.19
function map(callback, thisArg) {
    /* eslint-disable */
    if (Array.prototype.map) {
        return Array.prototype.map.apply(this, arguments);
    }

    var T, A, k;

    if (this == null) {
        throw new TypeError(' this is null or not defined');
    }

    // 1. Let O be the result of calling ToObject passing the |this|
    //    value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get internal
    //    method of O with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If IsCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
        throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
    if (arguments.length > 1) {
        T = thisArg;
    }

    // 6. Let A be a new array created as if by the expression new Array(len)
    //    where Array is the standard built-in constructor with that name and
    //    len is the value of len.
    A = new Array(len);

    // 7. Let k be 0
    k = 0;

    // 8. Repeat, while k < len
    while (k < len) {

        var kValue, mappedValue;

        // a. Let Pk be ToString(k).
        //   This is implicit for LHS operands of the in operator
        // b. Let kPresent be the result of calling the HasProperty internal
        //    method of O with argument Pk.
        //   This step can be combined with c
        // c. If kPresent is true, then
        if (k in O) {

            // i. Let kValue be the result of calling the Get internal
            //    method of O with argument Pk.
            kValue = O[k];

            // ii. Let mappedValue be the result of calling the Call internal
            //     method of callback with T as the this value and argument
            //     list containing kValue, k, and O.
            mappedValue = callback.call(T, kValue, k, O);

            // iii. Call the DefineOwnProperty internal method of A with arguments
            // Pk, Property Descriptor
            // { Value: mappedValue,
            //   Writable: true,
            //   Enumerable: true,
            //   Configurable: true },
            // and false.

            // In browsers that support Object.defineProperty, use the following:
            // Object.defineProperty(A, k, {
            //   value: mappedValue,
            //   writable: true,
            //   enumerable: true,
            //   configurable: true
            // });

            // For best browser support, use the following:
            A[k] = mappedValue;
        }
        // d. Increase k by 1.
        k++;
    }

    // 9. return A
    return A;
    /* eslint-enable */
}

/**
 * Clones an object with omiting provided properties
 * @param {object} object
 * @param {string[]} keys
 * @returns {object}
 */
function omit(object, keys) {
    return Object.keys(object).reduce(function (result, key) {
        if (!keys || keys.indexOf(key) < 0) {
            result[key] = object[key];
        }
        return result;
    }, {});
}

/**
 * Returns true if parameter can be iterated.
 * @param {*} obj
 */
function canBeIterated(obj) {
    return Array.isArray(obj) || obj instanceof __WEBPACK_IMPORTED_MODULE_0_jquery___default.a || obj instanceof NodeList;
}

/**
 * Returns the array of nodes based on given selector or object.
 * @param {*} selectorOrObject CSS Selector string or object which can be Node or JQuery element or a collection of them
 * @returns {Array} an array of elements which can be iterated
 */
function getNodeArray(selectorOrObject) {
    var nodeArray = [];
    if (typeof selectorOrObject === 'string') {
        selectorOrObject = document.querySelectorAll(selectorOrObject);
    }
    if (canBeIterated(selectorOrObject)) {
        forEach.call(selectorOrObject, function (elem) {
            if (elem instanceof Node) {
                nodeArray.push(elem);
            } else if (elem instanceof __WEBPACK_IMPORTED_MODULE_0_jquery___default.a) {
                nodeArray.push(elem[0]);
            }
        });
    } else if (selectorOrObject instanceof __WEBPACK_IMPORTED_MODULE_0_jquery___default.a || selectorOrObject instanceof Node) {
        nodeArray = [selectorOrObject];
    }
    return nodeArray;
}

/**
 * Normalize optional selectorOrCallback and callback parameters and returns the nodeArray and callback.
 * @param {*} defaultSelector is the default selector, if selector is not defined.
 * @param {*} Widget widget constructor
 * @param {*} selectorOrCallback is an optional parameter which can be a CSS Selector string
 * or a callback function if callback parameter is not defined.
 * @param {*} callback is an optional callback function if selectorOrCallback is CSS Selector string.
 */
function initWidget(defaultSelector, Widget, selectorOrCallback, callback) {
    var callbackWithoutSelector = callback === undefined && typeof selector === 'function',
        selector = selectorOrCallback === undefined || callbackWithoutSelector ? defaultSelector : selectorOrCallback,
        widgets = getNodeArray(selector).map(function (node) {
            return new Widget(node).init();
        });

    invoke(callbackWithoutSelector ? selectorOrCallback : callback);
    return widgets.length === 1 ? widgets[0] : widgets;
}

/**
 * Moves markup element out from wrapper container and place it before the container.
 *
 * @param markup {Node} is a living element in DOM
 * @param container {Node} is a living element in DOM
 */
function unwrapMarkup(markup, container) {
    if (container && container.parentNode) {
        container.parentNode.insertBefore(markup, container);
        container.parentNode.removeChild(container);
    }
}

/**
 * Returns the size of an element and its position relative to the viewport in an object if the element is bound to a
 * DOM element. Otherwise method returns undefined.
 * @param {*} el is a DOM element
 */
function getBoundingClientRect(el) {
    var boundingClientRect;
    try {
        boundingClientRect = el.getBoundingClientRect();
    /* eslint-disable no-empty */
    } catch (e) { }
    /* eslint-enable no-empty */
    return boundingClientRect;
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * mustache.js - Logic-less {{mustache}} templates with JavaScript
 * http://github.com/janl/mustache.js
 */

/*global define: false*/

(function (root, factory) {
  if (typeof exports === "object" && exports) {
    factory(exports); // CommonJS
  } else {
    var mustache = {};
    factory(mustache);
    if (true) {
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (mustache),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // AMD
    } else {
      root.Mustache = mustache; // <script>
    }
  }
}(this, function (mustache) {

  var whiteRe = /\s*/;
  var spaceRe = /\s+/;
  var nonSpaceRe = /\S/;
  var eqRe = /\s*=/;
  var curlyRe = /\s*\}/;
  var tagRe = /#|\^|\/|>|\{|&|=|!/;

  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
  // See https://github.com/janl/mustache.js/issues/189
  var RegExp_test = RegExp.prototype.test;
  function testRegExp(re, string) {
    return RegExp_test.call(re, string);
  }

  function isWhitespace(string) {
    return !testRegExp(nonSpaceRe, string);
  }

  var Object_toString = Object.prototype.toString;
  var isArray = Array.isArray || function (object) {
    return Object_toString.call(object) === '[object Array]';
  };

  function isFunction(object) {
    return typeof object === 'function';
  }

  function escapeRegExp(string) {
    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
  }

  var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': '&quot;',
    "'": '&#39;',
    "/": '&#x2F;'
  };

  function escapeHtml(string) {
    return String(string).replace(/[&<>"'\/]/g, function (s) {
      return entityMap[s];
    });
  }

  function escapeTags(tags) {
    if (!isArray(tags) || tags.length !== 2) {
      throw new Error('Invalid tags: ' + tags);
    }

    return [
      new RegExp(escapeRegExp(tags[0]) + "\\s*"),
      new RegExp("\\s*" + escapeRegExp(tags[1]))
    ];
  }

  /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all template text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices
   * in the original template of the token, respectively.
   *
   * Tokens that are the root node of a subtree contain two more elements: an
   * array of tokens in the subtree and the index in the original template at which
   * the closing tag for that section begins.
   */
  function parseTemplate(template, tags) {
    tags = tags || mustache.tags;
    template = template || '';

    if (typeof tags === 'string') {
      tags = tags.split(spaceRe);
    }

    var tagRes = escapeTags(tags);
    var scanner = new Scanner(template);

    var sections = [];     // Stack to hold section tokens
    var tokens = [];       // Buffer to hold the tokens
    var spaces = [];       // Indices of whitespace tokens on the current line
    var hasTag = false;    // Is there a {{tag}} on the current line?
    var nonSpace = false;  // Is there a non-space char on the current line?

    // Strips all whitespace tokens array for the current line
    // if there was a {{#tag}} on it and otherwise only space.
    function stripSpace() {
      if (hasTag && !nonSpace) {
        while (spaces.length) {
          delete tokens[spaces.pop()];
        }
      } else {
        spaces = [];
      }

      hasTag = false;
      nonSpace = false;
    }

    var start, type, value, chr, token, openSection;
    while (!scanner.eos()) {
      start = scanner.pos;

      // Match any text between tags.
      value = scanner.scanUntil(tagRes[0]);
      if (value) {
        for (var i = 0, len = value.length; i < len; ++i) {
          chr = value.charAt(i);

          if (isWhitespace(chr)) {
            spaces.push(tokens.length);
          } else {
            nonSpace = true;
          }

          tokens.push(['text', chr, start, start + 1]);
          start += 1;

          // Check for whitespace on the current line.
          if (chr === '\n') {
            stripSpace();
          }
        }
      }

      // Match the opening tag.
      if (!scanner.scan(tagRes[0])) break;
      hasTag = true;

      // Get the tag type.
      type = scanner.scan(tagRe) || 'name';
      scanner.scan(whiteRe);

      // Get the tag value.
      if (type === '=') {
        value = scanner.scanUntil(eqRe);
        scanner.scan(eqRe);
        scanner.scanUntil(tagRes[1]);
      } else if (type === '{') {
        value = scanner.scanUntil(new RegExp('\\s*' + escapeRegExp('}' + tags[1])));
        scanner.scan(curlyRe);
        scanner.scanUntil(tagRes[1]);
        type = '&';
      } else {
        value = scanner.scanUntil(tagRes[1]);
      }

      // Match the closing tag.
      if (!scanner.scan(tagRes[1])) {
        throw new Error('Unclosed tag at ' + scanner.pos);
      }

      token = [ type, value, start, scanner.pos ];
      tokens.push(token);

      if (type === '#' || type === '^') {
        sections.push(token);
      } else if (type === '/') {
        // Check section nesting.
        openSection = sections.pop();

        if (!openSection) {
          throw new Error('Unopened section "' + value + '" at ' + start);
        }
        if (openSection[1] !== value) {
          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
        }
      } else if (type === 'name' || type === '{' || type === '&') {
        nonSpace = true;
      } else if (type === '=') {
        // Set the tags for the next time around.
        tagRes = escapeTags(tags = value.split(spaceRe));
      }
    }

    // Make sure there are no open sections when we're done.
    openSection = sections.pop();
    if (openSection) {
      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
    }

    return nestTokens(squashTokens(tokens));
  }

  /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */
  function squashTokens(tokens) {
    var squashedTokens = [];

    var token, lastToken;
    for (var i = 0, len = tokens.length; i < len; ++i) {
      token = tokens[i];

      if (token) {
        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
          lastToken[1] += token[1];
          lastToken[3] = token[3];
        } else {
          squashedTokens.push(token);
          lastToken = token;
        }
      }
    }

    return squashedTokens;
  }

  /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */
  function nestTokens(tokens) {
    var nestedTokens = [];
    var collector = nestedTokens;
    var sections = [];

    var token, section;
    for (var i = 0, len = tokens.length; i < len; ++i) {
      token = tokens[i];

      switch (token[0]) {
      case '#':
      case '^':
        collector.push(token);
        sections.push(token);
        collector = token[4] = [];
        break;
      case '/':
        section = sections.pop();
        section[5] = token[2];
        collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
        break;
      default:
        collector.push(token);
      }
    }

    return nestedTokens;
  }

  /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */
  function Scanner(string) {
    this.string = string;
    this.tail = string;
    this.pos = 0;
  }

  /**
   * Returns `true` if the tail is empty (end of string).
   */
  Scanner.prototype.eos = function () {
    return this.tail === "";
  };

  /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */
  Scanner.prototype.scan = function (re) {
    var match = this.tail.match(re);

    if (match && match.index === 0) {
      var string = match[0];
      this.tail = this.tail.substring(string.length);
      this.pos += string.length;
      return string;
    }

    return "";
  };

  /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */
  Scanner.prototype.scanUntil = function (re) {
    var index = this.tail.search(re), match;

    switch (index) {
    case -1:
      match = this.tail;
      this.tail = "";
      break;
    case 0:
      match = "";
      break;
    default:
      match = this.tail.substring(0, index);
      this.tail = this.tail.substring(index);
    }

    this.pos += match.length;

    return match;
  };

  /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */
  function Context(view, parentContext) {
    this.view = view == null ? {} : view;
    this.cache = { '.': this.view };
    this.parent = parentContext;
  }

  /**
   * Creates a new context using the given view with this context
   * as the parent.
   */
  Context.prototype.push = function (view) {
    return new Context(view, this);
  };

  /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */
  Context.prototype.lookup = function (name) {
    var value;
    if (name in this.cache) {
      value = this.cache[name];
    } else {
      var context = this;

      while (context) {
        if (name.indexOf('.') > 0) {
          value = context.view;

          var names = name.split('.'), i = 0;
          while (value != null && i < names.length) {
            value = value[names[i++]];
          }
        } else {
          value = context.view[name];
        }

        if (value != null) break;

        context = context.parent;
      }

      this.cache[name] = value;
    }

    if (isFunction(value)) {
      value = value.call(this.view);
    }

    return value;
  };

  /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */
  function Writer() {
    this.cache = {};
  }

  /**
   * Clears all cached templates in this writer.
   */
  Writer.prototype.clearCache = function () {
    this.cache = {};
  };

  /**
   * Parses and caches the given `template` and returns the array of tokens
   * that is generated from the parse.
   */
  Writer.prototype.parse = function (template, tags) {
    var cache = this.cache;
    var tokens = cache[template];

    if (tokens == null) {
      tokens = cache[template] = parseTemplate(template, tags);
    }

    return tokens;
  };

  /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   */
  Writer.prototype.render = function (template, view, partials) {
    var tokens = this.parse(template);
    var context = (view instanceof Context) ? view : new Context(view);
    return this.renderTokens(tokens, context, partials, template);
  };

  /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */
  Writer.prototype.renderTokens = function (tokens, context, partials, originalTemplate) {
    var buffer = '';

    // This function is used to render an arbitrary template
    // in the current context by higher-order sections.
    var self = this;
    function subRender(template) {
      return self.render(template, context, partials);
    }

    var token, value;
    for (var i = 0, len = tokens.length; i < len; ++i) {
      token = tokens[i];

      switch (token[0]) {
      case '#':
        value = context.lookup(token[1]);
        if (!value) continue;

        if (isArray(value)) {
          for (var j = 0, jlen = value.length; j < jlen; ++j) {
            buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
          }
        } else if (typeof value === 'object' || typeof value === 'string') {
          buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
        } else if (isFunction(value)) {
          if (typeof originalTemplate !== 'string') {
            throw new Error('Cannot use higher-order sections without the original template');
          }

          // Extract the portion of the original template that the section contains.
          value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);

          if (value != null) buffer += value;
        } else {
          buffer += this.renderTokens(token[4], context, partials, originalTemplate);
        }

        break;
      case '^':
        value = context.lookup(token[1]);

        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || (isArray(value) && value.length === 0)) {
          buffer += this.renderTokens(token[4], context, partials, originalTemplate);
        }

        break;
      case '>':
        if (!partials) continue;
        value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) buffer += this.renderTokens(this.parse(value), context, partials, value);
        break;
      case '&':
        value = context.lookup(token[1]);
        if (value != null) buffer += value;
        break;
      case 'name':
        value = context.lookup(token[1]);
        if (value != null) buffer += mustache.escape(value);
        break;
      case 'text':
        buffer += token[1];
        break;
      }
    }

    return buffer;
  };

  mustache.name = "mustache.js";
  mustache.version = "0.8.1";
  mustache.tags = [ "{{", "}}" ];

  // All high-level mustache.* functions use this writer.
  var defaultWriter = new Writer();

  /**
   * Clears all cached templates in the default writer.
   */
  mustache.clearCache = function () {
    return defaultWriter.clearCache();
  };

  /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */
  mustache.parse = function (template, tags) {
    return defaultWriter.parse(template, tags);
  };

  /**
   * Renders the `template` with the given `view` and `partials` using the
   * default writer.
   */
  mustache.render = function (template, view, partials) {
    return defaultWriter.render(template, view, partials);
  };

  // This is here for backwards compatibility with 0.4.x.
  mustache.to_html = function (template, view, partials, send) {
    var result = mustache.render(template, view, partials);

    if (isFunction(send)) {
      send(result);
    } else {
      return result;
    }
  };

  // Export the escaping function so that the user may override it.
  // See https://github.com/janl/mustache.js/issues/244
  mustache.escape = escapeHtml;

  // Export these mainly for testing, but also for advanced usage.
  mustache.Scanner = Scanner;
  mustache.Context = Context;
  mustache.Writer = Writer;

}));


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export arePlainObjects */
/* harmony export (immutable) */ __webpack_exports__["c"] = assign;
/* harmony export (immutable) */ __webpack_exports__["b"] = retrieve;
/* unused harmony export shortcut */
/* harmony export (immutable) */ __webpack_exports__["a"] = getUwrResourcePath;
/* harmony export (immutable) */ __webpack_exports__["d"] = merge;
/**
 * Are arguments objects or not?
 */
function arePlainObjects() {
    var result = true,
        i;
    for(i = 0; i < arguments.length; i++) {
        result = (
            typeof arguments[i] === 'object'
            && (
                (Object.getPrototypeOf && Object.getPrototypeOf(arguments[i]) === {})
                || arguments[i].constructor === Object // IE8 fallback
            )
        );
        if (!result) { break; }
    }
    return result;
}

/**
 * Puts a value under a given namespace.
 */
function assign(namespace, data) {
    var i,
        obj = window,
        parts = namespace.split('.'),
        len = parts.length;
    for (i = 0; i < len; i++) {
        if (obj === null || typeof obj !== 'object' && typeof obj !== 'function') {
            throw new Error('No subitem can be defined in a non-object element: ' + namespace);
        }
        if (i === len - 1) {
            if (arePlainObjects(obj[parts[i]], data)) {
                obj[parts[i]] = merge(obj[parts[i]], data);
            } else {
                obj[parts[i]] = data;
            }
        } else if (typeof obj[parts[i]] === 'undefined') {
            obj[parts[i]] = {};
        }
        obj = obj[parts[i]];
    }
}

/**
 * Gets a value from the given namespace.
 */
function retrieve(namespace) {
    var i,
        obj = window,
        parts = namespace.split('.');
    for (i = 0; i < parts.length; i++) {
        obj = obj[parts[i]];
        if (obj === undefined) {
            break;
        }
    }
    return obj;
}

/**
 * This function provides shortcut functions to a module's API functions
 *
 * The attrs parameter is an object with the below properties:
 * - 'module': the module's name,
 * - 'namespace': the namespace string under which the functions will be exposed,
 * - 'apiFunctions': an array of function names to expose in the module under the given namespace
 *    as public API functions.
 *
 * E.g.:
 * shortcut({
 *     module: dataTable,
 *     namespace: 'uwr.datatable',
 *     apiFunctions: ['fill', 'sort']
 * });
 * will create the following shortcut methods: uwr.datatable.fill(), uwr.datatable.sort()
 * and they will delegate the call to the respective methods of the given module.
 */
function shortcut(attrs) {
    var moduleName = attrs.module,
        namespace = attrs.namespace,
        functionName,
        functionNames = attrs.apiFunctions,
        i,
        len = functionNames.length;
    for (i = 0; i < len; i++) {
        functionName = functionNames[i];
        assign(namespace + '.' + functionName, moduleName[functionName]);
    }
}

/**
 * Returns the full resource URL of uwr.js that is used on the page.
 * On IE7 and older, for relative paths it will return the same relative path.
 * If uwr.js is loaded with src="http://ubs.com/main/uwr.js" in the script tag, then this method
 * returns 'http://ubs.com/main'.
 * If uwr.js is loaded with "lib/uwr.js", then this method will still return the full URL of the resource,
 * e.g., 'http://ubs.com/main/lib' (in IE7 it would be "lib").
 */
function getUwrResourcePath() {
    var scripts = document.getElementsByTagName('script'),
        script,
        src,
        uwrJsPath = '',
        i,
        foundAt;
    for (i = 0; i < scripts.length; i++) {
        script = scripts.item(i);
        src = script.src;
        if (src && (foundAt = src.indexOf('/uwr.js')) !== -1) {
            uwrJsPath = src.substring(0, foundAt);
            break;
        }
    }
    return uwrJsPath;
}

function mergeObjects(obj1, obj2) {
    var prop;
    for (prop in obj2) {
        if (obj2.hasOwnProperty(prop)) {
            if(arePlainObjects(obj1[prop], obj2[prop])) {
                obj1[prop] = mergeObjects(obj1[prop], obj2[prop]);
            } else {
                obj1[prop] = obj2[prop];
            }
        }
    }
    return obj1;
}

/**
 * Merges the properties of objects into the first object. The objects will be merged one after the other,
 * with the last one merged last. Non-object arguments will be skipped. The first argument must be an object,
 * otherwise undefined will be returned. The merging goes in-depth, the objects within the parameter objects are
 * merged too.
 * @param {object} The target object.
 * @param {...object} The objects to merge into the target object.
 * @return {object} The first argument with all the other objects merged into that. If there are no arguments
 *      or the first one is not an object, undefined will return.
 */
function merge() {
    var target,
        i,
        obj;

    if (arguments.length > 0 && arePlainObjects(arguments[0])) {
        target = arguments[0];
        for (i = 1; i < arguments.length; i++) {
            obj = arguments[i];
            if (arePlainObjects(obj)) {
                mergeObjects(target, obj);
            }
        }
    }
    return target;
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "message", function() { return message; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_input_less__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_input_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_input_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__features_styles_formatter_less__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__features_styles_formatter_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__features_styles_formatter_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loader_util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_modules_support__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mustache__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inputView__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inputMessageUtil__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__features_js_formatter__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_modules_domchange__ = __webpack_require__(5);
/**
 * A class which represents a New Form Design Input widget.
 * This defines the structure and the main behavior of the widget.
 *
 * The Input has a special feature which requires some additional cooperation with its features. To increase the
 * customization level a feature can extend or overwrite the parameters of a context object provided by the widget.
 *
 * Context items:
 * -fieldSyncFunction: A feature could change the value of the original field on blur.
 *                     function(originalInputField, visibleInputField)
 *
 * @param $markup The jQuery element which is the Input markup.
 */













function Input(markup) {
    var $markup = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(markup),
        $view,
        mutationObserver,
        behaviorContext;

    /**
     * @return the placeholder text of the input field
     */
    function getPlaceholderText() {
        var placeholderText = markup.getAttribute('placeholder');
        if (placeholderText) {
            markup.setAttribute('data-placeholder', placeholderText);
            markup.removeAttribute('placeholder');
        }
        return placeholderText || markup.getAttribute('data-placeholder');
    }

    /**
     * @return the label text of the input field
     */
    function getLabelText() {
        return $markup.attr('data-label');
    }

    /**
     * @param visibleInputField Optional. The event which can influence the state outcome. (For focus/blur).
     * @return the state of the input field
     */
    /* eslint-disable complexity */
    function getState(stateHolderElement) {
        var disabled = stateHolderElement.hasAttribute('disabled') ? 'disabled' : undefined,
            readonly = stateHolderElement.hasAttribute('readonly') ? 'readonly' : undefined,
            focus = __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["w" /* hasFocus */](stateHolderElement) ? 'focus' : undefined;
        return disabled || readonly || focus || 'blur';
    }
    /* eslint-enable complexity */

    function addAllEventListeners(target) {
        target.addEventListener('input', inputHandler);
        target.addEventListener('change', inputHandler);
        if (__WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["u" /* isIe9 */]()) {
            target.addEventListener('keyup', inputHandler);
            target.addEventListener('blur', inputHandler);
        }
        target.addEventListener('focus', stateHandler);
        target.addEventListener('blur', stateHandler);
    }

    function removeAllEventListeners(target) {
        target.removeEventListener('input', inputHandler);
        target.removeEventListener('change', inputHandler);
        if (__WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["u" /* isIe9 */]()) {
            target.removeEventListener('keyup', inputHandler);
            target.removeEventListener('blur', inputHandler);
        }
        target.removeEventListener('focus', stateHandler);
        target.removeEventListener('blur', stateHandler);
    }

    /**
     * Input handler
     */
    function inputHandler(event) {
        var eventTarget = event.target,
            hasValue = !!eventTarget.value.length;
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_modules_support__["a" /* isInputFiredOnPlaceholderDelete */])(event) || !__WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["r" /* isNodeDetached */](eventTarget)) {
            updateLabelTextsInView(getView(), hasValue);
        }
    }

    function stateHandler(event) {
        var state = getState(event.target);
        $view.removeClass('uwr-input-blur uwr-input-focus uwr-input-readonly uwr-input-disabled');
        $view.addClass('uwr-input-' + state);
    }

    function getButtonIconSelector() {
        return __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["h" /* data */]($markup, 'icon-button-selector');
    }

    function setButtonIcon() {
        var iconButtonSelector = getButtonIconSelector(),
            button = document.querySelector(iconButtonSelector),
            afterPlaceholderBox = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.uwr-input-after', $view).get(0);

        if (iconButtonSelector) {
            /* TODO
             * button replacement or different mechanism to add or remove button (multiple button support required)
             */
            if (afterPlaceholderBox && button) {
                __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["o" /* addClass */](button, 'uwr-input-icon');
                afterPlaceholderBox.appendChild(button);
                __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["o" /* addClass */](afterPlaceholderBox.parentNode, 'uwr-input-has-button');
            } else {
                __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["n" /* removeClass */](afterPlaceholderBox.parentNode, 'uwr-input-has-button');
            }
        }
    }

    function updateLabelTextsInView(inputViewContainer, hasValue) {
        var labelText = getLabelText() || '',
            placeholderText = getPlaceholderText() || '',
            label = inputViewContainer.querySelector('.uwr-input-label'),
            placeholder = inputViewContainer.querySelector('.uwr-input-placeholder');

        if (hasValue) {
            __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["o" /* addClass */](inputViewContainer, 'uwr-input-has-value');
        } else {
            __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["n" /* removeClass */](inputViewContainer, 'uwr-input-has-value');
        }

        if (!placeholderText) {
            if (hasValue) {
                __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["n" /* removeClass */](label, 'uwr-input-label-bottom');
                __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["o" /* addClass */](label, 'uwr-input-label-top');
            } else {
                __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["n" /* removeClass */](label, 'uwr-input-label-top');
                __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["o" /* addClass */](label, 'uwr-input-label-bottom');
            }
        }

        __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["x" /* textContent */](placeholder, placeholderText);
        __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["x" /* textContent */](label, labelText);
    }

    function getView() {
        return $markup.closest('.uwr-input-container')[0];
    }

    function handleValueChange() {
        updateLabelTextsInView(getView(), markup.value.length > 0);
    }

    /**
     * Initialize widget view
     */
    function init() {
        var markup = $markup.get(0);

        if (!__WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["p" /* shouldBeInitialized */](markup)) {
            return;
        }

        behaviorContext = {
            visibleInputField: markup
        };

        $view = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_7__inputView__["a" /* default */].inputContainer, {
            state: getState(markup),
            value: $markup.value,
            messageIcon: __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["h" /* data */](markup, 'message')
        }));
        updateLabelTextsInView($view[0], !!$markup.val().length);
        $markup.after($view);
        $view.find('.uwr-input-content').prepend($markup);

        // initialize icon button before MessageBox to proper tip position
        setButtonIcon();

        // Run feature initialization before adding any listeners (feature changes should run before acting here)
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__loader_util__["d" /* merge */])(behaviorContext,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__inputMessageUtil__["a" /* init */])($markup),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__features_js_formatter__["a" /* init */])($markup)
        );

        // The visibleInputField is set or modified by the features. Now it can be decorated.
        __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["o" /* addClass */](behaviorContext.visibleInputField, 'uwr-input-visible-input');
        if (getState(behaviorContext.visibleInputField) !== 'disabled') {
            addAllEventListeners(behaviorContext.visibleInputField);
        }

        mutationObserver = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared_modules_domchange__["a" /* addMutationHandlers */])(markup, {
            node: {
                'data-message': function (mutation) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__inputMessageUtil__["a" /* init */])(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(mutation.target));
                },
                'data-label': function (mutation) {
                    updateLabelTextsInView(getView(), mutation.target.value);
                },
                'data-placeholder': function (mutation) {
                    updateLabelTextsInView(getView(), mutation.target.value);
                },
                'placeholder': function (mutation) {
                    updateLabelTextsInView(getView(), mutation.target.value);
                },
                'data-icon-button-selector': setButtonIcon,
                'disabled': function (mutation) {
                    var view = $view.get(0);
                    if (mutation.target === null) { // attribute removed
                        __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["n" /* removeClass */](view, 'uwr-input-disabled');
                        __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["o" /* addClass */](view, 'uwr-input-' + getState(markup));
                        addAllEventListeners(behaviorContext.visibleInputField);
                    } else {
                        __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["n" /* removeClass */](view, 'uwr-input-blur');
                        __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["n" /* removeClass */](view, 'uwr-input-focus');
                        __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["n" /* removeClass */](view, 'uwr-input-readonly');
                        __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["o" /* addClass */](view, 'uwr-input-disabled');
                        removeAllEventListeners(behaviorContext.visibleInputField);
                    }
                }
            },
            properties: {
                value: handleValueChange
            }
        });

        __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["q" /* markInitialized */](markup);

        return this;
    }

    function cleanup() {
        if (mutationObserver) {
            mutationObserver.disconnect();
        }
        removeAllEventListeners(behaviorContext.visibleInputField);
        __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["y" /* unwrapMarkup */](markup, $view[0]);
        __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["n" /* removeClass */](markup, 'uwr-input-visible-input');
        __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["z" /* unmarkInitialized */](markup);

        return this;
    }

    return {
        init: init,
        cleanup: cleanup
    };
}

/**
 * Initialize the selected Input(s)
 * Supported use cases:
 *   - init();
 *   - init(callback);
 *   - init(selector);
 *   - init(selector, callback);
 * @param selector CSS selector string that returns the elements that need to be initialized.
 *   Optional: If not passed in, then all elements marked with "uwr-input" CSS class will be processed.
 * @param callback The function to run after initialization (optional).
 */
var init = __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["A" /* initWidget */].bind(null, '.uwr-input', Input);

var message = __WEBPACK_IMPORTED_MODULE_8__inputMessageUtil__["b" /* message */];


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addMutationHandlers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loader_util__ = __webpack_require__(3);



var noop = function () {};

function getMutationHandler(mutation, handlers) {
    if (mutation.type === 'childList' && typeof handlers.childList === 'function') {
        return handlers.childList;
    } else if (mutation.type === 'characterData' && typeof handlers.characterData === 'function') {
        return handlers.characterData;
    } else if (mutation.type === 'attributes' && typeof handlers[mutation.attributeName] === 'function') {
        return handlers[mutation.attributeName];
    }

    // In IE11 there is some bug with attributeFilter.
    // Attribute mutation record is emitted for an attribute which is not in the list
    return noop;
}

function updateObserverOptions(options, attribute) {
    if (attribute === 'childList') {
        options.childList = true;
    } else if (attribute === 'characterData') {
        options.characterData = true;
    } else {
        if (options.attributes) {
            options.attributeFilter.push(attribute);
        } else {
            options.attributes = true;
            options.attributeFilter = [attribute];
        }
    }
}

function getMutationRecordLikeFromEvent(event) {
    var mutationRecordLike;

    switch (event.type) {
        case 'DOMAttrModified':
            mutationRecordLike = {
                type: 'attributes',
                target: event.target,
                attributeName: event.attrName,
                oldValue: event.prevValue
            };
            break;
        case 'DOMSubtreeModified':
            mutationRecordLike = {
                type: 'childList',
                target: event.target
            };
            break;
        case 'DOMCharacterDataModified':
            mutationRecordLike = {
                type: 'characterData',
                target: event.target,
                oldValue: event.prevValue
            };
            break;
        default:
            mutationRecordLike = {};
    }

    return mutationRecordLike;
}

function setPropertyCallbacks(target, callbacks) {
    var targetPrototype = Object.getPrototypeOf(target),
        propertiesToWatch = Object.keys(callbacks);

    propertiesToWatch.forEach(function (propertyName) {
        var propDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, propertyName),
            newPropDescriptor;

        if (propDescriptor) {
            newPropDescriptor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__loader_util__["d" /* merge */])({}, propDescriptor);
            newPropDescriptor.set = function (newValue) {
                var oldValue = propDescriptor.get.call(target);
                if (oldValue !== newValue) {
                    propDescriptor.set.call(target, newValue);
                    callbacks[propertyName].call(target, newValue);
                }
            };
            Object.defineProperty(target, propertyName, newPropDescriptor);
        }
    });
}

function createObserverCallback(handlers) {
    return function (mutations) {
        mutations.forEach(function (mutation) {
            getMutationHandler(mutation, handlers)(mutation);
        });
    };
}

function prepareOptions(target, optionGroups, handlers) {
    var attribute,
        optionName,
        options = {},
        supportedOptions = ['subtree', 'attributeOldValue', 'characterDataOldValue'],
        i;

    for (i = 0; i < optionGroups.length && (optionName = optionGroups[i]); i++) {
        options[optionName] = {};

        if (optionName === 'properties') {
            setPropertyCallbacks(target, handlers[optionName]);
            continue;
        }

        for (attribute in handlers[optionName]) {
            if (handlers[optionName].hasOwnProperty(attribute)) {
                updateObserverOptions(options[optionName], attribute);
            }
        }

        options[optionName][optionName] = supportedOptions.indexOf(optionName) > -1;
    }

    return options;
}

/**
 * Add DOM change handlers to the target.
 *
 * @param {HTMLElement} target - The HTML node which DOM changes are observed.
 * @param {Object} handlers - An object that groups handler definitions by different Observer options
 * @example
 * var mutationObserver = domchange.addMutationObservers(element, {
 *     node: {
 *         'data-small': function (mutation) {
 *             // Will be called if data-small attribute is changed on target element
 *         },
 *         'data-size': function...
 *     },
 *     properties: {
 *         'value': function () {
 *             // Will be called if value property is changed on target element
 *         }
 *     },
 *     subtree: {
 *        'data-big': function (mutation) {
 *            // Will be called if data-big attribute is changed on any descendant element of target
 *        },
 *        childList: function (mutation) {
 *            // Will be called if any descendant element is added or removed of target. Including text nodes
 *        },
 *        characterData: function (mutation) {
 *            // Will be called if any descendant text node value is changed
 *        }
 *     }
 * });
 *
 * mutationObserver.byPass(function () {
 *     // Mutation observer is disabled here. You can make any DOM mutations without triggering handlers
 *     // on this observer instance
 * });
 *
 * // Shut down mutation observing
 * mutationObserver.disconnect();
 */
function addMutationObservers(target, handlers) {
    var connect,
        disconnect,
        observers = {},
        optionGroups = Object.keys(handlers),
        options = prepareOptions(target, optionGroups, handlers),
        optionName,
        i;

    for (i = 0; i < optionGroups.length && (optionName = optionGroups[i]); i++) {
        if (optionName !== 'properties') {
            observers[optionName] = new window.MutationObserver(createObserverCallback(handlers[optionName]));
        }
    }

    connect = function () {
        for (var optionName in observers) {
            if (observers.hasOwnProperty(optionName)) {
                observers[optionName].observe(target, options[optionName]);
            }
        }
    };
    disconnect = function () {
        for (var optionName in observers) {
            if (observers.hasOwnProperty(optionName)) {
                observers[optionName].disconnect();
            }
        }
    };

    connect();

    return {
        byPass: function (fn) {
            var result;
            disconnect();
            result = fn();
            connect();
            return result;
        },
        disconnect: disconnect
    };
}

function addMutationEvents(target, handlers) {
    var connect,
        disconnect,
        optionGroups = Object.keys(handlers),
        options = prepareOptions(target, optionGroups, handlers),
        disconnectListeners = {};

    connect = function () {
        for (var optionName in options) {
            if (options.hasOwnProperty(optionName)) {
                disconnectListeners[optionName] = addEventListeners(target, options[optionName], handlers[optionName]);
            }
        }
    };

    disconnect = function () {
        for (var optionName in disconnectListeners) {
            if (disconnectListeners.hasOwnProperty(optionName)) {
                disconnectListeners[optionName].disconnect();
            }
        }
    };

    connect();

    return {
        byPass: function (fn) {
            var result;
            disconnect();
            result = fn();
            connect();
            return result;
        },
        disconnect: disconnect
    };
}

function shouldHandleMutation(options, mutation) {
    var inOptions = mutation.type === 'childList'
            || mutation.type === 'characterData'
            || mutation.attributeName
            && options.attributeFilter.length
            && options.attributeFilter.indexOf(mutation.attributeName) > -1,
        // should a change on a child be handled
        isSubtreeOrTarget = options.subtree || mutation.target === options.target,
        // is it a DOMSubtreeModified event following a DOMAttrModified event for the same node
        subtreeAfterAttr = mutation.type === 'childList' && (options.lastAttrTarget === mutation.target);

    // workaround for DOMSubtreeModified event following a DOMAttrModified event for the same node
    if (inOptions && mutation.type === 'attributes') {
        options.lastAttrTarget = mutation.target;
    } else if (subtreeAfterAttr) {
        options.lastAttrTarget = null;
    }

    return inOptions && isSubtreeOrTarget && !subtreeAfterAttr && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["r" /* isNodeDetached */])(mutation.target);
}

function getEventHandler(options) {
    return function (event) {
        var mutation = getMutationRecordLikeFromEvent(event),
            handler = getMutationHandler(mutation, options.handlers);

        // should handle constraints implicitly existing in mutation observers
        if (shouldHandleMutation(options, mutation)) {
            handler(mutation);
        }
    };
}

function getEventNameOfType(type) {
    var eventListenersForTypes = {
        childList: 'DOMSubtreeModified',
        characterData: 'DOMCharacterDataModified',
        attributes: 'DOMAttrModified'
    };
    return eventListenersForTypes[type];
}

function getListenersDisconnectFunction(target, listeners) {
    return function disconnectAllListeners() {
        for (var eventType in listeners) {
            if (listeners.hasOwnProperty(eventType)) {
                target.removeEventListener(eventType, listeners[eventType], true);
            }
        }
    };
}

function addEventListeners(target, optionGroup, allHandlers) {
    var eventHandler,
        disconnectListeners = {},
        optionKeys,
        eventType,
        eventName,
        i;

    optionKeys = Object.keys(optionGroup);

    for (i = 0; i < optionKeys.length; i++) {
        eventType = optionKeys[i];

        optionGroup.target = target;
        optionGroup.handlers = allHandlers;
        eventHandler = getEventHandler(optionGroup);
        eventName = getEventNameOfType(eventType);
        target.addEventListener(eventName, eventHandler, true);
        disconnectListeners[eventName] = eventHandler;
    }

    return {
        disconnect: getListenersDisconnectFunction(target, disconnectListeners)
    };
}

function addMutationHandlers(target, handlers) {
    if (window.MutationObserver) {
        return addMutationObservers(target, handlers);
    }
    if (window.addEventListener) {
        return addMutationEvents(target, handlers);
    }
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getDocument;
/* unused harmony export isAccessible */
/* unused harmony export isTopAccessibleAncestor */
/* harmony export (immutable) */ __webpack_exports__["a"] = getTargetFrameForOverlay;
/* unused harmony export getVisibleClientRectOfFrames */
/* harmony export (immutable) */ __webpack_exports__["e"] = getVisibleClientRect;
/* harmony export (immutable) */ __webpack_exports__["c"] = innerWidth;
/* harmony export (immutable) */ __webpack_exports__["d"] = innerHeight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(1);



/**
 * Returns the document object of the given DOM node (e.g. frame).
 * Note that this may throw an error, if the a frame's content comes from a different domain or, e.g., about:blank.
 * Those errors must be handled (e.g., caught) by caller.
 */
function getDocument(frame) {
    return frame.document || frame.contentDocument || frame.contentWindow.document;
}

/**
 * Tells that a frame is accessible (and writeable) or not - for example because of cross domain restrictions.
 */
function isAccessible(frame) {
    var isOk = false,
        varName = 'uwrFrameVar';
    try {
        // If a frame breaks the 'same origin policy' this line will result in a permission denied error.
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(frame);
        frame.location;
        getDocument(frame);

        // Check if the frame is writable.
        frame[varName] = 13;
        isOk = frame[varName] === 13;
        frame[varName] = undefined;
    } catch (e) {
        isOk = false;
    }
    return isOk;
}

function isTopAccessibleAncestor(win) {
    return win === win.parent || !isAccessible(win.parent);
}

function isUwrLoadedIn(frame) {
    return !!(frame.uwr && frame.uwr.version);
}

/**
 * Get the parent frame of the currentFrame, if it is accessible by the script.
 */
function getAccessibleParentFrame(currentFrame) {
    var targetFrame;
    if (isAccessible(currentFrame.parent)) {
        targetFrame = currentFrame.parent;
    }
    return targetFrame;
}

/**
 * Get the array of the accessible frames in a top-down order. UWR loaded is not checked.
 */
function getAccessibleFramesInHierarchy(frame) {
    var lastFrame = frame,
        ancestorFrames = [];
    ancestorFrames.push(lastFrame);

    while (window.top !== lastFrame && lastFrame !== undefined) {
        lastFrame = getAccessibleParentFrame(lastFrame);
        if (lastFrame !== undefined) {
            ancestorFrames.push(lastFrame);
        }
    }

    ancestorFrames.reverse();
    return ancestorFrames;
}

/**
 * Returns the top or the topmost accessible frame starting from the actual window frame. Accessible means writable
 * and the additional conditions based on the given configuration. The method stops at the first inaccessible frame.
 * @param {object} config An object which contains parameters to set up additional conditions for the
 *                 availability check.
 *                 Current parameters:
 *                 - uwrLoaded: the frame contains a loaded uwr library or not
 * @return {object} The topmost available HTML frame starting from the actual window frame.
 */
function getTargetFrameForOverlay(config) {
    var targetFrame,
        availableFrames;
    if (!config) {
        config = {};
    }
    if (isAccessible(window.top) && (config.uwrLoaded !== true || isUwrLoadedIn(window.top))) {
        targetFrame = window.top;
    } else {
        availableFrames = getAccessibleFramesInHierarchy(window);
        targetFrame = availableFrames.shift();
        if (config.uwrLoaded === true) {
            while (!isUwrLoadedIn(targetFrame)) {
                targetFrame = availableFrames.shift();
            }
        }
    }
    return targetFrame;
}

/**
 * Get DOMRect dimension object of the frame. With IE8- support.
 * @param {object} The frame of which parameters are needed.
 * @return The DOMRect object of the frame.
 */
function getBoundingClientRect(frame) {
    var frameEl = isAccessible(frame.parent) ? frame.frameElement : null,
        documentEl,
        bcr;

    if (frameEl === null) {
        documentEl = frame.document.documentElement;
        bcr = {
            bottom: frame.innerHeight || documentEl.clientHeight,
            height: frame.innerHeight || documentEl.clientHeight,
            left: 0,
            right: frame.innerWidth || documentEl.clientWidth,
            top: 0,
            width: frame.innerWidth || documentEl.clientWidth
        };
    } else {
        bcr = frameEl.getBoundingClientRect();
    }
    return bcr;
}

/**
 * Returns an object that contains sizes calculated (cumulated) from the values included in the input parameter
 * object.
 * @param Array{object} framesInfo The array of the frames in a top-down order. The last frame contains the target
 *                      itself.
 * @return {object} It contains the sizes (absLeft, absTop, left, top, height, width) of the visible area
 *                  of the last frame calculated from the input frames' dimensions.
 */
function getVisibleClientRectOfFrames(framesInfo) {
    var currentFrame = framesInfo[0],
        currentAbsRight,
        currentAbsBottom,
        calculatedInfo = {
            absLeft: framesInfo[0].left,
            cumulatedAbsLeft: framesInfo[0].left,
            cumulatedAbsRight: framesInfo[0].right,
            absTop: framesInfo[0].top,
            cumulatedAbsTop: framesInfo[0].top,
            cumulatedAbsBottom: framesInfo[0].bottom
        },
        i;

    for (i = 1; i < framesInfo.length; i++) {
        currentFrame = framesInfo[i];

        currentAbsRight = framesInfo[i].right + calculatedInfo.absLeft;
        calculatedInfo.cumulatedAbsRight = Math.min(currentAbsRight, calculatedInfo.cumulatedAbsRight);
        calculatedInfo.absLeft += framesInfo[i].left;
        calculatedInfo.cumulatedAbsLeft = Math.max(calculatedInfo.cumulatedAbsLeft, calculatedInfo.absLeft);

        currentAbsBottom = framesInfo[i].bottom + calculatedInfo.absTop;
        calculatedInfo.cumulatedAbsBottom = Math.min(currentAbsBottom, calculatedInfo.cumulatedAbsBottom);
        calculatedInfo.absTop += framesInfo[i].top;
        calculatedInfo.cumulatedAbsTop = Math.max(calculatedInfo.cumulatedAbsTop, calculatedInfo.absTop);
    }

    return {
        absLeft: calculatedInfo.absLeft,
        absTop: calculatedInfo.absTop,
        left: currentFrame.left,
        top: currentFrame.top,
        height: calculatedInfo.cumulatedAbsBottom - calculatedInfo.cumulatedAbsTop,
        width: calculatedInfo.cumulatedAbsRight - calculatedInfo.cumulatedAbsLeft
    };
}

/**
 * Returns the bounding rectangle data (bottom, height, left, right, top, width) of the visible part of the frame.
 * @param {object} frame The frame of which visible part should be calculated.
 * @return {object} The bounding rectangle of the visible part (DOMRect object + absLeft, absTop values). The
 *         additional values are the left and top distance between the top accessible frame (as the origo of the
 *         coordinate system) and the provided frame.
 */
function getVisibleClientRect(frame) {
    var ancestorFrames = getAccessibleFramesInHierarchy(frame),
        frameInfo = [],
        visibleFrameInfo,
        i;

    for (i = 0; i < ancestorFrames.length; i++) {
        frameInfo.push(getBoundingClientRect(ancestorFrames[i]));
    }

    visibleFrameInfo = getVisibleClientRectOfFrames(frameInfo);

    return {
        bottom: visibleFrameInfo.height,
        height: visibleFrameInfo.height,
        left: visibleFrameInfo.left,
        right: visibleFrameInfo.width,
        top: visibleFrameInfo.top,
        width: visibleFrameInfo.width,
        absLeft: visibleFrameInfo.absLeft,
        absTop: visibleFrameInfo.absTop
    };
}

/**
     * Returns the inner width of a frame for both desktop and touch device browsers.
     * Note that for touch devices window.innerWidth usually returns a value that is
     * much higher than expected. This function aims to return a more realistic value.
     *
     * @param frame An iframe or the top frame of a page
     */
function innerWidth(frame) {
    var touchDeviceInnerWidth = 0;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* isTouchDevice */])()) {
        touchDeviceInnerWidth = frame.outerWidth;
    }
    return touchDeviceInnerWidth || frame.innerWidth || frame.document.documentElement.clientWidth;
}

/**
 * Returns the inner height of a frame for both desktop and touch device browsers.
 * Note that for touch devices window.innerHeight usually returns a value that is
 * much higher than expected. This function aims to return a more realistic value.
 *
 * @param frame An iframe or the top frame of a page
 */
function innerHeight(frame) {
    var touchDeviceInnerHeight = 0;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* isTouchDevice */])()) {
        touchDeviceInnerHeight = frame.outerHeight;
    }
    return touchDeviceInnerHeight || frame.innerHeight || frame.document.documentElement.clientHeight;
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export I18nMessages */
/* harmony export (immutable) */ __webpack_exports__["a"] = i18n;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loader_core__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cookie__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(1);





var DEFAULT_LOCALE = 'en';

/**
 * An instance of this class is the view of i18n messages for a given HTML markup. This object holds the
 * actual locale, the i18n overrides and a prefix for the keys.
 *
 * The locale will be looked up in order:
 * 1. From the markup's "data-locale" attribute.
 * 2. From the "locale" global config key.
 * 3. From a cookie, with its name defined by the "cookie.locale" global config key.
 * 4. From attribute lang of html tag of the current page.
 * 5. A locale of "en" will be used.
 *
 * i18n overrides are defined by the markup in the data-i18n attribute.
 *
 * Prefix for the i18n keys is given in the params.keyPrefix parameter.
 *
 * @param {object} This parameter object that is a hash object with the below optional attributes:
 * - $markup: The HTML markup of a widget from which these i18n related data-* attributes are taken:
 *     -- data-i18n: A JSON string with a hash object of i18n key-value overrides,
 *     -- data-locale: Override of the locale.
 * - keyPrefix: The i18n key prefix for the given keys.
 */
function I18nMessages(params) {
    var cookieName,
        locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["h" /* data */])(params.$markup, 'locale') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__loader_core__["b" /* config */])('locale');

    if (!locale) {
        cookieName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__loader_core__["b" /* config */])('cookie.locale');
        locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookie__["a" /* read */])(cookieName);
    }
    if (!locale) {
        locale = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html').attr('lang'); // get locale from lang attribute of HTML tag of current page
    }

    this.locale = locale || DEFAULT_LOCALE;
    this.localeParts = getLocaleParts(this.locale);
    this.overrides = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["B" /* jsonData */])(params.$markup, 'i18n');
    this.keyPrefix = params.keyPrefix;
}

__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend(I18nMessages.prototype, {
    /**
     * Resolves an i18n key using the below fallback chain until a defined value is found:
     * - First look up the key in the i18n overrides.
     * - Then resolve the key for the actual locale, then for the locale with one less part at the end, then
     *   two less parts, etc. finally with only the first part. Separator for locale parts are - and _, and
     *   parts are lowercased.
     * - Then take the value for the default locale of "en".
     *
     * @param {string} The i18n key without key prefixes.
     * @return {string} The resolved value.
     */
    get: function (key) {
        return resolveByOverride(key, this)
                || resolveByLocale(key, this)
                || resolveByDefaultLocale(key, this);
    }
});

function resolveByOverride(key, self) {
    return self.overrides ? self.overrides[key] : null;
}

function resolveByLocale(key, self) {
    var resolved,
        i,
        providedLocaleParts = self.localeParts,
        fallbackLocaleParts;
    // go through the locale fallback chain
    for (i = providedLocaleParts.length; i >= 1; i--) {
        fallbackLocaleParts = providedLocaleParts.slice(0, i);
        resolved = resolveKey(fallbackLocaleParts, self.keyPrefix, key);
        if (resolved) {
            break;
        }
    }
    return resolved;
}

function resolveByDefaultLocale(key, self) {
    return resolveKey(DEFAULT_LOCALE, self.keyPrefix, key);
}

/**
 * Split the given string by _ and - characters and lowercase each part.
 */
function getLocaleParts(locale) {
    var localeParts = locale.split(/[-_]/);
    localeParts = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.map(localeParts, function (el) {
        return el.toLowerCase();
    });
    return localeParts;
}

/**
 * Resolves an i18n key for a given locale.
 * @param {(string[]|string)} Array of locale parts or a string with only one part.
 * @param {string} Key prefix.
 * @param {string} Key without prefixes.
 */
function resolveKey(localeParts, keyPrefix, key) {
    var fullKey = [];
    fullKey.push('i18n');
    fullKey = fullKey.concat(__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.isArray(localeParts) ? localeParts.join('.') : localeParts);
    fullKey.push(keyPrefix || '');
    fullKey.push(key);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__loader_core__["b" /* config */])(fullKey.join('.'));
}

/**
 * Returns a view of i18n messages for a given HTML markup. The returned view is a new object with a get(key)
 * function to resolve a value for a given key. For the actual resolution fallback chain, see JSDoc of constructor
 * of I18nMessages and the get(key) function.
 *
 * @param {object} Same hash object as in the constructor of I18nMessages.
 * @return {Object} The view of i18n messages for the given HTML markup. Always returns a new object.
 */
function i18n(params) {
    return new I18nMessages(params);
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isInputFiredOnPlaceholderDelete;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasFocusinEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasInputEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(1);


function isEventSupported(elementName, eventName) {
    var element = document.createElement(elementName);
    return element['on' + eventName] !== undefined;
}

function isInputFiredOnPlaceholderDelete(event) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common__["I" /* isIe */])() && event.type === 'input' && !event.target.hasAttribute('placeholder');
}

var hasFocusinEvent = isEventSupported('div', 'focusin');
var hasInputEvent = isEventSupported('input', 'input');


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

    iconInside: '<span class="uwr-date-picker-icon-inside uwr-button"/>',

    iconOutside: [
            '<span class="uwr-date-picker-icon-outside-container">',
                '<button class="uwr-date-picker-icon-outside uwr-button" onclick="return false;" type="button"/>',
            '</span>'
        ].join(''),

    inputContainer: '<span class="uwr-date-picker-input-container"></span>',

    calendar: [
            '<div class="uwr-date-picker-calendar">',
                '<div class="uwr-date-picker-calendar-main">',
                    '<div class="uwr-date-picker-month-selector-view">',
                        '<div class="uwr-date-picker-month-selector-label">{{selectMonth}}</div>',
                        '<div class="uwr-date-picker-month-selector"></div>',
                    '</div>',
                    '<div class="uwr-date-picker-day-selector-view">',
                        '<div class="uwr-date-picker-weekdays">',
                            '{{#weekdays}}',
                                '<span>{{.}}</span>',
                            '{{/weekdays}}',
                        '</div>',
                        '<div class="uwr-date-picker-day-selector"></div>',
                    '</div>',
                '</div>',
            '</div>'
        ].join(''),

    yearSelector: [
            '<div class="uwr-date-picker-year-selector">',
                '<button class="uwr-date-picker-prev-year uwr-button uwr-button-small uwr-button-ghost"',
                        ' onclick="return false;">',
                '</button>',
                '<span class="uwr-date-picker-displayed-year">',
                    '<input class="uwr-date-picker-displayed-year-input-label" value="{{displayedYear}}"',
                        ' maxlength="4">',
                '</span>',
                '<button class="uwr-date-picker-next-year uwr-button uwr-button-small uwr-button-ghost"',
                        ' onclick="return false;">',
                '</button>',
            '</div>'
        ].join(''),

    monthSelector: [
            '<div class="uwr-date-picker-month-selector">',
                '{{#months}}',
                    '<div class="uwr-date-picker-month{{#disabled}} uwr-date-picker-month-disabled{{/disabled}}"',
                            ' data-month-of-year="{{monthOfYear}}">',
                        '<div class="uwr-month-in-num">{{monthOfYear2Digits}}</div>',
                        '<div class="uwr-month-in-txt">{{monthShort}}</div>',
                    '</div>',
                '{{/months}}',
            '</div>'
        ].join(''),

    daySelector: [
            '<div class="uwr-date-picker-day-selector">',
                '{{#months}}',
                    '<div class="uwr-date-picker-month" data-month-of-year="{{monthOfYear}}">',
                        '<div>{{month}}</div>',
                        '{{#weeks}}',
                            '<div class="uwr-date-picker-week">',
                                '{{#weekdays}}',
                                    '{{^value}}',
                                        '<span class="uwr-date-picker-cell ',
                                                'uwr-date-picker-cell-first-week uwr-date-picker-cell-empty">',
                                            '<span class="uwr-date-picker-day">&nbsp;</span>',
                                        '</span>',
                                    '{{/value}}',
                                    '{{#value}}',
                                        '<span class="uwr-date-picker-cell',
                                            '{{#hasTopBorder}} uwr-date-picker-cell-first-week{{/hasTopBorder}}">',
                                            '<span class="uwr-date-picker-day',
                                                '{{#selected}} uwr-date-picker-day-selected{{/selected}}',
                                                '{{#disabled}} uwr-date-picker-day-disabled{{/disabled}}',
                                                '{{#bankHoliday}} uwr-date-picker-day-bank-holiday{{/bankHoliday}}',
                                                '{{#today}} uwr-date-picker-day-today{{/today}}"',
                                                'data-date="{{value}}">',
                                                '{{dayOfMonth}}',
                                            '</span>',
                                            '{{#bankHoliday}}',
                                                '<span class="uwr-date-picker-day-bank-holiday-mark"></span>',
                                            '{{/bankHoliday}}',
                                            '{{#today}}',
                                                '<span class="uwr-date-picker-day-label',
                                                        '{{#selected}} uwr-date-picker-day-selected{{/selected}}">',
                                                    '{{todayAbbrev}}',
                                                '</span>',
                                            '{{/today}}',
                                        '</span>',
                                    '{{/value}}',
                                '{{/weekdays}}',
                            '</div>',
                        '{{/weeks}}',
                    '</div>',
                    '<div class="uwr-date-picker-month"></div>',
                '{{/months}}',
            '</div>'
        ].join(''),

    footer: [
            '<div class="uwr-date-picker-footer">',
                '<button class="uwr-button uwr-button-submit uwr-date-picker-done" onclick="return false;">',
                    '{{done}}',
                '</button>',
                '<button class="uwr-button uwr-date-picker-today" onclick="return false;">',
                    '{{today}}',
                '</button>',
                '<span class="uwr-date-picker-legend">',
                    '<span class="uwr-date-picker-day-bank-holiday-legend"></span>{{legendText}}',
                '</span>',
            '</div>'
        ].join('')
});


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return version; });
/* harmony export (immutable) */ __webpack_exports__["c"] = setRuntimeConfig;
/* harmony export (immutable) */ __webpack_exports__["d"] = setDefaultConfig;
/* harmony export (immutable) */ __webpack_exports__["b"] = config;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultConfig__ = __webpack_require__(79);



var version = '5.4.1';

function setRuntimeConfig() {
    if (typeof window.uwr === 'object' && typeof window.uwr.config === 'object') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* assign */])('uwr_.runtime.config', window.uwr.config);
    }
}

function setDefaultConfig() {
    Object.keys(__WEBPACK_IMPORTED_MODULE_1__defaultConfig__["a" /* default */]).forEach(function (key) {
        config(key, __WEBPACK_IMPORTED_MODULE_1__defaultConfig__["a" /* default */][key]);
    });
}

/**
 * Gets or sets a runtime config parameter.
 * @param {string} name of the config parameter
 * @param {object} value of the config parameter
 * @return If only the first parameter is passed then returns the value associated to the key if exists otherwise
 *         undefined.
 */
function config() {
    if (arguments.length === 1) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* retrieve */])('uwr_.runtime.config.' + arguments[0]);
    } else if (arguments.length === 2) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* assign */])('uwr_.runtime.config.' + arguments[0], arguments[1]);
    }
}


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony export (immutable) */ __webpack_exports__["deselect"] = deselect;
/* harmony export (immutable) */ __webpack_exports__["disable"] = disable;
/* harmony export (immutable) */ __webpack_exports__["enable"] = enable;
/* harmony export (immutable) */ __webpack_exports__["hide"] = hide;
/* harmony export (immutable) */ __webpack_exports__["select"] = select;
/* harmony export (immutable) */ __webpack_exports__["show"] = show;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_localNavigation_less__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_localNavigation_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_localNavigation_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__localNavigationItems__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_modules_frames__ = __webpack_require__(6);






var localNavigationInstance;

/**
 * A cache to store all models having ids in the Local Navigation config.
 */
function ItemCache() {
    this.cache = {};
}

__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend(ItemCache.prototype, {
    /**
     * Adds (id, object) pairs to the cache where id is of type string.
     * Checks duplicate ids and throws JS error if duplicate found.
     */
    add: function (id, obj) {
        if (id === undefined) {
            throw 'ID is undefined. Please, check the stacktrace for the root cause.';
        }
        if (this.cache[id] !== undefined) {
            throw 'Duplicate id found: ' + id;
        }
        this.cache[id] = obj;
    },

    get: function (id, requiredType) {
        var foundItem = this.cache[id];
        return (foundItem && foundItem instanceof requiredType) ? foundItem : undefined;
    },

    /**
     * Returns the active item - active status check based on the model.
     * Please note that it works only during Local Navigation initialization.
     */
    getActiveItem: function () {
        var key;
        for (key in this.cache) {
            if (this.cache.hasOwnProperty(key) && this.cache[key].active) {
                return this.cache[key];
            }
        }
    }
});

function resolveConfigItem(item, defaultValue) {
    return item !== undefined ? item : defaultValue;
}

/**
 * Represents a Local Navigation widget in the actual window frame.
 * @param {object} clientConfig The configuration object provided by the client. For details please check the API
 * documentation of the Local Navigation widget.
 */
function LocalNavigation(clientConfig) {
    var activeItem,
        self = this;

    this.$markup = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(clientConfig.targetElem);
    // Clone so that the original one is not modified
    this.config = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend(true, {}, clientConfig);
    this.iconPanel = null; // Will be set later
    this.itemCache = new ItemCache();

    this.setDefaults(this.config);
    this.pageGroups = this.generatePageGroupsModel(this.config);
    this.iconPanel = this.generateIconPanelModel(this.config);

    this.cssConfig = {};
    this.setCssClassesForAnimations(this.cssConfig);
    this.render(this.$markup);
    this.adjustCollapse();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).on('resize', function () {
        self.adjustCollapse();
    });

    // Display active item or pagegroup
    activeItem = this.itemCache.getActiveItem();
    if (activeItem) {
        this.select(activeItem.id);
    }

}

__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend(LocalNavigation.prototype, {
    adjustCollapse: function () {
        this.collapsible = this.isCollapsible();
        this.setCssClassesForCollapsibility();
        this.adjustViewDimensions();
    },

    setCssClassesForCollapsibility: function () {
        if (this.collapsible) {
            this.$markup.addClass(this.cssConfig.collapsible);
        } else {
            this.$markup.removeClass(this.cssConfig.collapsible + ' ' + this.cssConfig.collapsed);
            this.$markup.addClass(this.cssConfig.expanded);
        }
    },

    isCollapsible: function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_modules_frames__["c" /* innerWidth */])(window) < this.config.minimizingThreshold;
    },

    expandOrCollapse: function () {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$markup).toggleClass(this.cssConfig.collapsed + ' ' + this.cssConfig.expanded);
    },

    setDefaults: function (config) {
        config.animations = resolveConfigItem(config.animations, {});
        config.animations.enable = resolveConfigItem(config.animations.enable, true);
        config.animations.showOnStart = resolveConfigItem(config.animations.showOnStart, true);
        config.minimizingThreshold = resolveConfigItem(config.minimizingThreshold, 1253);
        config.hoverPreview = resolveConfigItem(config.hoverPreview, 'none');
        config.enableFilter = resolveConfigItem(config.enableFilter, true);
    },

    setCssClassesForAnimations: function (cssConfig) {
        cssConfig.collapsible = 'uwr-local-nav-collapsible';
        cssConfig.expanded = 'uwr-local-nav-expanded';
        cssConfig.collapsed = 'uwr-local-nav-collapsed';
        if (!(__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["m" /* isIe7 */]() || __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["c" /* isIe8 */]() || __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["u" /* isIe9 */]())) {
            cssConfig.expanded += '-animation';
            cssConfig.collapsed += '-animation';
        }
    },

    generatePageGroupsModel: function (config) {
        var pageGroups = [],
            pageGroupConfig,
            i;
        for (i = 0; i < config.pageGroups.length; i++) {
            pageGroupConfig = config.pageGroups[i];
            pageGroupConfig.parentObject = this;
            pageGroupConfig.rootObject = this;
            pageGroups.push(new __WEBPACK_IMPORTED_MODULE_3__localNavigationItems__["a" /* PageGroup */](pageGroupConfig));
        }
        return pageGroups;
    },

    generateIconPanelModel: function (config) {
        config.parentObject = this;
        config.rootObject = this;
        return new __WEBPACK_IMPORTED_MODULE_3__localNavigationItems__["b" /* IconPanel */](config);
    },

    render: function ($markup) {
        var i,
            self = this;
        this.iconPanel.render($markup);
        for (i = 0; i < this.pageGroups.length; i++) {
            this.pageGroups[i].render($markup);
        }
        $markup.addClass(this.cssConfig.expanded);
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-local-nav-hamburger-icon', $markup).on('click', function () {
            self.expandOrCollapse();
        });
    },

    adjustViewDimensions: function () {
        var pageGroupWidth = 0,
            $iconPanel = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-local-nav-iconpanel', this.$markup),
            iconPanelWidth = $iconPanel.width(),
            iconPanelHeight = $iconPanel.height(),
            largestHeight = iconPanelHeight;
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-local-nav-pagegroup', this.$markup).each(function () {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).height('auto');
        });
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-local-nav-pagegroup', this.$markup).each(function () {
            var height = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).height(),
                width = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).width();
            pageGroupWidth = Math.max(width, pageGroupWidth);
            largestHeight = Math.max(height, largestHeight);
        });
        pageGroupWidth = this.collapsible ? 0 : pageGroupWidth;
        this.$markup.height(largestHeight);
        this.$markup.width(iconPanelWidth + pageGroupWidth);
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-local-nav-pagegroup', this.$markup).each(function () {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).height(largestHeight);
        });
    },

    enable: function (id) {
        var node = this.itemCache.get(id, __WEBPACK_IMPORTED_MODULE_3__localNavigationItems__["c" /* Node */]);
        if (node) {
            node.setEnabled();
        }
    },

    disable: function (id) {
        var node = this.itemCache.get(id, __WEBPACK_IMPORTED_MODULE_3__localNavigationItems__["c" /* Node */]);
        if (node) {
            node.setEnabled(false);
        }
    },

    select: function (id) {
        var node = this.itemCache.get(id, __WEBPACK_IMPORTED_MODULE_3__localNavigationItems__["c" /* Node */]),
            parent,
            i;
        // if the item is a node
        if (node) {
            // activate id within the whole page group
            for (i = 0; i < this.pageGroups.length; i++) {
                this.pageGroups[i].setActive(id);
            }

            // show the item's page group
            parent = node;
            while (!(parent instanceof __WEBPACK_IMPORTED_MODULE_3__localNavigationItems__["a" /* PageGroup */])) {
                parent = parent.getParent();
            }
            this.show(parent.id);
        } else {
            // if item is page group or invalid
            this.show(id);
        }
    },

    deselect: function (id) {
        var node = this.itemCache.get(id, __WEBPACK_IMPORTED_MODULE_3__localNavigationItems__["c" /* Node */]);
        if (node) {
            node.setActive(id, false);
        }
    },

    show: function (id) {
        var i,
            pageGroup;
        if (id) {
            // adjust page groups
            for (i = 0; i < this.pageGroups.length; i++) {
                pageGroup = this.pageGroups[i];
                if (pageGroup.id === id) {
                    pageGroup.show(this.$markup);
                } else {
                    pageGroup.hide();
                    pageGroup.setActive(id);
                }
            }
            // adjust icon panel
            this.iconPanel.setActive(id);
        } else {
            this.$markup.removeClass('uwr-local-nav-hidden');
        }
    },

    hide: function (id) {
        var pageGroup;
        if (id) {
            pageGroup = this.itemCache.get(id, __WEBPACK_IMPORTED_MODULE_3__localNavigationItems__["a" /* PageGroup */]);
            if (pageGroup) {
                pageGroup.hide();
            }
        } else {
            this.$markup.addClass('uwr-local-nav-hidden');
        }
    }
});

function init(callback) {
    var $markup = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-local-nav').first(),
        config = __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["v" /* resolveConfig */]($markup, 'config');

    config.targetElem = $markup.get(0);

    if (config.targetElem) {
        localNavigationInstance = new LocalNavigation(config);
    }

    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}

function deselect(id, callback) {
    localNavigationInstance.deselect(id);
    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}

function disable(id, callback) {
    localNavigationInstance.disable(id);
    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}

function enable(id, callback) {
    localNavigationInstance.enable(id);
    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}

function hide(idOrCallback, callback) {
    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.isFunction(idOrCallback)) {
        localNavigationInstance.hide();
        __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](idOrCallback);
    } else {
        localNavigationInstance.hide(idOrCallback);
        __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
    }
}

function select(id, callback) {
    localNavigationInstance.select(id);
    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}

function show(idOrCallback, callback) {
    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.isFunction(idOrCallback)) {
        localNavigationInstance.show();
        __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](idOrCallback);
    } else {
        localNavigationInstance.show(idOrCallback);
        __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
    }
}


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_arrow_less__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_arrow_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_arrow_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_messageBox_less__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_messageBox_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_messageBox_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__ = __webpack_require__(1);





var supportedTypes = ['info', 'warning', 'emptyvalue', 'no-message', 'error', 'confirmation', 'confirmation-white',
                        'confirmation-ghost',
                        'neutral', 'mail', 'spotlight'], // UW4 types
    supportedIconTypes = ['none', 'small'];

function getType($mb) {
    var type = $mb.data('type');
    return __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.inArray(type, supportedTypes) >= 0 ? type : 'info';
}

function getIconType($mb) {
    var iconType = $mb.data('icon-type');
    return __WEBPACK_IMPORTED_MODULE_2_jquery___default.a.inArray(iconType, supportedIconTypes) >= 0 ? iconType : 'small';
}

function initSingle($mb) {
    var typeClass = 'uwr-message-box-type-' + getType($mb),
        iconTypeClass = 'uwr-message-box-icon-' + getIconType($mb),
        inited = $mb.hasClass(typeClass);

    if (!inited) {
        $mb.addClass(typeClass);
        $mb.addClass(iconTypeClass);
        $mb.wrapInner('<div class="uwr-message-box-content" />');
    }
}

/**
 * Supported use cases:
 * - init();
 * - init(callback);
 * - init(selector);
 * - init(selector, callback);
 */
function init(arg1, arg2) {
    var selector,
        callback;

    if (arguments.length === 0) {
        selector = '.uwr-message-box';
        callback = null;
    } else if (arguments.length === 1) {
        if (__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.type(arg1) === 'string') {
            selector = arg1;
            callback = null;
        } else if (__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.type(arg1) === 'function') {
            selector = '.uwr-message-box';
            callback = arg1;
        }
    } else if (arguments.length === 2) {
        selector = arg1;
        callback = arg2;
    }

    __WEBPACK_IMPORTED_MODULE_2_jquery___default()(selector).each(function (i, el) {
        var $mb = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(el);
        if ($mb.hasClass('uwr-message-box')) {
            initSingle($mb);
        }
    });

    __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["b" /* invoke */](callback);
}


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["disable"] = disable;
/* harmony export (immutable) */ __webpack_exports__["enable"] = enable;
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qtip2_dist_jquery_qtip_css__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qtip2_dist_jquery_qtip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qtip2_dist_jquery_qtip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_tooltip_less__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_tooltip_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_tooltip_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qtip2__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qtip2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qtip2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__ = __webpack_require__(1);






function getCloseButton(params) {
    return typeof params.closebutton === 'boolean' ? params.closebutton
        : typeof params.closebutton === 'string' ? params.closebutton === 'true'
        : (params.title || '').length === 0 ? false : true;
}

function getMyPosition(placement) {
    return placement === 'top' ? 'bottom'
            : placement === 'bottom' ? 'top'
            : placement === 'right' ? 'left'
            : placement === 'left' ? 'right'
            : 'left';
}

function getAtPosition(placement) {
    return placement === 'top' || placement === 'bottom' || placement === 'left' || placement === 'right'
        ? placement : 'right';
}

function normalizeTriggerEvent(event) {
    var triggerEvent = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.trim(event).toLowerCase();
    // add any potential alias conversions here
    return triggerEvent;
}

function getHoverClickShowEvent() {
    return __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["a" /* isTouchDevice */]() ? 'click' : 'mouseenter';
}

function getDefaultShowEvent() {
    return 'mouseenter';
}

function convertToShowEvent(triggerEvent) {
    return triggerEvent === 'focus' ? 'focusin'
        : triggerEvent === 'hover' ? 'mouseenter'
        : triggerEvent === 'click' ? 'click'
        : triggerEvent === 'hoverclick' ? getHoverClickShowEvent()
        : triggerEvent === 'load' ? ''
        : getDefaultShowEvent();
}

function getShowEvent(trigger) {
    var result = getDefaultShowEvent();

    if (trigger) {
        var events = trigger.split(','),
            showEvents = [],
            i,
            len = events.length,
            currentEvent;

        for (i = 0; i < len; i++) {
            currentEvent = normalizeTriggerEvent(events[i]);
            showEvents.push(convertToShowEvent(currentEvent));
        }
        result = showEvents.join(' ');
    }
    return result;
}

function getHoverClickHideEvent() {
    return __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["a" /* isTouchDevice */]() ? 'click' : 'mouseleave';
}

function getDefaultHideEvent() {
    return 'mouseleave';
}

function convertToHideEvent(triggerEvent) {
    return triggerEvent === 'focus' ? 'focusout'
        : triggerEvent === 'hover' ? 'mouseleave'
        : triggerEvent === 'click' ? 'click'
        : triggerEvent === 'hoverclick' ? getHoverClickHideEvent()
        : triggerEvent === 'load' ? ''
        : getDefaultHideEvent();
}

function getHideEvent(trigger) {
    var result = getDefaultHideEvent();

    if (trigger) {
        var events = trigger.split(','),
            hideEvents = [],
            i,
            len = events.length,
            currentEvent;

        for (i = 0; i < len; i++) {
            currentEvent = normalizeTriggerEvent(events[i]);
            hideEvents.push(convertToHideEvent(currentEvent));
        }
        result = hideEvents.join(' ');
    }
    return result;
}

function getDisplayOnLoad(trigger) {
    return trigger && trigger.indexOf('load') !== -1;
}

function getDelay(delay) {
    var value = (delay || 0) * 1;
    return value && value > 0 ? value : 0;
}

function getClass(type) {
    var classes = 'uwr-ui-tooltip-base';
    if (type === 'confirm' || type === 'warning' || type === 'error' || type === 'neutral') {
        classes += ' uwr-ui-tooltip-' + type;
    }
    return classes;
}

function buildConfig(params) {
    var config = {
        content: {
            text: params.text || ' ',
            title: {
                text: params.title || '',
                button: getCloseButton(params)
            }
        },
        position: {
            my: getMyPosition(params.placement) + ' center',
            at: getAtPosition(params.placement) + ' center',
            effect: false
        },
        show: {
            event: getShowEvent(params.trigger) || false,
            ready: getDisplayOnLoad(params.trigger),
            delay: getDelay(params.delay),
            effect: false
        },
        hide: {
            event: getHideEvent(params.trigger) || false
        },
        style: {
            classes: 'uwr-ui-tooltip-shadow ' + getClass(params.type),
            tip: {
                corner: true,
                width: 13,
                height: 13
            }
        }
    };
    if (__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.trim(config.content.title.text) === '' && config.content.title.button === true) {
        config.content.title.text = ' ';
    }
    return config;
}

function updateTitle($el) {
    var tooltipId = $el.attr('aria-describedby'),
        $titleBar = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + tooltipId + ' .qtip-titlebar'),
        $content = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#' + tooltipId + ' .qtip-content');
    $titleBar.css({
        'overflow': 'visible',
        'position': 'absolute',
        'padding': '0px',
        'right': '0px'
    });
    $titleBar.find('a').css('z-index', 1);
    $content.css('padding-right', '25px');
    $el.qtip('reposition');
}

function updateForEmptyTitleEvent($el, config) {
    if (!$el.data('updated')) {
        if (__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.trim(config.content.title.text) === '' && config.content.title.button) {
            updateTitle($el);
        }
        $el.data('updated', true);
    }
}

function updateForEmptyTitle($el, config) {
    function bindHandler() {
        updateForEmptyTitleEvent($el, config);
    }

    if (config.show.event) {
        var events = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.trim(config.show.event).split(' '),
            i;

        for (i = 0; i < events.length; i++) {
            $el.bind(__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.trim(events[i]), bindHandler);
        }
    } else {
        updateForEmptyTitleEvent($el, config);
    }
}

function addTooltip($el, params) {
    var config = buildConfig(params);
    $el.qtip(config);
    updateForEmptyTitle($el, config);
    if (params.disabled === 'true') {
        $el.qtip('api').disable(true);
    }
}

function adjustInlineHelpBackground($el) {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('input', $el).focusin(function () {
        $el.addClass('uwr-inline-help-active');
    });
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('input', $el).focusout(function () {
        $el.removeClass('uwr-inline-help-active');
    });
}

function addInlineHelp($el, params) {
    var modParams,
        config;

    // override some params
    modParams = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.extend({placement: 'right'}, params, {trigger: 'focus'});
    config = buildConfig(modParams);

    // add some more params
    config.position.adjust = {
        x: -15
    };
    config.show.target = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('input', $el);

    $el.qtip(config);
    updateForEmptyTitle($el, config);

    // set background
    adjustInlineHelpBackground($el);
}

var dataAttrs = ['closebutton', 'delay', 'disabled', 'placement', 'text', 'title', 'trigger', 'type'];

function buildParams($el) {
    var params = {};
    __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.each(dataAttrs, function (i, name) {
        params[name] = $el.attr('data-' + name);
    });
    return params;
}

function addTooltips() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.uwr-tooltip').each(function () {
        var $el = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this);
        if ($el.hasClass('uwr-inline-help')) {
            addInlineHelp($el, buildParams($el));
        } else {
            addTooltip($el, buildParams($el));
        }
    });
}

function setVisibility(visible, selector, callback) {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(selector).each(function () {
        var elem = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this);
        if (elem.hasClass('uwr-tooltip')) {
            elem.qtip('api').disable(!visible);
        }
    });
    if (__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.type(callback) === 'function') {
        callback();
    }
}

/**
 * Disable displaying the tooltip.
 * @param {string} The CSS selector of the tooltip that will be disabled.
 * @param {function} Optional callback function to do more after tooltip is disabled.
 */
function disable(selector, callback) {
    setVisibility(false, selector, callback);
}

/**
 * Enable displaying the tooltip.
 * @param {string} The CSS selector of the tooltip that will be enabled.
 * @param {function} Optional callback function to do more after tooltip is enabled.
 */
function enable(selector, callback) {
    setVisibility(true, selector, callback);
}

/**
 * Initializes all Tooltips on the page. This function like all other API functions is called asynchronously.
 * The no-arg init() is automatically called when the page is loaded.
 * Dynamically added Tooltips need to be initialized by explicitly calling init().
 *
 * @param callback Javascript function object that is called when init() is finished. Optional parameter.
 */
function init(callback) {
    addTooltips();
    __WEBPACK_IMPORTED_MODULE_4__shared_modules_common__["b" /* invoke */](callback);
}


/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);

/**
 * jQuery plugin truncate
 *
 * Source: https://github.com/tbasse/jquery-truncate
 * Originally released under the MIT License.
 */
/* eslint complexity: [error, 10] */
/* global jQuery */
(function ($) {
    /**
     * Checks whether the given param is a number or not.
     * @param n The value to check.
     */
    function isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    /**
     * Recursive method to find out what fits inside an element with the width of 'max'.
     *
     * @param data A complex parameter object, which contains all items required. The object's attributes:
     *             - dimension The dimension to check, usually 'width'.
     *             - max The maximum number of that dimension, e.g. width of 90px.
     *             - text The original text.
     *             - start The start point of the text (changes in recursive call).
     *             - end The end point of the text (changes in recursive call).
     *             - $workerEl The worker which concats the final text.
     *             - token The token which is inserted, e.g. '&hellip;'.
     *             - fromEnd Defines whether to check from end or not.
     */
    function findTruncPoint(data) {
        var opt1,
            opt2,
            mid;

        if (data.fromEnd) {
            opt1 = data.start === 0 ? '' : data.text.slice(-data.start);
            opt2 = data.text.slice(-data.end);
        } else {
            opt1 = data.text.slice(0, data.start);
            opt2 = data.text.slice(0, data.end);
        }

        if (data.max < data.$workerEl.text(data.token)[data.dimension]()) {
            return 0;
        }

        if (data.$workerEl.text(opt2 + data.token)[data.dimension]()
                < data.$workerEl.text(opt1 + data.token)[data.dimension]()) {
            return data.end;
        }

        mid = parseInt((data.start + data.end) / 2, 10);
        opt1 = data.fromEnd ? data.text.slice(-mid) : data.text.slice(0, mid);

        data.$workerEl.text(opt1 + data.token);
        if (data.$workerEl[data.dimension]() === data.max) {
            return mid;
        }

        if (data.$workerEl[data.dimension]() > data.max) {
            data.end = mid - 1;
        } else {
            data.start = mid + 1;
        }

        return findTruncPoint(data);
    }

    /**
     * the jQuery extension. These are the possible options:
     * - width:                'auto' or a numeric value
     * - token:                The string which will be displayed as the delimiter, standard is '&hellip;' (...).
     * - center:            boolean value defining whether the ellipsis is going to be in the text, not after it.
     * - visibleTrailChars:    numeric value defining how many characters should be shown after the ellipsis.
     *                         If the value is bigger then what fits into the displayed element, truncate will switch
     *                         to standard centered mode.
     * - addclass:            false or a string for the classname that should be added.
     * - addtitle:            boolean value, defines whether a title attribute containing the full text should be
     *                         added to the element.
     * - multiline:         boolean value, defines whether the element is multiline or not.
     */
    $.fn.truncate = function (options) {
        var defaults = {
            width: 'auto',
            token: '&hellip;',
            center: true,
            addclass: false,
            addtitle: true,
            multiline: false
        };
        options = $.extend(defaults, options);

        return this.each(function () {
            var $element = $(this),
                fontCSS = {
                    'fontFamily': $element.css('fontFamily'),
                    'fontSize': $element.css('fontSize'),
                    'fontStyle': $element.css('fontStyle'),
                    'fontWeight': $element.css('fontWeight'),
                    'font-variant': $element.css('font-variant'),
                    'text-indent': $element.css('text-indent'),
                    'text-transform': $element.css('text-transform'),
                    'letter-spacing': $element.css('letter-spacing'),
                    'word-spacing': $element.css('word-spacing'),
                    'display': 'none'
                },
                elementText = $element.text(),
                $truncateWorker = $('<span/>').css(fontCSS).text(elementText).appendTo('body'),
                originalWidth = $truncateWorker.width(),
                truncateWidth = isNumber(options.width) ? options.width : $element.width(),
                dimension = 'width',
                truncatedText, originalDim, truncateDim, lastCharsWidth, $lastCharsTruncateWorker;

            if ($.trim(elementText).length < 2) {
                return false;
            }

            if (options.multiline) {
                $truncateWorker.width($element.width());
                dimension = 'height';
                originalDim = $truncateWorker.height();
                truncateDim = $element.height() + 1;
            } else {
                originalDim = originalWidth;
                truncateDim = truncateWidth;
            }

            if (isNumber(options.visibleTrailChars)) {
                $lastCharsTruncateWorker = $('<span/>').css(fontCSS).text(
                            elementText.slice(-1 * options.visibleTrailChars)
                        ).appendTo('body');
                lastCharsWidth = $lastCharsTruncateWorker.width();
            }

            if (originalDim > truncateDim) {
                $truncateWorker.text('');
                if (options.center) {
                    if (isNumber(options.visibleTrailChars) && lastCharsWidth < truncateDim) {
                        var secondTruncateDim = lastCharsWidth;
                        var firstTruncateDim = truncateDim - secondTruncateDim;
                        truncatedText = elementText.slice(0, findTruncPoint({
                                dimension: dimension,
                                max: firstTruncateDim,
                                text: elementText,
                                start: 0,
                                end: elementText.length,
                                $workerEl: $truncateWorker,
                                token: options.token,
                                fromEnd: false
                            }))
                        + options.token
                        + elementText.slice(-1 * findTruncPoint({
                                dimension: dimension,
                                max: secondTruncateDim,
                                text: elementText,
                                start: 0,
                                end: elementText.length,
                                $workerEl: $truncateWorker,
                                token: '',
                                fromEnd: true
                            }));
                    } else {
                        truncateDim = parseInt(truncateDim / 2, 10) + 1;
                        truncatedText = elementText.slice(0, findTruncPoint({
                                dimension: dimension,
                                max: truncateDim,
                                text: elementText,
                                start: 0,
                                end: elementText.length,
                                $workerEl: $truncateWorker,
                                token: options.token,
                                fromEnd: false
                            }))
                        + options.token
                        + elementText.slice(-1 * findTruncPoint({
                                dimension: dimension,
                                max: truncateDim,
                                text: elementText,
                                start: 0,
                                end: elementText.length,
                                $workerEl: $truncateWorker,
                                token: '',
                                fromEnd: true
                            }));
                    }
                } else {
                    truncatedText = elementText.slice(0, findTruncPoint({
                        dimension: dimension,
                        max: truncateDim,
                        text: elementText,
                        start: 0,
                        end: elementText.length,
                        $workerEl: $truncateWorker,
                        token: options.token,
                        fromEnd: false
                    })) + options.token;
                }

                if (options.addclass) {
                    $element.addClass(options.addclass);
                }

                if (options.addtitle) {
                    $element.attr('title', elementText);
                }

                $element.empty().text(truncatedText);

            }

            $truncateWorker.remove();
            $lastCharsTruncateWorker.remove();
        });
    };
})(jQuery);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);

/*
 * qTip2 - Pretty powerful tooltips - v3.0.3
 * http://qtip2.com
 *
 * Copyright (c) 2016 
 * Released under the MIT licenses
 * http://jquery.org/license
 *
 * Date: Wed May 11 2016 10:31 GMT+0100+0100
 * Plugins: tips modal viewport svg imagemap ie6
 * Styles: core basic css3
 */
/*global window: false, jQuery: false, console: false, define: false */

/* Cache window, document, undefined */
(function( window, document, undefined ) {

// Uses AMD or browser globals to create a jQuery plugin.
(function( factory ) {
	"use strict";
	if(true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if(jQuery && !jQuery.fn.qtip) {
		factory(jQuery);
	}
}
(function($) {
	"use strict"; // Enable ECMAScript "strict" operation for this function. See more: http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
;// Munge the primitives - Paul Irish tip
var TRUE = true,
FALSE = false,
NULL = null,

// Common variables
X = 'x', Y = 'y',
WIDTH = 'width',
HEIGHT = 'height',

// Positioning sides
TOP = 'top',
LEFT = 'left',
BOTTOM = 'bottom',
RIGHT = 'right',
CENTER = 'center',

// Position adjustment types
FLIP = 'flip',
FLIPINVERT = 'flipinvert',
SHIFT = 'shift',

// Shortcut vars
QTIP, PROTOTYPE, CORNER, CHECKS,
PLUGINS = {},
NAMESPACE = 'qtip',
ATTR_HAS = 'data-hasqtip',
ATTR_ID = 'data-qtip-id',
WIDGET = ['ui-widget', 'ui-tooltip'],
SELECTOR = '.'+NAMESPACE,
INACTIVE_EVENTS = 'click dblclick mousedown mouseup mousemove mouseleave mouseenter'.split(' '),

CLASS_FIXED = NAMESPACE+'-fixed',
CLASS_DEFAULT = NAMESPACE + '-default',
CLASS_FOCUS = NAMESPACE + '-focus',
CLASS_HOVER = NAMESPACE + '-hover',
CLASS_DISABLED = NAMESPACE+'-disabled',

replaceSuffix = '_replacedByqTip',
oldtitle = 'oldtitle',
trackingBound,

// Browser detection
BROWSER = {
	/*
	 * IE version detection
	 *
	 * Adapted from: http://ajaxian.com/archives/attack-of-the-ie-conditional-comment
	 * Credit to James Padolsey for the original implemntation!
	 */
	ie: (function() {
		/* eslint-disable no-empty */
		var v, i;
		for (
			v = 4, i = document.createElement('div');
			(i.innerHTML = '<!--[if gt IE ' + v + ']><i></i><![endif]-->') && i.getElementsByTagName('i')[0];
			v+=1
		) {}
		return v > 4 ? v : NaN;
		/* eslint-enable no-empty */
	})(),

	/*
	 * iOS version detection
	 */
	iOS: parseFloat(
		('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0,''])[1])
		.replace('undefined', '3_2').replace('_', '.').replace('_', '')
	) || FALSE
};
;function QTip(target, options, id, attr) {
	// Elements and ID
	this.id = id;
	this.target = target;
	this.tooltip = NULL;
	this.elements = { target: target };

	// Internal constructs
	this._id = NAMESPACE + '-' + id;
	this.timers = { img: {} };
	this.options = options;
	this.plugins = {};

	// Cache object
	this.cache = {
		event: {},
		target: $(),
		disabled: FALSE,
		attr: attr,
		onTooltip: FALSE,
		lastClass: ''
	};

	// Set the initial flags
	this.rendered = this.destroyed = this.disabled = this.waiting =
		this.hiddenDuringWait = this.positioning = this.triggering = FALSE;
}
PROTOTYPE = QTip.prototype;

PROTOTYPE._when = function(deferreds) {
	return $.when.apply($, deferreds);
};

PROTOTYPE.render = function(show) {
	if(this.rendered || this.destroyed) { return this; } // If tooltip has already been rendered, exit

	var self = this,
		options = this.options,
		cache = this.cache,
		elements = this.elements,
		text = options.content.text,
		title = options.content.title,
		button = options.content.button,
		posOptions = options.position,
		deferreds = [];

	// Add ARIA attributes to target
	$.attr(this.target[0], 'aria-describedby', this._id);

	// Create public position object that tracks current position corners
	cache.posClass = this._createPosClass(
		(this.position = { my: posOptions.my, at: posOptions.at }).my
	);

	// Create tooltip element
	this.tooltip = elements.tooltip = $('<div/>', {
		'id': this._id,
		'class': [ NAMESPACE, CLASS_DEFAULT, options.style.classes, cache.posClass ].join(' '),
		'width': options.style.width || '',
		'height': options.style.height || '',
		'tracking': posOptions.target === 'mouse' && posOptions.adjust.mouse,

		/* ARIA specific attributes */
		'role': 'alert',
		'aria-live': 'polite',
		'aria-atomic': FALSE,
		'aria-describedby': this._id + '-content',
		'aria-hidden': TRUE
	})
	.toggleClass(CLASS_DISABLED, this.disabled)
	.attr(ATTR_ID, this.id)
	.data(NAMESPACE, this)
	.appendTo(posOptions.container)
	.append(
		// Create content element
		elements.content = $('<div />', {
			'class': NAMESPACE + '-content',
			'id': this._id + '-content',
			'aria-atomic': TRUE
		})
	);

	// Set rendered flag and prevent redundant reposition calls for now
	this.rendered = -1;
	this.positioning = TRUE;

	// Create title...
	if(title) {
		this._createTitle();

		// Update title only if its not a callback (called in toggle if so)
		if(!$.isFunction(title)) {
			deferreds.push( this._updateTitle(title, FALSE) );
		}
	}

	// Create button
	if(button) { this._createButton(); }

	// Set proper rendered flag and update content if not a callback function (called in toggle)
	if(!$.isFunction(text)) {
		deferreds.push( this._updateContent(text, FALSE) );
	}
	this.rendered = TRUE;

	// Setup widget classes
	this._setWidget();

	// Initialize 'render' plugins
	$.each(PLUGINS, function(name) {
		var instance;
		if(this.initialize === 'render' && (instance = this(self))) {
			self.plugins[name] = instance;
		}
	});

	// Unassign initial events and assign proper events
	this._unassignEvents();
	this._assignEvents();

	// When deferreds have completed
	this._when(deferreds).then(function() {
		// tooltiprender event
		self._trigger('render');

		// Reset flags
		self.positioning = FALSE;

		// Show tooltip if not hidden during wait period
		if(!self.hiddenDuringWait && (options.show.ready || show)) {
			self.toggle(TRUE, cache.event, FALSE);
		}
		self.hiddenDuringWait = FALSE;
	});

	// Expose API
	QTIP.api[this.id] = this;

	return this;
};

PROTOTYPE.destroy = function(immediate) {
	// Set flag the signify destroy is taking place to plugins
	// and ensure it only gets destroyed once!
	if(this.destroyed) { return this.target; }

	function process() {
		if(this.destroyed) { return; }
		this.destroyed = TRUE;

		var target = this.target,
			title = target.attr(oldtitle),
			timer;

		// Destroy tooltip if rendered
		if(this.rendered) {
			this.tooltip.stop(1,0).find('*').remove().end().remove();
		}

		// Destroy all plugins
		$.each(this.plugins, function() {
			this.destroy && this.destroy();
		});

		// Clear timers
		for (timer in this.timers) {
			if (this.timers.hasOwnProperty(timer)) {
				clearTimeout(this.timers[timer]);
			}
		}

		// Remove api object and ARIA attributes
		target.removeData(NAMESPACE)
			.removeAttr(ATTR_ID)
			.removeAttr(ATTR_HAS)
			.removeAttr('aria-describedby');

		// Reset old title attribute if removed
		if(this.options.suppress && title) {
			target.attr('title', title).removeAttr(oldtitle);
		}

		// Remove qTip events associated with this API
		this._unassignEvents();

		// Remove ID from used id objects, and delete object references
		// for better garbage collection and leak protection
		this.options = this.elements = this.cache = this.timers =
			this.plugins = this.mouse = NULL;

		// Delete epoxsed API object
		delete QTIP.api[this.id];
	}

	// If an immediate destroy is needed
	if((immediate !== TRUE || this.triggering === 'hide') && this.rendered) {
		this.tooltip.one('tooltiphidden', $.proxy(process, this));
		!this.triggering && this.hide();
	}

	// If we're not in the process of hiding... process
	else { process.call(this); }

	return this.target;
};
;function invalidOpt(a) {
	return a === NULL || $.type(a) !== 'object';
}

function invalidContent(c) {
	return !($.isFunction(c) || 
            c && c.attr || 
            c.length || 
            $.type(c) === 'object' && (c.jquery || c.then));
}

// Option object sanitizer
function sanitizeOptions(opts) {
	var content, text, ajax, once;

	if(invalidOpt(opts)) { return FALSE; }

	if(invalidOpt(opts.metadata)) {
		opts.metadata = { type: opts.metadata };
	}

	if('content' in opts) {
		content = opts.content;

		if(invalidOpt(content) || content.jquery || content.done) {
			text = invalidContent(content) ? FALSE : content;
			content = opts.content = {
				text: text
			};
		}
		else { text = content.text; }

		// DEPRECATED - Old content.ajax plugin functionality
		// Converts it into the proper Deferred syntax
		if('ajax' in content) {
			ajax = content.ajax;
			once = ajax && ajax.once !== FALSE;
			delete content.ajax;

			content.text = function(event, api) {
				var loading = text || $(this).attr(api.options.content.attr) || 'Loading...',

				deferred = $.ajax(
					$.extend({}, ajax, { context: api })
				)
				.then(ajax.success, NULL, ajax.error)
				.then(function(newContent) {
					if(newContent && once) { api.set('content.text', newContent); }
					return newContent;
				},
				function(xhr, status, error) {
					if(api.destroyed || xhr.status === 0) { return; }
					api.set('content.text', status + ': ' + error);
				});

				return !once ? (api.set('content.text', loading), deferred) : loading;
			};
		}

		if('title' in content) {
			if($.isPlainObject(content.title)) {
				content.button = content.title.button;
				content.title = content.title.text;
			}

			if(invalidContent(content.title || FALSE)) {
				content.title = FALSE;
			}
		}
	}

	if('position' in opts && invalidOpt(opts.position)) {
		opts.position = { my: opts.position, at: opts.position };
	}

	if('show' in opts && invalidOpt(opts.show)) {
		opts.show = opts.show.jquery ? { target: opts.show } :
			opts.show === TRUE ? { ready: TRUE } : { event: opts.show };
	}

	if('hide' in opts && invalidOpt(opts.hide)) {
		opts.hide = opts.hide.jquery ? { target: opts.hide } : { event: opts.hide };
	}

	if('style' in opts && invalidOpt(opts.style)) {
		opts.style = { classes: opts.style };
	}

	// Sanitize plugin options
	$.each(PLUGINS, function() {
		this.sanitize && this.sanitize(opts);
	});

	return opts;
}

// Setup builtin .set() option checks
CHECKS = PROTOTYPE.checks = {
	builtin: {
		// Core checks
		'^id$': function(obj, o, v, prev) {
			var id = v === TRUE ? QTIP.nextid : v,
				newId = NAMESPACE + '-' + id;

			if(id !== FALSE && id.length > 0 && !$('#'+newId).length) {
				this._id = newId;

				if(this.rendered) {
					this.tooltip[0].id = this._id;
					this.elements.content[0].id = this._id + '-content';
					this.elements.title[0].id = this._id + '-title';
				}
			}
			else { obj[o] = prev; }
		},
		'^prerender': function(obj, o, v) {
			v && !this.rendered && this.render(this.options.show.ready);
		},

		// Content checks
		'^content.text$': function(obj, o, v) {
			this._updateContent(v);
		},
		'^content.attr$': function(obj, o, v, prev) {
			if(this.options.content.text === this.target.attr(prev)) {
				this._updateContent( this.target.attr(v) );
			}
		},
		'^content.title$': function(obj, o, v) {
			// Remove title if content is null
			if(!v) { return this._removeTitle(); }

			// If title isn't already created, create it now and update
			v && !this.elements.title && this._createTitle();
			this._updateTitle(v);
		},
		'^content.button$': function(obj, o, v) {
			this._updateButton(v);
		},
		'^content.title.(text|button)$': function(obj, o, v) {
			this.set('content.'+o, v); // Backwards title.text/button compat
		},

		// Position checks
		'^position.(my|at)$': function(obj, o, v){
			if('string' === typeof v) {
				this.position[o] = obj[o] = new CORNER(v, o === 'at');
			}
		},
		'^position.container$': function(obj, o, v){
			this.rendered && this.tooltip.appendTo(v);
		},

		// Show checks
		'^show.ready$': function(obj, o, v) {
			v && (!this.rendered && this.render(TRUE) || this.toggle(TRUE));
		},

		// Style checks
		'^style.classes$': function(obj, o, v, p) {
			this.rendered && this.tooltip.removeClass(p).addClass(v);
		},
		'^style.(width|height)': function(obj, o, v) {
			this.rendered && this.tooltip.css(o, v);
		},
		'^style.widget|content.title': function() {
			this.rendered && this._setWidget();
		},
		'^style.def': function(obj, o, v) {
			this.rendered && this.tooltip.toggleClass(CLASS_DEFAULT, !!v);
		},

		// Events check
		'^events.(render|show|move|hide|focus|blur)$': function(obj, o, v) {
			this.rendered && this.tooltip[($.isFunction(v) ? '' : 'un') + 'bind']('tooltip'+o, v);
		},

		// Properties which require event reassignment
		'^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)': function() {
			if(!this.rendered) { return; }

			// Set tracking flag
			var posOptions = this.options.position;
			this.tooltip.attr('tracking', posOptions.target === 'mouse' && posOptions.adjust.mouse);

			// Reassign events
			this._unassignEvents();
			this._assignEvents();
		}
	}
};

// Dot notation converter
function convertNotation(options, notation) {
	var i = 0, obj, option = options,

	// Split notation into array
	levels = notation.split('.');

	// Loop through
	while(option = option[ levels[i++] ]) {
		if(i < levels.length) { obj = option; }
	}

	return [obj || options, levels.pop()];
}

PROTOTYPE.get = function(notation) {
	if(this.destroyed) { return this; }

	var o = convertNotation(this.options, notation.toLowerCase()),
		result = o[0][ o[1] ];

	return result.precedance ? result.string() : result;
};

function setCallback(notation, args) {
	var category, rule, match;

	for(category in this.checks) {
		if (!this.checks.hasOwnProperty(category)) { continue; }

		for(rule in this.checks[category]) {
			if (!this.checks[category].hasOwnProperty(rule)) { continue; }

			if(match = (new RegExp(rule, 'i')).exec(notation)) {
				args.push(match);

				if(category === 'builtin' || this.plugins[category]) {
					this.checks[category][rule].apply(
						this.plugins[category] || this, args
					);
				}
			}
		}
	}
}

var rmove = /^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i,
	rrender = /^prerender|show\.ready/i;

PROTOTYPE.set = function(option, value) {
	if(this.destroyed) { return this; }

	var rendered = this.rendered,
		reposition = FALSE,
		options = this.options,
		name;

	// Convert singular option/value pair into object form
	if('string' === typeof option) {
		name = option; option = {}; option[name] = value;
	}
	else { option = $.extend({}, option); }

	// Set all of the defined options to their new values
	$.each(option, function(notation, val) {
		if(rendered && rrender.test(notation)) {
			delete option[notation]; return;
		}

		// Set new obj value
		var obj = convertNotation(options, notation.toLowerCase()), previous;
		previous = obj[0][ obj[1] ];
		obj[0][ obj[1] ] = val && val.nodeType ? $(val) : val;

		// Also check if we need to reposition
		reposition = rmove.test(notation) || reposition;

		// Set the new params for the callback
		option[notation] = [obj[0], obj[1], val, previous];
	});

	// Re-sanitize options
	sanitizeOptions(options);

	/*
	 * Execute any valid callbacks for the set options
	 * Also set positioning flag so we don't get loads of redundant repositioning calls.
	 */
	this.positioning = TRUE;
	$.each(option, $.proxy(setCallback, this));
	this.positioning = FALSE;

	// Update position if needed
	if(this.rendered && this.tooltip[0].offsetWidth > 0 && reposition) {
		this.reposition( options.position.target === 'mouse' ? NULL : this.cache.event );
	}

	return this;
};
;PROTOTYPE._update = function(content, element) {
	var self = this,
		cache = this.cache;

	// Make sure tooltip is rendered and content is defined. If not return
	if(!this.rendered || !content) { return FALSE; }

	// Use function to parse content
	if($.isFunction(content)) {
		content = content.call(this.elements.target, cache.event, this) || '';
	}

	// Handle deferred content
	if($.isFunction(content.then)) {
		cache.waiting = TRUE;
		return content.then(function(c) {
			cache.waiting = FALSE;
			return self._update(c, element);
		}, NULL, function(e) {
			return self._update(e, element);
		});
	}

	// If content is null... return false
	if(content === FALSE || !content && content !== '') { return FALSE; }

	// Append new content if its a DOM array and show it if hidden
	if(content.jquery && content.length > 0) {
		element.empty().append(
			content.css({ display: 'block', visibility: 'visible' })
		);
	}

	// Content is a regular string, insert the new content
	else { element.html(content); }

	// Wait for content to be loaded, and reposition
	return this._waitForContent(element).then(function(images) {
		if(self.rendered && self.tooltip[0].offsetWidth > 0) {
			self.reposition(cache.event, !images.length);
		}
	});
};

PROTOTYPE._waitForContent = function(element) {
	var cache = this.cache;

	// Set flag
	cache.waiting = TRUE;

	// If imagesLoaded is included, ensure images have loaded and return promise
	return ( $.fn.imagesLoaded ? element.imagesLoaded() : new $.Deferred().resolve([]) )
		.done(function() { cache.waiting = FALSE; })
		.promise();
};

PROTOTYPE._updateContent = function(content, reposition) {
	this._update(content, this.elements.content, reposition);
};

PROTOTYPE._updateTitle = function(content, reposition) {
	if(this._update(content, this.elements.title, reposition) === FALSE) {
		this._removeTitle(FALSE);
	}
};

PROTOTYPE._createTitle = function()
{
	var elements = this.elements,
		id = this._id+'-title';

	// Destroy previous title element, if present
	if(elements.titlebar) { this._removeTitle(); }

	// Create title bar and title elements
	elements.titlebar = $('<div />', {
		'class': NAMESPACE + '-titlebar ' + (this.options.style.widget ? createWidgetClass('header') : '')
	})
	.append(
		elements.title = $('<div />', {
			'id': id,
			'class': NAMESPACE + '-title',
			'aria-atomic': TRUE
		})
	)
	.insertBefore(elements.content)

	// Button-specific events
	.delegate('.qtip-close', 'mousedown keydown mouseup keyup mouseout', function(event) {
		$(this).toggleClass('ui-state-active ui-state-focus', event.type.substr(-4) === 'down');
	})
	.delegate('.qtip-close', 'mouseover mouseout', function(event){
		$(this).toggleClass('ui-state-hover', event.type === 'mouseover');
	});

	// Create button if enabled
	if(this.options.content.button) { this._createButton(); }
};

PROTOTYPE._removeTitle = function(reposition)
{
	var elements = this.elements;

	if(elements.title) {
		elements.titlebar.remove();
		elements.titlebar = elements.title = elements.button = NULL;

		// Reposition if enabled
		if(reposition !== FALSE) { this.reposition(); }
	}
};
;PROTOTYPE._createPosClass = function(my) {
	return NAMESPACE + '-pos-' + (my || this.options.position.my).abbrev();
};

PROTOTYPE.reposition = function(event, effect) {
	if(!this.rendered || this.positioning || this.destroyed) { return this; }

	// Set positioning flag
	this.positioning = TRUE;

	var cache = this.cache,
		tooltip = this.tooltip,
		posOptions = this.options.position,
		target = posOptions.target,
		my = posOptions.my,
		at = posOptions.at,
		viewport = posOptions.viewport,
		container = posOptions.container,
		adjust = posOptions.adjust,
		method = adjust.method.split(' '),
		tooltipWidth = tooltip.outerWidth(FALSE),
		tooltipHeight = tooltip.outerHeight(FALSE),
		targetWidth = 0,
		targetHeight = 0,
		type = tooltip.css('position'),
		position = { left: 0, top: 0 },
		visible = tooltip[0].offsetWidth > 0,
		isScroll = event && event.type === 'scroll',
		win = $(window),
		doc = container[0].ownerDocument,
		mouse = this.mouse,
		pluginCalculations, offset, adjusted, newClass;

	// Check if absolute position was passed
	if($.isArray(target) && target.length === 2) {
		// Force left top and set position
		at = { x: LEFT, y: TOP };
		position = { left: target[0], top: target[1] };
	}

	// Check if mouse was the target
	else if(target === 'mouse') {
		// Force left top to allow flipping
		at = { x: LEFT, y: TOP };

		// Use the mouse origin that caused the show event, if distance hiding is enabled
		if((!adjust.mouse || this.options.hide.distance) && cache.origin && cache.origin.pageX) {
			event =  cache.origin;
		}

		// Use cached event for resize/scroll events
		else if(!event || event && (event.type === 'resize' || event.type === 'scroll')) {
			event = cache.event;
		}

		// Otherwise, use the cached mouse coordinates if available
		else if(mouse && mouse.pageX) {
			event = mouse;
		}

		// Calculate body and container offset and take them into account below
		if(type !== 'static') { position = container.offset(); }
		if(doc.body.offsetWidth !== (window.innerWidth || doc.documentElement.clientWidth)) {
			offset = $(document.body).offset();
		}

		// Use event coordinates for position
		position = {
			left: event.pageX - position.left + (offset && offset.left || 0),
			top: event.pageY - position.top + (offset && offset.top || 0)
		};

		// Scroll events are a pain, some browsers
		if(adjust.mouse && isScroll && mouse) {
			position.left -= (mouse.scrollX || 0) - win.scrollLeft();
			position.top -= (mouse.scrollY || 0) - win.scrollTop();
		}
	}

	// Target wasn't mouse or absolute...
	else {
		// Check if event targetting is being used
		if(target === 'event') {
			if(event && event.target && event.type !== 'scroll' && event.type !== 'resize') {
				cache.target = $(event.target);
			}
			else if(!event.target) {
				cache.target = this.elements.target;
			}
		}
		else if(target !== 'event'){
			cache.target = $(target.jquery ? target : this.elements.target);
		}
		target = cache.target;

		// Parse the target into a jQuery object and make sure there's an element present
		target = $(target).eq(0);
		if(target.length === 0) { return this; }

		// Check if window or document is the target
		else if(target[0] === document || target[0] === window) {
			targetWidth = BROWSER.iOS ? window.innerWidth : target.width();
			targetHeight = BROWSER.iOS ? window.innerHeight : target.height();

			if(target[0] === window) {
				position = {
					top: (viewport || target).scrollTop(),
					left: (viewport || target).scrollLeft()
				};
			}
		}

		// Check if the target is an <AREA> element
		else if(PLUGINS.imagemap && target.is('area')) {
			pluginCalculations = PLUGINS.imagemap(this, target, at, PLUGINS.viewport ? method : FALSE);
		}

		// Check if the target is an SVG element
		else if(PLUGINS.svg && target && target[0].ownerSVGElement) {
			pluginCalculations = PLUGINS.svg(this, target, at, PLUGINS.viewport ? method : FALSE);
		}

		// Otherwise use regular jQuery methods
		else {
			targetWidth = target.outerWidth(FALSE);
			targetHeight = target.outerHeight(FALSE);
			position = target.offset();
		}

		// Parse returned plugin values into proper variables
		if(pluginCalculations) {
			targetWidth = pluginCalculations.width;
			targetHeight = pluginCalculations.height;
			offset = pluginCalculations.offset;
			position = pluginCalculations.position;
		}

		// Adjust position to take into account offset parents
		position = this.reposition.offset(target, position, container);

		// Adjust for position.fixed tooltips (and also iOS scroll bug in v3.2-4.0 & v4.3-4.3.2)
		if(BROWSER.iOS > 3.1 && BROWSER.iOS < 4.1 ||
			BROWSER.iOS >= 4.3 && BROWSER.iOS < 4.33 ||
			!BROWSER.iOS && type === 'fixed'
		){
			position.left -= win.scrollLeft();
			position.top -= win.scrollTop();
		}

		// Adjust position relative to target
		if(!pluginCalculations || pluginCalculations && pluginCalculations.adjustable !== FALSE) {
			position.left += at.x === RIGHT ? targetWidth : at.x === CENTER ? targetWidth / 2 : 0;
			position.top += at.y === BOTTOM ? targetHeight : at.y === CENTER ? targetHeight / 2 : 0;
		}
	}

	// Adjust position relative to tooltip
	position.left += adjust.x + (my.x === RIGHT ? -tooltipWidth : my.x === CENTER ? -tooltipWidth / 2 : 0);
	position.top += adjust.y + (my.y === BOTTOM ? -tooltipHeight : my.y === CENTER ? -tooltipHeight / 2 : 0);

	// Use viewport adjustment plugin if enabled
	if(PLUGINS.viewport) {
		adjusted = position.adjusted = PLUGINS.viewport(
			this, position, posOptions, targetWidth, targetHeight, tooltipWidth, tooltipHeight
		);

		// Apply offsets supplied by positioning plugin (if used)
		if(offset && adjusted.left) { position.left += offset.left; }
		if(offset && adjusted.top) {  position.top += offset.top; }

		// Apply any new 'my' position
		if(adjusted.my) { this.position.my = adjusted.my; }
	}

	// Viewport adjustment is disabled, set values to zero
	else { position.adjusted = { left: 0, top: 0 }; }

	// Set tooltip position class if it's changed
	if(cache.posClass !== (newClass = this._createPosClass(this.position.my))) {
		cache.posClass = newClass;
		tooltip.removeClass(cache.posClass).addClass(newClass);
	}

	// tooltipmove event
	if(!this._trigger('move', [position, viewport.elem || viewport], event)) { return this; }
	delete position.adjusted;

	// If effect is disabled, target it mouse, no animation is defined or positioning gives NaN out, set CSS directly
	if(effect === FALSE || !visible || isNaN(position.left) || isNaN(position.top) || target === 'mouse' || !$.isFunction(posOptions.effect)) {
		tooltip.css(position);
	}

	// Use custom function if provided
	else if($.isFunction(posOptions.effect)) {
		posOptions.effect.call(tooltip, this, $.extend({}, position));
		tooltip.queue(function(next) {
			// Reset attributes to avoid cross-browser rendering bugs
			$(this).css({ opacity: '', height: '' });
			if(BROWSER.ie) { this.style.removeAttribute('filter'); }

			next();
		});
	}

	// Set positioning flag
	this.positioning = FALSE;

	return this;
};

// Custom (more correct for qTip!) offset calculator
PROTOTYPE.reposition.offset = function(elem, pos, container) {
	if(!container[0]) { return pos; }

	var ownerDocument = $(elem[0].ownerDocument),
		quirks = !!BROWSER.ie && document.compatMode !== 'CSS1Compat',
		parent = container[0],
		scrolled, position, parentOffset, overflow;

	function scroll(e, i) {
		pos.left += i * e.scrollLeft();
		pos.top += i * e.scrollTop();
	}

	// Compensate for non-static containers offset
	do {
		if((position = $.css(parent, 'position')) !== 'static') {
			if(position === 'fixed') {
				parentOffset = parent.getBoundingClientRect();
				scroll(ownerDocument, -1);
			}
			else {
				parentOffset = $(parent).position();
				parentOffset.left += parseFloat($.css(parent, 'borderLeftWidth')) || 0;
				parentOffset.top += parseFloat($.css(parent, 'borderTopWidth')) || 0;
			}

			pos.left -= parentOffset.left + (parseFloat($.css(parent, 'marginLeft')) || 0);
			pos.top -= parentOffset.top + (parseFloat($.css(parent, 'marginTop')) || 0);

			// If this is the first parent element with an overflow of "scroll" or "auto", store it
			if(!scrolled && (overflow = $.css(parent, 'overflow')) !== 'hidden' && overflow !== 'visible') { scrolled = $(parent); }
		}
	}
	while(parent = parent.offsetParent);

	// Compensate for containers scroll if it also has an offsetParent (or in IE quirks mode)
	if(scrolled && (scrolled[0] !== ownerDocument[0] || quirks)) {
		scroll(scrolled, 1);
	}

	return pos;
};

// Corner class
var C = (CORNER = PROTOTYPE.reposition.Corner = function(corner, forceY) {
	corner = ('' + corner).replace(/([A-Z])/, ' $1').replace(/middle/gi, CENTER).toLowerCase();
	this.x = (corner.match(/left|right/i) || corner.match(/center/) || ['inherit'])[0].toLowerCase();
	this.y = (corner.match(/top|bottom|center/i) || ['inherit'])[0].toLowerCase();
	this.forceY = !!forceY;

	var f = corner.charAt(0);
	this.precedance = f === 't' || f === 'b' ? Y : X;
}).prototype;

C.invert = function(z, center) {
	this[z] = this[z] === LEFT ? RIGHT : this[z] === RIGHT ? LEFT : center || this[z];
};

C.string = function(join) {
	var x = this.x, y = this.y;

	var result = x !== y ?
		x === 'center' || y !== 'center' && (this.precedance === Y || this.forceY) ? 
			[y,x] : 
			[x,y] :
		[x];

	return join !== false ? result.join(' ') : result;
};

C.abbrev = function() {
	var result = this.string(false);
	return result[0].charAt(0) + (result[1] && result[1].charAt(0) || '');
};

C.clone = function() {
	return new CORNER( this.string(), this.forceY );
};

;
PROTOTYPE.toggle = function(state, event) {
	var cache = this.cache,
		options = this.options,
		tooltip = this.tooltip;

	// Try to prevent flickering when tooltip overlaps show element
	if(event) {
		if((/over|enter/).test(event.type) && cache.event && (/out|leave/).test(cache.event.type) &&
			options.show.target.add(event.target).length === options.show.target.length &&
			tooltip.has(event.relatedTarget).length) {
			return this;
		}

		// Cache event
		cache.event = $.event.fix(event);
	}

	// If we're currently waiting and we've just hidden... stop it
	this.waiting && !state && (this.hiddenDuringWait = TRUE);

	// Render the tooltip if showing and it isn't already
	if(!this.rendered) { return state ? this.render(1) : this; }
	else if(this.destroyed || this.disabled) { return this; }

	var type = state ? 'show' : 'hide',
		opts = this.options[type],
		posOptions = this.options.position,
		contentOptions = this.options.content,
		width = this.tooltip.css('width'),
		visible = this.tooltip.is(':visible'),
		animate = state || opts.target.length === 1,
		sameTarget = !event || opts.target.length < 2 || cache.target[0] === event.target,
		identicalState, allow, after;

	// Detect state if valid one isn't provided
	if((typeof state).search('boolean|number')) { state = !visible; }

	// Check if the tooltip is in an identical state to the new would-be state
	identicalState = !tooltip.is(':animated') && visible === state && sameTarget;

	// Fire tooltip(show/hide) event and check if destroyed
	allow = !identicalState ? !!this._trigger(type, [90]) : NULL;

	// Check to make sure the tooltip wasn't destroyed in the callback
	if(this.destroyed) { return this; }

	// If the user didn't stop the method prematurely and we're showing the tooltip, focus it
	if(allow !== FALSE && state) { this.focus(event); }

	// If the state hasn't changed or the user stopped it, return early
	if(!allow || identicalState) { return this; }

	// Set ARIA hidden attribute
	$.attr(tooltip[0], 'aria-hidden', !!!state);

	// Execute state specific properties
	if(state) {
		// Store show origin coordinates
		this.mouse && (cache.origin = $.event.fix(this.mouse));

		// Update tooltip content & title if it's a dynamic function
		if($.isFunction(contentOptions.text)) { this._updateContent(contentOptions.text, FALSE); }
		if($.isFunction(contentOptions.title)) { this._updateTitle(contentOptions.title, FALSE); }

		// Cache mousemove events for positioning purposes (if not already tracking)
		if(!trackingBound && posOptions.target === 'mouse' && posOptions.adjust.mouse) {
			$(document).bind('mousemove.'+NAMESPACE, this._storeMouse);
			trackingBound = TRUE;
		}

		// Update the tooltip position (set width first to prevent viewport/max-width issues)
		if(!width) { tooltip.css('width', tooltip.outerWidth(FALSE)); }
		this.reposition(event, arguments[2]);
		if(!width) { tooltip.css('width', ''); }

		// Hide other tooltips if tooltip is solo
		if(!!opts.solo) {
			(typeof opts.solo === 'string' ? $(opts.solo) : $(SELECTOR, opts.solo))
				.not(tooltip).not(opts.target).qtip('hide', new $.Event('tooltipsolo'));
		}
	}
	else {
		// Clear show timer if we're hiding
		clearTimeout(this.timers.show);

		// Remove cached origin on hide
		delete cache.origin;

		// Remove mouse tracking event if not needed (all tracking qTips are hidden)
		if(trackingBound && !$(SELECTOR+'[tracking="true"]:visible', opts.solo).not(tooltip).length) {
			$(document).unbind('mousemove.'+NAMESPACE);
			trackingBound = FALSE;
		}

		// Blur the tooltip
		this.blur(event);
	}

	// Define post-animation, state specific properties
	after = $.proxy(function() {
		if(state) {
			// Prevent antialias from disappearing in IE by removing filter
			if(BROWSER.ie) { tooltip[0].style.removeAttribute('filter'); }

			// Remove overflow setting to prevent tip bugs
			tooltip.css('overflow', '');

			// Autofocus elements if enabled
			if('string' === typeof opts.autofocus) {
				$(this.options.show.autofocus, tooltip).focus();
			}

			// If set, hide tooltip when inactive for delay period
			this.options.show.target.trigger('qtip-'+this.id+'-inactive');
		}
		else {
			// Reset CSS states
			tooltip.css({
				display: '',
				visibility: '',
				opacity: '',
				left: '',
				top: ''
			});
		}

		// tooltipvisible/tooltiphidden events
		this._trigger(state ? 'visible' : 'hidden');
	}, this);

	// If no effect type is supplied, use a simple toggle
	if(opts.effect === FALSE || animate === FALSE) {
		tooltip[ type ]();
		after();
	}

	// Use custom function if provided
	else if($.isFunction(opts.effect)) {
		tooltip.stop(1, 1);
		opts.effect.call(tooltip, this);
		tooltip.queue('fx', function(n) {
			after(); n();
		});
	}

	// Use basic fade function by default
	else { tooltip.fadeTo(90, state ? 1 : 0, after); }

	// If inactive hide method is set, active it
	if(state) { opts.target.trigger('qtip-'+this.id+'-inactive'); }

	return this;
};

PROTOTYPE.show = function(event) { return this.toggle(TRUE, event); };

PROTOTYPE.hide = function(event) { return this.toggle(FALSE, event); };
;PROTOTYPE.focus = function(event) {
	if(!this.rendered || this.destroyed) { return this; }

	var qtips = $(SELECTOR),
		tooltip = this.tooltip,
		curIndex = parseInt(tooltip[0].style.zIndex, 10),
		newIndex = QTIP.zindex + qtips.length;

	// Only update the z-index if it has changed and tooltip is not already focused
	if(!tooltip.hasClass(CLASS_FOCUS)) {
		// tooltipfocus event
		if(this._trigger('focus', [newIndex], event)) {
			// Only update z-index's if they've changed
			if(curIndex !== newIndex) {
				// Reduce our z-index's and keep them properly ordered
				qtips.each(function() {
					if(this.style.zIndex > curIndex) {
						this.style.zIndex = this.style.zIndex - 1;
					}
				});

				// Fire blur event for focused tooltip
				qtips.filter('.' + CLASS_FOCUS).qtip('blur', event);
			}

			// Set the new z-index
			tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;
		}
	}

	return this;
};

PROTOTYPE.blur = function(event) {
	if(!this.rendered || this.destroyed) { return this; }

	// Set focused status to FALSE
	this.tooltip.removeClass(CLASS_FOCUS);

	// tooltipblur event
	this._trigger('blur', [ this.tooltip.css('zIndex') ], event);

	return this;
};
;PROTOTYPE.disable = function(state) {
	if(this.destroyed) { return this; }

	// If 'toggle' is passed, toggle the current state
	if(state === 'toggle') {
		state = !(this.rendered ? this.tooltip.hasClass(CLASS_DISABLED) : this.disabled);
	}

	// Disable if no state passed
	else if('boolean' !== typeof state) {
		state = TRUE;
	}

	if(this.rendered) {
		this.tooltip.toggleClass(CLASS_DISABLED, state)
			.attr('aria-disabled', state);
	}

	this.disabled = !!state;

	return this;
};

PROTOTYPE.enable = function() { return this.disable(FALSE); };
;PROTOTYPE._createButton = function()
{
	var self = this,
		elements = this.elements,
		tooltip = elements.tooltip,
		button = this.options.content.button,
		isString = typeof button === 'string',
		close = isString ? button : 'Close tooltip';

	if(elements.button) { elements.button.remove(); }

	// Use custom button if one was supplied by user, else use default
	if(button.jquery) {
		elements.button = button;
	}
	else {
		elements.button = $('<a />', {
			'class': 'qtip-close ' + (this.options.style.widget ? '' : NAMESPACE+'-icon'),
			'title': close,
			'aria-label': close
		})
		.prepend(
			$('<span />', {
				'class': 'ui-icon ui-icon-close',
				'html': '&times;'
			})
		);
	}

	// Create button and setup attributes
	elements.button.appendTo(elements.titlebar || tooltip)
		.attr('role', 'button')
		.click(function(event) {
			if(!tooltip.hasClass(CLASS_DISABLED)) { self.hide(event); }
			return FALSE;
		});
};

PROTOTYPE._updateButton = function(button)
{
	// Make sure tooltip is rendered and if not, return
	if(!this.rendered) { return FALSE; }

	var elem = this.elements.button;
	if(button) { this._createButton(); }
	else { elem.remove(); }
};
;// Widget class creator
function createWidgetClass(cls) {
	return WIDGET.concat('').join(cls ? '-'+cls+' ' : ' ');
}

// Widget class setter method
PROTOTYPE._setWidget = function()
{
	var on = this.options.style.widget,
		elements = this.elements,
		tooltip = elements.tooltip,
		disabled = tooltip.hasClass(CLASS_DISABLED);

	tooltip.removeClass(CLASS_DISABLED);
	CLASS_DISABLED = on ? 'ui-state-disabled' : 'qtip-disabled';
	tooltip.toggleClass(CLASS_DISABLED, disabled);

	tooltip.toggleClass('ui-helper-reset '+createWidgetClass(), on).toggleClass(CLASS_DEFAULT, this.options.style.def && !on);

	if(elements.content) {
		elements.content.toggleClass( createWidgetClass('content'), on);
	}
	if(elements.titlebar) {
		elements.titlebar.toggleClass( createWidgetClass('header'), on);
	}
	if(elements.button) {
		elements.button.toggleClass(NAMESPACE+'-icon', !on);
	}
};
;function delay(callback, duration) {
	// If tooltip has displayed, start hide timer
	if(duration > 0) {
		return setTimeout(
			$.proxy(callback, this), duration
		);
	}
	else{ callback.call(this); }
}

function showMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED)) { return; }

	// Clear hide timers
	clearTimeout(this.timers.show);
	clearTimeout(this.timers.hide);

	// Start show timer
	this.timers.show = delay.call(this,
		function() { this.toggle(TRUE, event); },
		this.options.show.delay
	);
}

function hideMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED) || this.destroyed) { return; }

	// Check if new target was actually the tooltip element
	var relatedTarget = $(event.relatedTarget),
		ontoTooltip = relatedTarget.closest(SELECTOR)[0] === this.tooltip[0],
		ontoTarget = relatedTarget[0] === this.options.show.target[0];

	// Clear timers and stop animation queue
	clearTimeout(this.timers.show);
	clearTimeout(this.timers.hide);

	// Prevent hiding if tooltip is fixed and event target is the tooltip.
	// Or if mouse positioning is enabled and cursor momentarily overlaps
	if(this !== relatedTarget[0] &&
		(this.options.position.target === 'mouse' && ontoTooltip) ||
		this.options.hide.fixed && (
			(/mouse(out|leave|move)/).test(event.type) && (ontoTooltip || ontoTarget))
		)
	{
		/* eslint-disable no-empty */
		try {
			event.preventDefault();
			event.stopImmediatePropagation();
		} catch(e) {}
		/* eslint-enable no-empty */

		return;
	}

	// If tooltip has displayed, start hide timer
	this.timers.hide = delay.call(this,
		function() { this.toggle(FALSE, event); },
		this.options.hide.delay,
		this
	);
}

function inactiveMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED) || !this.options.hide.inactive) { return; }

	// Clear timer
	clearTimeout(this.timers.inactive);

	this.timers.inactive = delay.call(this,
		function(){ this.hide(event); },
		this.options.hide.inactive
	);
}

function repositionMethod(event) {
	if(this.rendered && this.tooltip[0].offsetWidth > 0) { this.reposition(event); }
}

// Store mouse coordinates
PROTOTYPE._storeMouse = function(event) {
	(this.mouse = $.event.fix(event)).type = 'mousemove';
	return this;
};

// Bind events
PROTOTYPE._bind = function(targets, events, method, suffix, context) {
	if(!targets || !method || !events.length) { return; }
	var ns = '.' + this._id + (suffix ? '-'+suffix : '');
	$(targets).bind(
		(events.split ? events : events.join(ns + ' ')) + ns,
		$.proxy(method, context || this)
	);
	return this;
};
PROTOTYPE._unbind = function(targets, suffix) {
	targets && $(targets).unbind('.' + this._id + (suffix ? '-'+suffix : ''));
	return this;
};

// Global delegation helper
function delegate(selector, events, method) {
	$(document.body).delegate(selector,
		(events.split ? events : events.join('.'+NAMESPACE + ' ')) + '.'+NAMESPACE,
		function() {
			var api = QTIP.api[ $.attr(this, ATTR_ID) ];
			api && !api.disabled && method.apply(api, arguments);
		}
	);
}
// Event trigger
PROTOTYPE._trigger = function(type, args, event) {
	var callback = new $.Event('tooltip'+type);
	callback.originalEvent = event && $.extend({}, event) || this.cache.event || NULL;

	this.triggering = type;
	this.tooltip.trigger(callback, [this].concat(args || []));
	this.triggering = FALSE;

	return !callback.isDefaultPrevented();
};

PROTOTYPE._bindEvents = function(showEvents, hideEvents, showTargets, hideTargets, showCallback, hideCallback) {
	// Get tasrgets that lye within both
	var similarTargets = showTargets.filter( hideTargets ).add( hideTargets.filter(showTargets) ),
		toggleEvents = [];

	// If hide and show targets are the same...
	if(similarTargets.length) {

		// Filter identical show/hide events
		$.each(hideEvents, function(i, type) {
			var showIndex = $.inArray(type, showEvents);

			// Both events are identical, remove from both hide and show events
			// and append to toggleEvents
			showIndex > -1 && toggleEvents.push( showEvents.splice( showIndex, 1 )[0] );
		});

		// Toggle events are special case of identical show/hide events, which happen in sequence
		if(toggleEvents.length) {
			// Bind toggle events to the similar targets
			this._bind(similarTargets, toggleEvents, function(event) {
				var state = this.rendered ? this.tooltip[0].offsetWidth > 0 : false;
				(state ? hideCallback : showCallback).call(this, event);
			});

			// Remove the similar targets from the regular show/hide bindings
			showTargets = showTargets.not(similarTargets);
			hideTargets = hideTargets.not(similarTargets);
		}
	}

	// Apply show/hide/toggle events
	this._bind(showTargets, showEvents, showCallback);
	this._bind(hideTargets, hideEvents, hideCallback);
};

PROTOTYPE._assignInitialEvents = function(event) {
	var options = this.options,
		showTarget = options.show.target,
		hideTarget = options.hide.target,
		showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [],
		hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [];

	// Catch remove/removeqtip events on target element to destroy redundant tooltips
	this._bind(this.elements.target, ['remove', 'removeqtip'], function() {
		this.destroy(true);
	}, 'destroy');

	/*
	 * Make sure hoverIntent functions properly by using mouseleave as a hide event if
	 * mouseenter/mouseout is used for show.event, even if it isn't in the users options.
	 */
	if(/mouse(over|enter)/i.test(options.show.event) && !/mouse(out|leave)/i.test(options.hide.event)) {
		hideEvents.push('mouseleave');
	}

	/*
	 * Also make sure initial mouse targetting works correctly by caching mousemove coords
	 * on show targets before the tooltip has rendered. Also set onTarget when triggered to
	 * keep mouse tracking working.
	 */
	this._bind(showTarget, 'mousemove', function(moveEvent) {
		this._storeMouse(moveEvent);
		this.cache.onTarget = TRUE;
	});

	// Define hoverIntent function
	function hoverIntent(hoverEvent) {
		// Only continue if tooltip isn't disabled
		if(this.disabled || this.destroyed) { return FALSE; }

		// Cache the event data
		this.cache.event = hoverEvent && $.event.fix(hoverEvent);
		this.cache.target = hoverEvent && $(hoverEvent.target);

		// Start the event sequence
		clearTimeout(this.timers.show);
		this.timers.show = delay.call(this,
			function() { this.render(typeof hoverEvent === 'object' || options.show.ready); },
			options.prerender ? 0 : options.show.delay
		);
	}

	// Filter and bind events
	this._bindEvents(showEvents, hideEvents, showTarget, hideTarget, hoverIntent, function() {
		if(!this.timers) { return FALSE; }
		clearTimeout(this.timers.show);
	});

	// Prerendering is enabled, create tooltip now
	if(options.show.ready || options.prerender) { hoverIntent.call(this, event); }
};

// Event assignment method
PROTOTYPE._assignEvents = function() {
	var self = this,
		options = this.options,
		posOptions = options.position,

		tooltip = this.tooltip,
		showTarget = options.show.target,
		hideTarget = options.hide.target,
		containerTarget = posOptions.container,
		viewportTarget = posOptions.viewport,
		documentTarget = $(document),
		windowTarget = $(window),

		showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [],
		hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [];


	// Assign passed event callbacks
	$.each(options.events, function(name, callback) {
		self._bind(tooltip, name === 'toggle' ? ['tooltipshow','tooltiphide'] : ['tooltip'+name], callback, null, tooltip);
	});

	// Hide tooltips when leaving current window/frame (but not select/option elements)
	if(/mouse(out|leave)/i.test(options.hide.event) && options.hide.leave === 'window') {
		this._bind(documentTarget, ['mouseout', 'blur'], function(event) {
			if(!/select|option/.test(event.target.nodeName) && !event.relatedTarget) {
				this.hide(event);
			}
		});
	}

	// Enable hide.fixed by adding appropriate class
	if(options.hide.fixed) {
		hideTarget = hideTarget.add( tooltip.addClass(CLASS_FIXED) );
	}

	/*
	 * Make sure hoverIntent functions properly by using mouseleave to clear show timer if
	 * mouseenter/mouseout is used for show.event, even if it isn't in the users options.
	 */
	else if(/mouse(over|enter)/i.test(options.show.event)) {
		this._bind(hideTarget, 'mouseleave', function() {
			clearTimeout(this.timers.show);
		});
	}

	// Hide tooltip on document mousedown if unfocus events are enabled
	if(('' + options.hide.event).indexOf('unfocus') > -1) {
		this._bind(containerTarget.closest('html'), ['mousedown', 'touchstart'], function(event) {
			var elem = $(event.target),
				enabled = this.rendered && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0,
				isAncestor = elem.parents(SELECTOR).filter(this.tooltip[0]).length > 0;

			if(elem[0] !== this.target[0] && elem[0] !== this.tooltip[0] && !isAncestor &&
				!this.target.has(elem[0]).length && enabled
			) {
				this.hide(event);
			}
		});
	}

	// Check if the tooltip hides when inactive
	if('number' === typeof options.hide.inactive) {
		// Bind inactive method to show target(s) as a custom event
		this._bind(showTarget, 'qtip-'+this.id+'-inactive', inactiveMethod, 'inactive');

		// Define events which reset the 'inactive' event handler
		this._bind(hideTarget.add(tooltip), QTIP.inactiveEvents, inactiveMethod);
	}

	// Filter and bind events
	this._bindEvents(showEvents, hideEvents, showTarget, hideTarget, showMethod, hideMethod);

	// Mouse movement bindings
	this._bind(showTarget.add(tooltip), 'mousemove', function(event) {
		// Check if the tooltip hides when mouse is moved a certain distance
		if('number' === typeof options.hide.distance) {
			var origin = this.cache.origin || {},
				limit = this.options.hide.distance,
				abs = Math.abs;

			// Check if the movement has gone beyond the limit, and hide it if so
			if(abs(event.pageX - origin.pageX) >= limit || abs(event.pageY - origin.pageY) >= limit) {
				this.hide(event);
			}
		}

		// Cache mousemove coords on show targets
		this._storeMouse(event);
	});

	// Mouse positioning events
	if(posOptions.target === 'mouse') {
		// If mouse adjustment is on...
		if(posOptions.adjust.mouse) {
			// Apply a mouseleave event so we don't get problems with overlapping
			if(options.hide.event) {
				// Track if we're on the target or not
				this._bind(showTarget, ['mouseenter', 'mouseleave'], function(event) {
					if(!this.cache) {return FALSE; }
					this.cache.onTarget = event.type === 'mouseenter';
				});
			}

			// Update tooltip position on mousemove
			this._bind(documentTarget, 'mousemove', function(event) {
				// Update the tooltip position only if the tooltip is visible and adjustment is enabled
				if(this.rendered && this.cache.onTarget && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0) {
					this.reposition(event);
				}
			});
		}
	}

	// Adjust positions of the tooltip on window resize if enabled
	if(posOptions.adjust.resize || viewportTarget.length) {
		this._bind( $.event.special.resize ? viewportTarget : windowTarget, 'resize', repositionMethod );
	}

	// Adjust tooltip position on scroll of the window or viewport element if present
	if(posOptions.adjust.scroll) {
		this._bind( windowTarget.add(posOptions.container), 'scroll', repositionMethod );
	}
};

// Un-assignment method
PROTOTYPE._unassignEvents = function() {
	var options = this.options,
		showTargets = options.show.target,
		hideTargets = options.hide.target,
		targets = $.grep([
			this.elements.target[0],
			this.rendered && this.tooltip[0],
			options.position.container[0],
			options.position.viewport[0],
			options.position.container.closest('html')[0], // unfocus
			window,
			document
		], function(i) {
			return typeof i === 'object';
		});

	// Add show and hide targets if they're valid
	if(showTargets && showTargets.toArray) {
		targets = targets.concat(showTargets.toArray());
	}
	if(hideTargets && hideTargets.toArray) {
		targets = targets.concat(hideTargets.toArray());
	}

	// Unbind the events
	this._unbind(targets)
		._unbind(targets, 'destroy')
		._unbind(targets, 'inactive');
};

// Apply common event handlers using delegate (avoids excessive .bind calls!)
$(function() {
	delegate(SELECTOR, ['mouseenter', 'mouseleave'], function(event) {
		var state = event.type === 'mouseenter',
			tooltip = $(event.currentTarget),
			target = $(event.relatedTarget || event.target),
			options = this.options;

		// On mouseenter...
		if(state) {
			// Focus the tooltip on mouseenter (z-index stacking)
			this.focus(event);

			// Clear hide timer on tooltip hover to prevent it from closing
			tooltip.hasClass(CLASS_FIXED) && !tooltip.hasClass(CLASS_DISABLED) && clearTimeout(this.timers.hide);
		}

		// On mouseleave...
		else {
			// When mouse tracking is enabled, hide when we leave the tooltip and not onto the show target (if a hide event is set)
			if(options.position.target === 'mouse' && options.position.adjust.mouse &&
				options.hide.event && options.show.target && !target.closest(options.show.target[0]).length) {
				this.hide(event);
			}
		}

		// Add hover class
		tooltip.toggleClass(CLASS_HOVER, state);
	});

	// Define events which reset the 'inactive' event handler
	delegate('['+ATTR_ID+']', INACTIVE_EVENTS, inactiveMethod);
});
;// Initialization method
function init(elem, id, opts) {
	var obj, posOptions, attr, config, title,

	// Setup element references
	docBody = $(document.body),

	// Use document body instead of document element if needed
	newTarget = elem[0] === document ? docBody : elem,

	// Grab metadata from element if plugin is present
	metadata = elem.metadata ? elem.metadata(opts.metadata) : NULL,

	// If metadata type if HTML5, grab 'name' from the object instead, or use the regular data object otherwise
	metadata5 = opts.metadata.type === 'html5' && metadata ? metadata[opts.metadata.name] : NULL,

	// Grab data from metadata.name (or data-qtipopts as fallback) using .data() method,
	html5 = elem.data(opts.metadata.name || 'qtipopts');

	// If we don't get an object returned attempt to parse it manualyl without parseJSON
	/* eslint-disable no-empty */
	try { html5 = typeof html5 === 'string' ? $.parseJSON(html5) : html5; }
	catch(e) {}
	/* eslint-enable no-empty */

	// Merge in and sanitize metadata
	config = $.extend(TRUE, {}, QTIP.defaults, opts,
		typeof html5 === 'object' ? sanitizeOptions(html5) : NULL,
		sanitizeOptions(metadata5 || metadata));

	// Re-grab our positioning options now we've merged our metadata and set id to passed value
	posOptions = config.position;
	config.id = id;

	// Setup missing content if none is detected
	if('boolean' === typeof config.content.text) {
		attr = elem.attr(config.content.attr);

		// Grab from supplied attribute if available
		if(config.content.attr !== FALSE && attr) { config.content.text = attr; }

		// No valid content was found, abort render
		else { return FALSE; }
	}

	// Setup target options
	if(!posOptions.container.length) { posOptions.container = docBody; }
	if(posOptions.target === FALSE) { posOptions.target = newTarget; }
	if(config.show.target === FALSE) { config.show.target = newTarget; }
	if(config.show.solo === TRUE) { config.show.solo = posOptions.container.closest('body'); }
	if(config.hide.target === FALSE) { config.hide.target = newTarget; }
	if(config.position.viewport === TRUE) { config.position.viewport = posOptions.container; }

	// Ensure we only use a single container
	posOptions.container = posOptions.container.eq(0);

	// Convert position corner values into x and y strings
	posOptions.at = new CORNER(posOptions.at, TRUE);
	posOptions.my = new CORNER(posOptions.my);

	// Destroy previous tooltip if overwrite is enabled, or skip element if not
	if(elem.data(NAMESPACE)) {
		if(config.overwrite) {
			elem.qtip('destroy', true);
		}
		else if(config.overwrite === FALSE) {
			return FALSE;
		}
	}

	// Add has-qtip attribute
	elem.attr(ATTR_HAS, id);

	// Remove title attribute and store it if present
	if(config.suppress && (title = elem.attr('title'))) {
		// Final attr call fixes event delegatiom and IE default tooltip showing problem
		elem.removeAttr('title').attr(oldtitle, title).attr('title', '');
	}

	// Initialize the tooltip and add API reference
	obj = new QTip(elem, config, id, !!attr);
	elem.data(NAMESPACE, obj);

	return obj;
}

// jQuery $.fn extension method
QTIP = $.fn.qtip = function(options, notation, newValue)
{
	var command = ('' + options).toLowerCase(), // Parse command
		returned = NULL,
		args = $.makeArray(arguments).slice(1),
		event = args[args.length - 1],
		opts = this[0] ? $.data(this[0], NAMESPACE) : NULL;

	// Check for API request
	if(!arguments.length && opts || command === 'api') {
		return opts;
	}

	// Execute API command if present
	else if('string' === typeof options) {
		this.each(function() {
			var api = $.data(this, NAMESPACE);
			if(!api) { return TRUE; }

			// Cache the event if possible
			if(event && event.timeStamp) { api.cache.event = event; }

			// Check for specific API commands
			if(notation && (command === 'option' || command === 'options')) {
				if(newValue !== undefined || $.isPlainObject(notation)) {
					api.set(notation, newValue);
				}
				else {
					returned = api.get(notation);
					return FALSE;
				}
			}

			// Execute API command
			else if(api[command]) {
				api[command].apply(api, args);
			}
		});

		return returned !== NULL ? returned : this;
	}

	// No API commands. validate provided options and setup qTips
	else if('object' === typeof options || !arguments.length) {
		// Sanitize options first
		opts = sanitizeOptions($.extend(TRUE, {}, options));

		return this.each(function(i) {
			var api, id;

			// Find next available ID, or use custom ID if provided
			id = $.isArray(opts.id) ? opts.id[i] : opts.id;
			id = !id || id === FALSE || id.length < 1 || QTIP.api[id] ? QTIP.nextid++ : id;

			// Initialize the qTip and re-grab newly sanitized options
			api = init($(this), id, opts);
			if(api === FALSE) { return TRUE; }
			else { QTIP.api[id] = api; }

			// Initialize plugins
			$.each(PLUGINS, function() {
				if(this.initialize === 'initialize') { this(api); }
			});

			// Assign initial pre-render events
			api._assignInitialEvents(event);
		});
	}
};

// Expose class
$.qtip = QTip;

// Populated in render method
QTIP.api = {};
;$.each({
	/* Allow other plugins to successfully retrieve the title of an element with a qTip applied */
	attr: function(attr, val) {
		if(this.length) {
			var self = this[0],
				title = 'title',
				api = $.data(self, 'qtip');

			if(attr === title && api && api.options && 'object' === typeof api && 'object' === typeof api.options && api.options.suppress) {
				if(arguments.length < 2) {
					return $.attr(self, oldtitle);
				}

				// If qTip is rendered and title was originally used as content, update it
				if(api && api.options.content.attr === title && api.cache.attr) {
					api.set('content.text', val);
				}

				// Use the regular attr method to set, then cache the result
				return this.attr(oldtitle, val);
			}
		}

		return $.fn['attr'+replaceSuffix].apply(this, arguments);
	},

	/* Allow clone to correctly retrieve cached title attributes */
	clone: function(keepData) {
		// Clone our element using the real clone method
		var elems = $.fn['clone'+replaceSuffix].apply(this, arguments);

		// Grab all elements with an oldtitle set, and change it to regular title attribute, if keepData is false
		if(!keepData) {
			elems.filter('['+oldtitle+']').attr('title', function() {
				return $.attr(this, oldtitle);
			})
			.removeAttr(oldtitle);
		}

		return elems;
	}
}, function(name, func) {
	if(!func || $.fn[name+replaceSuffix]) { return TRUE; }

	var old = $.fn[name+replaceSuffix] = $.fn[name];
	$.fn[name] = function() {
		return func.apply(this, arguments) || old.apply(this, arguments);
	};
});

/* Fire off 'removeqtip' handler in $.cleanData if jQuery UI not present (it already does similar).
 * This snippet is taken directly from jQuery UI source code found here:
 *     http://code.jquery.com/ui/jquery-ui-git.js
 */
if(!$.ui) {
	$['cleanData'+replaceSuffix] = $.cleanData;
	$.cleanData = function( elems ) {
		for(var i = 0, elem; (elem = $( elems[i] )).length; i++) {
			if(elem.attr(ATTR_HAS)) {
				/* eslint-disable no-empty */
				try { elem.triggerHandler('removeqtip'); }
				catch( e ) {}
				/* eslint-enable no-empty */
			}
		}
		$['cleanData'+replaceSuffix].apply(this, arguments);
	};
}
;// qTip version
QTIP.version = '3.0.3';

// Base ID for all qTips
QTIP.nextid = 0;

// Inactive events array
QTIP.inactiveEvents = INACTIVE_EVENTS;

// Base z-index for all qTips
QTIP.zindex = 15000;

// Define configuration defaults
QTIP.defaults = {
	prerender: FALSE,
	id: FALSE,
	overwrite: TRUE,
	suppress: TRUE,
	content: {
		text: TRUE,
		attr: 'title',
		title: FALSE,
		button: FALSE
	},
	position: {
		my: 'top left',
		at: 'bottom right',
		target: FALSE,
		container: FALSE,
		viewport: FALSE,
		adjust: {
			x: 0, y: 0,
			mouse: TRUE,
			scroll: TRUE,
			resize: TRUE,
			method: 'flipinvert flipinvert'
		},
		effect: function(api, pos) {
			$(this).animate(pos, {
				duration: 200,
				queue: FALSE
			});
		}
	},
	show: {
		target: FALSE,
		event: 'mouseenter',
		effect: TRUE,
		delay: 90,
		solo: FALSE,
		ready: FALSE,
		autofocus: FALSE
	},
	hide: {
		target: FALSE,
		event: 'mouseleave',
		effect: TRUE,
		delay: 0,
		fixed: FALSE,
		inactive: FALSE,
		leave: 'window',
		distance: FALSE
	},
	style: {
		classes: '',
		widget: FALSE,
		width: FALSE,
		height: FALSE,
		def: TRUE
	},
	events: {
		render: NULL,
		move: NULL,
		show: NULL,
		hide: NULL,
		toggle: NULL,
		visible: NULL,
		hidden: NULL,
		focus: NULL,
		blur: NULL
	}
};
;var TIP,
createVML,
SCALE,
PIXEL_RATIO,
BACKING_STORE_RATIO,

// Common CSS strings
MARGIN = 'margin',
BORDER = 'border',
COLOR = 'color',
BG_COLOR = 'background-color',
TRANSPARENT = 'transparent',
IMPORTANT = ' !important',

// Check if the browser supports <canvas/> elements
HASCANVAS = !!document.createElement('canvas').getContext,

// Invalid colour values used in parseColours()
INVALID = /rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i;

// Camel-case method, taken from jQuery source
// http://code.jquery.com/jquery-1.8.0.js
function camel(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

/*
 * Modified from Modernizr's testPropsAll()
 * http://modernizr.com/downloads/modernizr-latest.js
 */
var cssProps = {}, cssPrefixes = ['Webkit', 'O', 'Moz', 'ms'];
function vendorCss(elem, prop) {
	var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
		props = (prop + ' ' + cssPrefixes.join(ucProp + ' ') + ucProp).split(' '),
		cur, val, i = 0;

	// If the property has already been mapped...
	if(cssProps[prop]) { return elem.css(cssProps[prop]); }

	while(cur = props[i++]) {
		if((val = elem.css(cur)) !== undefined) {
			cssProps[prop] = cur;
			return val;
		}
	}
}

// Parse a given elements CSS property into an int
function intCss(elem, prop) {
	return Math.ceil(parseFloat(vendorCss(elem, prop)));
}


// VML creation (for IE only)
if(!HASCANVAS) {
	createVML = function(tag, props, style) {
		return '<qtipvml:'+tag+' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" '+(props||'')+
			' style="behavior: url(#default#VML); '+(style||'')+ '" />';
	};
}

// Canvas only definitions
else {
	PIXEL_RATIO = window.devicePixelRatio || 1;
	BACKING_STORE_RATIO = (function() {
		var context = document.createElement('canvas').getContext('2d');
		return context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio ||
				context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || 1;
	})();
	SCALE = PIXEL_RATIO / BACKING_STORE_RATIO;
}


function Tip(qtip, options) {
	this._ns = 'tip';
	this.options = options;
	this.offset = options.offset;
	this.size = [ options.width, options.height ];

	// Initialize
	this.qtip = qtip;
	this.init(qtip);
}

$.extend(Tip.prototype, {
	init: function(qtip) {
		var context, tip;

		// Create tip element and prepend to the tooltip
		tip = this.element = qtip.elements.tip = $('<div />', { 'class': NAMESPACE+'-tip' }).prependTo(qtip.tooltip);

		// Create tip drawing element(s)
		if(HASCANVAS) {
			// save() as soon as we create the canvas element so FF2 doesn't bork on our first restore()!
			context = $('<canvas />').appendTo(this.element)[0].getContext('2d');

			// Setup constant parameters
			context.lineJoin = 'miter';
			context.miterLimit = 100000;
			context.save();
		}
		else {
			context = createVML('shape', 'coordorigin="0,0"', 'position:absolute;');
			this.element.html(context + context);

			// Prevent mousing down on the tip since it causes problems with .live() handling in IE due to VML
			qtip._bind( $('*', tip).add(tip), ['click', 'mousedown'], function(event) { event.stopPropagation(); }, this._ns);
		}

		// Bind update events
		qtip._bind(qtip.tooltip, 'tooltipmove', this.reposition, this._ns, this);

		// Create it
		this.create();
	},

	_swapDimensions: function() {
		this.size[0] = this.options.height;
		this.size[1] = this.options.width;
	},
	_resetDimensions: function() {
		this.size[0] = this.options.width;
		this.size[1] = this.options.height;
	},

	_useTitle: function(corner) {
		var titlebar = this.qtip.elements.titlebar;
		return titlebar && (
			corner.y === TOP || corner.y === CENTER && this.element.position().top + this.size[1] / 2 + this.options.offset < titlebar.outerHeight(TRUE)
		);
	},

	_parseCorner: function(corner) {
		var my = this.qtip.options.position.my;

		// Detect corner and mimic properties
		if(corner === FALSE || my === FALSE) {
			corner = FALSE;
		}
		else if(corner === TRUE) {
			corner = new CORNER( my.string() );
		}
		else if(!corner.string) {
			corner = new CORNER(corner);
			corner.fixed = TRUE;
		}

		return corner;
	},

	_parseWidth: function(corner, side, use) {
		var elements = this.qtip.elements,
			prop = BORDER + camel(side) + 'Width';

		return (use ? intCss(use, prop) : 
			intCss(elements.content, prop) ||
			intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) ||
			intCss(elements.tooltip, prop)
		) || 0;
	},

	_parseRadius: function(corner) {
		var elements = this.qtip.elements,
			prop = BORDER + camel(corner.y) + camel(corner.x) + 'Radius';

		return BROWSER.ie < 9 ? 0 :
			intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) ||
			intCss(elements.tooltip, prop) || 0;
	},

	_invalidColour: function(elem, prop, compare) {
		var val = elem.css(prop);
		return !val || compare && val === elem.css(compare) || INVALID.test(val) ? FALSE : val;
	},

	_parseColours: function(corner) {
		var elements = this.qtip.elements,
			tip = this.element.css('cssText', ''),
			borderSide = BORDER + camel(corner[ corner.precedance ]) + camel(COLOR),
			colorElem = this._useTitle(corner) && elements.titlebar || elements.content,
			css = this._invalidColour, color = [];

		// Attempt to detect the background colour from various elements, left-to-right precedance
		color[0] = css(tip, BG_COLOR) || css(colorElem, BG_COLOR) || css(elements.content, BG_COLOR) ||
			css(elements.tooltip, BG_COLOR) || tip.css(BG_COLOR);

		// Attempt to detect the correct border side colour from various elements, left-to-right precedance
		color[1] = css(tip, borderSide, COLOR) || css(colorElem, borderSide, COLOR) ||
			css(elements.content, borderSide, COLOR) || css(elements.tooltip, borderSide, COLOR) || elements.tooltip.css(borderSide);

		// Reset background and border colours
		$('*', tip).add(tip).css('cssText', BG_COLOR+':'+TRANSPARENT+IMPORTANT+';'+BORDER+':0'+IMPORTANT+';');

		return color;
	},

	_calculateSize: function(corner) {
		var y = corner.precedance === Y,
			width = this.options.width,
			height = this.options.height,
			isCenter = corner.abbrev() === 'c',
			base = (y ? width: height) * (isCenter ? 0.5 : 1),
			pow = Math.pow,
			round = Math.round,
			bigHyp, ratio, result,

		smallHyp = Math.sqrt( pow(base, 2) + pow(height, 2) ),
		hyp = [
			this.border / base * smallHyp,
			this.border / height * smallHyp
		];

		hyp[2] = Math.sqrt( pow(hyp[0], 2) - pow(this.border, 2) );
		hyp[3] = Math.sqrt( pow(hyp[1], 2) - pow(this.border, 2) );

		bigHyp = smallHyp + hyp[2] + hyp[3] + (isCenter ? 0 : hyp[0]);
		ratio = bigHyp / smallHyp;

		result = [ round(ratio * width), round(ratio * height) ];
		return y ? result : result.reverse();
	},

	// Tip coordinates calculator
	_calculateTip: function(corner, size, scale) {
		scale = scale || 1;
		size = size || this.size;

		var width = size[0] * scale,
			height = size[1] * scale,
			width2 = Math.ceil(width / 2), height2 = Math.ceil(height / 2),

		// Define tip coordinates in terms of height and width values
		tips = {
			br:	[0,0,		width,height,	width,0],
			bl:	[0,0,		width,0,		0,height],
			tr:	[0,height,	width,0,		width,height],
			tl:	[0,0,		0,height,		width,height],
			tc:	[0,height,	width2,0,		width,height],
			bc:	[0,0,		width,0,		width2,height],
			rc:	[0,0,		width,height2,	0,height],
			lc:	[width,0,	width,height,	0,height2]
		};

		// Set common side shapes
		tips.lt = tips.br; tips.rt = tips.bl;
		tips.lb = tips.tr; tips.rb = tips.tl;

		return tips[ corner.abbrev() ];
	},

	// Tip coordinates drawer (canvas)
	_drawCoords: function(context, coords) {
		context.beginPath();
		context.moveTo(coords[0], coords[1]);
		context.lineTo(coords[2], coords[3]);
		context.lineTo(coords[4], coords[5]);
		context.closePath();
	},

	create: function() {
		// Determine tip corner
		var c = this.corner = (HASCANVAS || BROWSER.ie) && this._parseCorner(this.options.corner);

		// If we have a tip corner...
		this.enabled = !!this.corner && this.corner.abbrev() !== 'c';
		if(this.enabled) {
			// Cache it
			this.qtip.cache.corner = c.clone();

			// Create it
			this.update();
		}

		// Toggle tip element
		this.element.toggle(this.enabled);

		return this.corner;
	},

	update: function(corner, position) {
		if(!this.enabled) { return this; }

		var elements = this.qtip.elements,
			tip = this.element,
			inner = tip.children(),
			options = this.options,
			curSize = this.size,
			mimic = options.mimic,
			round = Math.round,
			color, precedance, context,
			coords, bigCoords, translate, newSize, border;

		// Re-determine tip if not already set
		if(!corner) { corner = this.qtip.cache.corner || this.corner; }

		// Use corner property if we detect an invalid mimic value
		if(mimic === FALSE) { mimic = corner; }

		// Otherwise inherit mimic properties from the corner object as necessary
		else {
			mimic = new CORNER(mimic);
			mimic.precedance = corner.precedance;

			if(mimic.x === 'inherit') { mimic.x = corner.x; }
			else if(mimic.y === 'inherit') { mimic.y = corner.y; }
			else if(mimic.x === mimic.y) {
				mimic[ corner.precedance ] = corner[ corner.precedance ];
			}
		}
		precedance = mimic.precedance;

		// Ensure the tip width.height are relative to the tip position
		if(corner.precedance === X) { this._swapDimensions(); }
		else { this._resetDimensions(); }

		// Update our colours
		color = this.color = this._parseColours(corner);

		// Detect border width, taking into account colours
		if(color[1] !== TRANSPARENT) {
			// Grab border width
			border = this.border = this._parseWidth(corner, corner[corner.precedance]);

			// If border width isn't zero, use border color as fill if it's not invalid (1.0 style tips)
			if(options.border && border < 1 && !INVALID.test(color[1])) { color[0] = color[1]; }

			// Set border width (use detected border width if options.border is true)
			this.border = border = options.border !== TRUE ? options.border : border;
		}

		// Border colour was invalid, set border to zero
		else { this.border = border = 0; }

		// Determine tip size
		newSize = this.size = this._calculateSize(corner);
		tip.css({
			width: newSize[0],
			height: newSize[1],
			lineHeight: newSize[1]+'px'
		});

		// Calculate tip translation
		if(corner.precedance === Y) {
			translate = [
				round(mimic.x === LEFT ? border : mimic.x === RIGHT ? newSize[0] - curSize[0] - border : (newSize[0] - curSize[0]) / 2),
				round(mimic.y === TOP ? newSize[1] - curSize[1] : 0)
			];
		}
		else {
			translate = [
				round(mimic.x === LEFT ? newSize[0] - curSize[0] : 0),
				round(mimic.y === TOP ? border : mimic.y === BOTTOM ? newSize[1] - curSize[1] - border : (newSize[1] - curSize[1]) / 2)
			];
		}

		// Canvas drawing implementation
		if(HASCANVAS) {
			// Grab canvas context and clear/save it
			context = inner[0].getContext('2d');
			context.restore(); context.save();
			context.clearRect(0,0,6000,6000);

			// Calculate coordinates
			coords = this._calculateTip(mimic, curSize, SCALE);
			bigCoords = this._calculateTip(mimic, this.size, SCALE);

			// Set the canvas size using calculated size
			inner.attr(WIDTH, newSize[0] * SCALE).attr(HEIGHT, newSize[1] * SCALE);
			inner.css(WIDTH, newSize[0]).css(HEIGHT, newSize[1]);

			// Draw the outer-stroke tip
			this._drawCoords(context, bigCoords);
			context.fillStyle = color[1];
			context.fill();

			// Draw the actual tip
			context.translate(translate[0] * SCALE, translate[1] * SCALE);
			this._drawCoords(context, coords);
			context.fillStyle = color[0];
			context.fill();
		}

		// VML (IE Proprietary implementation)
		else {
			// Calculate coordinates
			coords = this._calculateTip(mimic);

			// Setup coordinates string
			coords = 'm' + coords[0] + ',' + coords[1] + ' l' + coords[2] +
				',' + coords[3] + ' ' + coords[4] + ',' + coords[5] + ' xe';

			// Setup VML-specific offset for pixel-perfection
			translate[2] = border && /^(r|b)/i.test(corner.string()) ?
				BROWSER.ie === 8 ? 2 : 1 : 0;

			// Set initial CSS
			inner.css({
				coordsize: newSize[0]+border + ' ' + newSize[1]+border,
				antialias: ''+(mimic.string().indexOf(CENTER) > -1),
				left: translate[0] - translate[2] * Number(precedance === X),
				top: translate[1] - translate[2] * Number(precedance === Y),
				width: newSize[0] + border,
				height: newSize[1] + border
			})
			.each(function(i) {
				var $this = $(this);

				// Set shape specific attributes
				$this[ $this.prop ? 'prop' : 'attr' ]({
					coordsize: newSize[0]+border + ' ' + newSize[1]+border,
					path: coords,
					fillcolor: color[0],
					filled: !!i,
					stroked: !i
				})
				.toggle(!!(border || i));

				// Check if border is enabled and add stroke element
				!i && $this.html( createVML(
					'stroke', 'weight="'+border*2+'px" color="'+color[1]+'" miterlimit="1000" joinstyle="miter"'
				) );
			});
		}

		// Opera bug #357 - Incorrect tip position
		// https://github.com/Craga89/qTip2/issues/367
		window.opera && setTimeout(function() {
			elements.tip.css({
				display: 'inline-block',
				visibility: 'visible'
			});
		}, 1);

		// Position if needed
		if(position !== FALSE) { this.calculate(corner, newSize); }
	},

	calculate: function(corner, size) {
		if(!this.enabled) { return FALSE; }

		var self = this,
			elements = this.qtip.elements,
			tip = this.element,
			userOffset = this.options.offset,
			position = {},
			precedance, corners;

		// Inherit corner if not provided
		corner = corner || this.corner;
		precedance = corner.precedance;

		// Determine which tip dimension to use for adjustment
		size = size || this._calculateSize(corner);

		// Setup corners and offset array
		corners = [ corner.x, corner.y ];
		if(precedance === X) { corners.reverse(); }

		// Calculate tip position
		$.each(corners, function(i, side) {
			var b, bc, br;

			if(side === CENTER) {
				b = precedance === Y ? LEFT : TOP;
				position[ b ] = '50%';
				position[MARGIN+'-' + b] = -Math.round(size[ precedance === Y ? 0 : 1 ] / 2) + userOffset;
			}
			else {
				b = self._parseWidth(corner, side, elements.tooltip);
				bc = self._parseWidth(corner, side, elements.content);
				br = self._parseRadius(corner);

				position[ side ] = Math.max(-self.border, i ? bc : userOffset + (br > b ? br : -b));
			}
		});

		// Adjust for tip size
		position[ corner[precedance] ] -= size[ precedance === X ? 0 : 1 ];

		// Set and return new position
		tip.css({ margin: '', top: '', bottom: '', left: '', right: '' }).css(position);
		return position;
	},

	reposition: function(event, api, pos) {
		if(!this.enabled) { return; }

		var cache = api.cache,
			newCorner = this.corner.clone(),
			adjust = pos.adjusted,
			method = api.options.position.adjust.method.split(' '),
			horizontal = method[0],
			vertical = method[1] || method[0],
			shift = { left: FALSE, top: FALSE, x: 0, y: 0 },
			offset, css = {}, props;

		function shiftflip(direction, precedance, popposite, side, opposite) {
			// Horizontal - Shift or flip method
			if(direction === SHIFT && newCorner.precedance === precedance && adjust[side] && newCorner[popposite] !== CENTER) {
				newCorner.precedance = newCorner.precedance === X ? Y : X;
			}
			else if(direction !== SHIFT && adjust[side]){
				newCorner[precedance] = newCorner[precedance] === CENTER ?
					adjust[side] > 0 ? side : opposite :
					newCorner[precedance] === side ? opposite : side;
			}
		}

		function shiftonly(xy, side, opposite) {
			if(newCorner[xy] === CENTER) {
				css[MARGIN+'-'+side] = shift[xy] = offset[MARGIN+'-'+side] - adjust[side];
			}
			else {
				props = offset[opposite] !== undefined ?
					[ adjust[side], -offset[side] ] : [ -adjust[side], offset[side] ];

				if( (shift[xy] = Math.max(props[0], props[1])) > props[0] ) {
					pos[side] -= adjust[side];
					shift[side] = FALSE;
				}

				css[ offset[opposite] !== undefined ? opposite : side ] = shift[xy];
			}
		}

		// If our tip position isn't fixed e.g. doesn't adjust with viewport...
		if(this.corner.fixed !== TRUE) {
			// Perform shift/flip adjustments
			shiftflip(horizontal, X, Y, LEFT, RIGHT);
			shiftflip(vertical, Y, X, TOP, BOTTOM);

			// Update and redraw the tip if needed (check cached details of last drawn tip)
			if(newCorner.string() !== cache.corner.string() || cache.cornerTop !== adjust.top || cache.cornerLeft !== adjust.left) {
				this.update(newCorner, FALSE);
			}
		}

		// Setup tip offset properties
		offset = this.calculate(newCorner);

		// Readjust offset object to make it left/top
		if(offset.right !== undefined) { offset.left = -offset.right; }
		if(offset.bottom !== undefined) { offset.top = -offset.bottom; }
		offset.user = this.offset;

		// Perform shift adjustments
		shift.left = horizontal === SHIFT && !!adjust.left;
		if(shift.left) {
			shiftonly(X, LEFT, RIGHT);
		}
		shift.top = vertical === SHIFT && !!adjust.top;
		if(shift.top) {
			shiftonly(Y, TOP, BOTTOM);
		}

		/*
		* If the tip is adjusted in both dimensions, or in a
		* direction that would cause it to be anywhere but the
		* outer border, hide it!
		*/
		this.element.css(css).toggle(
			!(shift.x && shift.y || newCorner.x === CENTER && shift.y || newCorner.y === CENTER && shift.x)
		);

		// Adjust position to accomodate tip dimensions
		pos.left -= offset.left.charAt ? offset.user :
			horizontal !== SHIFT || shift.top || !shift.left && !shift.top ? offset.left + this.border : 0;
		pos.top -= offset.top.charAt ? offset.user :
			vertical !== SHIFT || shift.left || !shift.left && !shift.top ? offset.top + this.border : 0;

		// Cache details
		cache.cornerLeft = adjust.left; cache.cornerTop = adjust.top;
		cache.corner = newCorner.clone();
	},

	destroy: function() {
		// Unbind events
		this.qtip._unbind(this.qtip.tooltip, this._ns);

		// Remove the tip element(s)
		if(this.qtip.elements.tip) {
			this.qtip.elements.tip.find('*')
				.remove().end().remove();
		}
	}
});

TIP = PLUGINS.tip = function(api) {
	return new Tip(api, api.options.style.tip);
};

// Initialize tip on render
TIP.initialize = 'render';

// Setup plugin sanitization options
TIP.sanitize = function(options) {
	if(options.style && 'tip' in options.style) {
		var opts = options.style.tip;
		if(typeof opts !== 'object') { opts = options.style.tip = { corner: opts }; }
		if(!(/string|boolean/i).test(typeof opts.corner)) { opts.corner = TRUE; }
	}
};

// Add new option checks for the plugin
CHECKS.tip = {
	'^position.my|style.tip.(corner|mimic|border)$': function() {
		// Make sure a tip can be drawn
		this.create();

		// Reposition the tooltip
		this.qtip.reposition();
	},
	'^style.tip.(height|width)$': function(obj) {
		// Re-set dimensions and redraw the tip
		this.size = [ obj.width, obj.height ];
		this.update();

		// Reposition the tooltip
		this.qtip.reposition();
	},
	'^content.title|style.(classes|widget)$': function() {
		this.update();
	}
};

// Extend original qTip defaults
$.extend(TRUE, QTIP.defaults, {
	style: {
		tip: {
			corner: TRUE,
			mimic: FALSE,
			width: 6,
			height: 6,
			border: TRUE,
			offset: 0
		}
	}
});
;var MODAL, OVERLAY,
	MODALCLASS = 'qtip-modal',
	MODALSELECTOR = '.'+MODALCLASS;

OVERLAY = function()
{
	var self = this,
		focusableElems = {},
		current,
		prevState,
		elem;

	// Modified code from jQuery UI 1.10.0 source
	// http://code.jquery.com/ui/1.10.0/jquery-ui.js
	function focusable(element) {
		// Use the defined focusable checker when possible
		if($.expr[':'].focusable) { return $.expr[':'].focusable; }

		var isTabIndexNotNaN = !isNaN($.attr(element, 'tabindex')),
			nodeName = element.nodeName && element.nodeName.toLowerCase(),
			map, mapName, img;

		if('area' === nodeName) {
			map = element.parentNode;
			mapName = map.name;
			if(!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
				return false;
			}
			img = $('img[usemap=#' + mapName + ']')[0];
			return !!img && img.is(':visible');
		}

		return /input|select|textarea|button|object/.test( nodeName ) ?
			!element.disabled :
			'a' === nodeName ?
				element.href || isTabIndexNotNaN :
				isTabIndexNotNaN
		;
	}

	// Focus inputs using cached focusable elements (see update())
	function focusInputs(blurElems) {
		// Blurring body element in IE causes window.open windows to unfocus!
		if(focusableElems.length < 1 && blurElems.length) { blurElems.not('body').blur(); }

		// Focus the inputs
		else { focusableElems.first().focus(); }
	}

	// Steal focus from elements outside tooltip
	function stealFocus(event) {
		if(!elem.is(':visible')) { return; }

		var target = $(event.target),
			tooltip = current.tooltip,
			container = target.closest(SELECTOR),
			targetOnTop;

		// Determine if input container target is above this
		targetOnTop = container.length < 1 ? FALSE :
			parseInt(container[0].style.zIndex, 10) > parseInt(tooltip[0].style.zIndex, 10);

		// If we're showing a modal, but focus has landed on an input below
		// this modal, divert focus to the first visible input in this modal
		// or if we can't find one... the tooltip itself
		if(!targetOnTop && target.closest(SELECTOR)[0] !== tooltip[0]) {
			focusInputs(target);
		}
	}

	$.extend(self, {
		init: function() {
			// Create document overlay
			elem = self.elem = $('<div />', {
				id: 'qtip-overlay',
				html: '<div></div>',
				mousedown: function() { return FALSE; }
			})
			.hide();

			// Make sure we can't focus anything outside the tooltip
			$(document.body).bind('focusin'+MODALSELECTOR, stealFocus);

			// Apply keyboard "Escape key" close handler
			$(document).bind('keydown'+MODALSELECTOR, function(event) {
				if(current && current.options.show.modal.escape && event.keyCode === 27) {
					current.hide(event);
				}
			});

			// Apply click handler for blur option
			elem.bind('click'+MODALSELECTOR, function(event) {
				if(current && current.options.show.modal.blur) {
					current.hide(event);
				}
			});

			return self;
		},

		update: function(api) {
			// Update current API reference
			current = api;

			// Update focusable elements if enabled
			if(api.options.show.modal.stealfocus !== FALSE) {
				focusableElems = api.tooltip.find('*').filter(function() {
					return focusable(this);
				});
			}
			else { focusableElems = []; }
		},

		toggle: function(api, state, duration) {
			var tooltip = api.tooltip,
				options = api.options.show.modal,
				effect = options.effect,
				type = state ? 'show': 'hide',
				visible = elem.is(':visible'),
				visibleModals = $(MODALSELECTOR).filter(':visible:not(:animated)').not(tooltip);

			// Set active tooltip API reference
			self.update(api);

			// If the modal can steal the focus...
			// Blur the current item and focus anything in the modal we an
			if(state && options.stealfocus !== FALSE) {
				focusInputs( $(':focus') );
			}

			// Toggle backdrop cursor style on show
			elem.toggleClass('blurs', options.blur);

			// Append to body on show
			if(state) {
				elem.appendTo(document.body);
			}

			// Prevent modal from conflicting with show.solo, and don't hide backdrop is other modals are visible
			if(elem.is(':animated') && visible === state && prevState !== FALSE || !state && visibleModals.length) {
				return self;
			}

			// Stop all animations
			elem.stop(TRUE, FALSE);

			// Use custom function if provided
			if($.isFunction(effect)) {
				effect.call(elem, state);
			}

			// If no effect type is supplied, use a simple toggle
			else if(effect === FALSE) {
				elem[ type ]();
			}

			// Use basic fade function
			else {
				elem.fadeTo( parseInt(duration, 10) || 90, state ? 1 : 0, function() {
					if(!state) { elem.hide(); }
				});
			}

			// Reset position and detach from body on hide
			if(!state) {
				elem.queue(function(next) {
					elem.css({ left: '', top: '' });
					if(!$(MODALSELECTOR).length) { elem.detach(); }
					next();
				});
			}

			// Cache the state
			prevState = state;

			// If the tooltip is destroyed, set reference to null
			if(current.destroyed) { current = NULL; }

			return self;
		}
	});

	self.init();
};
OVERLAY = new OVERLAY();

function Modal(api, options) {
	this.options = options;
	this._ns = '-modal';

	this.qtip = api;
	this.init(api);
}

$.extend(Modal.prototype, {
	init: function(qtip) {
		var tooltip = qtip.tooltip;

		// If modal is disabled... return
		if(!this.options.on) { return this; }

		// Set overlay reference
		qtip.elements.overlay = OVERLAY.elem;

		// Add unique attribute so we can grab modal tooltips easily via a SELECTOR, and set z-index
		tooltip.addClass(MODALCLASS).css('z-index', QTIP.modal_zindex + $(MODALSELECTOR).length);

		// Apply our show/hide/focus modal events
		qtip._bind(tooltip, ['tooltipshow', 'tooltiphide'], function(event, api, duration) {
			var oEvent = event.originalEvent;

			// Make sure mouseout doesn't trigger a hide when showing the modal and mousing onto backdrop
			if(event.target === tooltip[0]) {
				if(oEvent && event.type === 'tooltiphide' && /mouse(leave|enter)/.test(oEvent.type) && $(oEvent.relatedTarget).closest(OVERLAY.elem[0]).length) {
					/* eslint-disable no-empty */
					try { event.preventDefault(); }
					catch(e) {}
					/* eslint-enable no-empty */
				}
				else if(!oEvent || oEvent && oEvent.type !== 'tooltipsolo') {
					this.toggle(event, event.type === 'tooltipshow', duration);
				}
			}
		}, this._ns, this);

		// Adjust modal z-index on tooltip focus
		qtip._bind(tooltip, 'tooltipfocus', function(event, api) {
			// If focus was cancelled before it reached us, don't do anything
			if(event.isDefaultPrevented() || event.target !== tooltip[0]) { return; }

			var qtips = $(MODALSELECTOR),

			// Keep the modal's lower than other, regular qtips
			newIndex = QTIP.modal_zindex + qtips.length,
			curIndex = parseInt(tooltip[0].style.zIndex, 10);

			// Set overlay z-index
			OVERLAY.elem[0].style.zIndex = newIndex - 1;

			// Reduce modal z-index's and keep them properly ordered
			qtips.each(function() {
				if(this.style.zIndex > curIndex) {
					this.style.zIndex -= 1;
				}
			});

			// Fire blur event for focused tooltip
			qtips.filter('.' + CLASS_FOCUS).qtip('blur', event.originalEvent);

			// Set the new z-index
			tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;

			// Set current
			OVERLAY.update(api);

			// Prevent default handling
			/* eslint-disable no-empty */
			try { event.preventDefault(); }
			catch(e) {}
			/* eslint-enable no-empty */
		}, this._ns, this);

		// Focus any other visible modals when this one hides
		qtip._bind(tooltip, 'tooltiphide', function(event) {
			if(event.target === tooltip[0]) {
				$(MODALSELECTOR).filter(':visible').not(tooltip).last().qtip('focus', event);
			}
		}, this._ns, this);
	},

	toggle: function(event, state, duration) {
		// Make sure default event hasn't been prevented
		if(event && event.isDefaultPrevented()) { return this; }

		// Toggle it
		OVERLAY.toggle(this.qtip, !!state, duration);
	},

	destroy: function() {
		// Remove modal class
		this.qtip.tooltip.removeClass(MODALCLASS);

		// Remove bound events
		this.qtip._unbind(this.qtip.tooltip, this._ns);

		// Delete element reference
		OVERLAY.toggle(this.qtip, FALSE);
		delete this.qtip.elements.overlay;
	}
});


MODAL = PLUGINS.modal = function(api) {
	return new Modal(api, api.options.show.modal);
};

// Setup sanitiztion rules
MODAL.sanitize = function(opts) {
	if(opts.show) {
		if(typeof opts.show.modal !== 'object') { opts.show.modal = { on: !!opts.show.modal }; }
		else if(typeof opts.show.modal.on === 'undefined') { opts.show.modal.on = TRUE; }
	}
};

// Base z-index for all modal tooltips (use qTip core z-index as a base)
/* eslint-disable camelcase */
QTIP.modal_zindex = QTIP.zindex - 200;
/* eslint-enable camelcase */

// Plugin needs to be initialized on render
MODAL.initialize = 'render';

// Setup option set checks
CHECKS.modal = {
	'^show.modal.(on|blur)$': function() {
		// Initialise
		this.destroy();
		this.init();

		// Show the modal if not visible already and tooltip is visible
		this.qtip.elems.overlay.toggle(
			this.qtip.tooltip[0].offsetWidth > 0
		);
	}
};

// Extend original api defaults
$.extend(TRUE, QTIP.defaults, {
	show: {
		modal: {
			on: FALSE,
			effect: TRUE,
			blur: TRUE,
			stealfocus: TRUE,
			escape: TRUE
		}
	}
});
;PLUGINS.viewport = function(api, position, posOptions, targetWidth, targetHeight, elemWidth, elemHeight)
{
	var target = posOptions.target,
		tooltip = api.elements.tooltip,
		my = posOptions.my,
		at = posOptions.at,
		adjust = posOptions.adjust,
		method = adjust.method.split(' '),
		methodX = method[0],
		methodY = method[1] || method[0],
		viewport = posOptions.viewport,
		container = posOptions.container,
		adjusted = { left: 0, top: 0 },
		fixed, newMy, containerOffset, containerStatic,
		viewportWidth, viewportHeight, viewportScroll, viewportOffset;

	// If viewport is not a jQuery element, or it's the window/document, or no adjustment method is used... return
	if(!viewport.jquery || target[0] === window || target[0] === document.body || adjust.method === 'none') {
		return adjusted;
	}

	// Cach container details
	containerOffset = container.offset() || adjusted;
	containerStatic = container.css('position') === 'static';

	// Cache our viewport details
	fixed = tooltip.css('position') === 'fixed';
	viewportWidth = viewport[0] === window ? viewport.width() : viewport.outerWidth(FALSE);
	viewportHeight = viewport[0] === window ? viewport.height() : viewport.outerHeight(FALSE);
	viewportScroll = { left: fixed ? 0 : viewport.scrollLeft(), top: fixed ? 0 : viewport.scrollTop() };
	viewportOffset = viewport.offset() || adjusted;

	// Generic calculation method
	function calculate(side, otherSide, type, adjustment, side1, side2, lengthName, targetLength, elemLength) {
		var initialPos = position[side1],
			mySide = my[side],
			atSide = at[side],
			isShift = type === SHIFT,
			myLength = mySide === side1 ? elemLength : mySide === side2 ? -elemLength : -elemLength / 2,
			atLength = atSide === side1 ? targetLength : atSide === side2 ? -targetLength : -targetLength / 2,
			sideOffset = viewportScroll[side1] + viewportOffset[side1] - (containerStatic ? 0 : containerOffset[side1]),
			overflow1 = sideOffset - initialPos,
			overflow2 = initialPos + elemLength - (lengthName === WIDTH ? viewportWidth : viewportHeight) - sideOffset,
			offset = myLength - (my.precedance === side || mySide === my[otherSide] ? atLength : 0) - (atSide === CENTER ? targetLength / 2 : 0);

		// shift
		if(isShift) {
			offset = (mySide === side1 ? 1 : -1) * myLength;

			// Adjust position but keep it within viewport dimensions
			position[side1] += overflow1 > 0 ? overflow1 : overflow2 > 0 ? -overflow2 : 0;
			position[side1] = Math.max(
				-containerOffset[side1] + viewportOffset[side1],
				initialPos - offset,
				Math.min(
					Math.max(
						-containerOffset[side1] + viewportOffset[side1] + (lengthName === WIDTH ? viewportWidth : viewportHeight),
						initialPos + offset
					),
					position[side1],

					// Make sure we don't adjust complete off the element when using 'center'
					mySide === 'center' ? initialPos - myLength : 1E9
				)
			);

		}

		// flip/flipinvert
		else {
			// Update adjustment amount depending on if using flipinvert or flip
			adjustment *= type === FLIPINVERT ? 2 : 0;

			// Check for overflow on the left/top
			if(overflow1 > 0 && (mySide !== side1 || overflow2 > 0)) {
				position[side1] -= offset + adjustment;
				newMy.invert(side, side1);
			}

			// Check for overflow on the bottom/right
			else if(overflow2 > 0 && (mySide !== side2 || overflow1 > 0)  ) {
				position[side1] -= (mySide === CENTER ? -offset : offset) + adjustment;
				newMy.invert(side, side2);
			}

			// Make sure we haven't made things worse with the adjustment and reset if so
			if(position[side1] < viewportScroll[side1] && -position[side1] > overflow2) {
				position[side1] = initialPos; newMy = my.clone();
			}
		}

		return position[side1] - initialPos;
	}

	// Set newMy if using flip or flipinvert methods
	if(methodX !== 'shift' || methodY !== 'shift') { newMy = my.clone(); }

	// Adjust position based onviewport and adjustment options
	adjusted = {
		left: methodX !== 'none' ? calculate( X, Y, methodX, adjust.x, LEFT, RIGHT, WIDTH, targetWidth, elemWidth ) : 0,
		top: methodY !== 'none' ? calculate( Y, X, methodY, adjust.y, TOP, BOTTOM, HEIGHT, targetHeight, elemHeight ) : 0,
		my: newMy
	};

	return adjusted;
};
;PLUGINS.polys = {
	// POLY area coordinate calculator
	//	Special thanks to Ed Cradock for helping out with this.
	//	Uses a binary search algorithm to find suitable coordinates.
	polygon: function(baseCoords, corner) {
		var result = {
			width: 0, height: 0,
			position: {
				top: 1e10, right: 0,
				bottom: 0, left: 1e10
			},
			adjustable: FALSE
		},
		i = 0, next,
		coords = [],
		compareX = 1, compareY = 1,
		realX = 0, realY = 0,
		newWidth, newHeight;

		// First pass, sanitize coords and determine outer edges
		i = baseCoords.length; 
		while(i--) {
			next = [ parseInt(baseCoords[--i], 10), parseInt(baseCoords[i+1], 10) ];

			if(next[0] > result.position.right){ result.position.right = next[0]; }
			if(next[0] < result.position.left){ result.position.left = next[0]; }
			if(next[1] > result.position.bottom){ result.position.bottom = next[1]; }
			if(next[1] < result.position.top){ result.position.top = next[1]; }

			coords.push(next);
		}

		// Calculate height and width from outer edges
		newWidth = result.width = Math.abs(result.position.right - result.position.left);
		newHeight = result.height = Math.abs(result.position.bottom - result.position.top);

		// If it's the center corner...
		if(corner.abbrev() === 'c') {
			result.position = {
				left: result.position.left + result.width / 2,
				top: result.position.top + result.height / 2
			};
		}
		else {
			// Second pass, use a binary search algorithm to locate most suitable coordinate
			while(newWidth > 0 && newHeight > 0 && compareX > 0 && compareY > 0)
			{
				newWidth = Math.floor(newWidth / 2);
				newHeight = Math.floor(newHeight / 2);

				if(corner.x === LEFT){ compareX = newWidth; }
				else if(corner.x === RIGHT){ compareX = result.width - newWidth; }
				else{ compareX += Math.floor(newWidth / 2); }

				if(corner.y === TOP){ compareY = newHeight; }
				else if(corner.y === BOTTOM){ compareY = result.height - newHeight; }
				else{ compareY += Math.floor(newHeight / 2); }

				i = coords.length;
				while(i--)
				{
					if(coords.length < 2){ break; }

					realX = coords[i][0] - result.position.left;
					realY = coords[i][1] - result.position.top;

					if(
						corner.x === LEFT && realX >= compareX ||
						corner.x === RIGHT && realX <= compareX ||
						corner.x === CENTER && (realX < compareX || realX > result.width - compareX) ||
						corner.y === TOP && realY >= compareY ||
						corner.y === BOTTOM && realY <= compareY ||
						corner.y === CENTER && (realY < compareY || realY > result.height - compareY)) {
						coords.splice(i, 1);
					}
				}
			}
			result.position = { left: coords[0][0], top: coords[0][1] };
		}

		return result;
	},

	rect: function(ax, ay, bx, by) {
		return {
			width: Math.abs(bx - ax),
			height: Math.abs(by - ay),
			position: {
				left: Math.min(ax, bx),
				top: Math.min(ay, by)
			}
		};
	},

	_angles: {
		tc: 3 / 2, tr: 7 / 4, tl: 5 / 4,
		bc: 1 / 2, br: 1 / 4, bl: 3 / 4,
		rc: 2, lc: 1, c: 0
	},
	ellipse: function(cx, cy, rx, ry, corner) {
		var c = PLUGINS.polys._angles[ corner.abbrev() ],
			rxc = c === 0 ? 0 : rx * Math.cos( c * Math.PI ),
			rys = ry * Math.sin( c * Math.PI );

		return {
			width: rx * 2 - Math.abs(rxc),
			height: ry * 2 - Math.abs(rys),
			position: {
				left: cx + rxc,
				top: cy + rys
			},
			adjustable: FALSE
		};
	},
	circle: function(cx, cy, r, corner) {
		return PLUGINS.polys.ellipse(cx, cy, r, r, corner);
	}
};
;PLUGINS.svg = function(api, svg, corner)
{
	var elem = svg[0],
		root = $(elem.ownerSVGElement),
		ownerDocument = elem.ownerDocument,
		strokeWidth2 = (parseInt(svg.css('stroke-width'), 10) || 0) / 2,
		frameOffset, mtx, transformed,
		len, next, i, points,
		result, position;

	// Ascend the parentNode chain until we find an element with getBBox()
	while(!elem.getBBox) { elem = elem.parentNode; }
	if(!elem.getBBox || !elem.parentNode) { return FALSE; }

	// Determine which shape calculation to use
	switch(elem.nodeName) {
		case 'ellipse':
		case 'circle':
			result = PLUGINS.polys.ellipse(
				elem.cx.baseVal.value,
				elem.cy.baseVal.value,
				(elem.rx || elem.r).baseVal.value + strokeWidth2,
				(elem.ry || elem.r).baseVal.value + strokeWidth2,
				corner
			);
		break;

		case 'line':
		case 'polygon':
		case 'polyline':
			// Determine points object (line has none, so mimic using array)
			points = elem.points || [
				{ x: elem.x1.baseVal.value, y: elem.y1.baseVal.value },
				{ x: elem.x2.baseVal.value, y: elem.y2.baseVal.value }
			];

			for(result = [], i = -1, len = points.numberOfItems || points.length; ++i < len;) {
				next = points.getItem ? points.getItem(i) : points[i];
				result.push.apply(result, [next.x, next.y]);
			}

			result = PLUGINS.polys.polygon(result, corner);
		break;

		// Unknown shape or rectangle? Use bounding box
		default:
			result = elem.getBBox();
			result = {
				width: result.width,
				height: result.height,
				position: {
					left: result.x,
					top: result.y
				}
			};
		break;
	}

	// Shortcut assignments
	position = result.position;
	root = root[0];

	// Convert position into a pixel value
	if(root.createSVGPoint) {
		mtx = elem.getScreenCTM();
		points = root.createSVGPoint();

		points.x = position.left;
		points.y = position.top;
		transformed = points.matrixTransform( mtx );
		position.left = transformed.x;
		position.top = transformed.y;
	}

	// Check the element is not in a child document, and if so, adjust for frame elements offset
	if(ownerDocument !== document && api.position.target !== 'mouse') {
		frameOffset = $((ownerDocument.defaultView || ownerDocument.parentWindow).frameElement).offset();
		if(frameOffset) {
			position.left += frameOffset.left;
			position.top += frameOffset.top;
		}
	}

	// Adjust by scroll offset of owner document
	ownerDocument = $(ownerDocument);
	position.left += ownerDocument.scrollLeft();
	position.top += ownerDocument.scrollTop();

	return result;
};
;PLUGINS.imagemap = function(api, area, corner)
{
	if(!area.jquery) { area = $(area); }

	var shape = (area.attr('shape') || 'rect').toLowerCase().replace('poly', 'polygon'),
		image = $('img[usemap="#'+area.parent('map').attr('name')+'"]'),
		coordsString = $.trim(area.attr('coords')),
		coordsArray = coordsString.replace(/,$/, '').split(','),
		imageOffset, coords, i, result, len;

	// If we can't find the image using the map...
	if(!image.length) { return FALSE; }

	// Pass coordinates string if polygon
	if(shape === 'polygon') {
		result = PLUGINS.polys.polygon(coordsArray, corner);
	}

	// Otherwise parse the coordinates and pass them as arguments
	else if(PLUGINS.polys[shape]) {
		for(i = -1, len = coordsArray.length, coords = []; ++i < len;) {
			coords.push( parseInt(coordsArray[i], 10) );
		}

		result = PLUGINS.polys[shape].apply(
			this, coords.concat(corner)
		);
	}

	// If no shapre calculation method was found, return false
	else { return FALSE; }

	// Make sure we account for padding and borders on the image
	imageOffset = image.offset();
	imageOffset.left += Math.ceil((image.outerWidth(FALSE) - image.width()) / 2);
	imageOffset.top += Math.ceil((image.outerHeight(FALSE) - image.height()) / 2);

	// Add image position to offset coordinates
	result.position.left += imageOffset.left;
	result.position.top += imageOffset.top;

	return result;
};
;var IE6,

/*
 * BGIFrame adaption (http://plugins.jquery.com/project/bgiframe)
 * Special thanks to Brandon Aaron
 */
BGIFRAME = '<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';" ' +
	' style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); ' +
		'-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>';

function Ie6(api) {
	this._ns = 'ie6';

	this.qtip = api;
	this.init(api);
}

$.extend(Ie6.prototype, {
	_scroll : function() {
		var overlay = this.qtip.elements.overlay;
		overlay && (overlay[0].style.top = $(window).scrollTop() + 'px');
	},

	init: function(qtip) {
		var tooltip = qtip.tooltip;

		// Create the BGIFrame element if needed
		if($('select, object').length < 1) {
			this.bgiframe = qtip.elements.bgiframe = $(BGIFRAME).appendTo(tooltip);

			// Update BGIFrame on tooltip move
			qtip._bind(tooltip, 'tooltipmove', this.adjustBGIFrame, this._ns, this);
		}

		// redraw() container for width/height calculations
		this.redrawContainer = $('<div/>', { id: NAMESPACE+'-rcontainer' })
			.appendTo(document.body);

		// Fixup modal plugin if present too
		if( qtip.elements.overlay && qtip.elements.overlay.addClass('qtipmodal-ie6fix') ) {
			qtip._bind(window, ['scroll', 'resize'], this._scroll, this._ns, this);
			qtip._bind(tooltip, ['tooltipshow'], this._scroll, this._ns, this);
		}

		// Set dimensions
		this.redraw();
	},

	adjustBGIFrame: function() {
		var tooltip = this.qtip.tooltip,
			dimensions = {
				height: tooltip.outerHeight(FALSE),
				width: tooltip.outerWidth(FALSE)
			},
			plugin = this.qtip.plugins.tip,
			tip = this.qtip.elements.tip,
			tipAdjust, offset;

		// Adjust border offset
		offset = parseInt(tooltip.css('borderLeftWidth'), 10) || 0;
		offset = { left: -offset, top: -offset };

		// Adjust for tips plugin
		if(plugin && tip) {
			tipAdjust = plugin.corner.precedance === 'x' ? [WIDTH, LEFT] : [HEIGHT, TOP];
			offset[ tipAdjust[1] ] -= tip[ tipAdjust[0] ]();
		}

		// Update bgiframe
		this.bgiframe.css(offset).css(dimensions);
	},

	// Max/min width simulator function
	redraw: function() {
		if(this.qtip.rendered < 1 || this.drawing) { return this; }

		var tooltip = this.qtip.tooltip,
			style = this.qtip.options.style,
			container = this.qtip.options.position.container,
			perc, width, max, min;

		// Set drawing flag
		this.qtip.drawing = 1;

		// If tooltip has a set height/width, just set it... like a boss!
		if(style.height) { tooltip.css(HEIGHT, style.height); }
		if(style.width) { tooltip.css(WIDTH, style.width); }

		// Simulate max/min width if not set width present...
		else {
			// Reset width and add fluid class
			tooltip.css(WIDTH, '').appendTo(this.redrawContainer);

			// Grab our tooltip width (add 1 if odd so we don't get wrapping problems.. huzzah!)
			width = tooltip.width();
			if(width % 2 < 1) { width += 1; }

			// Grab our max/min properties
			max = tooltip.css('maxWidth') || '';
			min = tooltip.css('minWidth') || '';

			// Parse into proper pixel values
			perc = (max + min).indexOf('%') > -1 ? container.width() / 100 : 0;
			max = (max.indexOf('%') > -1 ? perc : 1 * parseInt(max, 10)) || width;
			min = (min.indexOf('%') > -1 ? perc : 1 * parseInt(min, 10)) || 0;

			// Determine new dimension size based on max/min/current values
			width = max + min ? Math.min(Math.max(width, min), max) : width;

			// Set the newly calculated width and remvoe fluid class
			tooltip.css(WIDTH, Math.round(width)).appendTo(container);
		}

		// Set drawing flag
		this.drawing = 0;

		return this;
	},

	destroy: function() {
		// Remove iframe
		this.bgiframe && this.bgiframe.remove();

		// Remove bound events
		this.qtip._unbind([window, this.qtip.tooltip], this._ns);
	}
});

IE6 = PLUGINS.ie6 = function(api) {
	// Proceed only if the browser is IE6
	return BROWSER.ie === 6 ? new Ie6(api) : FALSE;
};

IE6.initialize = 'render';

CHECKS.ie6 = {
	'^content|style$': function() {
		this.redraw();
	}
};
;}));
}( window, document ));



/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;//! moment.js
//! version : 2.8.3
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

(function (undefined) {
    /************************************
        Constants
    ************************************/

    var moment,
        VERSION = '2.8.3',
        // the global-scope this is NOT the global object in Node.js
        globalScope = typeof global !== 'undefined' ? global : this,
        oldGlobalMoment,
        round = Math.round,
        hasOwnProperty = Object.prototype.hasOwnProperty,
        i,

        YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,

        // internal storage for locale config files
        locales = {},

        // extra moment internal properties (plugins register props here)
        momentProperties = [],

        // check for nodeJS
        hasModule = (typeof module !== 'undefined' && module.exports),

        // ASP.NET json date format regex
        aspNetJsonRegex = /^\/?Date\((\-?\d+)/i,
        aspNetTimeSpanJsonRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/,

        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        isoDurationRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/,

        // format tokens
        formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,4}|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LT|LL?L?L?|l{1,4})/g,

        // parsing token regexes
        parseTokenOneOrTwoDigits = /\d\d?/, // 0 - 99
        parseTokenOneToThreeDigits = /\d{1,3}/, // 0 - 999
        parseTokenOneToFourDigits = /\d{1,4}/, // 0 - 9999
        parseTokenOneToSixDigits = /[+\-]?\d{1,6}/, // -999,999 - 999,999
        parseTokenDigits = /\d+/, // nonzero number of digits
        parseTokenWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i, // any word (or two) characters or numbers including two/three word month in arabic.
        parseTokenTimezone = /Z|[\+\-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        parseTokenT = /T/i, // T (ISO separator)
        parseTokenTimestampMs = /[\+\-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        parseTokenOrdinal = /\d{1,2}/,

        //strict parsing regexes
        parseTokenOneDigit = /\d/, // 0 - 9
        parseTokenTwoDigits = /\d\d/, // 00 - 99
        parseTokenThreeDigits = /\d{3}/, // 000 - 999
        parseTokenFourDigits = /\d{4}/, // 0000 - 9999
        parseTokenSixDigits = /[+-]?\d{6}/, // -999,999 - 999,999
        parseTokenSignedNumber = /[+-]?\d+/, // -inf - inf

        // iso 8601 regex
        // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
        isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,

        isoFormat = 'YYYY-MM-DDTHH:mm:ssZ',

        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/],
            ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/],
            ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d{2}/],
            ['YYYY-DDD', /\d{4}-\d{3}/]
        ],

        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/],
            ['HH:mm', /(T| )\d\d:\d\d/],
            ['HH', /(T| )\d\d/]
        ],

        // timezone chunker '+10:00' > ['10', '00'] or '-1530' > ['-15', '30']
        parseTimezoneChunker = /([\+\-]|\d\d)/gi,

        // getter and setter names
        proxyGettersAndSetters = 'Date|Hours|Minutes|Seconds|Milliseconds'.split('|'),
        unitMillisecondFactors = {
            'Milliseconds' : 1,
            'Seconds' : 1e3,
            'Minutes' : 6e4,
            'Hours' : 36e5,
            'Days' : 864e5,
            'Months' : 2592e6,
            'Years' : 31536e6
        },

        unitAliases = {
            ms : 'millisecond',
            s : 'second',
            m : 'minute',
            h : 'hour',
            d : 'day',
            D : 'date',
            w : 'week',
            W : 'isoWeek',
            M : 'month',
            Q : 'quarter',
            y : 'year',
            DDD : 'dayOfYear',
            e : 'weekday',
            E : 'isoWeekday',
            gg: 'weekYear',
            GG: 'isoWeekYear'
        },

        camelFunctions = {
            dayofyear : 'dayOfYear',
            isoweekday : 'isoWeekday',
            isoweek : 'isoWeek',
            weekyear : 'weekYear',
            isoweekyear : 'isoWeekYear'
        },

        // format function strings
        formatFunctions = {},

        // default relative time thresholds
        relativeTimeThresholds = {
            s: 45,  // seconds to minute
            m: 45,  // minutes to hour
            h: 22,  // hours to day
            d: 26,  // days to month
            M: 11   // months to year
        },

        // tokens to ordinalize and pad
        ordinalizeTokens = 'DDD w W M D d'.split(' '),
        paddedTokens = 'M D H h m s w W'.split(' '),

        formatTokenFunctions = {
            M    : function () {
                return this.month() + 1;
            },
            MMM  : function (format) {
                return this.localeData().monthsShort(this, format);
            },
            MMMM : function (format) {
                return this.localeData().months(this, format);
            },
            D    : function () {
                return this.date();
            },
            DDD  : function () {
                return this.dayOfYear();
            },
            d    : function () {
                return this.day();
            },
            dd   : function (format) {
                return this.localeData().weekdaysMin(this, format);
            },
            ddd  : function (format) {
                return this.localeData().weekdaysShort(this, format);
            },
            dddd : function (format) {
                return this.localeData().weekdays(this, format);
            },
            w    : function () {
                return this.week();
            },
            W    : function () {
                return this.isoWeek();
            },
            YY   : function () {
                return leftZeroFill(this.year() % 100, 2);
            },
            YYYY : function () {
                return leftZeroFill(this.year(), 4);
            },
            YYYYY : function () {
                return leftZeroFill(this.year(), 5);
            },
            YYYYYY : function () {
                var y = this.year(), sign = y >= 0 ? '+' : '-';
                return sign + leftZeroFill(Math.abs(y), 6);
            },
            gg   : function () {
                return leftZeroFill(this.weekYear() % 100, 2);
            },
            gggg : function () {
                return leftZeroFill(this.weekYear(), 4);
            },
            ggggg : function () {
                return leftZeroFill(this.weekYear(), 5);
            },
            GG   : function () {
                return leftZeroFill(this.isoWeekYear() % 100, 2);
            },
            GGGG : function () {
                return leftZeroFill(this.isoWeekYear(), 4);
            },
            GGGGG : function () {
                return leftZeroFill(this.isoWeekYear(), 5);
            },
            e : function () {
                return this.weekday();
            },
            E : function () {
                return this.isoWeekday();
            },
            a    : function () {
                return this.localeData().meridiem(this.hours(), this.minutes(), true);
            },
            A    : function () {
                return this.localeData().meridiem(this.hours(), this.minutes(), false);
            },
            H    : function () {
                return this.hours();
            },
            h    : function () {
                return this.hours() % 12 || 12;
            },
            m    : function () {
                return this.minutes();
            },
            s    : function () {
                return this.seconds();
            },
            S    : function () {
                return toInt(this.milliseconds() / 100);
            },
            SS   : function () {
                return leftZeroFill(toInt(this.milliseconds() / 10), 2);
            },
            SSS  : function () {
                return leftZeroFill(this.milliseconds(), 3);
            },
            SSSS : function () {
                return leftZeroFill(this.milliseconds(), 3);
            },
            Z    : function () {
                var a = -this.zone(),
                    b = '+';
                if (a < 0) {
                    a = -a;
                    b = '-';
                }
                return b + leftZeroFill(toInt(a / 60), 2) + ':' + leftZeroFill(toInt(a) % 60, 2);
            },
            ZZ   : function () {
                var a = -this.zone(),
                    b = '+';
                if (a < 0) {
                    a = -a;
                    b = '-';
                }
                return b + leftZeroFill(toInt(a / 60), 2) + leftZeroFill(toInt(a) % 60, 2);
            },
            z : function () {
                return this.zoneAbbr();
            },
            zz : function () {
                return this.zoneName();
            },
            X    : function () {
                return this.unix();
            },
            Q : function () {
                return this.quarter();
            }
        },

        deprecations = {},

        lists = ['months', 'monthsShort', 'weekdays', 'weekdaysShort', 'weekdaysMin'];

    // Pick the first defined of two or three arguments. dfl comes from
    // default.
    function dfl(a, b, c) {
        switch (arguments.length) {
            case 2: return a != null ? a : b;
            case 3: return a != null ? a : b != null ? b : c;
            default: throw new Error('Implement me');
        }
    }

    function hasOwnProp(a, b) {
        return hasOwnProperty.call(a, b);
    }

    function defaultParsingFlags() {
        // We need to deep clone this object, and es5 standard is not very
        // helpful.
        return {
            empty : false,
            unusedTokens : [],
            unusedInput : [],
            overflow : -2,
            charsLeftOver : 0,
            nullInput : false,
            invalidMonth : null,
            invalidFormat : false,
            userInvalidated : false,
            iso: false
        };
    }

    function printMsg(msg) {
        if (moment.suppressDeprecationWarnings === false &&
                typeof console !== 'undefined' && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function () {
            if (firstTime) {
                printMsg(msg);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    function deprecateSimple(name, msg) {
        if (!deprecations[name]) {
            printMsg(msg);
            deprecations[name] = true;
        }
    }

    function padToken(func, count) {
        return function (a) {
            return leftZeroFill(func.call(this, a), count);
        };
    }
    function ordinalizeToken(func, period) {
        return function (a) {
            return this.localeData().ordinal(func.call(this, a), period);
        };
    }

    while (ordinalizeTokens.length) {
        i = ordinalizeTokens.pop();
        formatTokenFunctions[i + 'o'] = ordinalizeToken(formatTokenFunctions[i], i);
    }
    while (paddedTokens.length) {
        i = paddedTokens.pop();
        formatTokenFunctions[i + i] = padToken(formatTokenFunctions[i], 2);
    }
    formatTokenFunctions.DDDD = padToken(formatTokenFunctions.DDD, 3);


    /************************************
        Constructors
    ************************************/

    function Locale() {
    }

    // Moment prototype object
    function Moment(config, skipOverflow) {
        if (skipOverflow !== false) {
            checkOverflow(config);
        }
        copyConfig(this, config);
        this._d = new Date(+config._d);
    }

    // Duration Constructor
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 36e5; // 1000 * 60 * 60
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = moment.localeData();

        this._bubble();
    }

    /************************************
        Helpers
    ************************************/


    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function copyConfig(to, from) {
        var i, prop, val;

        if (typeof from._isAMomentObject !== 'undefined') {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (typeof from._i !== 'undefined') {
            to._i = from._i;
        }
        if (typeof from._f !== 'undefined') {
            to._f = from._f;
        }
        if (typeof from._l !== 'undefined') {
            to._l = from._l;
        }
        if (typeof from._strict !== 'undefined') {
            to._strict = from._strict;
        }
        if (typeof from._tzm !== 'undefined') {
            to._tzm = from._tzm;
        }
        if (typeof from._isUTC !== 'undefined') {
            to._isUTC = from._isUTC;
        }
        if (typeof from._offset !== 'undefined') {
            to._offset = from._offset;
        }
        if (typeof from._pf !== 'undefined') {
            to._pf = from._pf;
        }
        if (typeof from._locale !== 'undefined') {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (typeof val !== 'undefined') {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.ceil(number);
        } else {
            return Math.floor(number);
        }
    }

    // left zero fill a number
    // see http://jsperf.com/left-zero-filling for performance comparison
    function leftZeroFill(number, targetLength, forceSign) {
        var output = '' + Math.abs(number),
            sign = number >= 0;

        while (output.length < targetLength) {
            output = '0' + output;
        }
        return (sign ? (forceSign ? '+' : '') : '-') + output;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        other = makeAs(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = moment.duration(val, period);
            addOrSubtractDurationFromMoment(this, dur, direction);
            return this;
        };
    }

    function addOrSubtractDurationFromMoment(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = duration._days,
            months = duration._months;
        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(+mom._d + milliseconds * isAdding);
        }
        if (days) {
            rawSetter(mom, 'Date', rawGetter(mom, 'Date') + days * isAdding);
        }
        if (months) {
            rawMonthSetter(mom, rawGetter(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            moment.updateOffset(mom, days || months);
        }
    }

    // check if is an array
    function isArray(input) {
        return Object.prototype.toString.call(input) === '[object Array]';
    }

    function isDate(input) {
        return Object.prototype.toString.call(input) === '[object Date]' ||
            input instanceof Date;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function normalizeUnits(units) {
        if (units) {
            var lowered = units.toLowerCase().replace(/(.)s$/, '$1');
            units = unitAliases[units] || camelFunctions[lowered] || lowered;
        }
        return units;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    function makeList(field) {
        var count, setter;

        if (field.indexOf('week') === 0) {
            count = 7;
            setter = 'day';
        }
        else if (field.indexOf('month') === 0) {
            count = 12;
            setter = 'month';
        }
        else {
            return;
        }

        moment[field] = function (format, index) {
            var i, getter,
                method = moment._locale[field],
                results = [];

            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            getter = function (i) {
                var m = moment().utc().set(setter, i);
                return method.call(moment._locale, m, format || '');
            };

            if (index != null) {
                return getter(index);
            }
            else {
                for (i = 0; i < count; i++) {
                    results.push(getter(i));
                }
                return results;
            }
        };
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            if (coercedNumber >= 0) {
                value = Math.floor(coercedNumber);
            } else {
                value = Math.ceil(coercedNumber);
            }
        }

        return value;
    }

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    function weeksInYear(year, dow, doy) {
        return weekOfYear(moment([year, 11, 31 + dow - doy]), dow, doy).week;
    }

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function checkOverflow(m) {
        var overflow;
        if (m._a && m._pf.overflow === -2) {
            overflow =
                m._a[MONTH] < 0 || m._a[MONTH] > 11 ? MONTH :
                m._a[DATE] < 1 || m._a[DATE] > daysInMonth(m._a[YEAR], m._a[MONTH]) ? DATE :
                m._a[HOUR] < 0 || m._a[HOUR] > 23 ? HOUR :
                m._a[MINUTE] < 0 || m._a[MINUTE] > 59 ? MINUTE :
                m._a[SECOND] < 0 || m._a[SECOND] > 59 ? SECOND :
                m._a[MILLISECOND] < 0 || m._a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (m._pf._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }

            m._pf.overflow = overflow;
        }
    }

    function isValid(m) {
        if (m._isValid == null) {
            m._isValid = !isNaN(m._d.getTime()) &&
                m._pf.overflow < 0 &&
                !m._pf.empty &&
                !m._pf.invalidMonth &&
                !m._pf.nullInput &&
                !m._pf.invalidFormat &&
                !m._pf.userInvalidated;

            if (m._strict) {
                m._isValid = m._isValid &&
                    m._pf.charsLeftOver === 0 &&
                    m._pf.unusedTokens.length === 0;
            }
        }
        return m._isValid;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        if (!locales[name] && hasModule) {
            try {
                oldLocale = moment.locale();
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                // because defineLocale currently also sets the global locale, we want to undo that for lazy loaded locales
                moment.locale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function makeAs(input, model) {
        return model._isUTC ? moment(input).zone(model._offset || 0) :
            moment(input).local();
    }

    /************************************
        Locale
    ************************************/


    extend(Locale.prototype, {

        set : function (config) {
            var prop, i;
            for (i in config) {
                prop = config[i];
                if (typeof prop === 'function') {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        },

        _months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        months : function (m) {
            return this._months[m.month()];
        },

        _monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        monthsShort : function (m) {
            return this._monthsShort[m.month()];
        },

        monthsParse : function (monthName) {
            var i, mom, regex;

            if (!this._monthsParse) {
                this._monthsParse = [];
            }

            for (i = 0; i < 12; i++) {
                // make the regex if we don't have it already
                if (!this._monthsParse[i]) {
                    mom = moment.utc([2000, i]);
                    regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                    this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                // test the regex
                if (this._monthsParse[i].test(monthName)) {
                    return i;
                }
            }
        },

        _weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdays : function (m) {
            return this._weekdays[m.day()];
        },

        _weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysShort : function (m) {
            return this._weekdaysShort[m.day()];
        },

        _weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        weekdaysMin : function (m) {
            return this._weekdaysMin[m.day()];
        },

        weekdaysParse : function (weekdayName) {
            var i, mom, regex;

            if (!this._weekdaysParse) {
                this._weekdaysParse = [];
            }

            for (i = 0; i < 7; i++) {
                // make the regex if we don't have it already
                if (!this._weekdaysParse[i]) {
                    mom = moment([2000, 1]).day(i);
                    regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                    this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                // test the regex
                if (this._weekdaysParse[i].test(weekdayName)) {
                    return i;
                }
            }
        },

        _longDateFormat : {
            LT : 'h:mm A',
            L : 'MM/DD/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY LT',
            LLLL : 'dddd, MMMM D, YYYY LT'
        },
        longDateFormat : function (key) {
            var output = this._longDateFormat[key];
            if (!output && this._longDateFormat[key.toUpperCase()]) {
                output = this._longDateFormat[key.toUpperCase()].replace(/MMMM|MM|DD|dddd/g, function (val) {
                    return val.slice(1);
                });
                this._longDateFormat[key] = output;
            }
            return output;
        },

        isPM : function (input) {
            // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
            // Using charAt should be more compatible.
            return ((input + '').toLowerCase().charAt(0) === 'p');
        },

        _meridiemParse : /[ap]\.?m?\.?/i,
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'pm' : 'PM';
            } else {
                return isLower ? 'am' : 'AM';
            }
        },

        _calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendar[key];
            return typeof output === 'function' ? output.apply(mom) : output;
        },

        _relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },

        relativeTime : function (number, withoutSuffix, string, isFuture) {
            var output = this._relativeTime[string];
            return (typeof output === 'function') ?
                output(number, withoutSuffix, string, isFuture) :
                output.replace(/%d/i, number);
        },

        pastFuture : function (diff, output) {
            var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
            return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
        },

        ordinal : function (number) {
            return this._ordinal.replace('%d', number);
        },
        _ordinal : '%d',

        preparse : function (string) {
            return string;
        },

        postformat : function (string) {
            return string;
        },

        week : function (mom) {
            return weekOfYear(mom, this._week.dow, this._week.doy).week;
        },

        _week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        },

        _invalidDate: 'Invalid date',
        invalidDate: function () {
            return this._invalidDate;
        }
    });

    /************************************
        Formatting
    ************************************/


    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '';
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());

        if (!formatFunctions[format]) {
            formatFunctions[format] = makeFormatFunction(format);
        }

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }


    /************************************
        Parsing
    ************************************/


    // get the regex to find the next token
    function getParseRegexForToken(token, config) {
        var a, strict = config._strict;
        switch (token) {
        case 'Q':
            return parseTokenOneDigit;
        case 'DDDD':
            return parseTokenThreeDigits;
        case 'YYYY':
        case 'GGGG':
        case 'gggg':
            return strict ? parseTokenFourDigits : parseTokenOneToFourDigits;
        case 'Y':
        case 'G':
        case 'g':
            return parseTokenSignedNumber;
        case 'YYYYYY':
        case 'YYYYY':
        case 'GGGGG':
        case 'ggggg':
            return strict ? parseTokenSixDigits : parseTokenOneToSixDigits;
        case 'S':
            if (strict) {
                return parseTokenOneDigit;
            }
            /* falls through */
        case 'SS':
            if (strict) {
                return parseTokenTwoDigits;
            }
            /* falls through */
        case 'SSS':
            if (strict) {
                return parseTokenThreeDigits;
            }
            /* falls through */
        case 'DDD':
            return parseTokenOneToThreeDigits;
        case 'MMM':
        case 'MMMM':
        case 'dd':
        case 'ddd':
        case 'dddd':
            return parseTokenWord;
        case 'a':
        case 'A':
            return config._locale._meridiemParse;
        case 'X':
            return parseTokenTimestampMs;
        case 'Z':
        case 'ZZ':
            return parseTokenTimezone;
        case 'T':
            return parseTokenT;
        case 'SSSS':
            return parseTokenDigits;
        case 'MM':
        case 'DD':
        case 'YY':
        case 'GG':
        case 'gg':
        case 'HH':
        case 'hh':
        case 'mm':
        case 'ss':
        case 'ww':
        case 'WW':
            return strict ? parseTokenTwoDigits : parseTokenOneOrTwoDigits;
        case 'M':
        case 'D':
        case 'd':
        case 'H':
        case 'h':
        case 'm':
        case 's':
        case 'w':
        case 'W':
        case 'e':
        case 'E':
            return parseTokenOneOrTwoDigits;
        case 'Do':
            return parseTokenOrdinal;
        default :
            a = new RegExp(regexpEscape(unescapeFormat(token.replace('\\', '')), 'i'));
            return a;
        }
    }

    function timezoneMinutesFromString(string) {
        string = string || '';
        var possibleTzMatches = (string.match(parseTokenTimezone) || []),
            tzChunk = possibleTzMatches[possibleTzMatches.length - 1] || [],
            parts = (tzChunk + '').match(parseTimezoneChunker) || ['-', 0, 0],
            minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? -minutes : minutes;
    }

    // function to convert string input to date
    function addTimeToArrayFromToken(token, input, config) {
        var a, datePartArray = config._a;

        switch (token) {
        // QUARTER
        case 'Q':
            if (input != null) {
                datePartArray[MONTH] = (toInt(input) - 1) * 3;
            }
            break;
        // MONTH
        case 'M' : // fall through to MM
        case 'MM' :
            if (input != null) {
                datePartArray[MONTH] = toInt(input) - 1;
            }
            break;
        case 'MMM' : // fall through to MMMM
        case 'MMMM' :
            a = config._locale.monthsParse(input);
            // if we didn't find a month name, mark the date as invalid.
            if (a != null) {
                datePartArray[MONTH] = a;
            } else {
                config._pf.invalidMonth = input;
            }
            break;
        // DAY OF MONTH
        case 'D' : // fall through to DD
        case 'DD' :
            if (input != null) {
                datePartArray[DATE] = toInt(input);
            }
            break;
        case 'Do' :
            if (input != null) {
                datePartArray[DATE] = toInt(parseInt(input, 10));
            }
            break;
        // DAY OF YEAR
        case 'DDD' : // fall through to DDDD
        case 'DDDD' :
            if (input != null) {
                config._dayOfYear = toInt(input);
            }

            break;
        // YEAR
        case 'YY' :
            datePartArray[YEAR] = moment.parseTwoDigitYear(input);
            break;
        case 'YYYY' :
        case 'YYYYY' :
        case 'YYYYYY' :
            datePartArray[YEAR] = toInt(input);
            break;
        // AM / PM
        case 'a' : // fall through to A
        case 'A' :
            config._isPm = config._locale.isPM(input);
            break;
        // 24 HOUR
        case 'H' : // fall through to hh
        case 'HH' : // fall through to hh
        case 'h' : // fall through to hh
        case 'hh' :
            datePartArray[HOUR] = toInt(input);
            break;
        // MINUTE
        case 'm' : // fall through to mm
        case 'mm' :
            datePartArray[MINUTE] = toInt(input);
            break;
        // SECOND
        case 's' : // fall through to ss
        case 'ss' :
            datePartArray[SECOND] = toInt(input);
            break;
        // MILLISECOND
        case 'S' :
        case 'SS' :
        case 'SSS' :
        case 'SSSS' :
            datePartArray[MILLISECOND] = toInt(('0.' + input) * 1000);
            break;
        // UNIX TIMESTAMP WITH MS
        case 'X':
            config._d = new Date(parseFloat(input) * 1000);
            break;
        // TIMEZONE
        case 'Z' : // fall through to ZZ
        case 'ZZ' :
            config._useUTC = true;
            config._tzm = timezoneMinutesFromString(input);
            break;
        // WEEKDAY - human
        case 'dd':
        case 'ddd':
        case 'dddd':
            a = config._locale.weekdaysParse(input);
            // if we didn't get a weekday name, mark the date as invalid
            if (a != null) {
                config._w = config._w || {};
                config._w['d'] = a;
            } else {
                config._pf.invalidWeekday = input;
            }
            break;
        // WEEK, WEEK DAY - numeric
        case 'w':
        case 'ww':
        case 'W':
        case 'WW':
        case 'd':
        case 'e':
        case 'E':
            token = token.substr(0, 1);
            /* falls through */
        case 'gggg':
        case 'GGGG':
        case 'GGGGG':
            token = token.substr(0, 2);
            if (input) {
                config._w = config._w || {};
                config._w[token] = toInt(input);
            }
            break;
        case 'gg':
        case 'GG':
            config._w = config._w || {};
            config._w[token] = moment.parseTwoDigitYear(input);
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = dfl(w.GG, config._a[YEAR], weekOfYear(moment(), 1, 4).year);
            week = dfl(w.W, 1);
            weekday = dfl(w.E, 1);
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            weekYear = dfl(w.gg, config._a[YEAR], weekOfYear(moment(), dow, doy).year);
            week = dfl(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < dow) {
                    ++week;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        temp = dayOfYearFromWeeks(weekYear, week, weekday, doy, dow);

        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function dateFromConfig(config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = dfl(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                config._pf._overflowDayOfYear = true;
            }

            date = makeUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        config._d = (config._useUTC ? makeUTCDate : makeDate).apply(null, input);
        // Apply timezone offset from input. The actual zone can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() + config._tzm);
        }
    }

    function dateFromObject(config) {
        var normalizedInput;

        if (config._d) {
            return;
        }

        normalizedInput = normalizeObjectUnits(config._i);
        config._a = [
            normalizedInput.year,
            normalizedInput.month,
            normalizedInput.day,
            normalizedInput.hour,
            normalizedInput.minute,
            normalizedInput.second,
            normalizedInput.millisecond
        ];

        dateFromConfig(config);
    }

    function currentDateArray(config) {
        var now = new Date();
        if (config._useUTC) {
            return [
                now.getUTCFullYear(),
                now.getUTCMonth(),
                now.getUTCDate()
            ];
        } else {
            return [now.getFullYear(), now.getMonth(), now.getDate()];
        }
    }

    // date from string and format string
    function makeDateFromStringAndFormat(config) {
        if (config._f === moment.ISO_8601) {
            parseISO(config);
            return;
        }

        config._a = [];
        config._pf.empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    config._pf.unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    config._pf.empty = false;
                }
                else {
                    config._pf.unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                config._pf.unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        config._pf.charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            config._pf.unusedInput.push(string);
        }

        // handle am pm
        if (config._isPm && config._a[HOUR] < 12) {
            config._a[HOUR] += 12;
        }
        // if is 12 am, change hours to 0
        if (config._isPm === false && config._a[HOUR] === 12) {
            config._a[HOUR] = 0;
        }

        dateFromConfig(config);
        checkOverflow(config);
    }

    function unescapeFormat(s) {
        return s.replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        });
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function regexpEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    // date from string and array of format strings
    function makeDateFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            config._pf.invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._pf = defaultParsingFlags();
            tempConfig._f = config._f[i];
            makeDateFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += tempConfig._pf.charsLeftOver;

            //or tokens
            currentScore += tempConfig._pf.unusedTokens.length * 10;

            tempConfig._pf.score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    // date from iso format
    function parseISO(config) {
        var i, l,
            string = config._i,
            match = isoRegex.exec(string);

        if (match) {
            config._pf.iso = true;
            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(string)) {
                    // match[5] should be 'T' or undefined
                    config._f = isoDates[i][0] + (match[6] || ' ');
                    break;
                }
            }
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(string)) {
                    config._f += isoTimes[i][0];
                    break;
                }
            }
            if (string.match(parseTokenTimezone)) {
                config._f += 'Z';
            }
            makeDateFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function makeDateFromString(config) {
        parseISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            moment.createFromInputFallback(config);
        }
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function makeDateFromInput(config) {
        var input = config._i, matched;
        if (input === undefined) {
            config._d = new Date();
        } else if (isDate(input)) {
            config._d = new Date(+input);
        } else if ((matched = aspNetJsonRegex.exec(input)) !== null) {
            config._d = new Date(+matched[1]);
        } else if (typeof input === 'string') {
            makeDateFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            dateFromConfig(config);
        } else if (typeof(input) === 'object') {
            dateFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            moment.createFromInputFallback(config);
        }
    }

    function makeDate(y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor doesn't accept years < 1970
        if (y < 1970) {
            date.setFullYear(y);
        }
        return date;
    }

    function makeUTCDate(y) {
        var date = new Date(Date.UTC.apply(null, arguments));
        if (y < 1970) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    function parseWeekday(input, locale) {
        if (typeof input === 'string') {
            if (!isNaN(input)) {
                input = parseInt(input, 10);
            }
            else {
                input = locale.weekdaysParse(input);
                if (typeof input !== 'number') {
                    return null;
                }
            }
        }
        return input;
    }

    /************************************
        Relative Time
    ************************************/


    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime(posNegDuration, withoutSuffix, locale) {
        var duration = moment.duration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            years = round(duration.as('y')),

            args = seconds < relativeTimeThresholds.s && ['s', seconds] ||
                minutes === 1 && ['m'] ||
                minutes < relativeTimeThresholds.m && ['mm', minutes] ||
                hours === 1 && ['h'] ||
                hours < relativeTimeThresholds.h && ['hh', hours] ||
                days === 1 && ['d'] ||
                days < relativeTimeThresholds.d && ['dd', days] ||
                months === 1 && ['M'] ||
                months < relativeTimeThresholds.M && ['MM', months] ||
                years === 1 && ['y'] || ['yy', years];

        args[2] = withoutSuffix;
        args[3] = +posNegDuration > 0;
        args[4] = locale;
        return substituteTimeAgo.apply({}, args);
    }


    /************************************
        Week of Year
    ************************************/


    // firstDayOfWeek       0 = sun, 6 = sat
    //                      the day of the week that starts the week
    //                      (usually sunday or monday)
    // firstDayOfWeekOfYear 0 = sun, 6 = sat
    //                      the first week is the week that contains the first
    //                      of this day of the week
    //                      (eg. ISO weeks use thursday (4))
    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
        var end = firstDayOfWeekOfYear - firstDayOfWeek,
            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
            adjustedMoment;


        if (daysToDayOfWeek > end) {
            daysToDayOfWeek -= 7;
        }

        if (daysToDayOfWeek < end - 7) {
            daysToDayOfWeek += 7;
        }

        adjustedMoment = moment(mom).add(daysToDayOfWeek, 'd');
        return {
            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
            year: adjustedMoment.year()
        };
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
        var d = makeUTCDate(year, 0, 1).getUTCDay(), daysToAdd, dayOfYear;

        d = d === 0 ? 7 : d;
        weekday = weekday != null ? weekday : firstDayOfWeek;
        daysToAdd = firstDayOfWeek - d + (d > firstDayOfWeekOfYear ? 7 : 0) - (d < firstDayOfWeek ? 7 : 0);
        dayOfYear = 7 * (week - 1) + (weekday - firstDayOfWeek) + daysToAdd + 1;

        return {
            year: dayOfYear > 0 ? year : year - 1,
            dayOfYear: dayOfYear > 0 ?  dayOfYear : daysInYear(year - 1) + dayOfYear
        };
    }

    /************************************
        Top Level Functions
    ************************************/

    function makeMoment(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || moment.localeData(config._l);

        if (input === null || (format === undefined && input === '')) {
            return moment.invalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (moment.isMoment(input)) {
            return new Moment(input, true);
        } else if (format) {
            if (isArray(format)) {
                makeDateFromStringAndArray(config);
            } else {
                makeDateFromStringAndFormat(config);
            }
        } else {
            makeDateFromInput(config);
        }

        return new Moment(config);
    }

    moment = function (input, format, locale, strict) {
        var c;

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c = {};
        c._isAMomentObject = true;
        c._i = input;
        c._f = format;
        c._l = locale;
        c._strict = strict;
        c._isUTC = false;
        c._pf = defaultParsingFlags();

        return makeMoment(c);
    };

    moment.suppressDeprecationWarnings = false;

    moment.createFromInputFallback = deprecate(
        'moment construction falls back to js Date. This is ' +
        'discouraged and will be removed in upcoming major ' +
        'release. Please refer to ' +
        'https://github.com/moment/moment/issues/1407 for more info.',
        function (config) {
            config._d = new Date(config._i);
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return moment();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    moment.min = function () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    };

    moment.max = function () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    };

    // creating with utc
    moment.utc = function (input, format, locale, strict) {
        var c;

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c = {};
        c._isAMomentObject = true;
        c._useUTC = true;
        c._isUTC = true;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        c._pf = defaultParsingFlags();

        return makeMoment(c).utc();
    };

    // creating with unix timestamp (in seconds)
    moment.unix = function (input) {
        return moment(input * 1000);
    };

    // duration
    moment.duration = function (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            parseIso,
            diffRes;

        if (moment.isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetTimeSpanJsonRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = isoDurationRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            parseIso = function (inp) {
                // We'd normally use ~~inp for this, but unfortunately it also
                // converts floats to ints.
                // inp may be undefined, so careful calling replace on it.
                var res = inp && parseFloat(inp.replace(',', '.'));
                // apply sign while we're at it
                return (isNaN(res) ? 0 : res) * sign;
            };
            duration = {
                y: parseIso(match[2]),
                M: parseIso(match[3]),
                d: parseIso(match[4]),
                h: parseIso(match[5]),
                m: parseIso(match[6]),
                s: parseIso(match[7]),
                w: parseIso(match[8])
            };
        } else if (typeof duration === 'object' &&
                ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(moment(duration.from), moment(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (moment.isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    };

    // version number
    moment.version = VERSION;

    // default format
    moment.defaultFormat = isoFormat;

    // constant that refers to the ISO standard
    moment.ISO_8601 = function () {};

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    moment.momentProperties = momentProperties;

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    moment.updateOffset = function () {};

    // This function allows you to set a threshold for relative time strings
    moment.relativeTimeThreshold = function (threshold, limit) {
        if (relativeTimeThresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return relativeTimeThresholds[threshold];
        }
        relativeTimeThresholds[threshold] = limit;
        return true;
    };

    moment.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        function (key, value) {
            return moment.locale(key, value);
        }
    );

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    moment.locale = function (key, values) {
        var data;
        if (key) {
            if (typeof(values) !== 'undefined') {
                data = moment.defineLocale(key, values);
            }
            else {
                data = moment.localeData(key);
            }

            if (data) {
                moment.duration._locale = moment._locale = data;
            }
        }

        return moment._locale._abbr;
    };

    moment.defineLocale = function (name, values) {
        if (values !== null) {
            values.abbr = name;
            if (!locales[name]) {
                locales[name] = new Locale();
            }
            locales[name].set(values);

            // backwards compat for now: also set the locale
            moment.locale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    };

    moment.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        function (key) {
            return moment.localeData(key);
        }
    );

    // returns locale data
    moment.localeData = function (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return moment._locale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    };

    // compare moment object
    moment.isMoment = function (obj) {
        return obj instanceof Moment ||
            (obj != null && hasOwnProp(obj, '_isAMomentObject'));
    };

    // for typechecking Duration objects
    moment.isDuration = function (obj) {
        return obj instanceof Duration;
    };

    for (i = lists.length - 1; i >= 0; --i) {
        makeList(lists[i]);
    }

    moment.normalizeUnits = function (units) {
        return normalizeUnits(units);
    };

    moment.invalid = function (flags) {
        var m = moment.utc(NaN);
        if (flags != null) {
            extend(m._pf, flags);
        }
        else {
            m._pf.userInvalidated = true;
        }

        return m;
    };

    moment.parseZone = function () {
        return moment.apply(null, arguments).parseZone();
    };

    moment.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    /************************************
        Moment Prototype
    ************************************/


    extend(moment.fn = Moment.prototype, {

        clone : function () {
            return moment(this);
        },

        valueOf : function () {
            return +this._d + ((this._offset || 0) * 60000);
        },

        unix : function () {
            return Math.floor(+this / 1000);
        },

        toString : function () {
            return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
        },

        toDate : function () {
            return this._offset ? new Date(+this) : this._d;
        },

        toISOString : function () {
            var m = moment(this).utc();
            if (0 < m.year() && m.year() <= 9999) {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            } else {
                return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        },

        toArray : function () {
            var m = this;
            return [
                m.year(),
                m.month(),
                m.date(),
                m.hours(),
                m.minutes(),
                m.seconds(),
                m.milliseconds()
            ];
        },

        isValid : function () {
            return isValid(this);
        },

        isDSTShifted : function () {
            if (this._a) {
                return this.isValid() && compareArrays(this._a, (this._isUTC ? moment.utc(this._a) : moment(this._a)).toArray()) > 0;
            }

            return false;
        },

        parsingFlags : function () {
            return extend({}, this._pf);
        },

        invalidAt: function () {
            return this._pf.overflow;
        },

        utc : function (keepLocalTime) {
            return this.zone(0, keepLocalTime);
        },

        local : function (keepLocalTime) {
            if (this._isUTC) {
                this.zone(0, keepLocalTime);
                this._isUTC = false;

                if (keepLocalTime) {
                    this.add(this._dateTzOffset(), 'm');
                }
            }
            return this;
        },

        format : function (inputString) {
            var output = formatMoment(this, inputString || moment.defaultFormat);
            return this.localeData().postformat(output);
        },

        add : createAdder(1, 'add'),

        subtract : createAdder(-1, 'subtract'),

        diff : function (input, units, asFloat) {
            var that = makeAs(input, this),
                zoneDiff = (this.zone() - that.zone()) * 6e4,
                diff, output, daysAdjust;

            units = normalizeUnits(units);

            if (units === 'year' || units === 'month') {
                // average number of days in the months in the given dates
                diff = (this.daysInMonth() + that.daysInMonth()) * 432e5; // 24 * 60 * 60 * 1000 / 2
                // difference in months
                output = ((this.year() - that.year()) * 12) + (this.month() - that.month());
                // adjust by taking difference in days, average number of days
                // and dst in the given months.
                daysAdjust = (this - moment(this).startOf('month')) -
                    (that - moment(that).startOf('month'));
                // same as above but with zones, to negate all dst
                daysAdjust -= ((this.zone() - moment(this).startOf('month').zone()) -
                        (that.zone() - moment(that).startOf('month').zone())) * 6e4;
                output += daysAdjust / diff;
                if (units === 'year') {
                    output = output / 12;
                }
            } else {
                diff = (this - that);
                output = units === 'second' ? diff / 1e3 : // 1000
                    units === 'minute' ? diff / 6e4 : // 1000 * 60
                    units === 'hour' ? diff / 36e5 : // 1000 * 60 * 60
                    units === 'day' ? (diff - zoneDiff) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                    units === 'week' ? (diff - zoneDiff) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                    diff;
            }
            return asFloat ? output : absRound(output);
        },

        from : function (time, withoutSuffix) {
            return moment.duration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        },

        fromNow : function (withoutSuffix) {
            return this.from(moment(), withoutSuffix);
        },

        calendar : function (time) {
            // We want to compare the start of today, vs this.
            // Getting start-of-today depends on whether we're zone'd or not.
            var now = time || moment(),
                sod = makeAs(now, this).startOf('day'),
                diff = this.diff(sod, 'days', true),
                format = diff < -6 ? 'sameElse' :
                    diff < -1 ? 'lastWeek' :
                    diff < 0 ? 'lastDay' :
                    diff < 1 ? 'sameDay' :
                    diff < 2 ? 'nextDay' :
                    diff < 7 ? 'nextWeek' : 'sameElse';
            return this.format(this.localeData().calendar(format, this));
        },

        isLeapYear : function () {
            return isLeapYear(this.year());
        },

        isDST : function () {
            return (this.zone() < this.clone().month(0).zone() ||
                this.zone() < this.clone().month(5).zone());
        },

        day : function (input) {
            var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
            if (input != null) {
                input = parseWeekday(input, this.localeData());
                return this.add(input - day, 'd');
            } else {
                return day;
            }
        },

        month : makeAccessor('Month', true),

        startOf : function (units) {
            units = normalizeUnits(units);
            // the following switch intentionally omits break keywords
            // to utilize falling through the cases.
            switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
                /* falls through */
            }

            // weeks are a special case
            if (units === 'week') {
                this.weekday(0);
            } else if (units === 'isoWeek') {
                this.isoWeekday(1);
            }

            // quarters are also special
            if (units === 'quarter') {
                this.month(Math.floor(this.month() / 3) * 3);
            }

            return this;
        },

        endOf: function (units) {
            units = normalizeUnits(units);
            return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
        },

        isAfter: function (input, units) {
            units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
            if (units === 'millisecond') {
                input = moment.isMoment(input) ? input : moment(input);
                return +this > +input;
            } else {
                return +this.clone().startOf(units) > +moment(input).startOf(units);
            }
        },

        isBefore: function (input, units) {
            units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
            if (units === 'millisecond') {
                input = moment.isMoment(input) ? input : moment(input);
                return +this < +input;
            } else {
                return +this.clone().startOf(units) < +moment(input).startOf(units);
            }
        },

        isSame: function (input, units) {
            units = normalizeUnits(units || 'millisecond');
            if (units === 'millisecond') {
                input = moment.isMoment(input) ? input : moment(input);
                return +this === +input;
            } else {
                return +this.clone().startOf(units) === +makeAs(input, this).startOf(units);
            }
        },

        min: deprecate(
                 'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
                 function (other) {
                     other = moment.apply(null, arguments);
                     return other < this ? this : other;
                 }
         ),

        max: deprecate(
                'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
                function (other) {
                    other = moment.apply(null, arguments);
                    return other > this ? this : other;
                }
        ),

        // keepLocalTime = true means only change the timezone, without
        // affecting the local hour. So 5:31:26 +0300 --[zone(2, true)]-->
        // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist int zone
        // +0200, so we adjust the time as needed, to be valid.
        //
        // Keeping the time actually adds/subtracts (one hour)
        // from the actual represented time. That is why we call updateOffset
        // a second time. In case it wants us to change the offset again
        // _changeInProgress == true case, then we have to adjust, because
        // there is no such time in the given timezone.
        zone : function (input, keepLocalTime) {
            var offset = this._offset || 0,
                localAdjust;
            if (input != null) {
                if (typeof input === 'string') {
                    input = timezoneMinutesFromString(input);
                }
                if (Math.abs(input) < 16) {
                    input = input * 60;
                }
                if (!this._isUTC && keepLocalTime) {
                    localAdjust = this._dateTzOffset();
                }
                this._offset = input;
                this._isUTC = true;
                if (localAdjust != null) {
                    this.subtract(localAdjust, 'm');
                }
                if (offset !== input) {
                    if (!keepLocalTime || this._changeInProgress) {
                        addOrSubtractDurationFromMoment(this,
                                moment.duration(offset - input, 'm'), 1, false);
                    } else if (!this._changeInProgress) {
                        this._changeInProgress = true;
                        moment.updateOffset(this, true);
                        this._changeInProgress = null;
                    }
                }
            } else {
                return this._isUTC ? offset : this._dateTzOffset();
            }
            return this;
        },

        zoneAbbr : function () {
            return this._isUTC ? 'UTC' : '';
        },

        zoneName : function () {
            return this._isUTC ? 'Coordinated Universal Time' : '';
        },

        parseZone : function () {
            if (this._tzm) {
                this.zone(this._tzm);
            } else if (typeof this._i === 'string') {
                this.zone(this._i);
            }
            return this;
        },

        hasAlignedHourOffset : function (input) {
            if (!input) {
                input = 0;
            }
            else {
                input = moment(input).zone();
            }

            return (this.zone() - input) % 60 === 0;
        },

        daysInMonth : function () {
            return daysInMonth(this.year(), this.month());
        },

        dayOfYear : function (input) {
            var dayOfYear = round((moment(this).startOf('day') - moment(this).startOf('year')) / 864e5) + 1;
            return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
        },

        quarter : function (input) {
            return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
        },

        weekYear : function (input) {
            var year = weekOfYear(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
            return input == null ? year : this.add((input - year), 'y');
        },

        isoWeekYear : function (input) {
            var year = weekOfYear(this, 1, 4).year;
            return input == null ? year : this.add((input - year), 'y');
        },

        week : function (input) {
            var week = this.localeData().week(this);
            return input == null ? week : this.add((input - week) * 7, 'd');
        },

        isoWeek : function (input) {
            var week = weekOfYear(this, 1, 4).week;
            return input == null ? week : this.add((input - week) * 7, 'd');
        },

        weekday : function (input) {
            var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
            return input == null ? weekday : this.add(input - weekday, 'd');
        },

        isoWeekday : function (input) {
            // behaves the same as moment#day except
            // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
            // as a setter, sunday should belong to the previous week.
            return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
        },

        isoWeeksInYear : function () {
            return weeksInYear(this.year(), 1, 4);
        },

        weeksInYear : function () {
            var weekInfo = this.localeData()._week;
            return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
        },

        get : function (units) {
            units = normalizeUnits(units);
            return this[units]();
        },

        set : function (units, value) {
            units = normalizeUnits(units);
            if (typeof this[units] === 'function') {
                this[units](value);
            }
            return this;
        },

        // If passed a locale key, it will set the locale for this
        // instance.  Otherwise, it will return the locale configuration
        // variables for this instance.
        locale : function (key) {
            var newLocaleData;

            if (key === undefined) {
                return this._locale._abbr;
            } else {
                newLocaleData = moment.localeData(key);
                if (newLocaleData != null) {
                    this._locale = newLocaleData;
                }
                return this;
            }
        },

        lang : deprecate(
            'moment().lang() is deprecated. Use moment().localeData() instead.',
            function (key) {
                if (key === undefined) {
                    return this.localeData();
                } else {
                    return this.locale(key);
                }
            }
        ),

        localeData : function () {
            return this._locale;
        },

        _dateTzOffset : function () {
            // On Firefox.24 Date#getTimezoneOffset returns a floating point.
            // https://github.com/moment/moment/pull/1871
            return Math.round(this._d.getTimezoneOffset() / 15) * 15;
        }
    });

    function rawMonthSetter(mom, value) {
        var dayOfMonth;

        // TODO: Move this out of here!
        if (typeof value === 'string') {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (typeof value !== 'number') {
                return mom;
            }
        }

        dayOfMonth = Math.min(mom.date(),
                daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function rawGetter(mom, unit) {
        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
    }

    function rawSetter(mom, unit, value) {
        if (unit === 'Month') {
            return rawMonthSetter(mom, value);
        } else {
            return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    function makeAccessor(unit, keepTime) {
        return function (value) {
            if (value != null) {
                rawSetter(this, unit, value);
                moment.updateOffset(this, keepTime);
                return this;
            } else {
                return rawGetter(this, unit);
            }
        };
    }

    moment.fn.millisecond = moment.fn.milliseconds = makeAccessor('Milliseconds', false);
    moment.fn.second = moment.fn.seconds = makeAccessor('Seconds', false);
    moment.fn.minute = moment.fn.minutes = makeAccessor('Minutes', false);
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    moment.fn.hour = moment.fn.hours = makeAccessor('Hours', true);
    // moment.fn.month is defined separately
    moment.fn.date = makeAccessor('Date', true);
    moment.fn.dates = deprecate('dates accessor is deprecated. Use date instead.', makeAccessor('Date', true));
    moment.fn.year = makeAccessor('FullYear', true);
    moment.fn.years = deprecate('years accessor is deprecated. Use year instead.', makeAccessor('FullYear', true));

    // add plural methods
    moment.fn.days = moment.fn.day;
    moment.fn.months = moment.fn.month;
    moment.fn.weeks = moment.fn.week;
    moment.fn.isoWeeks = moment.fn.isoWeek;
    moment.fn.quarters = moment.fn.quarter;

    // add aliased format methods
    moment.fn.toJSON = moment.fn.toISOString;

    /************************************
        Duration Prototype
    ************************************/


    function daysToYears (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        return days * 400 / 146097;
    }

    function yearsToDays (years) {
        // years * 365 + absRound(years / 4) -
        //     absRound(years / 100) + absRound(years / 400);
        return years * 146097 / 400;
    }

    extend(moment.duration.fn = Duration.prototype, {

        _bubble : function () {
            var milliseconds = this._milliseconds,
                days = this._days,
                months = this._months,
                data = this._data,
                seconds, minutes, hours, years = 0;

            // The following code bubbles up values, see the tests for
            // examples of what that means.
            data.milliseconds = milliseconds % 1000;

            seconds = absRound(milliseconds / 1000);
            data.seconds = seconds % 60;

            minutes = absRound(seconds / 60);
            data.minutes = minutes % 60;

            hours = absRound(minutes / 60);
            data.hours = hours % 24;

            days += absRound(hours / 24);

            // Accurately convert days to years, assume start from year 0.
            years = absRound(daysToYears(days));
            days -= absRound(yearsToDays(years));

            // 30 days to a month
            // TODO (iskren): Use anchor date (like 1st Jan) to compute this.
            months += absRound(days / 30);
            days %= 30;

            // 12 months -> 1 year
            years += absRound(months / 12);
            months %= 12;

            data.days = days;
            data.months = months;
            data.years = years;
        },

        abs : function () {
            this._milliseconds = Math.abs(this._milliseconds);
            this._days = Math.abs(this._days);
            this._months = Math.abs(this._months);

            this._data.milliseconds = Math.abs(this._data.milliseconds);
            this._data.seconds = Math.abs(this._data.seconds);
            this._data.minutes = Math.abs(this._data.minutes);
            this._data.hours = Math.abs(this._data.hours);
            this._data.months = Math.abs(this._data.months);
            this._data.years = Math.abs(this._data.years);

            return this;
        },

        weeks : function () {
            return absRound(this.days() / 7);
        },

        valueOf : function () {
            return this._milliseconds +
              this._days * 864e5 +
              (this._months % 12) * 2592e6 +
              toInt(this._months / 12) * 31536e6;
        },

        humanize : function (withSuffix) {
            var output = relativeTime(this, !withSuffix, this.localeData());

            if (withSuffix) {
                output = this.localeData().pastFuture(+this, output);
            }

            return this.localeData().postformat(output);
        },

        add : function (input, val) {
            // supports only 2.0-style add(1, 's') or add(moment)
            var dur = moment.duration(input, val);

            this._milliseconds += dur._milliseconds;
            this._days += dur._days;
            this._months += dur._months;

            this._bubble();

            return this;
        },

        subtract : function (input, val) {
            var dur = moment.duration(input, val);

            this._milliseconds -= dur._milliseconds;
            this._days -= dur._days;
            this._months -= dur._months;

            this._bubble();

            return this;
        },

        get : function (units) {
            units = normalizeUnits(units);
            return this[units.toLowerCase() + 's']();
        },

        as : function (units) {
            var days, months;
            units = normalizeUnits(units);

            if (units === 'month' || units === 'year') {
                days = this._days + this._milliseconds / 864e5;
                months = this._months + daysToYears(days) * 12;
                return units === 'month' ? months : months / 12;
            } else {
                // handle milliseconds separately because of floating point math errors (issue #1867)
                days = this._days + yearsToDays(this._months / 12);
                switch (units) {
                    case 'week': return days / 7 + this._milliseconds / 6048e5;
                    case 'day': return days + this._milliseconds / 864e5;
                    case 'hour': return days * 24 + this._milliseconds / 36e5;
                    case 'minute': return days * 24 * 60 + this._milliseconds / 6e4;
                    case 'second': return days * 24 * 60 * 60 + this._milliseconds / 1000;
                    // Math.floor prevents floating point math errors here
                    case 'millisecond': return Math.floor(days * 24 * 60 * 60 * 1000) + this._milliseconds;
                    default: throw new Error('Unknown unit ' + units);
                }
            }
        },

        lang : moment.fn.lang,
        locale : moment.fn.locale,

        toIsoString : deprecate(
            'toIsoString() is deprecated. Please use toISOString() instead ' +
            '(notice the capitals)',
            function () {
                return this.toISOString();
            }
        ),

        toISOString : function () {
            // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
            var years = Math.abs(this.years()),
                months = Math.abs(this.months()),
                days = Math.abs(this.days()),
                hours = Math.abs(this.hours()),
                minutes = Math.abs(this.minutes()),
                seconds = Math.abs(this.seconds() + this.milliseconds() / 1000);

            if (!this.asSeconds()) {
                // this is the same as C#'s (Noda) and python (isodate)...
                // but not other JS (goog.date)
                return 'P0D';
            }

            return (this.asSeconds() < 0 ? '-' : '') +
                'P' +
                (years ? years + 'Y' : '') +
                (months ? months + 'M' : '') +
                (days ? days + 'D' : '') +
                ((hours || minutes || seconds) ? 'T' : '') +
                (hours ? hours + 'H' : '') +
                (minutes ? minutes + 'M' : '') +
                (seconds ? seconds + 'S' : '');
        },

        localeData : function () {
            return this._locale;
        }
    });

    moment.duration.fn.toString = moment.duration.fn.toISOString;

    function makeDurationGetter(name) {
        moment.duration.fn[name] = function () {
            return this._data[name];
        };
    }

    for (i in unitMillisecondFactors) {
        if (hasOwnProp(unitMillisecondFactors, i)) {
            makeDurationGetter(i.toLowerCase());
        }
    }

    moment.duration.fn.asMilliseconds = function () {
        return this.as('ms');
    };
    moment.duration.fn.asSeconds = function () {
        return this.as('s');
    };
    moment.duration.fn.asMinutes = function () {
        return this.as('m');
    };
    moment.duration.fn.asHours = function () {
        return this.as('h');
    };
    moment.duration.fn.asDays = function () {
        return this.as('d');
    };
    moment.duration.fn.asWeeks = function () {
        return this.as('weeks');
    };
    moment.duration.fn.asMonths = function () {
        return this.as('M');
    };
    moment.duration.fn.asYears = function () {
        return this.as('y');
    };

    /************************************
        Default Locale
    ************************************/


    // Set default locale, other locale will inherit from English.
    moment.locale('en', {
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    /* EMBED_LOCALES */

    /************************************
        Exposing Moment
    ************************************/

    function makeGlobal(shouldDeprecate) {
        /*global ender:false */
        if (typeof ender !== 'undefined') {
            return;
        }
        oldGlobalMoment = globalScope.moment;
        if (shouldDeprecate) {
            globalScope.moment = deprecate(
                    'Accessing Moment through the global scope is ' +
                    'deprecated, and will be removed in an upcoming ' +
                    'release.',
                    moment);
        } else {
            globalScope.moment = moment;
        }
    }

    // CommonJS module is defined
    if (hasModule) {
        module.exports = moment;
    } else if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
            if (module.config && module.config() && module.config().noGlobal === true) {
                // release the global variable
                globalScope.moment = oldGlobalMoment;
            }

            return moment;
        }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        makeGlobal(true);
    } else {
        makeGlobal();
    }
}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(77)(module)))

/***/ }),
/* 19 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    inputContainer: [
            '<span class="uwr-input-container uwr-input-{{state}}">',
                '<span class="uwr-input-before"></span>',
                '<span class="uwr-input-content">',
                    '<span class="uwr-input-label uwr-input-label-top"></span>',
                    '<span class="uwr-input-placeholder uwr-input-label-bottom"></span>',
                '</span>',
                '{{#messageIcon}}',
                    '<span class="uwr-input-message uwr-input-no-message" tabindex="-1"></span>',
                '{{/messageIcon}}',
                '<span class="uwr-input-after"></span>',
            '</span>'
         ].join(''),

     inputMessageIcon:
         '<span class="uwr-input-message uwr-input-no-message" tabindex="-1"></span>',

     inputMessageBox:
         '<div class="uwr-message-box uwr-message-box-hidden uwr-arrow-top-right" data-icon-type="none"></div>'
});


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __webpack_require__(45).polyfill();


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["isValidValue"] = isValidValue;
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony export (immutable) */ __webpack_exports__["setValue"] = setValue;
/* harmony export (immutable) */ __webpack_exports__["ready"] = ready;
/* harmony export (immutable) */ __webpack_exports__["enable"] = enable;
/* harmony export (immutable) */ __webpack_exports__["disable"] = disable;
/* harmony export (immutable) */ __webpack_exports__["reset"] = reset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chosen_js_chosen_css__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chosen_js_chosen_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chosen_js_chosen_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_advancedDropdown_less__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_advancedDropdown_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_advancedDropdown_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chosen_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chosen_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chosen_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery_truncate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery_truncate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery_truncate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loader_util__ = __webpack_require__(3);








var state;

/* eslint camelcase: off, no-unused-vars: off, max-depth: [error, 4], complexity: [error, 8] */

function htmlEscape(str) {
    var s = String(str)
            // Removed duplicate replaces to prevent double conversion (because in Chosen it is already converted)
            .replace(/\u00a0/g, ' ') // converting non-breaking space to space
            .replace(/\u0009/g, ' '); // converting tab to space
    return s;
}

/**
 * @param {Object} The jQuery object of the span which is the base of measurement.
 * @param {string} The name(s) of css class(es) which should be applied on the span. More items
 *                 are space separated. If no item is set, please set as null.
 * @param {string} The content which should be measured.
 * @param {boolean} The type of content is text (true) or html (false).
 * @return {number} Width of the span filled with the content and styled with the cssClassNames.
 */
function getContentWidth($span, cssClassNames, content, isText) {
    var width = 0;
    if (content && 0 < content.length) {
        if (cssClassNames) {
            $span.addClass(cssClassNames);
        }
        if (__WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["S" /* isString */](content)) {
            if (isText) {
                $span.text(content);
            } else {
                $span.html(content);
            }
            width = $span.outerWidth();
        }
        if (cssClassNames) {
            $span.removeClass(cssClassNames);
        }
    }
    return width;
}

function getOptionLabel(option, labelType) {
    return labelType === 'html' ? option.text : option.html;
}

function getListWidth($span, chznObj, attrs) {
    var elemList = chznObj.results_data,
        elem,
        i = 0,
        len = elemList.length,
        maxWidth = 0,
        groupsWidth = 0,
        itemsWidth = 0,
        groupItemsWidth = 0,
        groups = '',
        items = '',
        groupItems = '';
    for (; i < len; i++) {
        elem = elemList[i];
        if (elem.label) { // group label: only valid group has children
            if (elem.children > 0) {
                groups += elem.label + '<br>';
            }
        } else if (elem.group_array_index) { // group item: only grouped item has index
            groupItems += getOptionLabel(elem, attrs.labelType) + '<br>';
        } else if (!elem.empty) { // normal item: non-grouped and non-empty item
            items += getOptionLabel(elem, attrs.labelType) + '<br>';
        }
    }
    itemsWidth = getContentWidth($span, null, items, false);
    groupItemsWidth = getContentWidth($span, 'uwr-advanced-dropdown-measure-groupitems', groupItems, false);
    groupsWidth = getContentWidth($span, 'uwr-advanced-dropdown-measure-groups', groups, false);
    maxWidth = Math.max(groupsWidth, itemsWidth, groupItemsWidth);
    return maxWidth;
}

function getAddWidths(chznObj, attrs) {
    var $span = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<span class="uwr-advanced-dropdown-measure-items"></span>'),
        inputWidth = 0,
        maxWidth = 0;
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()('body').append($span);
    maxWidth = getListWidth($span, chznObj, attrs);
    if (isPlaceholderTextVisible(chznObj)) {
        inputWidth = getContentWidth($span, 'uwr-advanced-dropdown-measure-placeholder',
                chznObj.default_text, true);
        maxWidth = Math.max(inputWidth, maxWidth);
    } else {
        inputWidth = maxWidth;
    }
    $span.remove();

    return {
        maxOptionWidth: maxWidth,
        inputWidth: inputWidth
    };
}

/**
 * @param {Object} The chosen object associated to the current select (dropdown).
 * @return {boolean} Is placeholder text of this chosen object visible.
 */
function isPlaceholderTextVisible(chznObj) {
    var isMultipleSelect = chznObj.is_multiple,
        hasEmptyItem = false,
        isEmptyList = true,
        elemList = chznObj.results_data,
        elem;
    if (!isMultipleSelect) { // on multiple select the placeholder is always visible
        for (var i = 0; i < elemList.length; i++) {
            /* The empty {boolean} and html {string} attributes are chosen's inner representation of an option
                * - empty - if there is an option without value
                * - html - if groups are placed in only (group elements has only label)
                */
            elem = elemList[i];
            if (elem.empty) {
                hasEmptyItem = true;
                break;
            }
            if (isEmptyList && elem.html) {
                isEmptyList = false;
            }
        }
    }
    return isMultipleSelect || hasEmptyItem || isEmptyList;
}

function setLeftAlignHandler(chznObj, left) {
    chznObj.results_show = (function (resultShow, left) {
        return function (evt) {
            var result = resultShow.call(this, evt);
            this.dropdown.css({
                'left': left
            });
            return result;
        };
    })(chznObj.results_show, left);
}

function hasAttributeInStyle(stylesText, attrName) {
    var result = false,
        styles,
        style,
        i;
    if (stylesText && attrName) {
        styles = stylesText.split(';');
        for (i = 0; !result && i < styles.length; i++) {
            style = styles[i].split(':');
            if (__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.trim(style[0]) === attrName) {
                result = true;
            }
        }
    }
    return result;
}

function isWidthSpecified(attrs) {
    if (attrs) {
        if (attrs.width || hasAttributeInStyle(attrs.style, 'width')) {
            return true;
        }
    }
    return false;
}

function setContainerWidth(chznObj, listWidth) {
    var $container = chznObj.container,
        containerNewWidth = listWidth + 2;
    $container.width(containerNewWidth);
}

function setListWidth(chznObj, attrs) {
    var isContainerWidthNotSpecified = !isWidthSpecified(attrs),
        listWidth,
        diff,
        addWidths;
    if (attrs.listAutoWidth === 'true' || isContainerWidthNotSpecified) {
        addWidths = getAddWidths(chznObj, attrs);
        listWidth = addWidths.maxOptionWidth;
        chznObj.f_width = addWidths.inputWidth;

        if (attrs.listMinWidth) {
            listWidth = Math.max(listWidth, attrs.listMinWidth);
        }
        if (attrs.listMaxWidth) {
            listWidth = Math.min(listWidth, attrs.listMaxWidth);
        }
        chznObj.dropdown.width(listWidth);

        if (isContainerWidthNotSpecified) {
            setContainerWidth(chznObj, listWidth);
        }

        if (attrs.listAlignment === 'left') {
            if (listWidth > chznObj.container.outerWidth()) {
                diff = listWidth - chznObj.container.outerWidth() + 2;
                setLeftAlignHandler(chznObj, -diff);
            }
        }

        chznObj.search_field_scale();
    }
}

function setListHeight(chznObj, attrs) {
    if (__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.isNumeric(attrs.listMaxHeight)) {
        chznObj.search_results.css('max-height', parseInt(attrs.listMaxHeight, 10));
    }
}

function changeSelectedText(chznObj, visibleTrailChars) {
    var $choices,
        $toTruncate,
        $parent,
        wdiff,
        width,
        $item;
    if (visibleTrailChars) {
        if (chznObj.is_multiple) {
            $choices = chznObj.search_container.parent();
            $toTruncate = $choices.find('li.search-choice > span:not(.uwr-temp-truncated)');
            if ($toTruncate.length > 0) {
                $parent = $toTruncate.parent();
                wdiff = $parent.outerWidth() - $parent.width() + parseInt($parent.css('marginLeft'), 10) * 2;
                width = $choices.width() - wdiff;

                $toTruncate.truncate({
                    visibleTrailChars: visibleTrailChars,
                    width: width
                });
                $toTruncate.addClass('uwr-temp-truncated');
            }
        } else {
            $item = chznObj.selected_item.find('span').first();
            $item.truncate({
                visibleTrailChars: visibleTrailChars,
                width: $item.width() - 1
            });
        }
    }
}

function normalizeOptionValue(value) {
    return value.replace(/ /g, '_');
}

function contains(str, sub) {
    return str && str.indexOf(sub) > -1;
}

function removeClassesLike($item, classAttr, like) {
    if (classAttr) {
        var classArray = classAttr.split(' '),
            classItem,
            i,
            len;
        for (i = 0, len = classArray.length; i < len; i++) {
            classItem = classArray[i];
            if (contains(classItem, like)) {
                $item.removeClass(classItem);
            }
        }
    }
}

function setIconClasses($item, optionValue) {
    var classAttr = $item.attr('class');
    removeClassesLike($item, classAttr, 'uwr-advanced-dropdown-item-');
    $item.addClass('uwr-advanced-dropdown-text-selected');
    $item.addClass('uwr-advanced-dropdown-item');
    if (optionValue) {
        $item.addClass('uwr-advanced-dropdown-item-' + normalizeOptionValue(optionValue));
    }
}

function setOriginalListClasses($item, classes) {
    $item.addClass(classes);
}

function getNewChoice(oldChoices, newChoices) {
    var newChoice;
    if (oldChoices) {
        if (newChoices.length > 1) {
            newChoice = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(newChoices).not(oldChoices)[0];
        } else {
            newChoice = newChoices[0];
        }
    } else {
        newChoice = newChoices[0];
    }
    return newChoice;
}

function getSelectedChoices(chznObj) {
    var selectedChoices;
    if (chznObj.is_multiple) {
        var newValueObjs = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.grep(chznObj.results_data, function (e) {
            return e.selected === true;
        });
        selectedChoices = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.map(newValueObjs, function (e) {
            return e.value;
        });
    } else {
        selectedChoices = chznObj.current_value;
    }
    return selectedChoices;
}

function setUserIconClassesForSelected(chznObj, selectedValue, $item) {
    var previousClass,
        resultItem;
    if (selectedValue && $item) {
        resultItem = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.grep(chznObj.results_data, function (e) {
            return e.value === selectedValue;
        });
        if (resultItem && (resultItem.length > 0)) {
            if (!chznObj.is_multiple) {
                previousClass = $item.data('userclass');
                if (previousClass) {
                    $item.removeClass(previousClass);
                }
                $item.data('userclass', resultItem[0].classes);
            }
            $item.addClass(resultItem[0].classes);
        }
    }
}

function setIconForSelected(chznObj, oldChoices) {
    var $choices,
        $toHandle,
        selectedValue;
    if (chznObj.is_multiple) {
        $choices = chznObj.search_container.parent();
        $toHandle = $choices.find('li.search-choice > span:not(.uwr-advanced-dropdown-item)');
        if ($toHandle) {
            selectedValue = getNewChoice(oldChoices, getSelectedChoices(chznObj));
            setIconClasses($toHandle, selectedValue);
        }
    } else if (chznObj.current_selectedIndex >= 0) {
        selectedValue = chznObj.results_data[chznObj.current_selectedIndex].value;
        $toHandle = chznObj.selected_item.find('span');
        setIconClasses($toHandle, selectedValue);
    }
    setUserIconClassesForSelected(chznObj, selectedValue, $toHandle);
}

/**
 * Modified chosen method. Needed to be modified because of disabled options.
 *
 * To support additional functions this method can accept a user select event (if a user chooses from the
 * dropdown with mouse) and a script event (if the selection is changed by a code via setValue).
 *
 * In the first case no item is defined, because it will be originated from the user selection. In the second
 * case there is no result highlighting, because it will be set by the script and there were no selection in
 * the option list
 *
 * So we have to check item and result_highlighting (chosen inner object) too.
 */
/* eslint-disable */
function modifiedResultSelect(chznObj, evt) {
    var high, item, selected_index,
    // added code ---
        triggerChange = true;
    if (evt.item) {
        item = evt.item;
    }
    if (evt.hasOwnProperty('triggerChange')) {
        triggerChange = evt.triggerChange;
    }
    // ---
    if (chznObj.result_highlight || item) {
        high = chznObj.result_highlight;
        if (high) {
            chznObj.result_clear_highlight();
            if (chznObj.is_multiple && chznObj.max_selected_options <= chznObj.choices_count()) {
                chznObj.form_field_jq.trigger("chosen:maxselected", {
                    chosen: chznObj
                });
                return false;
            }
            if (chznObj.is_multiple) {
                high.removeClass("active-result");
            } else {
                if (chznObj.result_single_selected) {
                    chznObj.result_single_selected.removeClass("result-selected");
                    selected_index = chznObj.result_single_selected[0].getAttribute('data-option-array-index');
                    chznObj.results_data[selected_index].selected = false;
                }
                chznObj.result_single_selected = high;
            }
            high.addClass("result-selected");
            if (!item) {
                item = chznObj.results_data[high[0].getAttribute("data-option-array-index")];
            }
        }
        // added code ---
        if (!item || chznObj.form_field.options[item.options_index].disabled) {
            return false;
        }
        // ---
        item.selected = true;
        chznObj.form_field.options[item.options_index].selected = true;
        chznObj.selected_option_count = null;
        if (chznObj.is_multiple) {
            chznObj.choice_build(item);
        } else {
            chznObj.single_set_selected_text(item.text);
        }
        if (!((evt.metaKey || evt.ctrlKey) && chznObj.is_multiple)) {
            chznObj.results_hide();
        }
        chznObj.search_field.val("");
        if (chznObj.is_multiple || chznObj.form_field.selectedIndex !== chznObj.current_selectedIndex) {
            // added code
            if (triggerChange) {
            // ---
                chznObj.form_field_jq.trigger("change", {
                    'selected': chznObj.form_field.options[item.options_index].value
                });
            // added code
            }
            // ---
        }
        chznObj.current_selectedIndex = chznObj.form_field.selectedIndex;
        return chznObj.search_field_scale();
    }
}
/* eslint-enable */

/**
 * The selection handling object, which extends the original operation of
 * chosen (modifiedResultSelect) with own features. New features in connection
 * with selection can be placed at this point.
 */
function chosenSelectHandler(chznObj, attrs, evt) {
    var oldChoices = getSelectedChoices(chznObj);

    // call the modified original
    if (evt) {
        modifiedResultSelect(chznObj, evt);
    }

    // icon
    setIconForSelected(chznObj, oldChoices);

    // ellipsis
    changeSelectedText(chznObj, attrs.visibleTrailChars);
}

function modifySingleSelectedProgrammatically(chznObj, value) {
    var i,
        selectedItem;
    for (i = 0; i < chznObj.results_data.length; i++) {
        if (value === chznObj.results_data[i].value) {
            selectedItem = chznObj.results_data[i];
            chznObj.current_selectedIndex = i;
            break;
        }
    }
    chosenSelectHandler(chznObj, {}, {item: selectedItem, triggerChange: false});
}

/**
 * This is the bridge between chosen selection handling and the API function setValue. In
 * this method the item originated from the setValue is selected and propagated in an
 * internal event object to the selection handling code (chosenSelectHandler).
 */
function modifySelectedProgrammatically($obj, value) {
    var j,
        chznObj = getChozenObj($obj);
    if (chznObj) {
        if (chznObj.is_multiple) {
            $obj.val([]);
            $obj.trigger('chosen:updated.chosen');
        }
        if (value instanceof Array) {
            if (chznObj.is_multiple) {
                for (j = 0; j < value.length; j++) {
                    modifySingleSelectedProgrammatically(chznObj, value[j]);
                }
            } else {
                modifySingleSelectedProgrammatically(chznObj, value[0]);
            }
        } else {
            modifySingleSelectedProgrammatically(chznObj, value);
        }
    }
}

function setSelectHandler(chznObj, attrs) {
    chznObj.result_select = function (evt) {
        chosenSelectHandler(chznObj, attrs, evt);
    };
    changeSelectedText(chznObj, attrs.visibleTrailChars);
    var oldChoices = getSelectedChoices(chznObj);
    setIconForSelected(chznObj, oldChoices);
}

function setBorderClass(chznObj, attrs) {
    if (attrs.noBorder) {
        if (chznObj.is_multiple) {
            chznObj.search_choices.addClass('uwr-advanced-dropdown-no-border');
        } else {
            chznObj.selected_item.addClass('uwr-advanced-dropdown-no-border');
        }
    }
}

function setTextClasses(chznObj) {
    if (chznObj.is_multiple) {
        chznObj.search_choices.addClass('uwr-advanced-dropdown-text-selected');
    } else {
        chznObj.selected_item.addClass('uwr-advanced-dropdown-text-selected');
    }
    chznObj.search_results.find('li').addClass('uwr-advanced-dropdown-text-list');
}

function prepareListClasses(chznObj) {
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()(chznObj.dropdown).find('li').each(function () {
        var value = null,
            id = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).data('option-array-index'),
            results = chznObj.results_data,
            i,
            len,
            classes,
            data;
        for (i = 0, len = results.length; i < len; i++) {
            data = results[i];
            if (data.array_index === id) {
                value = data.value;
                classes = data.classes;
                break;
            }
        }
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).addClass('uwr-advanced-dropdown-text-list');
        setIconClasses(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this), value);
        setOriginalListClasses(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this), classes);
    });
}

function getSelectOptions($selectNode) {
    return __WEBPACK_IMPORTED_MODULE_4_jquery___default()('option', $selectNode);
}

function escapeOptions($selectNode) {
    getSelectOptions($selectNode).each(function () {
        this.text = htmlEscape(this.text);
        if (this.disabled === true && this.selected === true) {
            this.selected = false;
        }
    });
}

function isEmptySelect($selectNode) {
    var $options = getSelectOptions($selectNode),
        empty = true,
        i;
    for (i = 0; i < $options.length; i++) {
        if ($options[i].text) {
            empty = false;
            break;
        }
    }
    return empty;
}

function prepareForConversion($selectNode, attrs) {
    if (isEmptySelect($selectNode) && attrs.emptyPlaceholder) {
        $selectNode.data('originalPlaceholder', attrs.placeholder || '');
        $selectNode.attr('data-placeholder', attrs.emptyPlaceholder);
    } else {
        if ($selectNode.data('originalPlaceholder')) {
            $selectNode.attr('data-placeholder', $selectNode.data('originalPlaceholder'));
            $selectNode.removeData('originalPlaceholder');
        } else if ($selectNode.data('originalPlaceholder') === '') {
            $selectNode.removeAttr('data-placeholder');
            $selectNode.removeData('originalPlaceholder');
        } else if (attrs.placeholder) {
            $selectNode.attr('data-placeholder', attrs.placeholder);
        } else {
            $selectNode.removeAttr('data-placeholder');
        }
    }
    $selectNode.removeAttr('placeholder');

    escapeOptions($selectNode);
    // TRAC#1364: overwrite Chosen's disabling function
    if (attrs.disabled) {
        $selectNode.removeAttr('disabled').attr('data-disabled', attrs.disabled);
    }
}

function copyOriginalClasses(chznObj, originalClasses) {
    chznObj.container
        .addClass(originalClasses)
        .removeClass('chosen-select');
    removeClassesLike(chznObj.container, originalClasses, 'cuiListBox');
}

function resetDefaultSelectedValues(chznObj, $originalSelect) {
    var $options = getSelectOptions($originalSelect);
    $options.each(function () {
        this.selected = this.defaultSelected;
    });
}

function setResetHandler(chznObj, $originalSelect) {
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()('form').bind('reset', function () {
        reset($originalSelect);
    });
}

/**
 * Extracted and changed functionality from Chosen search.
 * Originally only ' ' (space) and '[' was checked.
 */
function isStringToBeSplit(valueHtml) {
    return valueHtml.indexOf(' ') >= 0
        || valueHtml.indexOf('&nbsp;') >= 0
        || valueHtml.indexOf('[') >= 0
        || valueHtml.indexOf(']') >= 0
        || valueHtml.indexOf('(') >= 0
        || valueHtml.indexOf(')') >= 0
        || valueHtml.indexOf('"') >= 0;
}

/**
 * Replaces &nbsp; to space for the result list (otherwise &nbsp; will be shown in the result list).
 */
function prepareText(text) {
    return htmlEscape(text.replace(/&nbsp;/g, ' '));
}

/**
* Extracted and changed functionality from Chosen search.
* Originally it replaced only [ and ] to '' (nothing).
* For correct search some special characters must be handled as space.
*/
function prepareValueForSearch(valueHtml) {
    return valueHtml.replace(/\&nbsp;|\[|\]|\(|\)|\"/g, ' ');
}

/**
 * UBSWI-945: support for multi-line entries in single select ADD
 */
function replaceChosenSingleSetSelectedText(chznObj, attrs) {
    /* eslint-disable */
    chznObj.single_set_selected_text = function(text) {
        if (text == null) {
            text = this.default_text;
            }
            if (text === this.default_text) {
            this.selected_item.addClass("chosen-default");
            } else {
            this.single_deselect_control_build();
            this.selected_item.removeClass("chosen-default");
            }
            if (attrs.labelType === 'html') { // UBSWI-945: fixed selected items when option label type is HTML
                return this.selected_item.find("span").html(text);
            }
            return this.selected_item.find("span").text(text);
    };
    /* eslint-enable */
}

/**
 * UBSWI-945: support for multi-line entries in multiple select ADD
 */
function replaceChosenChoiceBuild(chznObj, attrs) {
    /* eslint-disable */
    chznObj.choice_build = function(item) {
        var choice, close_link,
        _this = this;

        choice = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<li />', {
        "class": "search-choice"
        }).html("<span>" + getOptionLabel(item, attrs.labelType) + "</span>"); // UBSWI-945: fixed selected items when option label type is HTML
        if (item.disabled) {
        choice.addClass('search-choice-disabled');
        } else {
        close_link = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<a />', {
            "class": 'search-choice-close',
            'data-option-array-index': item.array_index
        });
        close_link.bind('click.chosen', function(evt) {
            return _this.choice_destroy_link_click(evt);
        });
        choice.append(close_link);
        }
        return this.search_container.before(choice);
    };
    /* eslint-enable */
}

/**
 * This function adds extra space after every tag's closing bracket (">")
 * when labelType is 'html' to prepare label text to search
 */
function prepareOptionLabel(option, labelType) {
    var label = option.html;
    if (labelType === 'html') {
        label = option.text.replace(/>/g, function (tag) {
            return tag + ' ';
        });
    }
    return label;
}

/**
 * The original chosen search function can't handle the &nbsp; and " characters, therefore we need to replace it.
 * We cloned the original function and changed only the minimal necessary parts where we extracted the changed
 * functionality to separate functions.
 */
function replaceChosenSearch(chznObj, attrs) { // UBSWI-945: enabled HTML label in option
    /* eslint-disable */
    var _i,
        _j,
        _len,
        _len1,
        parts,
        part;

    chznObj.winnow_results = function() {
        var escapedSearchText, escapedSearchTextElem, option, regex, regexAnchor, results, results_group, searchText, searchTextSplitted, searchTextElem, startpos, text, zregex, _i, _len, _ref, preparedOptionHtml; //  UBSWI-280: added extra variables to escapedSearchText splitting

        this.no_results_clear();
        results = 0;
        searchText = this.get_search_text();
        escapedSearchText = searchText.replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&"); // UBSWI-280: escape special regular expression characters: . \ + * ? [ ^ ] $ ( ) { } = ! < > | : -
        escapedSearchText = escapedSearchText.replace(/\s+/g, ".*\\s"); // UBSWI-280: extend search text to find word starting matches
        regexAnchor = this.search_contains ? "" : "\\s"; // UBSWI-280: add starting space before 1st search word
        regex = new RegExp(regexAnchor + escapedSearchText, 'i');
        _ref = this.results_data;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            option = _ref[_i];
            option.search_match = false;
            results_group = null;
            if (this.include_option_in_results(option)) {
            if (option.group) {
                option.group_match = false;
                option.active_options = 0;
            }
            if ((option.group_array_index != null) && this.results_data[option.group_array_index]) {
                results_group = this.results_data[option.group_array_index];
                if (results_group.active_options === 0 && results_group.search_match) {
                results += 1;
                }
                results_group.active_options += 1;
            }
            if (!(option.group && !this.group_search)) {
                option.search_text = htmlEscape(option.group ? option.label : prepareOptionLabel(option, attrs.labelType)); // UBSWI-945: enabled HTML label in option
                option.search_match = this.search_string_match(" " + option.search_text, regex); // UBSWI-280: add starting space before 1st world so that it can be found
                if (option.search_match && !option.group) {
                results += 1;
                } else if (this.enable_split_word_search && option.html && isStringToBeSplit(option.html)) { // UBSWI-143: fix search without quotes (block begin)
                    parts = prepareValueForSearch(option.html).split(" ");
                    if (parts.length) {
                        for (_j = 0, _len1 = parts.length; _j < _len1; _j++) {
                            part = parts[_j];
                            if (regex.test(part)) {
                                option.search_match = true;
                                results += 1;
                            }
                        }
                    }
                } // UBSWI-143: fix search without quotes (block end)
                if (option.search_match) {
                // UBSWI-281: new highlighting feature (block begin)
                startpos = 0;
                searchTextSplitted = searchText.split(" ");
                for (_j = 0, _len1 = searchTextSplitted.length; _j < _len1; _j++) {
                    searchTextElem = searchTextSplitted[_j];
                    if (searchTextElem.length) {
                    preparedOptionHtml = " " + prepareText(option.search_text);
                    escapedSearchTextElem = searchTextElem.replace(/\s+/g, ".*\\s"); // UBSWI-280: extend search text to find word starting matches
                    escapedSearchTextElem = escapedSearchTextElem.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"); // UBSWI-280: escape special regular expression characters: . \ + * ? [ ^ ] $ ( ) { } = ! < > | : -
                    zregex = new RegExp(regexAnchor + escapedSearchTextElem, 'i');
                    startpos += preparedOptionHtml.substr(startpos).search(zregex);
                    startpos += this.search_contains ? 0 : 1; // UBSWI-281: add length of extra starting space; UBSWI-2037: extra starting space length only added for non-partial searching
                    text = preparedOptionHtml.substr(0, startpos + searchTextElem.length) + '</em>' + preparedOptionHtml.substr(startpos + searchTextElem.length);
                    option.search_text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
                    startpos += 9; // UBSWI-281: add length of highlighting ('<em>' and '</em>')
                    }
                } // UBSWI-281: new highlighting feature (block end)
                if (results_group != null) {
                    results_group.group_match = true;
                }
                } else if ((option.group_array_index != null) && this.results_data[option.group_array_index].search_match) {
                option.search_match = true;
                }
            }
            }
        }
        this.result_clear_highlight();
        if (results < 1 && searchText.length) {
            this.update_results_content("");
            return this.no_results(searchText);
        } else {
            this.update_results_content(this.results_option_build());
            prepareListClasses(this);
            return this.winnow_results_set_highlight();
        }
    };
    /* eslint-enable */
}

// TRAC#1364: overwrite Chosen's disabling function
function replaceChosenResultsShow(chznObj) {
    /* eslint-disable */
    /*
        * @overwrite of chosen activate_field function for tablet devices
        */

    chznObj.activate_field = function(){
        this.container.addClass("chosen-container-active");
        this.active_field = true;
        this.search_field.val(this.search_field.val());
        return (__WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["a" /* isTouchDevice */]() ? this.search_field.blur() : this.search_field.focus());
    };

    chznObj.results_show = function() { // added code
        if (!this.container.hasClass('chosen-disabled')) {
            if (this.is_multiple
                    && this.max_selected_options <= this
                            .choices_count()) {
                this.form_field_jq.trigger("chosen:maxselected", {
                    chosen : this
                });
                return false;
            }
            this.container.addClass("chosen-with-drop");
            this.form_field_jq.trigger("chosen:showing_dropdown", {
                chosen : this
            });
            this.dropdown.css( { // added code
                'left' : 0,
                'top' : '100%'
            });
            this.results_showing = true;
            this.search_field.focus();
            this.search_field.val(this.search_field.val());
            return this.winnow_results();
        } // added code
    };
    /* eslint-enable */
}

function replaceChosenResultsHide(chznObj) {
    /* eslint-disable */
    chznObj.results_hide = function() {
        if (this.results_showing) {
            this.result_clear_highlight();
            this.container.removeClass("chosen-with-drop");
            this.form_field_jq.trigger("chosen:hiding_dropdown", {
                chosen : this
            });
            this.dropdown.css( { // added code
                'left' : -9999
            });
        }
        return this.results_showing = false;
    };
    /* eslint-enable */
}

function setActivateFieldHandler(chznObj) {
    chznObj.activate_field = (function (activateField) {
        return function () {
            var activateFieldResult;
            if (chznObj.is_disabled) {
                activateFieldResult = false;
            } else {
                activateFieldResult = activateField.call(this);
            }
            return activateFieldResult;
        };
    })(chznObj.activate_field);
}

function addFeaturesToChozen(chznObj, attrs, $originalSelect) {
    replaceChosenSingleSetSelectedText(chznObj, attrs);
    replaceChosenChoiceBuild(chznObj, attrs);
    replaceChosenSearch(chznObj, attrs);
    replaceChosenResultsShow(chznObj);
    replaceChosenResultsHide(chznObj);
    setListWidth(chznObj, attrs);
    setListHeight(chznObj, attrs);
    setBorderClass(chznObj, attrs);
    setTextClasses(chznObj);
    prepareListClasses(chznObj);
    setResetHandler(chznObj, $originalSelect);
    setActivateFieldHandler(chznObj);
    setSelectHandler(chznObj, attrs);
}

function enableElement(chznObj) {
    if (chznObj) {
        chznObj.form_field_jq[0].disabled = false;
        chznObj.search_field[0].style.cursor = '';
        chznObj.search_field_disabled();
    }
}

function disableElement(chznObj) {
    if (chznObj) {
        chznObj.form_field_jq[0].disabled = true;
        chznObj.search_field[0].style.cursor = 'default';
        chznObj.search_field_disabled();
    }
}

function resetElement(selector) {
    var $selector = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(selector),
        chznObj = getChozenObj($selector);
    if (chznObj) {
        resetDefaultSelectedValues(chznObj, $selector);
        internalInit($selector, true, function () {});
    }
}

function transformToChozen($selectNode, attrs) {
    var select = $selectNode.chosen({
        no_results_text: attrs.noResultsText,
        disable_search: attrs.noSearch || false,
        search_contains: attrs.partialSearch || false,
        width: $selectNode.css('width')
    });
    return __WEBPACK_IMPORTED_MODULE_4_jquery___default()(select);
}

function getChozenObj($select) {
    return $select.data('chosen');
}

function getSelection(chznObj, $originalSelect) {
    var $options = getSelectOptions($originalSelect),
        $selectedOption = null,
        selectedIndex = 0;
    $options.each(function (i) {
        if (0 <= chznObj.current_selectedIndex
                && i < chznObj.results_data.length
                && this.value === chznObj.results_data[chznObj.current_selectedIndex].value) {
            selectedIndex = i;
            $selectedOption = this;
        }
    });
    return {
        index: selectedIndex,
        option: $selectedOption
    };
}

function updateResultsData(chznObj, $originalSelect) {
    var selection = {};

    // This have to be before the single selected is set because it nulls that
    chznObj.results_update_field();
    if (!chznObj.is_multiple) {
        selection = getSelection(chznObj, $originalSelect);
        if (selection.option) {
            chznObj.result_single_selected = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(selection.option);
            chznObj.current_selectedIndex = selection.index;
            chznObj.result_single_selected[0].setAttribute('data-option-array-index', selection.index);
        }
    }
}

function transformSelectToAdvancedDropdown($selectNode) {
    var attrs = {
            placeholder: $selectNode.attr('placeholder') || $selectNode.attr('data-placeholder'),
            emptyPlaceholder: $selectNode.attr('data-empty-placeholder'),
            noResultsText: $selectNode.attr('data-no-results-text'),
            listAutoWidth: $selectNode.attr('data-list-autowidth'),
            listMaxWidth: $selectNode.attr('data-list-maxwidth'),
            listMinWidth: $selectNode.attr('data-list-minwidth'),
            listMaxHeight: $selectNode.attr('data-list-maxheight'),
            visibleTrailChars: $selectNode.attr('data-visible-trail-chars'),
            listAlignment: $selectNode.attr('data-list-alignment'),
            noSearch: $selectNode.attr('data-no-search'),
            partialSearch: $selectNode.attr('data-partial-search'),
            noBorder: $selectNode.attr('data-no-border'),
            width: $selectNode.attr('width'),
            style: $selectNode.attr('style'),
            disabled: $selectNode.attr('disabled') || $selectNode.attr('data-disabled'),
            labelType: $selectNode.attr('data-label-type')
        },
        originalClasses = $selectNode.attr('class'),
        $originalSelect,
        chznObj;

    prepareForConversion($selectNode, attrs);

    $originalSelect = transformToChozen($selectNode, attrs);
    if ($originalSelect) {
        chznObj = getChozenObj($originalSelect);
        if (chznObj) {
            updateResultsData(chznObj, $originalSelect);
            copyOriginalClasses(chznObj, originalClasses);
            addFeaturesToChozen(chznObj, attrs, $originalSelect);

            chosenSelectHandler(chznObj, attrs);

            // TRAC#1364: overwrite Chosen's disabling function
            if (attrs.disabled) {
                disable(chznObj);
            }

            // UBSWI-297: fix disabled style in IE8
            if (window.navigator.appName === 'Microsoft Internet Explorer' && document.documentMode < 9) {
                chznObj.container.addClass('uwr-advanced-dropdown-ie8');
            } else {
                chznObj.container.removeClass('uwr-advanced-dropdown-ie8');
            }
        }
    }
}

function transformAllSelectsToAdvancedDropdown(selector, reinitAll) {
    var $selectNodes = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(selector);
    $selectNodes.addClass('chosen-select');
    $selectNodes.each(function () {
        var $selectNode = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this),
            chznObj = getChozenObj($selectNode);
        if (chznObj) {
            if (reinitAll) {
                $selectNode.removeClass('chosen-done');
                __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#' + chznObj.container_id).remove();
            }
        }
        transformSelectToAdvancedDropdown($selectNode);
    });
}

/** function browser_is_supported as defined by Chosen 1.0.0 internally
 *
 * as it might not be possible to access it from outside without having
 * a transformed select (and thus no chznObj) it has to be duplicated
 * (funct. name "camelized", doublequotes replaced with singlequotes,
 * indendation adapted for ES linting)
 */
function chosenBrowserIsSupported() {
    if (window.navigator.appName === 'Microsoft Internet Explorer') {
        return document.documentMode >= 8;
    }
    if (/iP(od|hone)/i.test(window.navigator.userAgent)) {
        return false;
    }
    if (/Android/i.test(window.navigator.userAgent)) {
        if (/Mobile/i.test(window.navigator.userAgent)) {
            return false;
        }
    }
    return true;
}

/**
 * isUnsupportedBrowser returns true in browsers that should render the
 * select as native dropdown (IE before IE8, Android and iPhone)
 */
function isUnsupportedBrowser() {
    return !chosenBrowserIsSupported();
}

function createState() {
    if (!state) {
        state = {
            onReadyHandler: null,
            // This flag shows if all ADD's have been fully ready when the page loaded.
            isReady: false
        };
    }
}

function setReadyHandler(handler) {
    if (typeof handler === 'function') {
        createState();
        if (state.isReady) {
            handler();
        } else {
            state.onReadyHandler = handler;
        }
    }
}

function internalInit(selector, reinitAll) {
    createState();
    if (isUnsupportedBrowser()) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(selector).removeClass('uwr-advanced-dropdown');
    } else {
        transformAllSelectsToAdvancedDropdown(selector, reinitAll);
    }
}

function callReadyHandler() {
    state.isReady = true;
    __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["b" /* invoke */](state.onReadyHandler);
    state.onReadyHandler = null;
}

/**
 * Check a value is valid: not undefined, empty string or array, or some combination of them.
 */
function isValidValue(value) {
    var valid = false,
        i;
    if (value !== undefined) {
        if (__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.isArray(value)) {
            for (i = 0; !valid && i < value.length; i++) {
                if (isValidValue(value[i])) {
                    valid = true;
                }
            }
        } else
        if (__WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["S" /* isString */](value) && 0 < __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.trim(value).length) {
            valid = true;
        }
    }
    return valid;
}

/**
 * Supported use cases:
 * - init();
 * - init(callback);
 * - init(selector);
 * - init(selector, callback);
 */
function init(selector, callback) {
    if (arguments.length === 0) {
        internalInit('select.uwr-advanced-dropdown', false);

    } else if (arguments.length === 1) {
        var firstArg = selector;
        if (typeof firstArg === 'function') {
            internalInit('select.uwr-advanced-dropdown', true);
            __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["b" /* invoke */](firstArg);
        } else {
            internalInit(firstArg, true);
        }

    } else if (arguments.length === 2) {
        internalInit(selector, true);
        __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["b" /* invoke */](callback);
    }

    callReadyHandler();
}

function setValue(selector, value, callback) {
    if (isValidValue(value)) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()(selector).each(function () {
            var $obj = __WEBPACK_IMPORTED_MODULE_4_jquery___default()(this),
                oldValue = $obj.val();
            modifySelectedProgrammatically($obj, value);
            if (oldValue !== value) {
                $obj.trigger('change');
            }
        });
        __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["b" /* invoke */](callback);
    }
}

function ready(handler) {
    setReadyHandler(handler);
}

function enable(selector, callback) {
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()(selector).each(function () {
        enableElement(getChozenObj(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this)));
    });
    __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["b" /* invoke */](callback);
}

function disable(selector, callback) {
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()(selector).each(function () {
        disableElement(getChozenObj(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this)));
    });
    __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["b" /* invoke */](callback);
}

function reset(selector, callback) {
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()(selector).each(function () {
        resetElement(this);
    });
    __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["b" /* invoke */](callback);
}


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_button_less__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_button_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_button_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_button_icons_less__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_button_icons_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_button_icons_less__);




/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_buttonContainer_less__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_buttonContainer_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_buttonContainer_less__);



/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_checkbox_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_checkbox_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_checkbox_less__);



/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_common_less__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_common_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_common_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_defaultFonts_less__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_defaultFonts_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_defaultFonts_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_frutigerFonts_less__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_frutigerFonts_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_frutigerFonts_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_fontsCuiWorkarounds_less__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_fontsCuiWorkarounds_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_fontsCuiWorkarounds_less__);






/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_modules_i18n__ = __webpack_require__(7);
/**
 * General date formatter
 *
 * Configurable using the i18n module
 * configuration key: formatter.date
 * configuration values: {
 *   pattern: The date pattern following a subset of the Java SimpleDateFormat: YYYY means the year, MM means the month
 *   of year and DD means the day of month. We accept any separator between them (usually the hyphen, slash or dot are
 *   in use). Default is YYYY-MM-DD, and the original field content follows this default.
 * }
 */



var localizedTexts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_modules_i18n__["a" /* default */])({$markup: undefined, keyPrefix: 'formatter.date'}),

    defaultDateFormatPattern = 'YYYY-MM-DD',
    defaultDateFormatRegex = /^\s*?(\d{0,4})-(\d{0,2})-(\d{0,2})\s*?$/,
    notNumberRegex = /[^\d]/g,
    notFormatRegex = /[^YMD]/g,

    shortKeyMap = {Y: 'year', M: 'month', D: 'day'};

function getDateFormatPattern() {
    return localizedTexts.get('pattern') || defaultDateFormatPattern;
}

function fillWithLeadingZero(value, length) {
    var resultValue = value;
    while (resultValue.length < length) {
        resultValue = '0' + resultValue;
    }
    return resultValue;
}

function asDefaultFormat(normValue) {
    var defaultFormat = [normValue.year, normValue.month, normValue.day].join('-');
    if (defaultFormat === '--') {
        defaultFormat = '';
    }
    return defaultFormat;
}

function extractValue(value) {
    value = value || '';

    var normValue = { year: '', month: '', day: ''},
        cleanedValue,
        dateFormatPattern = getDateFormatPattern(),
        patternText = dateFormatPattern.replace(notFormatRegex, '');

    if (typeof value === 'object' && value instanceof Date) {
        // For Date objects
        normValue.year = value.getFullYear().toString();
        normValue.month = fillWithLeadingZero((value.getMonth() + 1).toString(), 2);
        normValue.day = fillWithLeadingZero(value.getDate().toString(), 2);
        normValue.length = normValue.year.length + normValue.month.length + normValue.day.length;
    } else if (defaultDateFormatRegex.test(value)) {
        // For default pattern values - this is a special case. It is used to convert the original value to the
        // visible one.
        cleanedValue = value.match(defaultDateFormatRegex);
        normValue.year = cleanedValue[1];
        normValue.month = cleanedValue[2];
        normValue.day = cleanedValue[3];
        normValue.length = normValue.year.length + normValue.month.length + normValue.day.length;
    }else {
        // For all other values, value fragments or patterns
        cleanedValue = value.toString().replace(notNumberRegex, '');
        normValue.year = cleanedValue.substring(patternText.indexOf('YYYY'), patternText.indexOf('YYYY') + 4);
        normValue.month = cleanedValue.substring(patternText.indexOf('MM'), patternText.indexOf('MM') + 2);
        normValue.day = cleanedValue.substring(patternText.indexOf('DD'), patternText.indexOf('DD') + 2);
        normValue.length = cleanedValue.length;
    }

    return normValue;
}

/**
 * Format a value according to the provided date pattern.
 * @param value The value to format.
 * @param change Optional. The difference between the current and the previous value to format. This is used to
 *               remove a separator character if there were no change (e.g. push backspace key).
 * @returns An object containing the formatted value, a raw value and a hint.
 */
function format(value, change) {
    var normalizedValue = extractValue(value),
        formattedValue = '',
        normItemPos = {
            full: 0,
            year: 0,
            month: 0,
            day: 0
        },
        patternItemPos = 0,
        datePartKey,
        dateFormatPattern = getDateFormatPattern();

    // Generate formatted value and position for hinting
    while (normItemPos.full < normalizedValue.length && patternItemPos < dateFormatPattern.length) {
        if (!notFormatRegex.test(dateFormatPattern[patternItemPos])) {
            datePartKey = shortKeyMap[dateFormatPattern[patternItemPos]];
            formattedValue += normalizedValue[datePartKey][normItemPos[datePartKey]++];
            normItemPos.full++;
        } else {
            formattedValue += dateFormatPattern[patternItemPos];
        }
        patternItemPos++;
    }

    // Append separator if it is the next character
    if ((change === undefined || change.length > 0)
            && patternItemPos < dateFormatPattern.length
            && notFormatRegex.test(dateFormatPattern[patternItemPos])) {
        formattedValue += dateFormatPattern[patternItemPos];
        patternItemPos++;
    }

    return {
        formatted: formattedValue,
        // Set maximum length of the raw
        raw: asDefaultFormat(normalizedValue),
        hint: dateFormatPattern.substring(patternItemPos)
    };
}


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_modules_i18n__ = __webpack_require__(7);
/**
 * General number formatter
 *
 * Configurable using the i18n module
 * configuration key: formatter.number
 * configuration values: {
 *   decimal: The separator of the decimal part of the float number,
 *   thousand: The separator of the thousand blocks of the integer part of the number
 * }
 */



var localizedTexts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_modules_i18n__["a" /* default */])({$markup: undefined, keyPrefix: 'formatter.number'}),
    defaultDecimalSeparator = '.', // Keep the same separator as the JS float
    notNumberRegex = /[^\d]/g;

function getSeparators() {
    return {
        decimal: localizedTexts.get('decimal') || defaultDecimalSeparator,
        thousand: localizedTexts.get('thousand') || ','
    };
}

function cleanupValue(value) {
    var separators = getSeparators(),
        lastDecimalSeparatorPosition = Math.max(
            value.lastIndexOf(separators.decimal),
            value.lastIndexOf(defaultDecimalSeparator)
        ),
        values = {};

    if (lastDecimalSeparatorPosition === -1) {
        values.integer = value.replace(notNumberRegex, '');
        values.fraction = '';
        values.separator = '';
    } else {
        values.integer = value.substring(0, lastDecimalSeparatorPosition).replace(notNumberRegex, '');
        values.fraction = value.substring(lastDecimalSeparatorPosition + 1). replace(notNumberRegex, '');
        values.separator = values.fraction.length > 0 ? separators.decimal : '';
    }
    return values;
}

function fillIntegerWithThousandSeparators(integerValue) {
    var separators = getSeparators(),
        thousandPosition = integerValue.length % 3,
        formattedIntegerValue = integerValue.substring(0, thousandPosition);

    for(; thousandPosition <= integerValue.length; thousandPosition += 3) {
        if (thousandPosition !== 0 && thousandPosition !== integerValue.length) {
            formattedIntegerValue = formattedIntegerValue + separators.thousand;
        }
        formattedIntegerValue += integerValue.substring(thousandPosition, thousandPosition + 3);
    }

    return formattedIntegerValue;
}

function format(value) {
    var numberString = (value || '').toString(),
        values = cleanupValue(numberString);

    return {
        formatted: fillIntegerWithThousandSeparators(values.integer) + values.separator + values.fraction,
        raw: values.integer + (values.fraction.length > 0 ? defaultDecimalSeparator : '') + values.fraction,
        hint: ''
    };
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qtip2_dist_jquery_qtip_css__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qtip2_dist_jquery_qtip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qtip2_dist_jquery_qtip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tooltip_styles_tooltip_less__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tooltip_styles_tooltip_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tooltip_styles_tooltip_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_datePicker_less__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_datePicker_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_datePicker_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qtip2__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qtip2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qtip2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_modules_i18n__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Input_js_input__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__datePickerCalendar__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__datePickerIcon__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__datePickerTooltip__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__datePickerView__ = __webpack_require__(9);
/**
 * A class which represents a DatePicker widget.
 * This defines the structure and the main behavior of the widget.
 *
 * @param $markup The jQuery element which is the DatePicker markup.
 */














function DatePicker($markup) {
    var markup = $markup[0],
        calendar,
        icon,
        model;

    /**
     * Creates model for DatePicker
     *
     * @return A JSON object, which contains the following parameters:
     *      getDateFormat: a function which returns the date format string of value,
     *      i18n: the i18n JSON object with keys and resolved values,
     *      iconPlacement: the placement of the date picker icon button depends on the opening mode
     *          (click mode: outside, focus mode: inside),
     *      openingMode: the opening mode of Date Picker (focus or click),
     *      placement: priority list of the calendar page overlay
     *      value: the value string of selected date,
     *      weekStart: the integer value of week starting day (0..6: Sunday to Saturday)
     */
    function buildModel() {
        /**
         * @return the date format string of value,
         *      default: 'DD.MM.YYYY'
         */
        function getDateFormat() {
            return __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["h" /* data */]($markup, 'date-format') || 'DD.MM.YYYY';
        }

        /**
         * Returns an object with the resolved i18n key-value pairs. See the i18n module for details on how
         * the resolution is done.
         *
         * @return the i18n hash object, with the following keys:
         *      done: label of done button
         *      legendText: description for non-selectable days
         *      months: array of month names starting from January
         *      monthsShort: array of short month names starting from January
         *      selectMonth: title of month selector view
         *      today: label of today button
         *      todayAbbrev: label of Today within the calendar (day selector) view
         *      weekdaysShort: array of short weekday names starting from Monday
         */
        function getI18n() {
            var keys = ['done', 'legendText', 'months', 'monthsShort',
                        'selectMonth', 'today', 'todayAbbrev', 'weekdaysShort'],
                keyPrefix = 'datepicker',
                messages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared_modules_i18n__["a" /* default */])({
                    $markup: $markup,
                    keyPrefix: keyPrefix
                }),
                resolvedKeys = {};

            __WEBPACK_IMPORTED_MODULE_4_jquery___default.a.each(keys, function (i, key) {
                resolvedKeys[key] = messages.get(key);
            });

            resolvedKeys.months = resolvedKeys.months.split(',');
            resolvedKeys.monthsShort = resolvedKeys.monthsShort.split(',');
            resolvedKeys.weekdaysShort = resolvedKeys.weekdaysShort.split(',');

            return resolvedKeys;
        }

        /**
         * @return the placement of the date picker icon button depends on the opening mode
         *      (click mode: outside, focus mode: inside),
         *      default: 'inside'
         */
        function getIconPlacement() {
            return getOpeningMode() === 'click' ? 'outside' : 'inside';
        }

        /**
         * @return the opening mode of Date Picker (focus or click),
         *      default: 'focus'
         */
        function getOpeningMode() {
            return __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["h" /* data */]($markup, 'opening-mode') === 'click' ? 'click' : 'focus';
        }

        /**
         * @return the placement priority list of the calendar page overlay,
         *      default: ['right']
         */
        function getPlacement() {
            var data = __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["h" /* data */]($markup, 'placement');
            return data ? data.split(' ') : ['right'];
        }

        /**
         * @return the integer value of week starting day (0..6: Sunday  to Saturday),
         *      default: 1
         */
        function getWeekStart() {
            var weekStart = __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["h" /* data */]($markup, 'week-start');
            return weekStart >= 0 && weekStart <= 6 ? weekStart : 1;
        }

        return {
            'getDateFormat': getDateFormat,
            'i18n': getI18n(),
            'iconPlacement': getIconPlacement(),
            'openingMode': getOpeningMode(),
            'placement': getPlacement(),
            'weekStart': getWeekStart()
        };
    }

    /**
     * Initialize widget view
     */
    function init() {
        var button,
            buttonSelector,
            $target;

        model = buildModel();

        $markup
            .wrap(__WEBPACK_IMPORTED_MODULE_11__datePickerView__["a" /* default */].inputContainer)
            .addClass('uwr-input')
            .attr('maxlength', model.getDateFormat().length);

        icon = new __WEBPACK_IMPORTED_MODULE_9__datePickerIcon__["a" /* default */]({
            'iconPlacement': model.iconPlacement,
            '$input': $markup
        });

        $target = model.openingMode === 'click' ? icon.getView() : $markup;

        calendar = new __WEBPACK_IMPORTED_MODULE_8__datePickerCalendar__["a" /* default */]({
            'getDateFormat': model.getDateFormat,
            'i18n': model.i18n,
            'weekStart': model.weekStart,
            '$input': $markup,
            '$target': $target
        });

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__Input_js_input__["init"])($markup);

        if (!$markup.is(':disabled')) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__datePickerTooltip__["a" /* default */])({
                'calendar': calendar,
                'icon': icon,
                'openingMode': model.openingMode,
                'placement': model.placement,
                '$target': $target
            });
        } else {
            buttonSelector = __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["h" /* data */]($markup, 'icon-button-selector');
            button = buttonSelector ? document.querySelector(buttonSelector)
                : icon.getView()[0].querySelector('.uwr-button'); // icon is outside
            button.setAttribute('disabled', '');
        }

    }

    if (__WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["p" /* shouldBeInitialized */](markup)) {
        init();
        // removed 'markInitialized' because input already did it at line 173
        // common.markInitialized(markup);
    }
}

/**
 * Initialize the selected Date Picker(s)
 * Supported use cases:
 *   - init();
 *   - init(callback);
 *   - init(selector);
 *   - init(selector, callback);
 * @param selector CSS selector string that returns the elements that need to be initialized.
 *   Optional: If not passed in, then all elements marked with "uwr-date-picker" CSS class will be processed.
 * @param callback The function to run after initialization (optional).
 */
function init(selector, callback) {
    var callbackWithoutSelector = arguments.length === 1 && typeof selector === 'function';
    if (arguments.length === 0 || callbackWithoutSelector) {
        __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.uwr-date-picker').each(function () {
            /* eslint-disable no-new */
            new DatePicker(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this));
            /* eslint-enable no-new */
        });
        if (callbackWithoutSelector) {
            __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["b" /* invoke */](selector);
        }
    } else {
        /* eslint-disable no-new */
        new DatePicker(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(selector));
        /* eslint-enable no-new */
        __WEBPACK_IMPORTED_MODULE_5__shared_modules_common__["b" /* invoke */](callback);
    }
}


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__ = __webpack_require__(1);



/**
 * A primary button is by default the button that gets triggered if one hits enter with the focus on an input field.
 */
function init(callback) {
    var focusableSelector = [
            'button',
            'input[type="text"]',
            'input[type="password"]',
            'input[type="radio"]',
            'input[type="checkbox"]',
            'select'
        ].join(',');

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(focusableSelector).keydown(function (e) {
        var keydownResult;
        if (e.keyCode === 13) {
            var $parentForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('form'),
                $defaultButtonsInForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.uwr-default-button', $parentForm);
            if ($defaultButtonsInForm.length) {
                $defaultButtonsInForm.click();
                keydownResult = false;
            } else {
                keydownResult = true;
            }
            return keydownResult;
        }
    });

    __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["b" /* invoke */](callback);
}


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_dropdown_less__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_dropdown_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_dropdown_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mustache__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_modules_support__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_modules_domchange__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Input_js_input__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dropdownView__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dropdownSearch__ = __webpack_require__(87);













function Dropdown(markup) {
    var $markup = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(markup),
        container,
        mutationObserver;

    function getOptionTexts(options) {
        return __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["J" /* map */].call(options, function (option) {
            return __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["x" /* textContent */](option);
        });
    }

    function markOptionSelected(option) {
        // This is the standard way of marking option as selected
        option.selected = true;
        // We decided to show the selected option in markup.
        // Because of that we need to set the selected attribute
        // But in IE selected attribute is read only and reflects the
        // defaultSelected property
        option.defaultSelected = true;
        option.setAttribute('selected', '');
    }

    function unmarkOptionsSelected(options) {
        options = options.length ? options : [options];
        __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["K" /* forEach */].call(options, function (option) {
            // This is the standard way of marking option as unseleced
            option.selected = false;
            // We decided to show the selected option in markup.
            // Because of that we need to set the selected attribute
            // But in IE selected attribute is read only and reflects the
            // defaultSelected property
            option.defaultSelected = false;
            option.removeAttribute('selected');
        });
    }

    function isOptionSelected(option) {
        return option.selected;
    }

    function getAllOptions() {
        return markup.querySelectorAll('option');
    }

    function getSelectedOptions() {
        return __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["L" /* filter */].call(getAllOptions(), isOptionSelected);
    }

    function getNotSelectedOptions() {
        return __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["L" /* filter */].call(getAllOptions(), function (option) {
            return !isOptionSelected(option);
        });
    }

    function getOptionByText(text) {
        var options = markup.querySelectorAll('option'),
            option,
            i;

        for (i = 0; i < options.length; i++) {
            if (__WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["x" /* textContent */](options[i]) === text) {
                option = options[i];
                break;
            }
        }

        return option;
    }

    function getSearchField() {
        return container.querySelector('.uwr-input');
    }

    function openOverlay() {
        var searchField = getSearchField();

        __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["o" /* addClass */](container, 'uwr-dropdown-container-opened');

        if (searchField) {
            searchField.focus();
        }
    }

    function closeOverlay() {
        var searchField = getSearchField();

        __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["n" /* removeClass */](container, 'uwr-dropdown-container-opened');

        if (searchField) {
            searchField.value = '';
            renderOptionList();
        }
    }

    function isOverlayOpened() {
        return __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["d" /* hasClass */](markup.parentNode, 'uwr-dropdown-container-opened');
    }

    function containerClickHandler(event) {
        var $content = $markup.next(),
            $topLabel = $content.next().find('.uwr-dropdown-top-label');

        if (getSearchField() === __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["E" /* getEventTarget */](event, true)) {
            return;
        }

        if (isMultiple()) {
            $topLabel.height($markup.parent().innerHeight() - $topLabel.innerHeight() + $topLabel.height());
        }

        if (isOverlayOpened()) {
            closeOverlay();
        } else {
            openOverlay();
        }
    }

    function selectItemHandler(event) {
        var target = __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["E" /* getEventTarget */](event, true),
            selectedText = __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["x" /* textContent */](__WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["E" /* getEventTarget */](event, true)),
            selectedOption,
            sameSelection;

        if (!__WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["d" /* hasClass */](target, 'uwr-dropdown-item')) {
            return;
        }

        selectedOption = getOptionByText(selectedText);
        sameSelection = isOptionSelected(selectedOption);

        if (!sameSelection) {
            updateModel({
                unselectOption: !isMultiple() && markup.querySelectorAll('option'),
                selectOption: selectedOption
            });
            updateView();
            markup.setAttribute('data-uwr-dropdown-change', '');
            __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["k" /* dispatchEvent */]('change', markup);
        }
    }

    function multipleSelectedClickHandler(event) {
        var target = __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["E" /* getEventTarget */](event, true),
            selectedText = __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["x" /* textContent */](target);

        if (!__WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["d" /* hasClass */](target, 'uwr-dropdown-multi-selected')) {
            return;
        }

        updateModel({ unselectOption: getOptionByText(selectedText) });
        updateView();
        closeOverlay();

        __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["s" /* stopPropagation */](event);
        __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["M" /* preventDefault */](event);
        markup.setAttribute('data-uwr-dropdown-change', '');
        __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["k" /* dispatchEvent */]('change', markup);
    }

    function onBlurHandler() {
        // IE8 no event.relatedTarget workaround :(
        setTimeout(function () {
            if (container.contains(document.activeElement)) {
                return;
            }

            closeOverlay();
        }, 0);
    }

    function updateModel(mutation) {
        mutationObserver.byPass(function () {
            if (mutation && mutation.unselectOption) {
                unmarkOptionsSelected(mutation.unselectOption);
            }
            if (mutation && mutation.selectOption) {
                markOptionSelected(mutation.selectOption);
            }
            __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["K" /* forEach */].call(getAllOptions(), function (option) {
                if (isOptionSelected(option)) {
                    markOptionSelected(option);
                } else {
                    unmarkOptionsSelected(option);
                }
            });
        });
    }

    function updateView() {
        var selectValue = container.querySelector('.uwr-dropdown-selected-value'),
            selectedOptionTexts = getOptionTexts(getSelectedOptions()),
            bottomLabel = container.querySelector('.uwr-dropdown-bottom-label'),
            bottomLabelAfterSelect = container.querySelector('.uwr-dropdown-bottom-label-after-select');

        if (isMultiple()) {
            selectValue.innerHTML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_7__dropdownView__["a" /* default */].multiSelected, {
                optionElements: selectedOptionTexts
            });
        } else {
            __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["x" /* textContent */](selectValue, selectedOptionTexts[0]);
        }

        renderOptionList();

        if (selectedOptionTexts.length) {
            __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["o" /* addClass */](bottomLabel, 'uwr-dropdown-hidden-element');
            __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["n" /* removeClass */](bottomLabelAfterSelect, 'uwr-dropdown-hidden-element');
        } else {
            __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["n" /* removeClass */](bottomLabel, 'uwr-dropdown-hidden-element');
            __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["o" /* addClass */](bottomLabelAfterSelect, 'uwr-dropdown-hidden-element');
        }
    }

    function rebuildView() {
        cleanup();
        init();
    }

    function setSize(value) {
        var optionList = container.querySelector('.uwr-dropdown-option-list'),
            elementNumber = Math.min(value, optionList.children.length);
        /* .uwr-dropdown-item height: 48px */
        if (value) {
            optionList.style.height = elementNumber * 48 + 'px';
        } else {
            optionList.style.height = '';
        }
    }

    function modelChangeHandler() {
        if (!markup.hasAttribute('data-uwr-dropdown-change')) {
            updateModel();
            updateView();
        } else {
            markup.removeAttribute('data-uwr-dropdown-change');
        }
    }

    function isMultiple() {
        return markup.hasAttribute('multiple');
    }

    function renderOptionList() {
        var searchField = getSearchField(),
            optionTexts = getOptionTexts(!isMultiple() ? getAllOptions() : getNotSelectedOptions()),
            filteredOptionTexts = searchField ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dropdownSearch__["a" /* default */])(optionTexts, searchField.value) : optionTexts,
            optionsElementsHtml = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_7__dropdownView__["a" /* default */].options, {
                optionElements: filteredOptionTexts
            }),
            messageHtml;

        if (searchField) {
            messageHtml = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_7__dropdownView__["a" /* default */].message, {
                noMatch: filteredOptionTexts.length === 0,
                searchPattern: searchField.value
            });
            container.querySelector('.uwr-dropdown-message').innerHTML = messageHtml;
        }

        container.querySelector('.uwr-dropdown-option-list').innerHTML = optionsElementsHtml;

        setSize(__WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["g" /* intData */](markup, 'option-list-max-size', 0));
    }

    function setLabel(value) {
        var label = markup.parentElement.querySelector('.uwr-dropdown-bottom-label-after-select');
        label.innerText = value;
    };

    function setEmptyLabel(value) {
        var bottomLabel = markup.parentElement.querySelector('.uwr-dropdown-bottom-label'),
            topLabel = markup.parentElement.querySelector('.uwr-dropdown-top-label');

        bottomLabel.innerText = value;
        topLabel.innerText = value;
    }

    function init() {
        if (!__WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["p" /* shouldBeInitialized */](markup)) {
            return;
        }

        var labelBeforeSelect = __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["h" /* data */](markup, 'label-before-select'),
            labelAfterSelect = __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["h" /* data */](markup, 'label-after-select'),
            searchEnabled = typeof __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["h" /* data */](markup, 'search-enabled') !== 'undefined',
            $contentView = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_7__dropdownView__["a" /* default */].content, {
                labelBeforeSelect: labelBeforeSelect,
                labelAfterSelect: labelAfterSelect,
                searchEnabled: searchEnabled
            })),
            searchField,
            multiSelectValue;

        $markup.wrap(__WEBPACK_IMPORTED_MODULE_7__dropdownView__["a" /* default */].container);
        container = markup.parentNode;
        // markup.selectedIndex;
        $contentView.insertAfter($markup);
        searchField = getSearchField();
        multiSelectValue = container.querySelector('.uwr-dropdown-selected-value');

        renderOptionList();

        if (isMultiple()) {
            $markup.parent().addClass('uwr-dropdown-multi');
        }

        if (searchField) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__Input_js_input__["init"])(searchField);
            __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["l" /* addEventListener */]('input', searchField, renderOptionList);
            __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["l" /* addEventListener */]('blur', searchField, onBlurHandler);
        }

        if (multiSelectValue) {
            __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["l" /* addEventListener */](['click', 'dblclick'], multiSelectValue, multipleSelectedClickHandler);
        }

        $markup.parent().on('click', containerClickHandler);
        $markup.parent().on('blur', onBlurHandler);
        // Use focusin for focus bubbling to the container node in IE
        if (__WEBPACK_IMPORTED_MODULE_4__shared_modules_support__["c" /* hasFocusinEvent */]) {
            __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["l" /* addEventListener */]('focusin', container, function (event) {
                var target = __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["E" /* getEventTarget */](event, true);
                if (!target.hasAttribute('tabindex') && target !== getSearchField()) {
                    __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["s" /* stopPropagation */](event);
                    __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["M" /* preventDefault */](event);
                    container.focus();
                }
            });
        }

        updateView();
        __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["l" /* addEventListener */]('click', container.querySelector('.uwr-dropdown-option-list'), selectItemHandler);
        $markup.on('change', modelChangeHandler); // required to support jquery 'change' event triggering

        mutationObserver = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared_modules_domchange__["a" /* addMutationHandlers */])(markup, {
            node: {
                'data-option-list-max-size': function (mutation) {
                    setSize(__WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["g" /* intData */](mutation.target, 'option-list-max-size', 0));
                },
                'data-label-after-select': function (mutation) {
                    setLabel(__WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["h" /* data */](mutation.target, 'label-after-select'));
                },
                'data-label-before-select': function (mutation) {
                    setEmptyLabel(__WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["h" /* data */](mutation.target, 'label-before-select'));
                },
                'multiple': rebuildView,
                'data-search-enabled': rebuildView
            },
            subtree: {
                'selected': updateView,
                childList: updateView,
                characterData: updateView
            }
        });

        __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["q" /* markInitialized */](markup);

        return this;
    }

    function cleanup() {
        if (mutationObserver) {
            mutationObserver.disconnect();
        }
        __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["y" /* unwrapMarkup */](markup, container);
        __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["N" /* removeEventListener */]('change', markup, modelChangeHandler);
        markup.removeAttribute('data-uwr-dropdown-change');
        container = undefined;
        mutationObserver = undefined;

        __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["z" /* unmarkInitialized */](markup);

        return this;
    }

    return {
        init: init,
        cleanup: cleanup
    };
}

/**
 * Initialize the selected Dropdown(s)
 * Supported use cases:
 *   - init();
 *   - init(callback);
 *   - init(selector);
 *   - init(selector, callback);
 * @param selector CSS selector string that returns the elements that need to be initialized.
 *   Optional: If not passed in, then all elements marked with "uwr-dropdown" CSS class will be processed.
 * @param callback The function to run after initialization (optional).
 */
var init = __WEBPACK_IMPORTED_MODULE_3__shared_modules_common__["A" /* initWidget */].bind(null, '.uwr-dropdown', Dropdown);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_link_less__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_link_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_link_less__);



/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_loadingMessage_less__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_loadingMessage_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_loadingMessage_less__);



/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["prepareMarkup"] = prepareMarkup;
/* harmony export (immutable) */ __webpack_exports__["getOriginalMarkup"] = getOriginalMarkup;
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony export (immutable) */ __webpack_exports__["open"] = open;
/* harmony export (immutable) */ __webpack_exports__["close"] = close;
/* harmony export (immutable) */ __webpack_exports__["invoke"] = invoke;
/* harmony export (immutable) */ __webpack_exports__["prepare"] = prepare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_modalDialog_less__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_modalDialog_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_modalDialog_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_modules_frames__ = __webpack_require__(6);





var commentStartReplacement = '__UWR_MODAL_DIALOG_COMMENT_START__',
    commentEndReplacement = '__UWR_MODAL_DIALOG_COMMENT_END__',
    extraText = '__UWR_MODAL_DIALOG_EXTRA_TEXT__';

/** EVENTS */

function escEventHandler(event, $popup) {
    if ($popup.data('close-on-esc') && event.keyCode === 27) {
        close();
    }
}

function enterEventHandler(event, $popup) {
    if (event.keyCode === 13) {
        var $submit = $popup.find('.uwr-button-submit');
        if ($submit.length !== 0) {
            $submit.click();
            __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["s" /* stopPropagation */](event);
        }
    }
}

function keyEventHandler(event) {
    var targetFrame = getState().targetFrame;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-modal-dialog-popup .uwr-modal-dialog', getDocument(targetFrame)).each(function () {
        escEventHandler(event, __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this));
        enterEventHandler(event, __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this));
    });
}

function bindKeyEventHandlers() {
    var targetFrame = getState().targetFrame;
    if (!getState().hasKeyHandlers) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(getDocument(window)).on('keydown', keyEventHandler);
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(getDocument(targetFrame)).on('keydown', keyEventHandler);
        getState().hasKeyHandlers = true;
    }
}

function unbindKeyEventHandlers() {
    var targetFrame = getState().targetFrame;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(getDocument(window)).off('keydown', keyEventHandler);
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(getDocument(targetFrame)).off('keydown', keyEventHandler);
    getState().hasKeyHandlers = false;
}

function addTopCloseButtonHandler($popup) {
    $popup.find('.uwr-modal-dialog-button-close').each(function () {
        var button = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
        if (button.attr('onclick') === undefined) {
            button.click(function () {
                close();
            });
        }
    });
}

function addTouchHandler($popup, $mask) {
    var origScrollTop,
        origScrollLeft,
        touchstartPageX,
        touchstartPageY;
    $mask.on('touchmove', null, false);
    $popup.on('touchmove', '.uwr-modal-dialog', false);
    $popup.on('touchstart touchend touchcancel touchleave touchmove', '.uwr-modal-dialog-content', function (ev) {
        var touch = ev.originalEvent.targetTouches[0],
            currentTarget = ev.currentTarget,
            deltaX,
            deltaY;
        if (ev.type === 'touchstart') {
            origScrollTop = currentTarget.scrollTop;
            origScrollLeft = currentTarget.scrollLeft;
            touchstartPageX = touch.pageX;
            touchstartPageY = touch.pageY;
        } else if (touch) {
            deltaX = touchstartPageX - touch.pageX;
            deltaY = touchstartPageY - touch.pageY;
            currentTarget.scrollLeft = origScrollLeft + deltaX;
            currentTarget.scrollTop = origScrollTop + deltaY;
        } else {
            origScrollLeft = currentTarget.scrollLeft;
            origScrollTop = currentTarget.scrollTop;
        }
    });
}

function addMouseWheelHandler($popup, $mask) {
    $mask.on('DOMMouseScroll mousewheel', null, false); // ignore mouse wheel events on mask
    // ignore mouse wheel events on popup in general
    $popup.on('DOMMouseScroll mousewheel', '.uwr-modal-dialog', false);
    // keep event from bubbling and overscrolling
    $popup.on('DOMMouseScroll mousewheel', '.uwr-modal-dialog-content', function (ev) {
        var modalDialogContent = this,
            $modalDialogContent = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(modalDialogContent),
            scrollTop = modalDialogContent.scrollTop,
            scrollHeight = modalDialogContent.scrollHeight,
            height = $modalDialogContent.height(),
            originalEvent = ev.originalEvent,
            delta = ev.type === 'DOMMouseScroll' ? originalEvent.detail * -40 : originalEvent.wheelDelta,
            up = delta > 0;

        if (!up && -delta > scrollHeight - height - scrollTop) {
            // Scrolling down, but this will take us past the bottom.
            $modalDialogContent.scrollTop(scrollHeight); // instead of overscrolling
            return __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["t" /* cancelEvent */](ev);
        } else if (up && delta > scrollTop) {
            // Scrolling up, but this will take us past the top.
            $modalDialogContent.scrollTop(0); // instead of overscrolling
            return __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["t" /* cancelEvent */](ev);
        }

        ev.stopPropagation(); // keep event from bubbling in any case
    });
}

function addResizeHandler($popup, $mask) {
    var targetFrame = getState().targetFrame;
    resizeModal($popup, $mask);
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(targetFrame).resize(function () {
        resizeModal($popup, $mask);
    });
}

function dispatchCustomCloseEvent() {
    var eventTarget = getState().eventTargetElement;
    if (eventTarget) {
        __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["k" /* dispatchEvent */]('uwr:modaldialog:close', eventTarget);
    }
}

/** DOM */

function getTargetFrameWithUwr() {
    return __WEBPACK_IMPORTED_MODULE_3__shared_modules_frames__["a" /* getTargetFrameForOverlay */]({uwrLoaded: true});
}

function getTargetFrameWithoutUwr() {
    return __WEBPACK_IMPORTED_MODULE_3__shared_modules_frames__["a" /* getTargetFrameForOverlay */]({uwrLoaded: false});
}

function getDocument(frame) {
    return __WEBPACK_IMPORTED_MODULE_3__shared_modules_frames__["b" /* getDocument */](frame);
}

function addZIndex($child, zIncrement) {
    var zIndexStr = $child.css('zIndex'),
        zIndexNum = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.isNumeric(zIndexStr) ? parseInt(zIndexStr, 10) : 1;
    $child.css('zIndex', zIndexNum + zIncrement);
}

function setZIndexForChildren($popup, zIncrementStr) {
    if ($popup && zIncrementStr) {
        var storedZIncrement = $popup.attr('data-uwr-zincrement'),
            zIncrement;
        if (!storedZIncrement) {
            zIncrement = parseInt(zIncrementStr, 10);
            $popup.attr('data-uwr-zincrement', zIncrementStr);
            $popup.find('*').each(function () {
                var $child = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
                $child.attr('data-uwr-saved-zindex', $child.css('zIndex'));
                addZIndex($child, zIncrement);
            });
        }
    }
}

function isWidthDefined($element) {
    var widthDefined = false,
        calculatedWidth;
    if ($element[0].style.width) {
        widthDefined = true;
    } else {
        $element.addClass('uwr-modal-dialog-bogus-width');
        // if calculated width of $element is 2187px, the value defined by CSS class uwr-modal-dialog-bogus-width
        // then we can safely assume, that no width is defined otherwise
        calculatedWidth = $element.css('width');
        if (calculatedWidth !== '2187px') {
            widthDefined = true;
        }
        $element.removeClass('uwr-modal-dialog-bogus-width');
    }
    return widthDefined;
}

function resizeModal($popup) {
    var targetFrame = getState().targetFrame,
        width = __WEBPACK_IMPORTED_MODULE_3__shared_modules_frames__["c" /* innerWidth */](targetFrame),
        height = __WEBPACK_IMPORTED_MODULE_3__shared_modules_frames__["d" /* innerHeight */](targetFrame),
        bottomPadding = parseInt($popup.css('marginBottom'), 10) + parseInt($popup.css('borderBottomWidth'), 10),
        left,
        $dialog = $popup.find('.uwr-modal-dialog');

    // if width is defined for uwr-modal-dialog element, then extend max width for $popup:
    if (isWidthDefined($dialog)) {
        $popup.addClass('uwr-modal-dialog-popup-enlarged');
    }

    $popup.css('left', '0');
    left = width / 2 - $popup.outerWidth(true) / 2;
    $popup.css({
        'top': 0, // Required for UW5 modal dialogs in UW4 iframes (UBSWI-1932)
        'left': left,
        'z-index': 9999
    });

    $popup.find('.uwr-modal-dialog-content').css('height', '');

    if (height - bottomPadding < $popup.height()) {
        var newHeight = height - ($popup.find('.uwr-modal-dialog-title').outerHeight() +
                $popup.find('.uwr-modal-dialog-actions').outerHeight() + bottomPadding);
        $popup.find('.uwr-modal-dialog-content').height(newHeight + 'px');
    }

    setZIndexForChildren($popup, $popup.css('zIndex'));
}

function restoreZIndexForChildren($popup) {
    if ($popup) {
        var storedZIncrementStr = $popup.attr('data-uwr-zincrement'),
            storedZIncrementNum;
        if (storedZIncrementStr) {
            storedZIncrementNum = parseInt(storedZIncrementStr, 10);
            $popup.find('*').each(function () {
                var $child = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
                var savedZIndex = $child.attr('data-uwr-saved-zindex');
                if (savedZIndex) {
                    $child.css('zIndex', savedZIndex);
                } else {
                    addZIndex($child, (-storedZIncrementNum));
                }
            });
            $popup.removeAttr('data-uwr-zincrement');
        }
    }
}

function getObjectByQualifiedName(name, win) {
    var obj,
        sanitizedName;
    if (name) {
        // remove some characters to prevent others doing eval() tricks
        sanitizedName = name.replace(/[^A-Za-z_0-9\.\[\]\'\"]/g, '');
        /* eslint-disable no-empty */
        try {
            obj = win.eval('window.' + sanitizedName); // eslint-disable-line
        } catch (e) {}
        /* eslint-enable no-empty */
    }
    return obj;
}


/** STATE */

function getState() {
    var targetFrame = getTargetFrameWithoutUwr(),
        state = targetFrame.uwr && targetFrame.uwr.modaldialog && targetFrame.uwr.modaldialog.state;
    if (!state) {
        state = {
            opener: null,
            targetFrame: targetFrame,
            eventTargetElement: null,
            popupDefinition: null,
            hasKeyHandlers: false
        };
        targetFrame.uwr = targetFrame.uwr || {};
        if (!targetFrame.uwr.modaldialog) {
            targetFrame.uwr.modaldialog = {};
        }
        targetFrame.uwr.modaldialog.state = state;
    }
    return state;
}

function initializeState(config) {
    var state = getState();
    state.opener = config.openerWindow;
    state.targetFrame = config.targetFrame;
    state.eventTargetElement = config.eventTargetElement || __WEBPACK_IMPORTED_MODULE_3__shared_modules_frames__["b" /* getDocument */](config.openerWindow).body;
}

function destroyState() {
    var targetFrame = getTargetFrameWithoutUwr();
    if (targetFrame.uwr && targetFrame.uwr.modaldialog && targetFrame.uwr.modaldialog.state) {
        targetFrame.uwr.modaldialog.state = null;
    }
}

/** MARKUP PREPARARTION */

function prepareMarkup(popupDefinition) {
    var content = popupDefinition.innerHTML,
        temp = content
            .replace(/<!--/g, commentStartReplacement)
            .replace(/-->/g, commentEndReplacement);

    // without an extra text IE would retrieve empty string after this call
    popupDefinition.innerHTML = extraText + '<!--' + temp + '-->';
}

function getOriginalMarkupFromPreparedPopupDefinition(preparedPopupDefinition) {
    var content = preparedPopupDefinition.innerHTML,
        inner,
        mainDiv;

    inner = content
        .replace(new RegExp(commentStartReplacement, 'g'), '<!--')
        .replace(new RegExp(commentEndReplacement, 'g'), '-->');
    inner = inner.substring(extraText.length + 4, inner.length - 3);

    mainDiv = preparedPopupDefinition.outerHTML
        .substring(0, preparedPopupDefinition.outerHTML.indexOf(extraText + '<!--'));

    return mainDiv + inner + '</div>';
}

function getOriginalMarkupFromUnpreparedPopupDefinition(unpreparedPopupDefinition) {
    return unpreparedPopupDefinition.outerHTML;
}

function getOriginalMarkup(popupDefinition) {
    var content = popupDefinition.innerHTML,
        isPrepared = content.indexOf(extraText + '<!--') === 0;

    // For backwards compatibility: if the popup definiton's frame used an older UW4 version
    // that did not prepare the popup definition, we apply a different logic.
    return isPrepared
        ? getOriginalMarkupFromPreparedPopupDefinition(popupDefinition)
        : getOriginalMarkupFromUnpreparedPopupDefinition(popupDefinition);
}

function convertIdAttributes($el) {
    if ($el && $el.attr('id')) {
        $el.attr('data-uwr-id', $el.attr('id'));
        $el.removeAttr('id');
    }
    $el.find('*').each(function () {
        var child = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
        child.attr('data-uwr-id', child.attr('id'));
        child.removeAttr('id');
    });
}

function restoreIdAttributes($el) {
    if ($el && isAccessiblePopupDefinition($el)) {
        if ($el.attr('data-uwr-id')) {
            $el.attr('id', $el.attr('data-uwr-id'));
            $el.removeAttr('data-uwr-id');
        }
        $el.find('*').each(function () {
            var child = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
            child.attr('id', child.attr('data-uwr-id'));
            child.removeAttr('data-uwr-id');
        });
    }
}

/** MODAL BUILDING */

function buildMask($targetBody, $preparedPopupDefinition, targetJQuery) {
    var maskHtml = '<div class="uwr-modal-dialog-mask"></div>',
        $mask = targetJQuery(maskHtml);
    $mask.appendTo($targetBody);
    if ($preparedPopupDefinition.data('close-on-dimmed')) {
        $mask.on('click', function () {
            close();
        });
    }
    return $mask;
}

function buildPopup($targetBody, popupDefinitonHtml, targetJQuery) {
    var $popup = targetJQuery('<div class="uwr-modal-dialog-popup"></div>'),
        oldAjaxCacheState = targetJQuery.ajaxSetup().cache;

    $popup[0].innerHTML = popupDefinitonHtml;
    try {
        targetJQuery.ajaxSetup().cache = true;
        $popup.appendTo($targetBody);
    } finally {
        targetJQuery.ajaxSetup().cache = oldAjaxCacheState;
    }

    return $popup;
}

function finalizeTopButtons($popup) {
    var $popupTitle = $popup.find('.uwr-modal-dialog-title'),
        $titleControl = $popup.find('.uwr-modal-dialog-title .uwr-modal-dialog-title-controls');

    // UW4 compatibility structure conversions
    $popupTitle.wrap('<div class="uwr-modal-dialog-title-bar"></div>');
    $titleControl.detach().appendTo($popup.find('.uwr-modal-dialog-title-bar'));
    $titleControl.find('.uwr-modal-dialog-button-help')
        .addClass('uwr-button uwr-button-small uwr-button-icon uwr-button-icon-right');
}

/** MISC */

function show($mask, $popup) {
    $mask.fadeTo(100, 0.4);
    $popup.fadeIn(100);
    $popup.find('.uwr-modal-dialog').not('.uwr-modal-dialog .uwr-modal-dialog').show();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('input:focus, button:focus').blur();
    $popup.focus();
}

function callOnReadyHandler(onReadyHandler, $popup, openerWindow) {
    if (typeof onReadyHandler === 'function') {
        var popupDiv = $popup.find('.uwr-modal-dialog').get(0),
        context = {
            'opener': openerWindow,
            'popup': popupDiv
        };
        onReadyHandler(context);
    }
}

    function isAccessiblePopupDefinition($popupDefinition) {
        var isAccessible = true;
        try {
            $popupDefinition.attr('data-uwr-id');
        } catch (e) {
            isAccessible = false;
        }
        return isAccessible;
    }

/**
 * Clears the content of any iframe.
 *
 * This is to prevent "stolen focus" issue caused by an IE bug where input fields
 * cannot be edited any more after content of iframe had been changed (UBSWI-782).
 */
function clearIframeContent($iframe) {
    $iframe.attr('src', '');
}

function removePopup() {
    var targetFrame = getState().targetFrame,
        $targetBody = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body', getDocument(targetFrame));

    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-modal-dialog-popup', $targetBody).each(function () {
        var $popup = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
        restoreIdAttributes(getState().popupDefinition);
        restoreZIndexForChildren($popup);
        clearIframeContent($popup.find('iframe'));
        $popup.remove();
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-modal-dialog-mask', $targetBody).each(function () {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).remove();
    });
}

function openInternal(selector, onReadyHandler, targetJQuery, openingTargetFrame) {
    var $preparedPopupDefinition = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector),
        popupDefinitonHtml,
        targetFrame = openingTargetFrame || getTargetFrameWithUwr(),
        $targetBody = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body', getDocument(targetFrame)),
        $mask,
        $popup,
        alreadyOpen = $targetBody.find('.uwr-modal-dialog-mask').length > 0;

    if (!alreadyOpen) {
        popupDefinitonHtml = getOriginalMarkup($preparedPopupDefinition[0]);
        convertIdAttributes($preparedPopupDefinition);

        $mask = buildMask($targetBody, $preparedPopupDefinition, targetJQuery);
        $popup = buildPopup($targetBody, popupDefinitonHtml, targetJQuery);

        getState().popupDefinition = $preparedPopupDefinition;

        finalizeTopButtons($popup);
        addTopCloseButtonHandler($popup);
        addTouchHandler($popup, $mask);
        addMouseWheelHandler($popup, $mask);
        show($mask, $popup);
        addResizeHandler($popup, $mask);
        bindKeyEventHandlers();

        callOnReadyHandler(onReadyHandler, $popup, window);

        // init UWR widgets in the opened modal dialog
        targetFrame.uwr.init();
    }
}

function createIframeHtml(url) {
    return ['<iframe src="',
            url,
            '" class="uwr-modal-dialog-iframe" ',
            ' name="modalDialogContentIframe"',
            'style="z-index:11000;position:fixed;top:0;left:0;width:0;height:0;',
            'background:transparent;border:0;">',
            '</iframe>'].join('');
}

function openAsHtml(config) {
    config.targetFrame = config.targetFrame || getTargetFrameWithUwr();
    config.openerWindow = config.openerWindow || window;

    config.targetFrame.uwr.util.jquery(function (targetJQuery) {
        initializeState(config);
        openInternal(config.selector, config.onReadyHandler, targetJQuery, config.targetFrame);
    });
    fixParentScrolling(getDocument(config.targetFrame).body);
}

/**
 * Opens a modal dialog page in an iframe. If the selector is set, then the according Modal Dialog will
 * be opened.
 *
 * @param config The configuration object described at the open function.
 */
function openAsIframe(config) {
    var modalSelector = config.selector || '.uwr-modal-dialog',
        targetFrame = getTargetFrameWithoutUwr(),
        openerWindow = window,
        $targetBody = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body', getDocument(targetFrame)),
        $iframe,
        iframeElement;

    $iframe = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('iframe.uwr-modal-dialog-iframe', $targetBody);
    if ($iframe.length === 0) {
        $iframe = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(createIframeHtml(config.frameUrl));
        $targetBody.append($iframe);
    }

    iframeElement = $iframe.get(0);

    iframeElement.onload = function iframeOnloadHandler() {
        var frameWindow = iframeElement.contentWindow;
        frameWindow.uwr.ready(function () {
            frameWindow.uwr.modaldialog.open({
                selector: modalSelector,
                onReadyHandler: config.onReadyHandler,
                targetFrame: frameWindow,
                openerWindow: openerWindow
            });
            fixParentScrolling($targetBody.get(0));
            // Fix IE blinking
            $iframe.css('width', '100%');
            $iframe.css('height', '100%');
            iframeElement.onload = undefined; // Prevent second onload on clearIframeContent
        });
    };
}

function fixParentScrolling(targetBody) {
    var state = getState(),
        $targetBody = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(targetBody),
        body = $targetBody[0],
        origClientHeight = body.clientHeight,
        origClientWidth = body.clientWidth,
        fixedMarginRight,
        fixedMarginTop,
        marginTop;

    // store original styles then hide body scrollbars
    // separate properties for backwards compatibility
    if (!$targetBody.find('.uwr-modal-dialog-iframe').length) {
        state.noScrollBody = targetBody;

        state.marginRight = $targetBody.css('margin-right');
        state.marginTop = $targetBody.css('margin-top');
        state.overflowX = $targetBody.css('overflow-x');
        state.overflowY = $targetBody.css('overflow-y');

        $targetBody.css('overflow-x', 'hidden');
        $targetBody.css('overflow-y', 'hidden');
    } else {
        state.iframeNoScrollBody = targetBody;

        state.oldIframeStyleRules = {
                marginRight: $targetBody.css('margin-right'),
                marginTop: $targetBody.css('margin-top'),
                overflowX: $targetBody.css('overflow-x'),
                overflowY: $targetBody.css('overflow-y')
            };

        $targetBody.css('overflow-x', 'hidden');
        $targetBody.css('overflow-y', 'hidden');
    }

    // fix body's right margin by using body client width increment to prevent page re-wrapping
    fixedMarginRight = parseInt(state.marginRight, 10) + (body.clientWidth - origClientWidth);
    $targetBody.css('margin-right', fixedMarginRight);

    // fix body's top margin by using the body client height increment to prevent page jumping
    marginTop = parseInt(state.marginTop, 10);
    fixedMarginTop = marginTop - (body.clientHeight - origClientHeight);

    // fix top margin only when original value is less than scrollbar increment
    if (fixedMarginTop < 0) {
        fixedMarginTop = marginTop < 0 ? marginTop : 0;
    }

    $targetBody.css('margin-top', fixedMarginTop);
}

function restoreParentScrolling() {
    var state = getState(),
        $iframeBody = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(state.iframeNoScrollBody),
        $targetBody = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(state.noScrollBody),
        restoreProperties = ['overflow', 'overflowX', 'overflowY', 'marginTop', 'marginRight'],
        styleProperty,
        i, l;

    if (!state) { return; }
    if (!$targetBody.length) {
        $targetBody = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body', getTargetFrameWithUwr().document);
    }

    for (i = 0, l = restoreProperties.length; i < l; i++) {
        styleProperty = restoreProperties[i];
        if (state[styleProperty]) {
            $targetBody.css(styleProperty, state[styleProperty]);
        }
    }

    if (state.oldIframeStyleRules) {
        $iframeBody.css(state.oldIframeStyleRules);
    }
}

function closeIframe() {
    var targetFrame = getTargetFrameWithoutUwr(),
        $targetBody = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body', getDocument(targetFrame)),
        $iframe = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-modal-dialog-iframe', $targetBody);
    if ($iframe.length > 0) {
        clearIframeContent($iframe);
        $iframe.remove();
    }
}

function cleanupAfterClose() {
    dispatchCustomCloseEvent();
    destroyState();
    closeIframe();
}

/**
 * Initializes all modal dialogs on the page. Basically binds key press handlers to the top window.
 * It is called by the framework once with no parameters, on page load. Should be called by client
 * apps only if they inject popup definitions dynamically.
 *
 * init() is an asynchronous call, so if some logic needs to be added once init() is finished, a callback
 * function can be passed in as a parameter.
 *
 * @param callback A Javascript function object that will be called at the end of the init() call.
 */
function init(callback) {
    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}

/**
 * Opens a modal dialog defined by the given CSS selector.
 *
 * The API is changed in a backward compatible way to support iframe based Modal Dialogs. Please,
 * use the recommended open(config) call style instead of the open(selector, onReadyHandler).
 *
 * The config object can have more parameters:
 * - frameUrl:           If this is set, then the Modal Dialog will be opened in a separated iframe. This
 *                       is the recommended usage in an iframe environment like workbenches.
 * - selector:           The CSS selector of the popup. If not set and only one Modal Dialog definition
 *                       is placed in the page, then this will be used. If there are multiple definitions
 *                       on a page, but this is not set, then the same result of different calls is not
 *                       guaranteed.
 * - onReadyHandler:     The callback function what can modify the content of the Modal Dialog when it is
 *                       ready for that.
 * - eventTargetElement: The HTML element which calls the open (what the click listener is registered to).
 *                       This is necessary to the custom events dispatching, the event will be dispatched
 *                       using the HTML element registered here. Using the 'this' is recommended.
 *
 * @param configOrSelector A config object to set up the Modal Dialog opening or a CSS selector string
 *        that points to the Modal Dialog which should be open. Please, use the config instead of the
 *        selector string. Selector string is deprecated.
 * @param onReadyHandler Optional, deprecated. A function which is called after the Modal Dialog is
 *        opened but before the content is initialized. Please, use the config instead of that.
 */
function open(configOrSelector, onReadyHandler) {
    if (typeof configOrSelector === 'object') {
        if (configOrSelector.frameUrl) {
            openAsIframe(configOrSelector);
        } else {
            openAsHtml(configOrSelector);
        }
    } else {
        openAsHtml({selector: configOrSelector, onReadyHandler: onReadyHandler});
    }
}

/**
 * Closes the actual visible modal dialog.
 */
function close() {
    removePopup();
    restoreParentScrolling();
    unbindKeyEventHandlers();
    setTimeout(cleanupAfterClose, 0); // Event Loop solution
}

/**
 * Invokes a function from the modal dialog. The function must be defined in the frame that opens
 * the modal dialog. Within the function the 'this' will reference an object with the below fields:
 * this.opener: the opener window frame, this.popup: the visible popup's main DOM element.
 *
 * The 1st argument is the name of the above function, the other arguments are the normal arguments of it.
 *
 * E.g.: invoke('resetForm', true, 23); in the modal dialog will call resetForm(true, 23); in the
 * opener frame.
 */
function invoke() {
    var state = getState(),
        $target = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(getDocument(state.targetFrame)),
        $popup = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-modal-dialog-popup', $target),

        args = Array.prototype.slice.call(arguments, 0),
        functionName = args[0],
        functionArgs = args.slice(1, args.length),
        func = getObjectByQualifiedName(functionName, state.opener),

        // this object will be passed to the function as 'this'
        context = {
            'opener': state.opener,
            'popup': $popup.get(0)
        };

    if (func) {
        func.apply(context, functionArgs);
    }
}

function prepare(callback) {
    // wait till the page is ready
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(function () {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-modal-dialog').each(function (i, el) {
            prepareMarkup(el);
        });
        __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
    });
}


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["hide"] = hide;
/* harmony export (immutable) */ __webpack_exports__["show"] = show;
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony export (immutable) */ __webpack_exports__["default"] = overlay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_overlay_less__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_overlay_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_overlay_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__ = __webpack_require__(1);




var functionNames = ['init', 'hide', 'show'];

/**
 * A class which represents a Overlay widget.
 * This defines the structure and the main behavior of the widget.
 *
 * @param $markup The jQuery element which is the Overlay markup.
 */
function Overlay(config) {
    var $view,
        baseZIndex = config.$markup.css('z-index'),
        overlayIndex;

    function createView() {
        if ($view) {
            $view.remove();
        }
        $view = config.$markup.clone(true, true).appendTo(config.$parent);
        $view.removeAttr('id');
        $view.addClass('uwr-overlay-view');
    }

    function orderVisibleOverlays(removedOverlayIndex) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-overlay:visible').each(function () {
            var visibleOverlay = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('uwrWidget'),
                visibleOverlayIndex = visibleOverlay.getOverlayIndex();
            if (visibleOverlayIndex > removedOverlayIndex) {
                visibleOverlay.setOverlayIndex(visibleOverlayIndex - 1);
            }
        });
    }

    this.init = function (callback) {
        __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
    };

    this.show = function (callback) {
        var notVisibleIncrement = + 1 - this.getView().is(':visible'),
            newOverlayIndex = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-overlay:visible').size() + notVisibleIncrement;
        orderVisibleOverlays(overlayIndex);
        this.setOverlayIndex(newOverlayIndex);
        this.getView().show(0, callback);
    };

    this.hide = function (callback) {
        this.getView().hide(0, callback);
        this.getView().css('z-index', baseZIndex);
        this.setOverlayIndex(undefined);
        orderVisibleOverlays(overlayIndex);
    };

    this.getView = function () {
        if ($view === undefined) {
            createView();
        }
        return $view;
    };

    this.getOverlayIndex = function () {
        return overlayIndex;
    };

    this.setOverlayIndex = function (newOverlayIndex) {
        overlayIndex = newOverlayIndex ? newOverlayIndex : 0;
        $view.css('z-index', baseZIndex + overlayIndex);
    };
}

function hide(selector, callback) {
    var overlay = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector).data('uwrWidget');
    if (overlay && overlay.hide) {
        overlay.hide(callback);
    }
}

function show(selector, callback) {
    var overlay = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector).data('uwrWidget');
    if (overlay && overlay.show) {
        overlay.show(callback);
    }
}

/**
 * Initialize the selected Overlay(s)
 * Supported use cases:
 *   - init();
 *   - init(callback);
 *   - init(selector);
 *   - init(selector, callback);
 * @param selector CSS selector string that returns the elements that need to be initialized.
 *   Optional: If not passed in, then all elements marked with "uwr-overlay" CSS class will be processed.
 * @param callback The function to run after initialization (optional).
 */
function init(selector, callback) {
    var widget,
        callbackWithoutSelector = arguments.length === 1 && typeof selector === 'function';
    if (arguments.length === 0 || callbackWithoutSelector) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-overlay').each(function () {
            var config = {
                    $markup: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this),
                    $parent: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('parent') || __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).parent())
                };
            widget = new Overlay(config);
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('uwrWidget', widget);
        });
        if (callbackWithoutSelector) {
            __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](selector);
        }
    } else {
        widget = new Overlay(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector));
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector).data('uwrWidget', widget);
        __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
    }
    return widget;
}

function WidgetList(methods) {
    var widgetArray = [],
        i,
        methodName;

    function createMethodMediator(methodName) {
        return function () {
            var j;
            for (j = 0; j < widgetArray.length; j++) {
                widgetArray[j][methodName](arguments);
            }
        };
    }

    this.length = function () {
        return widgetArray.length;
    };

    this.get = function (index) {
        return widgetArray[index];
    };

    this.push = function (item) {
        if (item) {
            widgetArray.push(item);
        }
    };

    for (i = 0; i < methods.length; i++) {
        methodName = methods[i];
        this[methodName] = createMethodMediator(methodName);
    }
};

function overlay(selector) {
    var $elements = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-overlay' + (selector || '')),
        overlayList = new WidgetList(functionNames),
        widget;
    $elements.each(function () {
        widget = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('uwrWidget');
        overlayList.push(widget);
    });
    return overlayList;
}





/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["complete"] = complete;
/* harmony export (immutable) */ __webpack_exports__["active"] = active;
/* harmony export (immutable) */ __webpack_exports__["next"] = next;
/* harmony export (immutable) */ __webpack_exports__["back"] = back;
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_processNavigation_less__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_processNavigation_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_processNavigation_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_modules_domchange__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__ = __webpack_require__(1);




var ACTIVE_STEP_CLASS = 'uwr-process-navigation-current',
    COMPLETED_STEP_CLASS = 'uwr-process-navigation-complete',
    container,
    isGuided,
    allSteps;

function getActiveStepElement() {
    return container.querySelector('.' + ACTIVE_STEP_CLASS);
}

function setActive(stepNumber, skipForwardCheck) {
    var prevActive = getActiveStepElement(),
        prevActiveNumber = getStepNumber(prevActive),
        isAfterNextStep = stepNumber > prevActiveNumber + 1;

    // prevent moving forward more than one step in guided flows
    if (isGuided && isAfterNextStep && !skipForwardCheck) {
        return prevActiveNumber;
    }

    if (prevActive) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["n" /* removeClass */])(prevActive, ACTIVE_STEP_CLASS);
    }
    if (stepNumber <= allSteps.length) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["o" /* addClass */])(allSteps[stepNumber - 1], ACTIVE_STEP_CLASS);
    }

    return stepNumber;
}

function handleGuidedSteps(newStepNumber) {
    Array.prototype.forEach.call(allSteps, function (step) {
        var stepNumber = getStepNumber(step);
        complete(stepNumber, stepNumber < newStepNumber);
    });
}

function complete(step, isCompleted) {
    if (isCompleted === undefined || isCompleted) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["o" /* addClass */])(allSteps[step - 1], COMPLETED_STEP_CLASS);
    } else if (!isCompleted) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["n" /* removeClass */])(allSteps[step - 1], COMPLETED_STEP_CLASS);
    }
}

function getStepNumber(item) {
    var stepNumber = 0,
        i;

    if (!item) {
            return stepNumber;
    }

    for (i = 0; i < allSteps.length; i++) {
        if (allSteps[i] === item) {
            stepNumber = i + 1;
            break;
        }
    }

    return stepNumber;
}

function getActiveStepNumber() {
    return getStepNumber(getActiveStepElement());
}

function limitStepNumber(step) {
    var lastStep = isGuided ? allSteps.length + 1 : allSteps.length;
    return Math.min(Math.max(1, step), lastStep);
}

function active(step, skipGuidedCheck) {
    var limitedStep = setActive(limitStepNumber(step), skipGuidedCheck);
    if (isGuided) {
        handleGuidedSteps(limitedStep);
    }
}

function next() {
    active(getActiveStepNumber() + 1);
}

function back() {
    active(getActiveStepNumber() - 1);
}

function parseCompletedAttribute(attributeValue) {
    var sanitizedValue = (attributeValue && attributeValue.match(/-\d+|\d+/g)) || [];
    return JSON.parse('[' + sanitizedValue.join() + ']');
}

function updateCompletedStepsFromAttribute() {
    var completedAttribute = container.getAttribute('data-completed'),
        completedSteps,
        step,
        isCompleted;

    if (!isGuided) {
        completedSteps = parseCompletedAttribute(completedAttribute);

        for (step = 1; step <= allSteps.length; step++) {
            isCompleted = completedSteps.indexOf(step) > -1;
            complete(step, isCompleted);
        }
    }
}

function initProcessNavigation(container) {
    var activeStepNumber;

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["p" /* shouldBeInitialized */])(container)) {
        return;
    }

    isGuided = container.tagName === 'OL';
    allSteps = container.getElementsByTagName('li');

    activeStepNumber = parseInt(container.getAttribute('data-active'), 10) || getActiveStepNumber() || 1;

    active(activeStepNumber, true);

    if (container.hasAttribute('data-completed')) {
        updateCompletedStepsFromAttribute();
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_modules_domchange__["a" /* addMutationHandlers */])(container, {
        node: {
            'data-active': function () {
                var activeStepNumber = parseInt(container.getAttribute('data-active'), 10);
                if (!isNaN(activeStepNumber)) {
                    active(activeStepNumber, true);
                }
            },
            'data-completed': updateCompletedStepsFromAttribute
        }
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["q" /* markInitialized */])(container);
}

function init(selector, callback) {
    var callbackWithoutSelector = arguments.length === 1 && typeof selector === 'function';
    if (arguments.length === 0 || callbackWithoutSelector) {
        container = document.querySelector('.uwr-process-navigation');
        if (container) {
            initProcessNavigation(container);
        }
        if (callbackWithoutSelector) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */])(selector);
        }
    } else {
        if (typeof selector === 'string') {
            container = document.querySelector(selector);
        } else {
            container = selector;
        }
        initProcessNavigation(container);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */])(callback);
    }
}


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_radioButton_less__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_radioButton_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_radioButton_less__);



/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony export (immutable) */ __webpack_exports__["toggle"] = toggle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_segmentedControl_less__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_segmentedControl_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_segmentedControl_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_modules_jquery_truncate__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_modules_jquery_truncate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__shared_modules_jquery_truncate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tooltip_js_tooltip__ = __webpack_require__(13);






/**
 * Get the topmost invisible parent of an element.
 * @param $element The invisible element.
 * @return The topmost invisible element which descendant is the parameter.
 */
function findTopmostInvisibleParent($element) {
    var $current = $element,
        $nonVisible = $element;

    while (!$current.is(':visible')) {
        $nonVisible = $current;
        $current = $current.parent();
    }

    return $nonVisible;
}

/**
 * Make the first visible parent of an segmented control visible.
 * @param $control The segmented controlled.
 * @return A JSON which contains the following properties:
 * - $firstNonVisibleParentElement The element which was the first non visible parent.
 *   It is a Jquery object.
 * - originalDisplay The original value for display in the style attr if it was set.
 * - originalPosition The original value for position in the style attr if it was set.
 * - originalVisibility The original value for visibility in the style attr if it was set.
 * - wasVisible The segmented control is visible or not when the function is called.
 *   If it is visible then the other parameters are not set.
 */
function makeTopmostInvisibleParentVisible($control) {
    var isVisible = $control.is(':visible'),
        $nonVisible,
        cssAttrValue,
        cssTokens,
        cssTrimTokens = {
            'display': '',
            'position': '',
            'visibility': ''
        };

    if (!isVisible) {
        $nonVisible = findTopmostInvisibleParent($control);

        cssAttrValue = $nonVisible.attr('style');

        if (cssAttrValue) {
            cssTokens = cssAttrValue.split(';');
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.each(cssTokens, function (index, el) {
                var parts = el.split(':');
                cssTrimTokens[__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.trim(parts[0])] = parts[1];
            });
        }

        $nonVisible.css('display', 'block');
        $nonVisible.css('visibility', 'hidden');
        $nonVisible.css('position', 'absolute');
    }

    return {
        $firstNonVisibleParentElement: $nonVisible,
        originalDisplay: cssTrimTokens.display,
        originalPosition: cssTrimTokens.position,
        originalVisibility: cssTrimTokens.visibility,
        wasVisible: isVisible
    };
}

/**
 * Revert the non visible parent to its original state.
 */
function revertInvisibleParent(parentInfo) {
    if (!parentInfo.wasVisible) {
        parentInfo.$firstNonVisibleParentElement.css({
            'display': parentInfo.originalDisplay,
            'position': parentInfo.originalPosition,
            'visibility': parentInfo.originalVisibility
        });
    }
}

/**
 * Run dimension related function on an element, which could be invisible.
 */
function runDimensionFunctionOn($element, dimensionFunction) {
    var parentInfo = makeTopmostInvisibleParentVisible($element),
        result = dimensionFunction.call(this, $element);
    revertInvisibleParent(parentInfo);
    return result;
}

function calculateMaxControlItemHeight($control) {
    var height = 0;
    $control.find('.uwr-segmented-control-button').each(function () {
        var currentControlItemHeight = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).height();
        if (currentControlItemHeight > height) {
            height = currentControlItemHeight;
        }
    });
    return height;
}

function isFixedVerticalLayout($control) {
    var layoutAttr = $control.attr('data-layout');
    return layoutAttr === 'vertical' || layoutAttr === 'v' || layoutAttr === 'V';
}

function isFixedHorizontalLayout($control) {
    var layoutAttr = $control.attr('data-layout');
    return layoutAttr === 'horizontal' || layoutAttr === 'h' || layoutAttr === 'H';
}

function isDynamicLayout($control) {
    return !isFixedVerticalLayout($control) && !isFixedHorizontalLayout($control);
}

function resize($control) {
    var $controlItems = $control.find('.uwr-segmented-control-button'),
        fullControlWidth = $control.attr('data-width'),
        controlItemWidth = fullControlWidth / $controlItems.length,
        controlItemHeight = $control.height(),
        orientation = 'h';

    function setOrientationClass($element, orientation) {
        if (orientation === 'h') {
            $element.addClass('uwr-segmented-control-horizontal');
            $element.removeClass('uwr-segmented-control-vertical');
        } else {
            $element.removeClass('uwr-segmented-control-horizontal');
            $element.addClass('uwr-segmented-control-vertical');
        }
    }
    function updateButton(index, element) {
        var $controlItem = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(element),
            $contents = $controlItem.clone().contents(),
            btnText = $controlItem.text(),
            btnHtml = $controlItem.html(),
            btnDisabled = $controlItem.attr('data-disabled');
        if (btnDisabled === 'true') {
            $controlItem.addClass('uwr-segmented-control-disabled');
        }
        if (orientation === 'h') {
            $controlItem.height = controlItemHeight;
        }
        if ($controlItem.get(0).tagName === 'BUTTON') {
            $controlItem.width((orientation === 'h') ? controlItemWidth - 1 : '100%');
        }
        $controlItem.truncate({
            visibleTrailChars: 0,
            width: $controlItem.width() * 2 - 20,
            token: '\u2026'
        });
        if ($controlItem.text() !== btnText) {
            $controlItem.addClass('uwr-tooltip');
            $controlItem.attr('data-trigger', 'focus,hover');
            $controlItem.attr('data-text', btnHtml);
            $controlItem.attr('data-type', 'neutral');
            $controlItem.attr('data-placement', 'top');
            $contents.each(function () {
                if (this.length === undefined) {
                    $controlItem.append(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this));
                }
            });
        }
    }

    $control.width(fullControlWidth);

    if ((fullControlWidth > $control.parent().width() && !isFixedHorizontalLayout($control))
            || isFixedVerticalLayout($control)) {
        fullControlWidth = controlItemWidth;
        orientation = 'v';
    }

    $control.width(fullControlWidth);
    setOrientationClass($control, orientation);
    $controlItems.each(updateButton);
    controlItemHeight = calculateMaxControlItemHeight($control);
    $controlItems.each(function () {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).height(controlItemHeight);
    });
}

function getTopPadding($outerSpan, $innerSpan) {
    return runDimensionFunctionOn($outerSpan, function () {
        return Math.floor(($outerSpan.height() - $innerSpan.height()) / 2); // padding
    });
}

function setVerticalAlignOfControlContent($outerSpan) {
    var $innerSpan = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<span></span>'),
        $tooltipSpan = $outerSpan.find('.uwr-tooltip'),
        topPadding;
    if ($tooltipSpan.length > 0) {
        $innerSpan = $tooltipSpan;
    } else {
        $innerSpan.append($outerSpan.contents());
        $outerSpan.empty();
        $outerSpan.append($innerSpan);
    }

    topPadding = getTopPadding($outerSpan, $innerSpan);
    $innerSpan.css('top', topPadding);
}

function resizeAll() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window.document).find('.uwr-segmented-control').each(function () {
        runDimensionFunctionOn(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this), resize);
    });

    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).resize(function () {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-segmented-control').each(function () {
            var $this = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
            if ($this.attr('data-auto-collapse') !== 'false' && isDynamicLayout($this)) {
                resize($this);
            }
        });
    });
}

function toggleItemSelection(selector) {
    var $controlItem = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector),
    $parent = $controlItem.closest('.uwr-segmented-control'),
    $prevSelected = $parent.find('.uwr-segmented-control-selected');

    $prevSelected.removeClass('uwr-segmented-control-selected');
    $controlItem.toggleClass('uwr-segmented-control-selected');

    var prevValue = $controlItem.find('.uwr-segmented-control-hidden-accessible').prop('checked');
    $controlItem.find('.uwr-segmented-control-hidden-accessible').prop('checked', !prevValue);

    setClasses($parent);
}

function setClickHandlers() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-segmented-control').each(function () {
        var $control = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this),
            initialized = $control.data('initialized');
        if (!initialized) {
            $control.data('initialized', true);

            $control.find('.uwr-segmented-control-button').each(function () {
                var $controlItem = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this),
                    $input = $controlItem.find('input'),
                    clickEventHandler = $controlItem.prop('onclick');
                if ($input.length > 0) {
                    clickEventHandler = $input.prop('onclick');
                    $input.prop('onclick', null);
                } else {
                    $controlItem.prop('onclick', null);
                }
                $controlItem.click(function (event) {
                    if (!$controlItem.hasClass('uwr-segmented-control-disabled')
                            && (!$controlItem.hasClass('uwr-segmented-control-selected')
                            || $input.length && $input.attr('type').toLowerCase() === 'checkbox')) {
                        toggleItemSelection($controlItem);
                        if (clickEventHandler) {
                            clickEventHandler.call(this, event);
                        }
                    }
                });
                setVerticalAlignOfControlContent($controlItem);
            });
        }
        $control.css('visibility', 'inherit');
    });
}

function copyDataAttributes($target, $source) {
    var regexp = /^data\-(.+)$/;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.each($source[0].attributes, function (index, attr) {
        if (regexp.test(attr.nodeName)) {
            var key = attr.nodeName.match(regexp)[1];
            $target.attr('data-' + key, attr.nodeValue);
        }
    });
}

function wrapInputs() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-segmented-control-button').each(function () {
        var $controlItem = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this),
            controlItem = $controlItem.get(0);
        if (controlItem.nodeName === 'INPUT') {
            var $outerSpan = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<span></span>'),
                classes = $controlItem.attr('class'),
                next = controlItem.nextSibling;

            // Set up classes
            if ($controlItem.attr('checked')) {
                classes += ' uwr-segmented-control-selected';
            }
            $outerSpan.attr('class', classes);
            $controlItem.removeAttr('class');
            $controlItem.addClass('uwr-segmented-control-hidden-accessible');

            // Build structure
            if (next && next.nodeValue) {
                $outerSpan.append(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(next));
            }
            copyDataAttributes($outerSpan, $controlItem);
            $controlItem.wrap($outerSpan);
        }
    });
}

function setClasses($parent) {
    $parent.find('.uwr-segmented-control-hidden-accessible').each(function () {
        var $this = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this),
            $controlItem = $this.closest('.uwr-segmented-control-button');
        if ($this.prop('checked')) {
            $controlItem.addClass('uwr-segmented-control-selected');
        } else {
            $controlItem.removeClass('uwr-segmented-control-selected');
        }
    });
}

/**
 * Initializes all segmented controls on the page. Should be called by client apps only after injecting
 * segmented controls dynamically.
 *
 * init() is an asynchronous call, so if some logic needs to be added once init() is finished, a callback
 * function can be passed in as a parameter.
 *
 * @param callback A Javascript function object that will be called at the end of the init() call.
 */
function init(callback) {
    wrapInputs();
    resizeAll();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Tooltip_js_tooltip__["init"])();
    setClickHandlers();

    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}

/**
 * Selects a particular button of a Segmented Control.
 *
 * @param selector CSS selector string specifying the button's element (span, button or input).
 * @param callback Function object that is executed when the given button has been toggled.
 */
function toggle(selector, callback) {
    toggleItemSelection(selector);
    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getState"] = getState;
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_shifterBox_less__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_shifterBox_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_shifterBox_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mustache__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shifterBoxView__ = __webpack_require__(94);






var isIe7OrIe8 = __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["m" /* isIe7 */]() || __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["c" /* isIe8 */](),
    isTouchDevice = __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["a" /* isTouchDevice */]();

function getInputData($sb) {
    var inputDataId = $sb.data('input'),
        inputDataReference = $sb.data('input-reference'),
        inputData,
        inputJson,
        $inputScript;
    if (inputDataReference) {
        inputData = __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["f" /* resolveReference */](inputDataReference);
    } else {
        $inputScript = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#' + inputDataId);
        inputJson = $inputScript.html();
        inputData = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.parseJSON(inputJson);
    }
    return inputData;
}

function transformNode(inputNode, stateNode, idPrefix) {
    if (inputNode) {
        stateNode.title = inputNode.title ? __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.trim(inputNode.title) : '';
        if (inputNode.items) {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.each(inputNode.items, function (i, el) {
                stateNode.items.push({
                    id: idPrefix + __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.trim(el.id),
                    name: __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.trim(el.name)
                });
            });
        }
    }
}

/**
 * Create the inner state from the input data. It does some validation and data transformation.
 */
function transformToState(inputData) {
    var state,
        idPrefix;

    state = {
        left: {
            items: [],
            title: ''
        },
        right: {
            items: [],
            title: ''
        },
        autoSort: false
    };

    if (inputData) {
        idPrefix = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.trim(inputData.idPrefix);

        transformNode(inputData.left, state.left, idPrefix);
        transformNode(inputData.right, state.right, idPrefix);

        state.autoSort = !!inputData.autoSort;
    }

    sortList(state.left.items, state.autoSort);
    sortList(state.right.items, state.autoSort);

    return state;
}

function getInternalState($sb) {
    return $sb.data('state');
}

function refreshItems($sb) {
    var state = getInternalState($sb),
        $leftItems = $sb.find('.uwr-shifter-box-panel-left .uwr-shifter-box-items'),
        $rightItems = $sb.find('.uwr-shifter-box-panel-right .uwr-shifter-box-items'),
        $formElements = $sb.find('.uwr-shifter-box-form-elements'),
        itemsTemplate,
        leftItemsHtml,
        rightItemsHtml,
        formElementsHtml;

    itemsTemplate = isTouchDevice ? __WEBPACK_IMPORTED_MODULE_4__shifterBoxView__["a" /* default */].itemListTablet : __WEBPACK_IMPORTED_MODULE_4__shifterBoxView__["a" /* default */].itemListDesktop;

    leftItemsHtml = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mustache__["render"])(itemsTemplate, state.left);
    $leftItems.html(leftItemsHtml);

    rightItemsHtml = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mustache__["render"])(itemsTemplate, state.right);
    $rightItems.html(rightItemsHtml);

    formElementsHtml = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_4__shifterBoxView__["a" /* default */].itemListFormElements, __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend({selected: false}, state.left));
    $formElements.html(formElementsHtml);
    formElementsHtml = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_4__shifterBoxView__["a" /* default */].itemListFormElements, __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.extend({selected: true}, state.right));
    $formElements.append(formElementsHtml);
}

function setButtonDisabled($btn, bool) {
    $btn.prop('disabled', bool);
}

function hasSelected($inputs) {
    var hasSelectedItem = false,
        prop = isTouchDevice ? 'checked' : 'selected',
        i;
    for (i = 0; i < $inputs.length; i++) {
        if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()($inputs[i]).prop(prop)) {
            hasSelectedItem = true;
            break;
        }
    }
    return hasSelectedItem;
}

function getInputSelector(onlySelected) {
    var inputSelector;
    if (isTouchDevice) {
        inputSelector = 'input' + (onlySelected ? ':checked' : '');
    } else {
        inputSelector = 'option' + (onlySelected ? ':selected' : '');
    }
    return inputSelector;
}

function refreshButtons($sb) {
    var state = getInternalState($sb),
        $rightShiftBtn = $sb.find('.uwr-shifter-box-button-right-shift'),
        $leftShiftBtn = $sb.find('.uwr-shifter-box-button-left-shift'),
        $rightShiftAllBtn = $sb.find('.uwr-shifter-box-button-right-shift-all'),
        $leftShiftAllBtn = $sb.find('.uwr-shifter-box-button-left-shift-all'),
        inputSelector = getInputSelector(),
        $leftInputs = $sb.find('.uwr-shifter-box-panel-left ' + inputSelector),
        $rightInputs = $sb.find('.uwr-shifter-box-panel-right ' + inputSelector);

    setButtonDisabled($rightShiftBtn, !hasSelected($leftInputs));
    setButtonDisabled($leftShiftBtn, !hasSelected($rightInputs));
    setButtonDisabled($rightShiftAllBtn, state.left.items.length === 0);
    setButtonDisabled($leftShiftAllBtn, state.right.items.length === 0);
}

function addItemClickHandler($sb) {
    function tabletIe7Ie8Handler(event, $label) {
        event.preventDefault();
        event.stopPropagation();
        var $input = $label.parents('li').find('input');
        if ($input.prop('checked') === undefined) {
            $input.prop('checked', 'checked');
            $label.addClass('uwr-shifter-box-item-checked');
        } else {
            $input.removeProp('checked');
            $label.removeClass('uwr-shifter-box-item-checked');
        }
    }

    function refresh() {
        setTimeout(function () {
            refreshButtons($sb);
        }, 100);
    }

    if (isTouchDevice) {
        // Workaround for IE7/IE8 to highlight the checked elements (Tablets in IE8 mode)
        $sb.on('click', $sb.find('li label'), function (event) {
            if (isIe7OrIe8) {
                tabletIe7Ie8Handler(event, __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this));
            }
            refresh();
        });
    } else {
        var $shifterBoxItems = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-shifter-box-items', $sb);
        $shifterBoxItems.on('mouseup', function () {
            refresh();
        });
    }
}

function moveObject(id, moveFromList, moveToList) {
    var i,
        item;
    for (i = 0; i < moveFromList.length; i++) {
        item = moveFromList[i];
        if (item.id === id) {
            moveFromList.splice(i, 1);
            moveToList.push(item);
            break;
        }
    }
}

function sortFunction(a, b) {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
}

function sortList(list, autoSort) {
    if (autoSort) {
        list.sort(sortFunction);
    }
}

function addButtonsClickHandler($sb) {
    var $buttons = $sb.find('.uwr-shifter-box-buttons .uwr-shifter-box-button');

    $buttons.on('click', function (event) {
        event.preventDefault();

        var $btn = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this),
            state = getInternalState($sb),
            btnClass = $btn.prop('class'),
            isRightShiftBtn = btnClass.indexOf('-right-shift') > -1,
            isAllBtn = $btn.prop('class').indexOf('-all') > -1,
            moveFromPanelClass = isRightShiftBtn ? 'uwr-shifter-box-panel-left' : 'uwr-shifter-box-panel-right',
            inputSelector = getInputSelector(!isAllBtn),
            $selectedItems,
            moveFromList = isRightShiftBtn ? state.left.items : state.right.items,
            moveToList = isRightShiftBtn ? state.right.items : state.left.items;

        $selectedItems = $sb.find('.' + moveFromPanelClass + ' ' + inputSelector);
        $selectedItems.each(function (i, elem) {
            var id = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(elem).prop('id');
            moveObject(id, moveFromList, moveToList);
        });

        sortList(moveToList, state.autoSort);

        refreshItems($sb);
        refreshButtons($sb);
    });
}

function updateSizes($sb, prefix, elementExtras) {
    var heightAttributeName = prefix + 'height',
        widthAttributeName = prefix + 'width',
        fixHeight,
        fixWidth,
        panelHeight,
        panelWidth,
        requiredHeight = $sb.css(heightAttributeName),
        requiredWidth = $sb.css(widthAttributeName);

    if (requiredHeight || requiredWidth) {
        // total of fixed width paddings between buttons and panels and around panels
        fixWidth = elementExtras.panels.left.width + elementExtras.items.left.width + elementExtras.buttons.width
                + elementExtras.items.right.width + elementExtras.panels.right.width;
        fixHeight = Math.max(elementExtras.panels.left.height, elementExtras.panels.right.height)
                + Math.max(elementExtras.labels.left.height, elementExtras.labels.right.height)
                + Math.max(elementExtras.items.left.height, elementExtras.items.right.height);

        panelWidth = Math.floor((requiredWidth.replace('px', '') - fixWidth) / 2);
        panelHeight = Math.max(requiredHeight.replace('px', '') - fixHeight, elementExtras.buttons.height);

        $sb.find('.uwr-shifter-box-items').css(heightAttributeName, panelHeight + 'px');
        $sb.find('.uwr-shifter-box-items').css(widthAttributeName, panelWidth + 'px');
    }
}

/**
 * Should be refactored later because values in this function should be kept in sync with CSS changes which
 * is very error prone. Exact values should be calculated instead.
 */
function createElementExtrasObject() {
    var elementExtras = {};
    elementExtras.buttons = {width: 35, height: 120};
    elementExtras.panels = {};
    elementExtras.panels.left = {width: 0, height: 0};
    elementExtras.panels.right = {width: 0, height: 0};
    elementExtras.labels = {};
    elementExtras.labels.left = {width: 0, height: 20};
    elementExtras.labels.right = {width: 0, height: 20};
    elementExtras.items = {};
    elementExtras.items.left = {width: 2, height: 2};
    elementExtras.items.right = {width: 2, height: 2};
    return elementExtras;
}

function setSizes($sb) {
    var elementExtras = createElementExtrasObject();
    updateSizes($sb, '', elementExtras);
    updateSizes($sb, 'min-', elementExtras);
    updateSizes($sb, 'max-', elementExtras);
}

function initSingle($sb) {
    var inputData = getInputData($sb),
        state = transformToState(inputData),
        sbHtml;

    if (isTouchDevice) {
        $sb.addClass('uwr-shifter-box-tablet');
    }

    sbHtml = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_4__shifterBoxView__["a" /* default */].mainMarkup, {
        titleLeft: state.left.title,
        titleRight: state.right.title
    });
    $sb.html(sbHtml);

    $sb.data('state', state);
    refreshItems($sb);
    refreshButtons($sb);

    addItemClickHandler($sb);
    addButtonsClickHandler($sb);
    setSizes($sb);
}

function transformStateItemsToPublicItems(stateItems) {
    var result = [],
        i,
        item;
    if (stateItems.length > 0) {
        for (i = 0; i < stateItems.length; i++) {
            item = stateItems[i];
            result.push({id: item.id, name: item.name});
        }
    }
    return result;
}

/**
 * Get the state of the Shifter Box.
 *
 * @param {string} The CSS selector of the Shifter Box div of which state is needed. It is recommended to
 *                 set id attribute of the Shifter Box HTML div.
 * @param {function} The callback function, which handles the state of the given Shifter Box. It has
 *                   one parameter: state. This state object is the JSON representation of the current
 *                   state of the Shifter Box.
 */
function getState(selector, callback) {
    var state = getInternalState(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector)),
        publicState = {
            left: transformStateItemsToPublicItems(state.left.items),
            right: transformStateItemsToPublicItems(state.right.items)
        };
    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.type(callback) === 'function') {
        callback(publicState);
    }
}

/**
 * Initializes all shifter boxes on the page. Should be called by client apps only after injecting
 * shifter boxes dynamically.
 *
 * init() is an asynchronous call, so if some logic needs to be added once init() is finished, a
 * callback function can be passed in as a parameter.
 *
 * @param callback A Javascript function object that will be called at the end of the init() call.
 */
function init(callback) {
    var $sbs = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-shifter-box');
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.each($sbs, function (i, el) {
        var $sb = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el);
        initSingle($sb);
    });
    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony export (immutable) */ __webpack_exports__["setChecked"] = setChecked;
/* harmony export (immutable) */ __webpack_exports__["setType"] = setType;
/* harmony export (immutable) */ __webpack_exports__["toggle"] = toggle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_singleCheckbox_less__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_singleCheckbox_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_singleCheckbox_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__ = __webpack_require__(1);




var isBorderRadiusSupportedCache;

/**
 * This function is needed only for backward compatibility for '<select>' markup (temporarily).
 */
function isValidSelectMarkup($markup) {
    var isSelect = false,
        $options = $markup.find('option');
    if ($markup.is('select')) {
        if ($options.length === 2) {
            isSelect = true;
        }
    }
    return isSelect;
}

function isBorderRadiusSupported() {
    if (isBorderRadiusSupportedCache) {
        return isBorderRadiusSupportedCache;
    }

    isBorderRadiusSupportedCache = document.createElement('div').style.borderRadius !== undefined;
    return isBorderRadiusSupportedCache;
}

/**
 * Returns true if the Single Checkbox implementation is based on sliced images.
 * Returns false if it's implemented fully in CSS.
 */
function isSliced() {
    return !isBorderRadiusSupported();
}

function getSliceSuffix() {
    return isSliced() ? '-slice' : '';
}

function getKnobOnPosition($knob) {
    var knobOnPosition = $knob.parent().width() - 22;
    if (isSliced()) {
        knobOnPosition += 8;
    }
    return knobOnPosition + 'px';
}

function getKnobOffPosition() {
    var knobOffPosition = 0;
    if (isSliced()) {
        knobOffPosition -= 14;
    }
    return knobOffPosition + 'px';
}

function animateKnobToOn($knob, enabledTypeSuffix, sliceSuffix) {
    $knob.css('left', getKnobOffPosition());
    $knob.stop().animate({'left': getKnobOnPosition($knob)}, 100, 'linear', function () {
        $knob.removeClass('uwr-single-checkbox-knob-off' + enabledTypeSuffix + sliceSuffix);
        $knob.addClass('uwr-single-checkbox-knob-on' + enabledTypeSuffix + sliceSuffix);
    });
}

function animateKnobToOff($knob, enabledTypeSuffix, sliceSuffix) {
    $knob.css('left', getKnobOnPosition($knob));
    $knob.stop().animate({'left': getKnobOffPosition()}, 100, 'linear', function () {
        $knob.removeClass('uwr-single-checkbox-knob-on' + enabledTypeSuffix + sliceSuffix);
        $knob.addClass('uwr-single-checkbox-knob-off' + enabledTypeSuffix + sliceSuffix);
    });
}

function toggleKnob($backgroundDiv, $markup, enabledTypeSuffix, sliceSuffix) {
    var $knob = __WEBPACK_IMPORTED_MODULE_1_jquery___default()($backgroundDiv.find('.uwr-single-checkbox-knob' + enabledTypeSuffix + sliceSuffix).get(0));
    if (getMarkupState($markup)) {
        animateKnobToOn($knob, enabledTypeSuffix, sliceSuffix);
    } else {
        animateKnobToOff($knob, enabledTypeSuffix, sliceSuffix);
    }
}

function toggleLabel($backgroundDiv, $markup, sliceSuffix) {
    var $labelOn = __WEBPACK_IMPORTED_MODULE_1_jquery___default()($backgroundDiv.find('.uwr-single-checkbox-label-on' + sliceSuffix).get(0)),
        $labelOff = __WEBPACK_IMPORTED_MODULE_1_jquery___default()($backgroundDiv.find('.uwr-single-checkbox-label-off' + sliceSuffix).get(0));
    if (getMarkupState($markup)) {
        $labelOff.addClass('uwr-single-checkbox-hidden');
        $labelOn.removeClass('uwr-single-checkbox-hidden');
    } else {
        $labelOff.removeClass('uwr-single-checkbox-hidden');
        $labelOn.addClass('uwr-single-checkbox-hidden');
    }
}

function getMarkupType($markup) {
    var type = $markup.data('type');
    if (typeof type === 'undefined' || (type !== 'readonly' && type !== 'disabled')) {
        type = 'enabled';
    }
    return type;
}

function isEnabled($markup) {
    return getMarkupType($markup) === 'enabled';
}

function isReadonly($markup) {
    return getMarkupType($markup) === 'readonly';
}

function isDisabled($markup) {
    return getMarkupType($markup) === 'disabled';
}

function getMarkupTypeSuffix($markup) {
    var result;
    if (isEnabled($markup)) {
        result = '';
    } else {
        result = '-' + getMarkupType($markup);
    }
    return result;
}

function toggleBackgroundColor($backgroundDiv, $markup, enabledTypeSuffix, sliceSuffix) {
    var $curveLeft = $backgroundDiv.prev(),
        $curveRight = $backgroundDiv.next(),
        colorOn = $backgroundDiv.data('color-on'),
        colorOff = $backgroundDiv.data('color-off');
    if (getMarkupState($markup)) {
        $curveLeft.removeClass('uwr-single-checkbox-curve-left-' + colorOff + enabledTypeSuffix + sliceSuffix);
        $curveLeft.addClass('uwr-single-checkbox-curve-left-' + colorOn + enabledTypeSuffix + sliceSuffix);
        $backgroundDiv.removeClass('uwr-single-checkbox-background-' + colorOff + enabledTypeSuffix + sliceSuffix);
        $backgroundDiv.addClass('uwr-single-checkbox-background-' + colorOn + enabledTypeSuffix + sliceSuffix);
        $curveRight.removeClass('uwr-single-checkbox-curve-right-' + colorOff + enabledTypeSuffix + sliceSuffix);
        $curveRight.addClass('uwr-single-checkbox-curve-right-' + colorOn + enabledTypeSuffix + sliceSuffix);
    } else {
        $curveLeft.removeClass('uwr-single-checkbox-curve-left-' + colorOn + enabledTypeSuffix + sliceSuffix);
        $curveLeft.addClass('uwr-single-checkbox-curve-left-' + colorOff + enabledTypeSuffix + sliceSuffix);
        $backgroundDiv.removeClass('uwr-single-checkbox-background-' + colorOn + enabledTypeSuffix + sliceSuffix);
        $backgroundDiv.addClass('uwr-single-checkbox-background-' + colorOff + enabledTypeSuffix + sliceSuffix);
        $curveRight.removeClass('uwr-single-checkbox-curve-right-' + colorOn + enabledTypeSuffix + sliceSuffix);
        $curveRight.addClass('uwr-single-checkbox-curve-right-' + colorOff + enabledTypeSuffix + sliceSuffix);
    }
}

function toggleDiv($backgroundDiv, $markup) {
    var sliceSuffix = getSliceSuffix(),
        enabledTypeSuffix = getMarkupTypeSuffix($markup);
    toggleBackgroundColor($backgroundDiv, $markup, enabledTypeSuffix, sliceSuffix);
    toggleKnob($backgroundDiv, $markup, enabledTypeSuffix, sliceSuffix);
    toggleLabel($backgroundDiv, $markup, sliceSuffix);
}

function isChangeable($markup) {
    var readonly = isReadonly($markup),
        enabled = isEnabled($markup);
    return enabled || readonly;
}

function getVisibleState($backgroundDiv) {
    var selector = '.uwr-single-checkbox-label-off';
    if (isSliced()) {
        selector = '.uwr-single-checkbox-label-off-slice';
    }
    return $backgroundDiv.find(selector).hasClass('uwr-single-checkbox-hidden');
}

/**
 * Returns true if the Single Checkbox is on at markup level, false otherwise.
 */
function getMarkupState($markup) {
    var state = $markup.is(':checked'),
        $options = $markup.find('option');
    if (isValidSelectMarkup($markup)) {
        state = !$options.get(1).selected;
    }
    return state;
}

function setMarkupStateWithoutChange($markup, newState) {
    var $options = $markup.find('option'),
        state = getMarkupState($markup);
    if (isValidSelectMarkup($markup)) {
        state = !$options.get(1).selected;
        if (newState !== state) {
            if (newState) {
                $options.get(0).selected = true;
                $options.get(1).selected = false;
            } else {
                $options.get(0).selected = false;
                $options.get(1).selected = true;
            }
        }
    } else {
        if (newState !== state) {
            if (newState) {
                $markup[0].setAttribute('checked', '');
            } else {
                $markup[0].removeAttribute('checked');
            }
        }
    }
}

function setMarkupState($markup, newState) {
    if (isChangeable($markup) && getMarkupState($markup) !== newState) {
        setMarkupStateWithoutChange($markup, newState);
        __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["k" /* dispatchEvent */]('change', $markup.get(0));
        $markup.focus();
    }
}

function toggleState($markup) {
    setMarkupState($markup, !getMarkupState($markup));
}

function isChanged($markup, $backgroundDiv) {
    return getMarkupState($markup) !== getVisibleState($backgroundDiv);
}

function changeHandler($markup, $backgroundDiv) {
    if (isChanged($markup, $backgroundDiv)) {
        if (isChangeable($markup)) {
            toggleDiv($backgroundDiv, $markup);
        } else if (isDisabled($markup) && isValidSelectMarkup($markup)) {
            // rollback unwanted state change on select markup
            setMarkupStateWithoutChange($markup, !getMarkupState($markup));
        }
    }
}

function keyupHandler($markup, event) {
    var $focusDiv = $markup.data('focus-div');
    if (event.which === 13) { // Enter or space on select should trigger switching
        toggleState($markup);
    }
    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["k" /* dispatchEvent */]('change', $markup.get(0));
    $focusDiv.focus();
}

function addListenersToMarkup($markup, $backgroundDiv) {
    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["l" /* addEventListener */]('change', $markup.get(0), function () {
        changeHandler($markup, $backgroundDiv);
    });
    $markup.keyup(function (event) {
        keyupHandler($markup, event);
    });
}

function isUseIconLabels($markup) {
    return typeof $markup.data('use-icon-labels') === 'undefined' || $markup.data('use-icon-labels') === true;
}

function getLabelOnText($markup) {
    var labelOnText = $markup[0].getAttribute('data-label-on'),
        $options = $markup.find('option');
    if (isValidSelectMarkup($markup)) {
        labelOnText = $options.get(0).innerHTML;
    }
    return labelOnText;
}

function getLabelOffText($markup) {
    var labelOffText = $markup[0].getAttribute('data-label-off'),
        $options = $markup.find('option');
    if (isValidSelectMarkup($markup)) {
        labelOffText = $options.get(1).innerHTML;
    }
    return labelOffText;
}

function addTypeClasses(type, $markup) {
    var sliceSuffix = getSliceSuffix(),
        $background = $markup.data('backgroundDiv'),
        colorOn = $background.data('color-on'),
        colorOff = $background.data('color-off'),
        color = (getMarkupState($markup) ? colorOn : colorOff),
        knobState = (getMarkupState($markup) ? 'on' : 'off'),
        $curveLeft = $markup.data('curveLeftDiv'),
        $curveRight = $markup.data('curveRightDiv'),
        $knob = $markup.data('knobDiv');
    $curveLeft.addClass('uwr-single-checkbox-curve-left-' + color + type + sliceSuffix);
    $background.addClass('uwr-single-checkbox-background' + type + sliceSuffix);
    $background.addClass('uwr-single-checkbox-background-' + color + type + sliceSuffix);
    $knob.addClass('uwr-single-checkbox-knob' + type + sliceSuffix);
    $knob.addClass('uwr-single-checkbox-knob-' + knobState + type + sliceSuffix);
    $curveRight.addClass('uwr-single-checkbox-curve-right-' + color + type + sliceSuffix);
}

function removeTypeClasses(type, $markup) {
    var sliceSuffix = getSliceSuffix(),
        $background = $markup.data('backgroundDiv'),
        colorOn = $background.data('color-on'),
        colorOff = $background.data('color-off'),
        color = (getMarkupState($markup) ? colorOn : colorOff),
        knobState = (getMarkupState($markup) ? 'on' : 'off'),
        $curveLeft = $markup.data('curveLeftDiv'),
        $curveRight = $markup.data('curveRightDiv'),
        $knob = $markup.data('knobDiv');
    $curveLeft.removeClass('uwr-single-checkbox-curve-left-' + color + type + sliceSuffix);
    $background.removeClass('uwr-single-checkbox-background' + type + sliceSuffix);
    $background.removeClass('uwr-single-checkbox-background-' + color + type + sliceSuffix);
    $knob.removeClass('uwr-single-checkbox-knob' + type + sliceSuffix);
    $knob.removeClass('uwr-single-checkbox-knob-' + knobState + type + sliceSuffix);
    $curveRight.removeClass('uwr-single-checkbox-curve-right-' + color + type + sliceSuffix);
}

function switchToEnabled($markup) {
    addTypeClasses('', $markup);
    removeTypeClasses('-readonly', $markup);
    removeTypeClasses('-disabled', $markup);
}

function switchToReadonly($markup) {
    addTypeClasses('-readonly', $markup);
    removeTypeClasses('', $markup);
    removeTypeClasses('-disabled', $markup);
}

function switchToDisabled($markup) {
    addTypeClasses('-disabled', $markup);
    removeTypeClasses('', $markup);
    removeTypeClasses('-readonly', $markup);
}

function setMarkupType($markup, newType) {
    if (newType === 'enabled' || newType === 'readonly' || newType === 'disabled') {
        $markup.data('type', newType);
        switch (getMarkupType($markup)) {
        case 'enabled':
            switchToEnabled($markup);
            break;
        case 'readonly':
            switchToReadonly($markup);
            break;
        case 'disabled':
            switchToDisabled($markup);
            break;
        }
        parseTypeAttribute($markup);
    }
}

function setResetHandler($markup) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('form').bind('reset', function () {
        var defaultState = $markup.data('default-state');
        if (!isDisabled($markup) && defaultState !== getMarkupState($markup)) {
            setMarkupState($markup, defaultState);
        }
    });
}

function blurAll() {
    var blurFunc = function () {
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).blur();
        };
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-single-checkbox-markup').each(blurFunc);
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-single-checkbox-markup-slice').each(blurFunc);
}

function addFocusDIV($markup, $backgroundDiv, $containerDiv) {
    var $focusDiv = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<a href=\'\'></a>');
    $markup.data('focus-div', $focusDiv);
    if (isEnabled($markup)) {
        $focusDiv[0].setAttribute('tabindex', $markup[0].getAttribute('tabindex'));
        $focusDiv.appendTo($containerDiv);
        $focusDiv.addClass('uwr-single-checkbox-markup' + getSliceSuffix());
        $focusDiv.focus(function () {
            blurAll();
            if (isSliced()) {
                $containerDiv.addClass('uwr-single-checkbox-focus-slice');
            } else {
                $backgroundDiv.addClass('uwr-single-checkbox-focus');
            }
        });
        $focusDiv.focusout(function () {
            if (isSliced()) {
                $containerDiv.removeClass('uwr-single-checkbox-focus-slice');
            } else {
                $backgroundDiv.removeClass('uwr-single-checkbox-focus');
            }
        });
        $focusDiv.blur(function () {
            if (isSliced()) {
                $containerDiv.removeClass('uwr-single-checkbox-focus-slice');
            } else {
                $backgroundDiv.removeClass('uwr-single-checkbox-focus');
            }
        });
        $focusDiv.keydown(function (event) {
            if (event.which === 13 || event.which === 32) { // Enter or space on select should trigger toggle
                toggleState($markup);
                __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["k" /* dispatchEvent */]('change', $markup.get(0));
                return false; // stop key event propagation to link
            }
        });
    }
}

function addFocusHandler($markup, $backgroundDiv, $containerDiv) {
    $markup.appendTo($containerDiv);
    $markup.addClass('uwr-single-checkbox-hidden');
    $markup.focus(function () {
        if (isEnabled($markup)) {
            blurAll();
            if (isSliced()) {
                $containerDiv.addClass('uwr-single-checkbox-focus-slice');
            } else {
                $backgroundDiv.addClass('uwr-single-checkbox-focus');
            }
        }
    });
    $markup.focusout(function () {
        if (isSliced()) {
            $containerDiv.removeClass('uwr-single-checkbox-focus-slice');
        } else {
            $backgroundDiv.removeClass('uwr-single-checkbox-focus');
        }
    });
    $markup.blur(function () {
        if (isSliced()) {
            $containerDiv.removeClass('uwr-single-checkbox-focus-slice');
        } else {
            $backgroundDiv.removeClass('uwr-single-checkbox-focus');
        }
    });
    addFocusDIV($markup, $backgroundDiv, $containerDiv);
}

function initSelectedStateInOriginalMarkup($markup) {
    if (isValidSelectMarkup($markup)) {
        var $options = $markup.find('option');
        if (!$options.get(0).selected && !$options.get(1).selected) {
            $options.get(0).selected = true;
        }
    }
}

function parseColorAttribute($markup, $backgroundDiv) {
    var colorCode = $markup.data('color'),
        colorArray;
    if (colorCode !== 'kiwi-grey' && colorCode !== 'olive-chestnut' && colorCode !== 'atlantic-chestnut') {
        colorCode = 'kiwi-grey';
    }
    colorArray = colorCode.split('-');
    $backgroundDiv.data('color-on', colorArray[0]);
    $backgroundDiv.data('color-off', colorArray[1]);
}

function parseTypeAttribute($markup) {
    if (isDisabled($markup)) {
        $markup[0].setAttribute('disabled', '');
        $markup.css('display', 'none');
    } else if (isReadonly($markup)) {
        $markup[0].removeAttribute('disabled');
        $markup.css('display', 'none');
    } else {
        $markup[0].removeAttribute('disabled');
        $markup.css('display', '');
    }
}

function buildCurveLeftDiv($markup, $backgroundDiv, colorOn, enabledTypeSuffix, sliceSuffix) {
    var $curveLeftDiv = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<div></div>');
    $curveLeftDiv.addClass('uwr-single-checkbox-curve' + sliceSuffix);
    $curveLeftDiv.addClass('uwr-single-checkbox-curve-left-' + colorOn + enabledTypeSuffix + sliceSuffix);
    $curveLeftDiv.click(function () {
        if (isEnabled($markup)) {
            toggleState($markup);
            changeHandler($markup, $backgroundDiv);
        }
    });
    return $curveLeftDiv;
}

function buildCurveRightDiv($markup, $backgroundDiv, colorOn, enabledTypeSuffix, sliceSuffix) {
    var $curveRightDiv = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<div></div>');
    $curveRightDiv.addClass('uwr-single-checkbox-curve' + sliceSuffix);
    $curveRightDiv.addClass('uwr-single-checkbox-curve-right-' + colorOn + enabledTypeSuffix + sliceSuffix);
    $curveRightDiv.click(function () {
        if (isEnabled($markup)) {
            toggleState($markup);
            changeHandler($markup, $backgroundDiv);
        }
    });
    return $curveRightDiv;
}

function buildLabelOnDiv(useIcon, text, sliceSuffix, colorOn) {
    var $labelOnDiv = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<div></div>');
    $labelOnDiv.addClass('uwr-single-checkbox-label' + sliceSuffix);
    $labelOnDiv.addClass('uwr-single-checkbox-label-on' + sliceSuffix);
    if (useIcon) {
        $labelOnDiv.addClass('uwr-single-checkbox-label-on-icon-' + colorOn);
    } else {
        $labelOnDiv.html(text);
    }
    return $labelOnDiv;
}

function buildLabelOffDiv(useIcon, text, sliceSuffix, colorOff) {
    var $labelOffDiv = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<div></div>');
    $labelOffDiv.addClass('uwr-single-checkbox-label' + sliceSuffix);
    $labelOffDiv.addClass('uwr-single-checkbox-label-off' + sliceSuffix);
    if (useIcon) {
        $labelOffDiv.addClass('uwr-single-checkbox-label-off-icon-' + colorOff);
    } else {
        $labelOffDiv.html(text);
    }
    return $labelOffDiv;
}

function buildKnobDiv(enabledTypeSuffix, sliceSuffix) {
    var $knobDiv = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<div></div>');
    $knobDiv.addClass('uwr-single-checkbox-knob' + enabledTypeSuffix + sliceSuffix);
    $knobDiv.addClass('uwr-single-checkbox-knob-on' + enabledTypeSuffix + sliceSuffix);
    return $knobDiv;
}

function calcComponentWidth($labelOnDiv, $labelOffDiv) {
    var widthOn = $labelOnDiv.width(),
        widthOff = $labelOffDiv.width(),
        // If we use slices we have to subtract the width of the two curves
        gap = isSliced() ? 11 : 35;
    return (widthOn < widthOff ? widthOff : widthOn) + gap;
}

function configureBackgroundDiv($markup, $backgroundDiv, width, classSuffix, coloredClassSuffix) {
    $backgroundDiv.width(width);
    $backgroundDiv.addClass('uwr-single-checkbox-background' + classSuffix);
    $backgroundDiv.addClass('uwr-single-checkbox-background-' + coloredClassSuffix);
    $backgroundDiv.click(function () {
        if (isEnabled($markup)) {
            toggleState($markup);
        }
    });
}

function buildBackgroundDiv($markup) {
    var $containerDiv = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<div></div>'),
        $backgroundDiv = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<div></div>'),
        $labelOnDiv,
        $labelOffDiv,
        sliceSuffix = getSliceSuffix(),
        enabledTypeSuffix,
        colorOn,
        colorOff,
        width,
        classSuffix,
        coloredClassSuffix,
        $curveLeftDiv,
        $curveRightDiv,
        $knobDiv;
    $containerDiv.addClass('uwr-single-checkbox-container');
    $containerDiv.insertBefore($markup);
    initSelectedStateInOriginalMarkup($markup);
    parseColorAttribute($markup, $backgroundDiv);
    parseTypeAttribute($markup);
    enabledTypeSuffix = getMarkupTypeSuffix($markup);
    colorOn = $backgroundDiv.data('color-on');
    colorOff = $backgroundDiv.data('color-off');
    $curveLeftDiv = buildCurveLeftDiv($markup, $backgroundDiv, colorOn, enabledTypeSuffix, sliceSuffix);
    $containerDiv.append($curveLeftDiv);
    $containerDiv.append($backgroundDiv);
    $curveRightDiv = buildCurveRightDiv($markup, $backgroundDiv, colorOn, enabledTypeSuffix, sliceSuffix);
    $containerDiv.append($curveRightDiv);
    $labelOnDiv = buildLabelOnDiv(isUseIconLabels($markup), getLabelOnText($markup), sliceSuffix, colorOn);
    $backgroundDiv.append($labelOnDiv);
    $labelOffDiv = buildLabelOffDiv(isUseIconLabels($markup), getLabelOffText($markup), sliceSuffix, colorOff);
    $backgroundDiv.append($labelOffDiv);
    $knobDiv = buildKnobDiv(enabledTypeSuffix, sliceSuffix);
    $backgroundDiv.append($knobDiv);
    width = calcComponentWidth($labelOnDiv, $labelOffDiv);
    classSuffix = enabledTypeSuffix + sliceSuffix;
    coloredClassSuffix = colorOn + enabledTypeSuffix + sliceSuffix;
    configureBackgroundDiv($markup, $backgroundDiv, width, classSuffix, coloredClassSuffix);
    /* Necessary to add hidden class to $labelOffDiv only after invoking calcTextWidth
        * (called from configureBackgroundDiv()), but before setInitialCheckboxState()
        */
    $labelOffDiv.addClass('uwr-single-checkbox-hidden');
    addFocusHandler($markup, $backgroundDiv, $containerDiv);
    $markup.data('containerDiv', $containerDiv);
    $markup.data('backgroundDiv', $backgroundDiv);
    $markup.data('curveLeftDiv', $curveLeftDiv);
    $markup.data('curveRightDiv', $curveRightDiv);
    $markup.data('knobDiv', $knobDiv);
    return $backgroundDiv;
}

/**
 * SingleCheckbox is always initialized with unchecked state.
 * If the checkbox is selected or first element selected in the original select,
 * SingleCheckbox toggle will be triggered.
 */
function setInitialCheckboxState($backgroundDiv, $markup, state) {
    if (!state) {
        toggleDiv($backgroundDiv, $markup);
    }
}

function saveInitialData($markup) {
    $markup.data('default-state', getMarkupState($markup));
}

function buildComponent($markup) {
    var $backgroundDiv = buildBackgroundDiv($markup);
    saveInitialData($markup);
    setInitialCheckboxState($backgroundDiv, $markup, getMarkupState($markup));
    addListenersToMarkup($markup, $backgroundDiv);
    setResetHandler($markup);
}

function isSingleCheckbox($markup) {
    return $markup.hasClass('uwr-single-checkbox');
}

/**
 * Initializes all single checkboxes on the page. It is called by the framework once, on page load.
 * Should be called by client apps only after injecting single checkboxes dynamically.
 *
 * init() is an asynchronous call, so if some logic needs to be added once init() is finished, a callback
 * function can be passed in as a parameter.
 *
 * @param callback A Javascript function object that will be called at the end of the init() call.
 */
function init(callback) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-single-checkbox').each(function () {
        var $sc = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
        if ($sc.data('initialized') !== true) {
            buildComponent($sc);
            $sc.data('initialized', true);
        }
    });
    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}

/**
 * Switches the given single checkbox on or off.
 *
 * @param selector CSS selector string that will return the single checkbox or checkboxes to set.
 * @param newState Boolean value specifying the new state of the single checkbox.
 */
function setChecked(selector, newState) {
    var checked = newState === true;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector).each(function () {
        var $sc = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
        if (isSingleCheckbox($sc)) {
            setMarkupState($sc, checked);
        }
    });
}

/**
 * Sets the given single checkbox's type.
 *
 * @param selector CSS selector string that will return the single checkbox or checkboxes to set.
 * @param newType String value specifying the new type of the single checkbox.
 *     Accepted values: 'enabled', 'readonly', 'disabled'
 */
function setType(selector, newType) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector).each(function () {
        var $sc = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
        if (isSingleCheckbox($sc)) {
            setMarkupType($sc, newType);
        }
    });
}

/**
 * Toggles the single checkbox's state.
 *
 * @param selector CSS selector string that will return the single checkbox or checkboxes to toggle.
 */
function toggle(selector) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector).each(function () {
        var $sc = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
        if (isSingleCheckbox($sc)) {
            toggleState($sc);
        }
    });
}


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Calculator"] = Calculator;
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_slider_less__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_slider_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_slider_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mustache__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sliderView__ = __webpack_require__(95);






/**
 * Returns the CSS property value of a jQuery object by one or more property names.
 *
 * @param A CSS property name or array of property names.
 *
 * @return The value of the property name or the first value found going along the property names array.
 */
function getCssValue($item, cssPropName) {
    var value,
        i;
    if (cssPropName instanceof Array) {
        for (i = 0; !value && i < cssPropName.length; i++) {
            value = parseInt($item.css(cssPropName[i]), 10);
        }
    } else {
        value = parseInt($item.css(cssPropName), 10);
    }
    return value;
}

/**
 * A class which represents a Slider widget. This defines the structure and the main behavior of the widget.
 *
 * @param The jQuery element which is the slider markup.
 */
function Slider($slider) {
    var model = {
            min: new __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["e" /* ObservableValue */](0),
            max: new __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["e" /* ObservableValue */](100),
            basePoint: new __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["e" /* ObservableValue */](0),
            width: getCssValue($slider, 'width'),
            hasFloatingBase: function () {
                return model.min.value() < model.basePoint.value() && model.basePoint.value() < model.max.value();
            }
        },
        components = {
            containers: undefined,
            sliderBase: {},
            scale: undefined,
            inputs: [],
            indicators: [],
            thumbs: [],
            markers: [],
            addComponent: function (component) {
                if (component instanceof Indicator) {
                    this.indicators.push(component);
                } else
                if (component instanceof Thumb) {
                    this.thumbs.push(component);
                } else
                if (component instanceof Marker) {
                    this.markers.push(component);
                } else
                if (component instanceof __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["e" /* ObservableValue */]) {
                    this.inputs.push(component);
                }
            }
        },
        positionCalculator,

        valueSelector = $slider.data('value-selector'),
        $valueElems = valueSelector !== undefined ? __WEBPACK_IMPORTED_MODULE_1_jquery___default()(valueSelector) : __WEBPACK_IMPORTED_MODULE_1_jquery___default()('input', $slider),
        indicatorColor = $slider.data('indicator-color') !== undefined
                ? $slider.data('indicator-color')
                : undefined,
        scaleFormatterReference = $slider.data('label-formatter'),
        scaleFormatterFunction = scaleFormatterReference !== undefined
                ? __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["f" /* resolveReference */](scaleFormatterReference)
                : function (a) { return a; },
        scaleStepSize = __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["g" /* intData */]($slider, 'scale-step-size', undefined),
        showBoundaries = !(scaleStepSize && scaleStepSize > 0),
        stepSize = __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["g" /* intData */]($slider, 'step-size', model.stepSize);

    function cleanupView() {
        $slider.find('> div').remove();
    }

    function buildContainers(model, showBoundaries) {
        var conf = {
                showBoundaries: showBoundaries,
                sliderWidth: model.width,
                minValue: model.min.value(),
                maxValue: model.max.value()
            },
            $containers = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_4__sliderView__["a" /* default */].container, conf));

        $slider.append($containers);
        return {
            $sliderContainer: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-slider-container', $slider),
            $indicatorContainer: __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-slider-indicator-container', $slider)
        };
    }

    function buildSliderBase(model, calculator) {
        var sliderBase = new Indicator({
                parent: components.containers.$indicatorContainer,
                start: model.min.value(),
                end: model.max.value(),
                basePoint: model.basePoint.value(),
                calculator: calculator,
                withFloatingBase: model.hasFloatingBase(),
                isSliderBase: true
            });
        return sliderBase;
    }

    function buildScale(model, scaleStepSize, scaleFormatterFunction, positionCalculator) {
        return new Scale({
            min: model.min.value(),
            max: model.max.value(),
            basePoint: model.basePoint.value(),
            stepSize: scaleStepSize,
            width: model.width,
            scaleFormatter: scaleFormatterFunction,
            calculator: positionCalculator
        });
    }

    function buildObservableValueForInput($value, positionCalculator) {
        var ov = new __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["e" /* ObservableValue */]($value.val(), function (newValue) {
            $value.val(newValue);
            $value.trigger('change');
        });

        $value.data('valueObject', ov);
        $value.on('change', function () {
            ov.value(positionCalculator.closestStepValue($value.val()));
        });
        return ov;
    }

    function buildIndicator(model, value, indicatorColor, positionCalculator) {
        var indicator = new Indicator({
                parent: components.containers.$indicatorContainer,
                start: model.basePoint.value(),
                end: value,
                basePoint: model.basePoint.value(),
                calculator: positionCalculator,
                withFloatingBase: model.hasFloatingBase(),
                isSliderBase: false
            });
        indicator.getElement().css('background-color', indicatorColor);
        return indicator;
    }

    function buildThumb(value, positionCalculator) {
        var thumb = new Thumb({
                parent: components.containers.$indicatorContainer,
                value: value,
                calculator: positionCalculator
            });
        return thumb;
    }

    function buildMarker(value, positionCalculator) {
        var marker = new Marker({
                parent: components.containers.$indicatorContainer,
                value: value,
                calculator: positionCalculator
            });
        return marker;
    }

    function appendScale() {
        if (scaleStepSize) {
            components.scale = buildScale(model, scaleStepSize, scaleFormatterFunction, positionCalculator);
            components.containers.$indicatorContainer.append(components.scale.getElement());

            model.max.on('change:value', function (newValue) { components.scale.max.value(newValue); });
            model.min.on('change:value', function (newValue) { components.scale.min.value(newValue); });
            model.basePoint.on('change:value', function (newValue) { components.scale.basePoint.value(newValue); });
        }
    }

    function bindItemsWithEvents(observableValueElem, indicator, indicatorBindableElem, thumb, marker) {
        observableValueElem.on('change:value', function (newValue) {
            indicatorBindableElem.value(newValue);
            marker.value.value(newValue);
            thumb.value.value(newValue);
        });
        indicatorBindableElem.on('change:value', function (newValue) { observableValueElem.value(newValue); });

        thumb.value.on('change:value', function (newValue) { observableValueElem.value(newValue); });
        thumb.on('thumb:mousestatechange', function (mouseState) {
            marker.setVisible(mouseState.active || mouseState.hover);
        });
    }

    function getNearestThumb(value) {
        var i,
            nearestThumbItem,
            currentDistance,
            baseDistance = (model.max.value() - model.min.value());

        for (i = 0; i < components.thumbs.length; i++) {
            currentDistance = Math.abs(components.thumbs[i].value.value() - value);
            if (!nearestThumbItem || currentDistance < baseDistance) {
                baseDistance = currentDistance;
                nearestThumbItem = components.thumbs[i];
            }
        }

        return nearestThumbItem;
    }

    function setThumbFromValue(newValue) {
        var nearestThumbItem = components.thumbs[0];

        if (components.thumbs.length > 1) {
            nearestThumbItem = getNearestThumb(newValue);
        }

        nearestThumbItem.value.value(newValue);
        nearestThumbItem.setHover(true);
    }

    function bindSliderBaseClick() {
        components.sliderBase.on('indicator:click', function (newValue) {
            setThumbFromValue(newValue);
        });
    }

    function handleTouchEvent(jqueryEvent) {
        var i,
            touch,
            touchEvent = jqueryEvent.originalEvent,
            offsetX = components.containers.$indicatorContainer.get(0).getBoundingClientRect().left;

        for (i = 0; i < touchEvent.targetTouches.length; i++) {
            touch = touchEvent.targetTouches[i];
            setThumbFromValue(positionCalculator.positionToValue(touch.clientX - offsetX));
        }
    }

    function indicatorTouchStartMove(touchEvent) {
        touchEvent.preventDefault();
        handleTouchEvent(touchEvent);
    }

    function indicatorTouchEndCancel(touchEvent) {
        var i;

        if (touchEvent.cancelable) {
            touchEvent.preventDefault();
        }

        for (i = 0; i < components.thumbs.length; i++) {
            components.thumbs[i].setHover(false);
        }
    }

    function setTouchHandlers() {
        var $indicatorContainer = components.containers.$indicatorContainer;

        $slider.css({'touch-action': 'none', 'user-select': 'none'});

        $indicatorContainer.on('touchstart touchmove', indicatorTouchStartMove);
        $indicatorContainer.on('touchend touchcancel', indicatorTouchEndCancel);
    }

    function init() {
        var sliderType = __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["h" /* data */]($slider, 'type', 'simple'),
            rangeIndicator;

        model.max.value(__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["g" /* intData */]($slider, 'max-value', model.max.value()));
        model.min.value(__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["g" /* intData */]($slider, 'min-value', model.min.value()));
        model.basePoint.value(__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["g" /* intData */]($slider, 'base-value', model.min.value()));
        model.width = __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["g" /* intData */]($slider, 'width', model.width);
        $slider.css('width', 'auto');

        positionCalculator = new Calculator({
            min: model.min.value(),
            max: model.max.value(),
            basePoint: model.basePoint.value(),
            width: model.width,
            stepSize: stepSize,
            inputs: components.inputs
        });

        components.containers = buildContainers(model, showBoundaries);
        components.sliderBase = buildSliderBase(model, positionCalculator);

        $valueElems.each(function () {
            var $value = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this),
                observableValueElem = buildObservableValueForInput($value, positionCalculator),
                ownIndicatorColor = $value.data('slider-indicator-color') !== undefined
                    ? $value.data('slider-indicator-color')
                    : indicatorColor,
                thumb,
                marker,
                indicator,
                indicatorBindableItem;

            thumb = buildThumb($value.val(), positionCalculator);
            marker = buildMarker($value.val(), positionCalculator);
            if (sliderType === 'range') {
                if (!rangeIndicator) {
                    rangeIndicator = buildIndicator(model, $value.val(), ownIndicatorColor, positionCalculator);
                    indicatorBindableItem = rangeIndicator.start;
                    indicator = rangeIndicator;
                    rangeIndicator.setStart(thumb.value.value());
                    components.addComponent(rangeIndicator);
                } else {
                    rangeIndicator.setEnd(thumb.value.value());
                    indicatorBindableItem = rangeIndicator.end;
                    indicator = undefined;
                }
            } else {
                indicator = buildIndicator(model, $value.val(), ownIndicatorColor, positionCalculator);
                indicatorBindableItem = indicator.end;
                components.addComponent(indicator);
            }
            bindItemsWithEvents(observableValueElem, indicator, indicatorBindableItem, thumb, marker);
            components.addComponent(observableValueElem);
            components.addComponent(thumb);
            components.addComponent(marker);
            setTouchHandlers();
        });

        appendScale();
        bindSliderBaseClick();
    }

    cleanupView();
    init();
}

/**
 * The scale which shows some available values (defined by some settings as the stepSize or the scaleFormatter) of
 * an interval in an easy format.
 *
 * @param conf A JSON object, which contains the following parameters:
 *         min: the minimum point of the interval,
 *         max: the maximum point of the interval,
 *         basePoint: the basePoint point of the interval,
 *         stepSize: the size of the scale stepping (e.g. every fifth value should be displayed),
 *         width: the displayed width of the interval,
 *         scaleFormatter: a formatter function to format the scale label contents (e.g. with percent sign),
 *         calculator: a Calculator object
 */

function Scale(conf) {
    var $scale = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_4__sliderView__["a" /* default */].scale)),
        scaleLabels,
        i,
        $label,
        labelPosition,
        labelPositionCorrection,
        labelWidth;

    function scaleLabelArray(stepSize, minValue, maxValue, basePointValue) {
        var label,
            labels = [];
        if (stepSize && stepSize > 0) {
            // Find the first (min) scale value
            label = basePointValue;
            while (label >= minValue) {
                label -= stepSize;
            }
            label += stepSize;
            while (label <= maxValue) {
                labels.push(label);
                label += stepSize;
            }
        }
        return labels;
    }

    this.getElement = function () {
        return $scale;
    };

    scaleLabels = scaleLabelArray(conf.stepSize, conf.min, conf.max, conf.basePoint);
    labelWidth = Math.floor(conf.width / scaleLabels.length);

    for (i = 0; i < scaleLabels.length; i++) {
        labelPositionCorrection = Math.round(labelWidth / 2) + i * labelWidth;
        labelPosition = conf.calculator.valueToPosition(scaleLabels[i]) - labelPositionCorrection;
        $label = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_4__sliderView__["a" /* default */].label, {}));
        $label.css('width', labelWidth);
        $label.css('left', labelPosition);
        $label.text(conf.scaleFormatter(scaleLabels[i]));
        $scale.append($label);
    }
}

/**
 * The colored indicator line between two values.
 *
 * @param conf A JSON object, which contains the following parameters:
 *              parent: the parent jQuery object which this will be appended
 *              start: the start point of the indicator (the lowest value),
 *              end: the end point of the indicator (the highest value),
 *              basePoint: the basePoint point of the displayed interval,
 *              calculator: a Calculator object,
 *              withFloatingBase: the basePoint point is in the interval and not boundary value,
 *              isSliderBase: indicator is sliderBase
 */
function Indicator(conf) {
    var $indicator,
        self = this;

    function updateView() {
        var minValue = Math.min(self.start.value(), self.end.value()),
            indicatorLeft = conf.calculator.valueToPosition(minValue) - self.geometry.radius,
            endPos = conf.calculator.valueToPosition(self.end.value()),
            startPos = conf.calculator.valueToPosition(self.start.value()),
            indicatorWidth = Math.abs(endPos - startPos) + self.geometry.radius * 2;

        if (conf.withFloatingBase && !conf.isSliderBase) {
            // If the basePointValue less or equals to inputValue, then the indicator direction is left-to-right.
            indicatorLeft += conf.basePoint <= self.end.value() ? self.geometry.radius : 0;
            indicatorWidth -= self.geometry.radius;
        }
        $indicator.css('left', indicatorLeft + 'px');
        $indicator.css('width', indicatorWidth + 'px');
    }

    this.start = new __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["e" /* ObservableValue */](conf.start, updateView);
    this.setStart = function (startValue) {
        this.start.value(startValue);
    };

    this.end = new __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["e" /* ObservableValue */](conf.end, updateView);
    this.setEnd = function (endValue) {
        this.end.value(endValue);
    };

    this.getElement = function () {
        return $indicator;
    };

    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["i" /* Observable */].call(this);

    $indicator = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_4__sliderView__["a" /* default */].indicator, {}));
    $indicator.on('click', function (e) {
        var parentOffset = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).parent().offset(),
            clickPos = e.pageX - parentOffset.left,
            clickedValue = conf.calculator.positionToValue(clickPos);

        clickedValue = conf.calculator.closestStepValue(clickedValue);
        if (!conf.isSliderBase) {
            self.end.value(clickedValue);
            updateView();
        }
        self.trigger('indicator:click', clickedValue);
    });

    if (!conf.isSliderBase && conf.withFloatingBase) {
        $indicator.addClass('uwr-slider-indicator-angled');
    }
    if (conf.isSliderBase) {
        $indicator.addClass('uwr-slider-bar');
    }

    conf.parent.append($indicator);
    this.geometry = {
        radius: getCssValue($indicator, ['border-radius', 'border-top-left-radius'])
                || getCssValue($indicator, 'height') / 2
    };
    updateView();
}

/**
 * The thumb which represents a value from the interval.
 *
 * @param conf A JSON object, which contains the following parameters:
 *              parent: the parent jQuery object which this will be appended
 *              value: The initial value which is associated to this thumb,
 *              calculator: a Calculator object
 */
function Thumb(conf) {
    var $thumb,
        mouseState = {
            active: false,
            hover: false
        },
        self = this;

    function switchClass(className, add) {
        if (add) {
            $thumb.addClass(className);
        } else {
            $thumb.removeClass(className);
        }
    }
    function updateView() {
        var thumbLeft = conf.calculator.valueToPosition(self.value.value()) - self.geometry.radius;
        $thumb.css('left', thumbLeft + 'px');
        if (mouseState.active) {
            switchClass('uwr-slider-thumb-active', true);
        } else {
            switchClass('uwr-slider-thumb-active', false);
            if (mouseState.hover) {
                switchClass('uwr-slider-thumb-hover', true);
            } else {
                switchClass('uwr-slider-thumb-hover', false);
            }
        }
    }

    this.value = new __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["e" /* ObservableValue */](conf.value, updateView);

    this.getElement = function () {
        return $thumb;
    };

    this.setActive = function (active) {
        mouseState.active = active;
        this.trigger('thumb:mousestatechange', mouseState);
    };

    this.setHover = function (hover) {
        mouseState.hover = hover;
        this.trigger('thumb:mousestatechange', mouseState);
    };

    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["i" /* Observable */].call(this);

    $thumb = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_4__sliderView__["a" /* default */].thumb, {}));
    $thumb.on('mousedown', function (e) {
        e.preventDefault();
        self.trigger('thumb:dragstart', null);
        self.setActive(true);
        $thumb.css('cursor', 'pointer');
        var parsedThumbPos = parseInt($thumb.css('left').replace('px', ''), 10),
            startThumbPos = parsedThumbPos + self.geometry.radius,
            startMouseX = e.clientX,
            eventNamespace = '.uwr-slider-' + new Date().getTime(), // Date.now() from IE9+
            boundaryValues = conf.calculator.boundaryValues(self.value.value());

        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('mousemove' + eventNamespace, function (e) {
            var mouseOffsetX = (e.clientX - startMouseX),
                thumbPos = startThumbPos + mouseOffsetX,
                thumbValue;
            thumbValue = conf.calculator.positionToValue(thumbPos);
            thumbValue = conf.calculator.closestStepValue(thumbValue);
            thumbValue = Math.max(Math.min(thumbValue, boundaryValues.maxValue), boundaryValues.minValue);
            self.value.value(thumbValue);
            e.preventDefault();
            e.stopPropagation();
        });

        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('mouseup' + eventNamespace, function () {
            self.trigger('thumb:dragend');
            self.setActive(false);
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).off('mousemove' + eventNamespace);
            __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).off('mouseup' + eventNamespace);
            $thumb.css('cursor', 'auto');
        });
    });

    $thumb.on('mouseover', function () {
        self.trigger('thumb:mouseover');
        self.setHover(true);
    });

    $thumb.on('mouseout', function () {
        self.trigger('thumb:mouseout');
        self.setHover(false);
    });

    this.on('thumb:mousestatechange', updateView);

    conf.parent.append($thumb);
    self.geometry = {
        radius: getCssValue($thumb, ['border-radius', 'border-top-left-radius'])
                || getCssValue($thumb, 'height') / 2
    };
    updateView();
}

/**
 * The marker value above the thumb.
 *
 * @param conf A JSON object, which contains the following parameters:
 *         value: The initial value which is associated to this marker,
 *         calculator: a Calculator object
 */
function Marker(conf) {
    var $marker = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_4__sliderView__["a" /* default */].marker)),
        self = this,
        isVisible = false,
        markerLeft;

    function updateView() {
        if (isVisible) {
            $marker.text(self.value.value());
            markerLeft = conf.calculator.valueToPosition(self.value.value()) - Math.floor(self.geometry.width / 2);
            $marker.css('left', markerLeft + 'px');
            $marker.css('visibility', 'visible');
        } else {
            $marker.css('visibility', 'hidden');
        }
    }

    this.value = new __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["e" /* ObservableValue */](conf.value, updateView);

    this.getElement = function () {
        return $marker;
    };

    this.setVisible = function (visible) {
        isVisible = visible;
        updateView();
    };

    conf.parent.append($marker);
    self.geometry = {
        width: getCssValue($marker, 'width')
    };
    updateView();
}

/**
 * The calculator works on a range of values. All values out of this range will be changed
 * to the nearest boundary value.
 *
 * @param conf A JSON object, which contains the following parameters:
 *         min: the minimum point of the interval,
 *         max: the maximum point of the interval,
 *         basePoint: the basePoint point of the interval,
 *         width: the displayed width of the interval,
 *         stepSize: the size of the value stepping (e.g. every fifth value can be selected),
 *         inputs: the array of the input values
 */
function Calculator(conf) {
    /**
     * @param {number} The position (px) which should be transformed to value. The zero
     *                 position is at the left endpoint of the scale.
     * @return The value associated to the position.
     */
    this.positionToValue = function (position) {
        var range = conf.max - conf.min,
            relativeValue = Math.round(position * range / conf.width),
            value = relativeValue + conf.min,
            limitedValue = Math.max(Math.min(value, conf.max), conf.min);

        return limitedValue;
    };

    /**
     * @param {number} The value which should be transformed to position (px).
     * @return The relative position (px) associated to the value. The zero
     *         position is at the left endpoint of the scale.
     */
    this.valueToPosition = function (value) {
        var limitedValue = Math.max(Math.min(value, conf.max), conf.min),
            relativeValue = limitedValue - conf.min,
            range = conf.max - conf.min,
            position = Math.round(relativeValue * conf.width / range);

        return position;
    };

    /**
     * @param {number} The value which we try to find closest valid step value for.
     * @return The closest valid step value to the value.
     */
    this.closestStepValue = function (value) {
        var closestValue = value,
            moduloValue;

        if (conf.stepSize) {
            moduloValue = (value - conf.basePoint) % conf.stepSize;
            closestValue = Math.abs(moduloValue) < conf.stepSize / 2
                    ? value - moduloValue
                    : value - moduloValue + __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["j" /* sign */](moduloValue) * conf.stepSize;
            if (closestValue > conf.max) {
                closestValue = closestValue - conf.stepSize;
            }
            if (closestValue < conf.min) {
                closestValue = closestValue + conf.stepSize;
            }
        }

        return closestValue;
    };

    /**
     * @return The boundary values for a value.
     * Notice: This is enough for one thumb, but more thumbs require a more sophisticated solution.
     */
    this.boundaryValues = function (value) {
        var maxV = conf.max,
            minV = conf.min,
            maxInputDiff,
            minInputDiff,
            maxValueDiff,
            minValueDiff,
            inputValue,
            lastInputValue,
            prevInputValueIsSame,
            i;

        for (i = 0; i < conf.inputs.length; i++) {
            inputValue = conf.inputs[i].value();
            prevInputValueIsSame = inputValue === lastInputValue;
            maxInputDiff = inputValue - value;
            minInputDiff = value - inputValue;
            maxValueDiff = maxV - value;
            minValueDiff = value - minV;
            if (0 < maxInputDiff && maxInputDiff < maxValueDiff) {
                maxV = inputValue;
            }
            if (prevInputValueIsSame || (0 < minInputDiff && minInputDiff < minValueDiff)) {
                minV = inputValue;
            }
            lastInputValue = inputValue;
        }

        return {
            maxValue: maxV,
            minValue: minV
        };
    };
}

/**
 * @param {function} Optional. The function to run after initialization.
 */
function init(callback) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-slider').each(function () {
        /* eslint-disable no-new */
        new Slider(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this));
        /* eslint-enable no-new */
    });
    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_tabControl_less__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_tabControl_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_tabControl_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__ = __webpack_require__(1);




function toggleClass(element, classNameString) {
    var classList, classIndex;

    if (!element) { return; }

    if (element.classList) {
        element.classList.toggle(classNameString);
    } else if (Array.prototype.indexOf) { // IE 9
        classList = element.className.split(' ');
        classIndex = classList.indexOf(classNameString);
        if (classIndex !== -1) {
            classList.splice(classIndex, 1);
        } else {
            classList.push(classNameString);
        }
        element.className = classList.join(' ');
    } else { // IE 8
        if (!element.className) {
            element.className = classNameString;
        } else if (element.className.indexOf(classNameString) !== -1) {
            element.className = element.className.replace(classNameString, '').replace(/\s+/gi, ' ');
        } else {
            element.className = element.className.concat(' ', classNameString);
        }
    }
}

function switchTab(newTab, id) {
    var tabControlElement = newTab.parentElement,
        previousActive = tabControlElement.querySelector('.uwr-tab-control-active'),
        previousId = null;

    if (previousActive && previousActive.querySelector('a')) {
        previousId = previousActive.querySelector('a').getAttribute('href');
        toggleClass(previousActive, 'uwr-tab-control-active');
    }

    if (previousId) {
        toggleClass(document.querySelector(previousId + '.uwr-tab-shown'), 'uwr-tab-shown');
    }

    toggleClass(document.querySelector(id), 'uwr-tab-shown');
    toggleClass(newTab, 'uwr-tab-control-active');
}

function clickHandler(event) {
    var id;

    id = this.querySelector('a') && // null check
            this.querySelector('a').getAttribute('href');

    if (id && document.querySelector(id)) {
        switchTab(this, id);
        event.preventDefault();
    }
}

function clickHandlerIE8(event) {
    var id,
        targetListItem = this.event.srcElement;

    if (targetListItem.tagName === 'A') {
        id = targetListItem.getAttribute('href');
        targetListItem = targetListItem.parentElement;
    } else {
        id = targetListItem.querySelector('a') && // null check
                targetListItem.querySelector('a').getAttribute('href');
    }

    if (id && document.querySelector(id)) {
        switchTab(targetListItem, id);
        event.returnValue = false;
    }
}

function setEventListeners(tabControlElement) {
    var tabs = tabControlElement.querySelectorAll('ul.uwr-tab-control li:not(.uwr-tab-group-right)');
    for (var i = 0, tl = tabs.length; i < tl; i++) {
        tabs[i].addEventListener('click', clickHandler);
    }
}

function setEventListenersIE8(tabControlElement) {
    var tabs = tabControlElement.querySelectorAll('ul.uwr-tab-control li');
    for (var i = 0, tl = tabs.length; i < tl; i++) {
        if (!tabs[i].className || tabs[i].className.indexOf('uwr-tab-group') === -1) {
            tabs[i].attachEvent('onclick', clickHandlerIE8);
        }
    }
}

function findActiveTab(tabControlElement, IE8) {
    var firstTabLink,
        firstTabId = null;

    if (!IE8) {
        firstTabLink = tabControlElement.querySelector('.uwr-tab-control-active > a[href^="#"]')
                    || tabControlElement.querySelector('li > a[href^="#"]');
    } else {
        firstTabLink = tabControlElement.querySelector('.uwr-tab-control-active > a[href]')
                    || tabControlElement.querySelector('li > a[href]');
    }

    if (firstTabLink) {
        firstTabId = firstTabLink.getAttribute('href');
    }

    if (firstTabId && firstTabId.match(/^#/)) {
        switchTab(firstTabLink.parentElement, firstTabId);
    }
}

function initTabControl(element) {
    if (!element.hasAttribute('data-initialized')) {
        element.setAttribute('data-initialized', '');

        if (!__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["c" /* isIe8 */]()) {
            findActiveTab(element);
            setEventListeners(element);
        } else {
            findActiveTab(element, 'IE8');
            setEventListenersIE8(element);
        }
    }
}

/**
 * Supported use cases:
 * - init();
 * - init(callback);
 * - init(selector);
 * - init(selector, callback);
 */
function init(arg1, arg2) {
    var selector,
        callback;

    if (arguments.length === 0) {
        selector = '.uwr-tab-control';
        callback = null;
    } else if (arguments.length === 1) {
        if (__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.type(arg1) === 'string') {
            selector = arg1;
            callback = null;
        } else if (__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.type(arg1) === 'function') {
            selector = '.uwr-tab-control';
            callback = arg1;
        }
    } else if (arguments.length === 2) {
        selector = arg1;
        callback = arg2;
    }

    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector).each(function (i, element) {
        if (__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["d" /* hasClass */](element, 'uwr-tab-control')) {
            initTabControl(element);
        }
    });

    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_tile_less__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_tile_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_tile_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__ = __webpack_require__(1);




/**
 * It changes the default margin (defined by the CSS) if it prevents placing the element inline.
 * @param {object} $container The jQuery object what is the container of the tile elements.
 */
function adjustMarginToWrap($container) {
    var containerWidth = $container.innerWidth(),
        currentWidth = 0;
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-tile', $container).each(function () {
        var $item = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this),
            rightMargin = 0,
            isLastItemInRow = false;
        $item.removeClass('uwr-tile-last-column');
        rightMargin = parseInt($item.css('marginRight'), 10);
        currentWidth += parseInt($item.css('marginLeft'), 10);
        currentWidth += $item.outerWidth();
        isLastItemInRow = currentWidth <= containerWidth && containerWidth < (currentWidth + rightMargin);
        if (isLastItemInRow) {
            $item.addClass('uwr-tile-last-column');
            currentWidth = 0;
        } else {
            currentWidth += rightMargin;
        }
    });
}

function initCard() {
    var $element = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
    $element.on('mousedown', function () { $element.addClass('uwr-tile-active'); });
    $element.on('mouseup', function () { $element.removeClass('uwr-tile-active'); });
}

function init(callback) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-tile-container').each(function () {
        var $container = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
        adjustMarginToWrap($container);
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).on('resize', function () {
            adjustMarginToWrap($container);
        });

    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-tile-card').each(initCard);
    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony export (immutable) */ __webpack_exports__["start"] = start;
/* harmony export (immutable) */ __webpack_exports__["cancel"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["ready"] = ready;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_timer_less__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_timer_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_timer_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__ = __webpack_require__(1);




function Spinner(domElements, imgWidth, frameNum, startTime) {
    this.updateImg = function (frame) {
        if (this.$spinner) {
            var pos = (frame - this.numberOfFrames + 1) * this.imageWidth;
            this.$spinner.css('background-position', pos + 'px');
        }
    };

    this.update = function (diff) {
        var frame = Math.floor(diff / this.factor);
        this.updateImg(frame);
    };

    this.setStartState = function () {
        this.updateImg(0);
        if (this.$spinner) {
            this.$spinner.removeClass('refresh');
        }
    };

    this.setFinishedState = function () {
        this.updateImg(this.numberOfFrames - 1);
        if (this.$spinner) {
            this.$spinner.removeAttr('style');
            this.$spinner.addClass('refresh');
        }
    };

    this.refreshDomElements = function (domElements) {
        this.$spinner = domElements.$spinner;
    };

    this.refreshDomElements(domElements);
    this.imageWidth = imgWidth;
    this.numberOfFrames = frameNum;
    this.startTimeInMillisec = startTime * 1000;
    this.factor = this.startTimeInMillisec / this.numberOfFrames;
}

function Counter(domElements, startTime) {
    this.updateNumber = function (sec) {
        if (this.$counter) {
            this.$counter.text(sec);
        }
    };

    this.update = function (diff) {
        var sec = this.startTime - Math.floor(diff / 1000);
        this.updateNumber(sec);
        if (sec <= 0) {
            this.isFinished = true;
            this.updateNumber(0);
        }
    };

    this.setStartState = function () {
        this.updateNumber(this.startTime);
    };

    this.setFinishedState = function () {
        this.updateNumber(0);
    };

    this.refreshDomElements = function (domElements) {
        this.$counter = domElements.$counter;
    };

    this.refreshDomElements(domElements);
    this.startTime = startTime;
    this.isFinished = false;
}

function Title(domElements) {
    this.setStartState = function () {
        if (this.$initialTitle) {
            this.$initialTitle.css('display', 'block');
        }
        if (this.$timeupTitle) {
            this.$timeupTitle.css('display', 'none');
        }
    };

    this.setFinishedState = function () {
        if (this.$initialTitle) {
            this.$initialTitle.css('display', 'none');
        }
        if (this.$timeupTitle) {
            this.$timeupTitle.css('display', 'block');
        }
    };

    this.refreshDomElements = function (domElements) {
        this.$initialTitle = domElements.$initialTitle;
        this.$timeupTitle = domElements.$timeupTitle;
    };

    this.refreshDomElements(domElements);
}

function CountdownTimer(titleObj, spinnerObj, counterObj) {
    this.stop = function () {
        if (this.intervalVariable) {
            clearInterval(this.intervalVariable);
            this.intervalVariable = null;
        }
        this.counterObj.isFinished = false;
    };

    this.cancel = function (domElements) {
        if (domElements) {
            this.refreshDomElements(domElements);
        }
        this.stop();
        this.callback = null;
    };

    this.setStartState = function () {
        this.spinnerObj.setStartState();
        this.counterObj.setStartState();
        this.titleObj.setStartState();
    };

    this.setFinishedState = function () {
        this.spinnerObj.setFinishedState();
        this.counterObj.setFinishedState();
        this.titleObj.setFinishedState();
    };

    this.update = function () {
        var diff = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.now() - this.startedAt;
        this.spinnerObj.update(diff);
        this.counterObj.update(diff);
        if (this.counterObj.isFinished) {
            this.stop();
            this.setFinishedState();
            __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](this.callback);
        }
    };

    this.start = function (finishHandler, domElements) {
        var instance = this;
        if (domElements) {
            this.refreshDomElements(domElements);
        }
        this.stop();
        this.setStartState();
        this.callback = finishHandler;
        this.startedAt = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.now();
        this.intervalVariable = setInterval(function () { instance.update(); }, this.interval);
    };

    this.refreshDomElements = function (domElements) {
        this.spinnerObj.refreshDomElements(domElements);
        this.counterObj.refreshDomElements(domElements);
        this.titleObj.refreshDomElements(domElements);
    };

    this.spinnerObj = spinnerObj;
    this.counterObj = counterObj;
    this.titleObj = titleObj;
    this.spinnerObj.setStartState();
    this.counterObj.setStartState();
    this.titleObj.setStartState();
    this.startedAt = 0;
    this.callback = null;
    this.intervalVariable = null;
    this.interval = 10;
}

function getTimerDomElements($timer) {
    var domElements = {
        $spinner: $timer.find('.uwr-timer-spinner'),
        $counter: $timer.find('.uwr-timer-counter'),
        $initialTitle: $timer.find('.uwr-timer-initial-title'),
        $timeupTitle: $timer.find('.uwr-timer-timeup-title')
    };
    return domElements;
}

function initTimer($timer) {
    var startTime = $timer.attr('data-start-time'),
        divIcon = '<div class="uwr-timer-spinner"><span class="uwr-timer-counter"></span></div>',
        frameNum = 100,
        imgWidth = 36,
        domElements,
        spinnerObj,
        counterObj,
        titleObj,
        timerObj;
    $timer.prepend(divIcon);
    domElements = getTimerDomElements($timer);
    spinnerObj = new Spinner(domElements, imgWidth, frameNum, startTime);
    counterObj = new Counter(domElements, startTime);
    titleObj = new Title(domElements);
    timerObj = new CountdownTimer(titleObj, spinnerObj, counterObj);
    $timer.data('timerObj', timerObj);
}

function initTimers() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-timer').each(function () {
        var $timer = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
        if ($timer.data('initialized') !== true) {
            initTimer($timer);
            $timer.data('initialized', true);
        }
    });
}

/**
 * Initializes all Timers on the page. This function like all other API functions is called asynchronously.
 * The no-arg init() is automatically called when the page is loaded.
 * Dynamically added Timers need to be initialized by explicitly calling init().
 *
 * @param callback Javascript function object that is called when init() is finished. Optional parameter.
 */
function init(callback) {
    initTimers();
    __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["b" /* invoke */](callback);
}

function startTimer($timer, handler) {
    if ($timer) {
        var timerObj = $timer.data('timerObj');
        if (timerObj) {
            timerObj.start(handler, getTimerDomElements($timer));
        }
    }
}

function cancelTimer($timer) {
    if ($timer) {
        var timerObj = $timer.data('timerObj');
        if (timerObj) {
            timerObj.cancel(getTimerDomElements($timer));
        }
    }
}

function startTimers(selector, handler) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector).each(function () {
        startTimer(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this), handler);
    });
}

function cancelTimers(selector) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(selector).each(function () {
        cancelTimer(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this));
    });
}

/**
 * Starts the countdown of the Timer.
 *
 * @param selector a CSS selector string pointing to one or more timer widgets to start.
 * @param timeUpHandler a function object that is called when the timer finishes.
 */
function start(selector, timeUpHandler) {
    startTimers(selector, timeUpHandler);
}

/**
 * Stops the countdown of the Timer.
 *
 * @param selector a CSS selector string pointing to one or more timer widgets to cancel.
 */
function cancel(selector) {
    cancelTimers(selector);
}

/**
 * DEPRECATED: Will be removed in the next MDP release. Use init(callback) instead.
 *
 * Registers a callback function to be executed when all Timers are initialized and ready
 * to use on the page. If more than one ready handler functions are added, the order of
 * execution might be different than the order of addition.
 *
 * @param callback Javascript function object
 */
function ready(callback) {
    init(callback);
}


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   4.1.1
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(96);
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === GET_THEN_ERROR) {
      reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator$1(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate(input);
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

Enumerator$1.prototype._enumerate = function (input) {
  for (var i = 0; this._state === PENDING && i < input.length; i++) {
    this._eachEntry(input[i], i);
  }
};

Enumerator$1.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$1 = c.resolve;

  if (resolve$$1 === resolve$1) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise$2) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$1) {
        return resolve$$1(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$1(entry), i);
  }
};

Enumerator$1.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator$1.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all$1(entries) {
  return new Enumerator$1(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race$1(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise$2(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise$2 ? initializePromise(this, resolver) : needsNew();
  }
}

Promise$2.all = all$1;
Promise$2.race = race$1;
Promise$2.resolve = resolve$1;
Promise$2.reject = reject$1;
Promise$2._setScheduler = setScheduler;
Promise$2._setAsap = setAsap;
Promise$2._asap = asap;

Promise$2.prototype = {
  constructor: Promise$2,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

/*global self*/
function polyfill$1() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise$2;
}

// Strange compat..
Promise$2.polyfill = polyfill$1;
Promise$2.Promise = Promise$2;

return Promise$2;

})));

//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78), __webpack_require__(19)))

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(0);

(function() {
  var $, AbstractChosen, Chosen, SelectParser, _ref,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  SelectParser = (function() {
    function SelectParser() {
      this.options_index = 0;
      this.parsed = [];
    }

    SelectParser.prototype.add_node = function(child) {
      if (child.nodeName.toUpperCase() === "OPTGROUP") {
        return this.add_group(child);
      } else {
        return this.add_option(child);
      }
    };

    SelectParser.prototype.add_group = function(group) {
      var group_position, option, _i, _len, _ref, _results;
      group_position = this.parsed.length;
      this.parsed.push({
        array_index: group_position,
        group: true,
        label: this.escapeExpression(group.label),
        title: group.title ? group.title : void 0,
        children: 0,
        disabled: group.disabled,
        classes: group.className
      });
      _ref = group.childNodes;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        _results.push(this.add_option(option, group_position, group.disabled));
      }
      return _results;
    };

    SelectParser.prototype.add_option = function(option, group_position, group_disabled) {
      if (option.nodeName.toUpperCase() === "OPTION") {
        if (option.text !== "") {
          if (group_position != null) {
            this.parsed[group_position].children += 1;
          }
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            value: option.value,
            text: option.text,
            html: option.innerHTML,
            title: option.title ? option.title : void 0,
            selected: option.selected,
            disabled: group_disabled === true ? group_disabled : option.disabled,
            group_array_index: group_position,
            group_label: group_position != null ? this.parsed[group_position].label : null,
            classes: option.className,
            style: option.style.cssText
          });
        } else {
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            empty: true
          });
        }
        return this.options_index += 1;
      }
    };

    SelectParser.prototype.escapeExpression = function(text) {
      var map, unsafe_chars;
      if ((text == null) || text === false) {
        return "";
      }
      if (!/[\&\<\>\"\'\`]/.test(text)) {
        return text;
      }
      map = {
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "`": "&#x60;"
      };
      unsafe_chars = /&(?!\w+;)|[\<\>\"\'\`]/g;
      return text.replace(unsafe_chars, function(chr) {
        return map[chr] || "&amp;";
      });
    };

    return SelectParser;

  })();

  SelectParser.select_to_array = function(select) {
    var child, parser, _i, _len, _ref;
    parser = new SelectParser();
    _ref = select.childNodes;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      child = _ref[_i];
      parser.add_node(child);
    }
    return parser.parsed;
  };

  AbstractChosen = (function() {
    function AbstractChosen(form_field, options) {
      this.form_field = form_field;
      this.options = options != null ? options : {};
      if (!AbstractChosen.browser_is_supported()) {
        return;
      }
      this.is_multiple = this.form_field.multiple;
      this.set_default_text();
      this.set_default_values();
      this.setup();
      this.set_up_html();
      this.register_observers();
      this.on_ready();
    }

    AbstractChosen.prototype.set_default_values = function() {
      var _this = this;
      this.click_test_action = function(evt) {
        return _this.test_active_click(evt);
      };
      this.activate_action = function(evt) {
        return _this.activate_field(evt);
      };
      this.active_field = false;
      this.mouse_on_container = false;
      this.results_showing = false;
      this.result_highlighted = null;
      this.allow_single_deselect = (this.options.allow_single_deselect != null) && (this.form_field.options[0] != null) && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
      this.disable_search_threshold = this.options.disable_search_threshold || 0;
      this.disable_search = this.options.disable_search || false;
      this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
      this.group_search = this.options.group_search != null ? this.options.group_search : true;
      this.search_contains = this.options.search_contains || false;
      this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
      this.max_selected_options = this.options.max_selected_options || Infinity;
      this.inherit_select_classes = this.options.inherit_select_classes || false;
      this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
      this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
      this.include_group_label_in_selected = this.options.include_group_label_in_selected || false;
      this.max_shown_results = this.options.max_shown_results || Number.POSITIVE_INFINITY;
      return this.case_sensitive_search = this.options.case_sensitive_search || false;
    };

    AbstractChosen.prototype.set_default_text = function() {
      if (this.form_field.getAttribute("data-placeholder")) {
        this.default_text = this.form_field.getAttribute("data-placeholder");
      } else if (this.is_multiple) {
        this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
      } else {
        this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
      }
      return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
    };

    AbstractChosen.prototype.choice_label = function(item) {
      if (this.include_group_label_in_selected && (item.group_label != null)) {
        return "<b class='group-name'>" + item.group_label + "</b>" + item.html;
      } else {
        return item.html;
      }
    };

    AbstractChosen.prototype.mouse_enter = function() {
      return this.mouse_on_container = true;
    };

    AbstractChosen.prototype.mouse_leave = function() {
      return this.mouse_on_container = false;
    };

    AbstractChosen.prototype.input_focus = function(evt) {
      var _this = this;
      if (this.is_multiple) {
        if (!this.active_field) {
          return setTimeout((function() {
            return _this.container_mousedown();
          }), 50);
        }
      } else {
        if (!this.active_field) {
          return this.activate_field();
        }
      }
    };

    AbstractChosen.prototype.input_blur = function(evt) {
      var _this = this;
      if (!this.mouse_on_container) {
        this.active_field = false;
        return setTimeout((function() {
          return _this.blur_test();
        }), 100);
      }
    };

    AbstractChosen.prototype.results_option_build = function(options) {
      var content, data, data_content, shown_results, _i, _len, _ref;
      content = '';
      shown_results = 0;
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        data = _ref[_i];
        data_content = '';
        if (data.group) {
          data_content = this.result_add_group(data);
        } else {
          data_content = this.result_add_option(data);
        }
        if (data_content !== '') {
          shown_results++;
          content += data_content;
        }
        if (options != null ? options.first : void 0) {
          if (data.selected && this.is_multiple) {
            this.choice_build(data);
          } else if (data.selected && !this.is_multiple) {
            this.single_set_selected_text(this.choice_label(data));
          }
        }
        if (shown_results >= this.max_shown_results) {
          break;
        }
      }
      return content;
    };

    AbstractChosen.prototype.result_add_option = function(option) {
      var classes, option_el;
      if (!option.search_match) {
        return '';
      }
      if (!this.include_option_in_results(option)) {
        return '';
      }
      classes = [];
      if (!option.disabled && !(option.selected && this.is_multiple)) {
        classes.push("active-result");
      }
      if (option.disabled && !(option.selected && this.is_multiple)) {
        classes.push("disabled-result");
      }
      if (option.selected) {
        classes.push("result-selected");
      }
      if (option.group_array_index != null) {
        classes.push("group-option");
      }
      if (option.classes !== "") {
        classes.push(option.classes);
      }
      option_el = document.createElement("li");
      option_el.className = classes.join(" ");
      option_el.style.cssText = option.style;
      option_el.setAttribute("data-option-array-index", option.array_index);
      option_el.innerHTML = option.search_text;
      if (option.title) {
        option_el.title = option.title;
      }
      return this.outerHTML(option_el);
    };

    AbstractChosen.prototype.result_add_group = function(group) {
      var classes, group_el;
      if (!(group.search_match || group.group_match)) {
        return '';
      }
      if (!(group.active_options > 0)) {
        return '';
      }
      classes = [];
      classes.push("group-result");
      if (group.classes) {
        classes.push(group.classes);
      }
      group_el = document.createElement("li");
      group_el.className = classes.join(" ");
      group_el.innerHTML = group.search_text;
      if (group.title) {
        group_el.title = group.title;
      }
      return this.outerHTML(group_el);
    };

    AbstractChosen.prototype.results_update_field = function() {
      this.set_default_text();
      if (!this.is_multiple) {
        this.results_reset_cleanup();
      }
      this.result_clear_highlight();
      this.results_build();
      if (this.results_showing) {
        return this.winnow_results();
      }
    };

    AbstractChosen.prototype.reset_single_select_options = function() {
      var result, _i, _len, _ref, _results;
      _ref = this.results_data;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        result = _ref[_i];
        if (result.selected) {
          _results.push(result.selected = false);
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    AbstractChosen.prototype.results_toggle = function() {
      if (this.results_showing) {
        return this.results_hide();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.results_search = function(evt) {
      if (this.results_showing) {
        return this.winnow_results();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.winnow_results = function() {
      var escapedSearchText, option, regex, results, results_group, searchText, startpos, text, zregex, _i, _len, _ref;
      this.no_results_clear();
      results = 0;
      searchText = this.get_search_text();
      escapedSearchText = searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
      zregex = new RegExp(escapedSearchText, 'i');
      regex = this.get_search_regex(escapedSearchText);
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        option.search_match = false;
        results_group = null;
        if (this.include_option_in_results(option)) {
          if (option.group) {
            option.group_match = false;
            option.active_options = 0;
          }
          if ((option.group_array_index != null) && this.results_data[option.group_array_index]) {
            results_group = this.results_data[option.group_array_index];
            if (results_group.active_options === 0 && results_group.search_match) {
              results += 1;
            }
            results_group.active_options += 1;
          }
          option.search_text = option.group ? option.label : option.html;
          if (!(option.group && !this.group_search)) {
            option.search_match = this.search_string_match(option.search_text, regex);
            if (option.search_match && !option.group) {
              results += 1;
            }
            if (option.search_match) {
              if (searchText.length) {
                startpos = option.search_text.search(zregex);
                text = option.search_text.substr(0, startpos + searchText.length) + '</em>' + option.search_text.substr(startpos + searchText.length);
                option.search_text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
              }
              if (results_group != null) {
                results_group.group_match = true;
              }
            } else if ((option.group_array_index != null) && this.results_data[option.group_array_index].search_match) {
              option.search_match = true;
            }
          }
        }
      }
      this.result_clear_highlight();
      if (results < 1 && searchText.length) {
        this.update_results_content("");
        return this.no_results(searchText);
      } else {
        this.update_results_content(this.results_option_build());
        return this.winnow_results_set_highlight();
      }
    };

    AbstractChosen.prototype.get_search_regex = function(escaped_search_string) {
      var regex_anchor, regex_flag;
      regex_anchor = this.search_contains ? "" : "^";
      regex_flag = this.case_sensitive_search ? "" : "i";
      return new RegExp(regex_anchor + escaped_search_string, regex_flag);
    };

    AbstractChosen.prototype.search_string_match = function(search_string, regex) {
      var part, parts, _i, _len;
      if (regex.test(search_string)) {
        return true;
      } else if (this.enable_split_word_search && (search_string.indexOf(" ") >= 0 || search_string.indexOf("[") === 0)) {
        parts = search_string.replace(/\[|\]/g, "").split(" ");
        if (parts.length) {
          for (_i = 0, _len = parts.length; _i < _len; _i++) {
            part = parts[_i];
            if (regex.test(part)) {
              return true;
            }
          }
        }
      }
    };

    AbstractChosen.prototype.choices_count = function() {
      var option, _i, _len, _ref;
      if (this.selected_option_count != null) {
        return this.selected_option_count;
      }
      this.selected_option_count = 0;
      _ref = this.form_field.options;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        if (option.selected) {
          this.selected_option_count += 1;
        }
      }
      return this.selected_option_count;
    };

    AbstractChosen.prototype.choices_click = function(evt) {
      evt.preventDefault();
      if (!(this.results_showing || this.is_disabled)) {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.keyup_checker = function(evt) {
      var stroke, _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      switch (stroke) {
        case 8:
          if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
            return this.keydown_backstroke();
          } else if (!this.pending_backstroke) {
            this.result_clear_highlight();
            return this.results_search();
          }
          break;
        case 13:
          evt.preventDefault();
          if (this.results_showing) {
            return this.result_select(evt);
          }
          break;
        case 27:
          if (this.results_showing) {
            this.results_hide();
          }
          return true;
        case 9:
        case 38:
        case 40:
        case 16:
        case 91:
        case 17:
        case 18:
          break;
        default:
          return this.results_search();
      }
    };

    AbstractChosen.prototype.clipboard_event_checker = function(evt) {
      var _this = this;
      return setTimeout((function() {
        return _this.results_search();
      }), 50);
    };

    AbstractChosen.prototype.container_width = function() {
      if (this.options.width != null) {
        return this.options.width;
      } else {
        return "" + this.form_field.offsetWidth + "px";
      }
    };

    AbstractChosen.prototype.include_option_in_results = function(option) {
      if (this.is_multiple && (!this.display_selected_options && option.selected)) {
        return false;
      }
      if (!this.display_disabled_options && option.disabled) {
        return false;
      }
      if (option.empty) {
        return false;
      }
      return true;
    };

    AbstractChosen.prototype.search_results_touchstart = function(evt) {
      this.touch_started = true;
      return this.search_results_mouseover(evt);
    };

    AbstractChosen.prototype.search_results_touchmove = function(evt) {
      this.touch_started = false;
      return this.search_results_mouseout(evt);
    };

    AbstractChosen.prototype.search_results_touchend = function(evt) {
      if (this.touch_started) {
        return this.search_results_mouseup(evt);
      }
    };

    AbstractChosen.prototype.outerHTML = function(element) {
      var tmp;
      if (element.outerHTML) {
        return element.outerHTML;
      }
      tmp = document.createElement("div");
      tmp.appendChild(element);
      return tmp.innerHTML;
    };

    AbstractChosen.browser_is_supported = function() {
      if ("Microsoft Internet Explorer" === window.navigator.appName) {
        return document.documentMode >= 8;
      }
      if (/iP(od|hone)/i.test(window.navigator.userAgent) || /IEMobile/i.test(window.navigator.userAgent) || /Windows Phone/i.test(window.navigator.userAgent) || /BlackBerry/i.test(window.navigator.userAgent) || /BB10/i.test(window.navigator.userAgent) || /Android.*Mobile/i.test(window.navigator.userAgent)) {
        return false;
      }
      return true;
    };

    AbstractChosen.default_multiple_text = "Select Some Options";

    AbstractChosen.default_single_text = "Select an Option";

    AbstractChosen.default_no_result_text = "No results match";

    return AbstractChosen;

  })();

  $ = jQuery;

  $.fn.extend({
    chosen: function(options) {
      if (!AbstractChosen.browser_is_supported()) {
        return this;
      }
      return this.each(function(input_field) {
        var $this, chosen;
        $this = $(this);
        chosen = $this.data('chosen');
        if (options === 'destroy') {
          if (chosen instanceof Chosen) {
            chosen.destroy();
          }
          return;
        }
        if (!(chosen instanceof Chosen)) {
          $this.data('chosen', new Chosen(this, options));
        }
      });
    }
  });

  Chosen = (function(_super) {
    __extends(Chosen, _super);

    function Chosen() {
      _ref = Chosen.__super__.constructor.apply(this, arguments);
      return _ref;
    }

    Chosen.prototype.setup = function() {
      this.form_field_jq = $(this.form_field);
      this.current_selectedIndex = this.form_field.selectedIndex;
      return this.is_rtl = this.form_field_jq.hasClass("chosen-rtl");
    };

    Chosen.prototype.set_up_html = function() {
      var container_classes, container_props;
      container_classes = ["chosen-container"];
      container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));
      if (this.inherit_select_classes && this.form_field.className) {
        container_classes.push(this.form_field.className);
      }
      if (this.is_rtl) {
        container_classes.push("chosen-rtl");
      }
      container_props = {
        'class': container_classes.join(' '),
        'style': "width: " + (this.container_width()) + ";",
        'title': this.form_field.title
      };
      if (this.form_field.id.length) {
        container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + "_chosen";
      }
      this.container = $("<div />", container_props);
      if (this.is_multiple) {
        this.container.html('<ul class="chosen-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chosen-drop"><ul class="chosen-results"></ul></div>');
      } else {
        this.container.html('<a class="chosen-single chosen-default"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chosen-drop"><div class="chosen-search"><input type="text" autocomplete="off" /></div><ul class="chosen-results"></ul></div>');
      }
      this.form_field_jq.hide().after(this.container);
      this.dropdown = this.container.find('div.chosen-drop').first();
      this.search_field = this.container.find('input').first();
      this.search_results = this.container.find('ul.chosen-results').first();
      this.search_field_scale();
      this.search_no_results = this.container.find('li.no-results').first();
      if (this.is_multiple) {
        this.search_choices = this.container.find('ul.chosen-choices').first();
        this.search_container = this.container.find('li.search-field').first();
      } else {
        this.search_container = this.container.find('div.chosen-search').first();
        this.selected_item = this.container.find('.chosen-single').first();
      }
      this.results_build();
      this.set_tab_index();
      return this.set_label_behavior();
    };

    Chosen.prototype.on_ready = function() {
      return this.form_field_jq.trigger("chosen:ready", {
        chosen: this
      });
    };

    Chosen.prototype.register_observers = function() {
      var _this = this;
      this.container.bind('touchstart.chosen', function(evt) {
        _this.container_mousedown(evt);
        return evt.preventDefault();
      });
      this.container.bind('touchend.chosen', function(evt) {
        _this.container_mouseup(evt);
        return evt.preventDefault();
      });
      this.container.bind('mousedown.chosen', function(evt) {
        _this.container_mousedown(evt);
      });
      this.container.bind('mouseup.chosen', function(evt) {
        _this.container_mouseup(evt);
      });
      this.container.bind('mouseenter.chosen', function(evt) {
        _this.mouse_enter(evt);
      });
      this.container.bind('mouseleave.chosen', function(evt) {
        _this.mouse_leave(evt);
      });
      this.search_results.bind('mouseup.chosen', function(evt) {
        _this.search_results_mouseup(evt);
      });
      this.search_results.bind('mouseover.chosen', function(evt) {
        _this.search_results_mouseover(evt);
      });
      this.search_results.bind('mouseout.chosen', function(evt) {
        _this.search_results_mouseout(evt);
      });
      this.search_results.bind('mousewheel.chosen DOMMouseScroll.chosen', function(evt) {
        _this.search_results_mousewheel(evt);
      });
      this.search_results.bind('touchstart.chosen', function(evt) {
        _this.search_results_touchstart(evt);
      });
      this.search_results.bind('touchmove.chosen', function(evt) {
        _this.search_results_touchmove(evt);
      });
      this.search_results.bind('touchend.chosen', function(evt) {
        _this.search_results_touchend(evt);
      });
      this.form_field_jq.bind("chosen:updated.chosen", function(evt) {
        _this.results_update_field(evt);
      });
      this.form_field_jq.bind("chosen:activate.chosen", function(evt) {
        _this.activate_field(evt);
      });
      this.form_field_jq.bind("chosen:open.chosen", function(evt) {
        _this.container_mousedown(evt);
      });
      this.form_field_jq.bind("chosen:close.chosen", function(evt) {
        _this.input_blur(evt);
      });
      this.search_field.bind('blur.chosen', function(evt) {
        _this.input_blur(evt);
      });
      this.search_field.bind('keyup.chosen', function(evt) {
        _this.keyup_checker(evt);
      });
      this.search_field.bind('keydown.chosen', function(evt) {
        _this.keydown_checker(evt);
      });
      this.search_field.bind('focus.chosen', function(evt) {
        _this.input_focus(evt);
      });
      this.search_field.bind('cut.chosen', function(evt) {
        _this.clipboard_event_checker(evt);
      });
      this.search_field.bind('paste.chosen', function(evt) {
        _this.clipboard_event_checker(evt);
      });
      if (this.is_multiple) {
        return this.search_choices.bind('click.chosen', function(evt) {
          _this.choices_click(evt);
        });
      } else {
        return this.container.bind('click.chosen', function(evt) {
          evt.preventDefault();
        });
      }
    };

    Chosen.prototype.destroy = function() {
      $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
      if (this.search_field[0].tabIndex) {
        this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
      }
      this.container.remove();
      this.form_field_jq.removeData('chosen');
      return this.form_field_jq.show();
    };

    Chosen.prototype.search_field_disabled = function() {
      this.is_disabled = this.form_field_jq[0].disabled;
      if (this.is_disabled) {
        this.container.addClass('chosen-disabled');
        this.search_field[0].disabled = true;
        if (!this.is_multiple) {
          this.selected_item.unbind("focus.chosen", this.activate_action);
        }
        return this.close_field();
      } else {
        this.container.removeClass('chosen-disabled');
        this.search_field[0].disabled = false;
        if (!this.is_multiple) {
          return this.selected_item.bind("focus.chosen", this.activate_action);
        }
      }
    };

    Chosen.prototype.container_mousedown = function(evt) {
      if (!this.is_disabled) {
        if (evt && evt.type === "mousedown" && !this.results_showing) {
          evt.preventDefault();
        }
        if (!((evt != null) && ($(evt.target)).hasClass("search-choice-close"))) {
          if (!this.active_field) {
            if (this.is_multiple) {
              this.search_field.val("");
            }
            $(this.container[0].ownerDocument).bind('click.chosen', this.click_test_action);
            this.results_show();
          } else if (!this.is_multiple && evt && (($(evt.target)[0] === this.selected_item[0]) || $(evt.target).parents("a.chosen-single").length)) {
            evt.preventDefault();
            this.results_toggle();
          }
          return this.activate_field();
        }
      }
    };

    Chosen.prototype.container_mouseup = function(evt) {
      if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
        return this.results_reset(evt);
      }
    };

    Chosen.prototype.search_results_mousewheel = function(evt) {
      var delta;
      if (evt.originalEvent) {
        delta = evt.originalEvent.deltaY || -evt.originalEvent.wheelDelta || evt.originalEvent.detail;
      }
      if (delta != null) {
        evt.preventDefault();
        if (evt.type === 'DOMMouseScroll') {
          delta = delta * 40;
        }
        return this.search_results.scrollTop(delta + this.search_results.scrollTop());
      }
    };

    Chosen.prototype.blur_test = function(evt) {
      if (!this.active_field && this.container.hasClass("chosen-container-active")) {
        return this.close_field();
      }
    };

    Chosen.prototype.close_field = function() {
      $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
      this.active_field = false;
      this.results_hide();
      this.container.removeClass("chosen-container-active");
      this.clear_backstroke();
      this.show_search_field_default();
      return this.search_field_scale();
    };

    Chosen.prototype.activate_field = function() {
      this.container.addClass("chosen-container-active");
      this.active_field = true;
      this.search_field.val(this.search_field.val());
      return this.search_field.focus();
    };

    Chosen.prototype.test_active_click = function(evt) {
      var active_container;
      active_container = $(evt.target).closest('.chosen-container');
      if (active_container.length && this.container[0] === active_container[0]) {
        return this.active_field = true;
      } else {
        return this.close_field();
      }
    };

    Chosen.prototype.results_build = function() {
      this.parsing = true;
      this.selected_option_count = null;
      this.results_data = SelectParser.select_to_array(this.form_field);
      if (this.is_multiple) {
        this.search_choices.find("li.search-choice").remove();
      } else if (!this.is_multiple) {
        this.single_set_selected_text();
        if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
          this.search_field[0].readOnly = true;
          this.container.addClass("chosen-container-single-nosearch");
        } else {
          this.search_field[0].readOnly = false;
          this.container.removeClass("chosen-container-single-nosearch");
        }
      }
      this.update_results_content(this.results_option_build({
        first: true
      }));
      this.search_field_disabled();
      this.show_search_field_default();
      this.search_field_scale();
      return this.parsing = false;
    };

    Chosen.prototype.result_do_highlight = function(el) {
      var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
      if (el.length) {
        this.result_clear_highlight();
        this.result_highlight = el;
        this.result_highlight.addClass("highlighted");
        maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
        visible_top = this.search_results.scrollTop();
        visible_bottom = maxHeight + visible_top;
        high_top = this.result_highlight.position().top + this.search_results.scrollTop();
        high_bottom = high_top + this.result_highlight.outerHeight();
        if (high_bottom >= visible_bottom) {
          return this.search_results.scrollTop((high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0);
        } else if (high_top < visible_top) {
          return this.search_results.scrollTop(high_top);
        }
      }
    };

    Chosen.prototype.result_clear_highlight = function() {
      if (this.result_highlight) {
        this.result_highlight.removeClass("highlighted");
      }
      return this.result_highlight = null;
    };

    Chosen.prototype.results_show = function() {
      if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
        this.form_field_jq.trigger("chosen:maxselected", {
          chosen: this
        });
        return false;
      }
      this.container.addClass("chosen-with-drop");
      this.results_showing = true;
      this.search_field.focus();
      this.search_field.val(this.search_field.val());
      this.winnow_results();
      return this.form_field_jq.trigger("chosen:showing_dropdown", {
        chosen: this
      });
    };

    Chosen.prototype.update_results_content = function(content) {
      return this.search_results.html(content);
    };

    Chosen.prototype.results_hide = function() {
      if (this.results_showing) {
        this.result_clear_highlight();
        this.container.removeClass("chosen-with-drop");
        this.form_field_jq.trigger("chosen:hiding_dropdown", {
          chosen: this
        });
      }
      return this.results_showing = false;
    };

    Chosen.prototype.set_tab_index = function(el) {
      var ti;
      if (this.form_field.tabIndex) {
        ti = this.form_field.tabIndex;
        this.form_field.tabIndex = -1;
        return this.search_field[0].tabIndex = ti;
      }
    };

    Chosen.prototype.set_label_behavior = function() {
      var _this = this;
      this.form_field_label = this.form_field_jq.parents("label");
      if (!this.form_field_label.length && this.form_field.id.length) {
        this.form_field_label = $("label[for='" + this.form_field.id + "']");
      }
      if (this.form_field_label.length > 0) {
        return this.form_field_label.bind('click.chosen', function(evt) {
          if (_this.is_multiple) {
            return _this.container_mousedown(evt);
          } else {
            return _this.activate_field();
          }
        });
      }
    };

    Chosen.prototype.show_search_field_default = function() {
      if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
        this.search_field.val(this.default_text);
        return this.search_field.addClass("default");
      } else {
        this.search_field.val("");
        return this.search_field.removeClass("default");
      }
    };

    Chosen.prototype.search_results_mouseup = function(evt) {
      var target;
      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
      if (target.length) {
        this.result_highlight = target;
        this.result_select(evt);
        return this.search_field.focus();
      }
    };

    Chosen.prototype.search_results_mouseover = function(evt) {
      var target;
      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
      if (target) {
        return this.result_do_highlight(target);
      }
    };

    Chosen.prototype.search_results_mouseout = function(evt) {
      if ($(evt.target).hasClass("active-result" || $(evt.target).parents('.active-result').first())) {
        return this.result_clear_highlight();
      }
    };

    Chosen.prototype.choice_build = function(item) {
      var choice, close_link,
        _this = this;
      choice = $('<li />', {
        "class": "search-choice"
      }).html("<span>" + (this.choice_label(item)) + "</span>");
      if (item.disabled) {
        choice.addClass('search-choice-disabled');
      } else {
        close_link = $('<a />', {
          "class": 'search-choice-close',
          'data-option-array-index': item.array_index
        });
        close_link.bind('click.chosen', function(evt) {
          return _this.choice_destroy_link_click(evt);
        });
        choice.append(close_link);
      }
      return this.search_container.before(choice);
    };

    Chosen.prototype.choice_destroy_link_click = function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (!this.is_disabled) {
        return this.choice_destroy($(evt.target));
      }
    };

    Chosen.prototype.choice_destroy = function(link) {
      if (this.result_deselect(link[0].getAttribute("data-option-array-index"))) {
        this.show_search_field_default();
        if (this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1) {
          this.results_hide();
        }
        link.parents('li').first().remove();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.results_reset = function() {
      this.reset_single_select_options();
      this.form_field.options[0].selected = true;
      this.single_set_selected_text();
      this.show_search_field_default();
      this.results_reset_cleanup();
      this.form_field_jq.trigger("change");
      if (this.active_field) {
        return this.results_hide();
      }
    };

    Chosen.prototype.results_reset_cleanup = function() {
      this.current_selectedIndex = this.form_field.selectedIndex;
      return this.selected_item.find("abbr").remove();
    };

    Chosen.prototype.result_select = function(evt) {
      var high, item;
      if (this.result_highlight) {
        high = this.result_highlight;
        this.result_clear_highlight();
        if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
          this.form_field_jq.trigger("chosen:maxselected", {
            chosen: this
          });
          return false;
        }
        if (this.is_multiple) {
          high.removeClass("active-result");
        } else {
          this.reset_single_select_options();
        }
        high.addClass("result-selected");
        item = this.results_data[high[0].getAttribute("data-option-array-index")];
        item.selected = true;
        this.form_field.options[item.options_index].selected = true;
        this.selected_option_count = null;
        if (this.is_multiple) {
          this.choice_build(item);
        } else {
          this.single_set_selected_text(this.choice_label(item));
        }
        if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
          this.results_hide();
        }
        this.show_search_field_default();
        if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
          this.form_field_jq.trigger("change", {
            'selected': this.form_field.options[item.options_index].value
          });
        }
        this.current_selectedIndex = this.form_field.selectedIndex;
        evt.preventDefault();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.single_set_selected_text = function(text) {
      if (text == null) {
        text = this.default_text;
      }
      if (text === this.default_text) {
        this.selected_item.addClass("chosen-default");
      } else {
        this.single_deselect_control_build();
        this.selected_item.removeClass("chosen-default");
      }
      return this.selected_item.find("span").html(text);
    };

    Chosen.prototype.result_deselect = function(pos) {
      var result_data;
      result_data = this.results_data[pos];
      if (!this.form_field.options[result_data.options_index].disabled) {
        result_data.selected = false;
        this.form_field.options[result_data.options_index].selected = false;
        this.selected_option_count = null;
        this.result_clear_highlight();
        if (this.results_showing) {
          this.winnow_results();
        }
        this.form_field_jq.trigger("change", {
          deselected: this.form_field.options[result_data.options_index].value
        });
        this.search_field_scale();
        return true;
      } else {
        return false;
      }
    };

    Chosen.prototype.single_deselect_control_build = function() {
      if (!this.allow_single_deselect) {
        return;
      }
      if (!this.selected_item.find("abbr").length) {
        this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
      }
      return this.selected_item.addClass("chosen-single-with-deselect");
    };

    Chosen.prototype.get_search_text = function() {
      return $('<div/>').text($.trim(this.search_field.val())).html();
    };

    Chosen.prototype.winnow_results_set_highlight = function() {
      var do_high, selected_results;
      selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
      do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
      if (do_high != null) {
        return this.result_do_highlight(do_high);
      }
    };

    Chosen.prototype.no_results = function(terms) {
      var no_results_html;
      no_results_html = $('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>');
      no_results_html.find("span").first().html(terms);
      this.search_results.append(no_results_html);
      return this.form_field_jq.trigger("chosen:no_results", {
        chosen: this
      });
    };

    Chosen.prototype.no_results_clear = function() {
      return this.search_results.find(".no-results").remove();
    };

    Chosen.prototype.keydown_arrow = function() {
      var next_sib;
      if (this.results_showing && this.result_highlight) {
        next_sib = this.result_highlight.nextAll("li.active-result").first();
        if (next_sib) {
          return this.result_do_highlight(next_sib);
        }
      } else {
        return this.results_show();
      }
    };

    Chosen.prototype.keyup_arrow = function() {
      var prev_sibs;
      if (!this.results_showing && !this.is_multiple) {
        return this.results_show();
      } else if (this.result_highlight) {
        prev_sibs = this.result_highlight.prevAll("li.active-result");
        if (prev_sibs.length) {
          return this.result_do_highlight(prev_sibs.first());
        } else {
          if (this.choices_count() > 0) {
            this.results_hide();
          }
          return this.result_clear_highlight();
        }
      }
    };

    Chosen.prototype.keydown_backstroke = function() {
      var next_available_destroy;
      if (this.pending_backstroke) {
        this.choice_destroy(this.pending_backstroke.find("a").first());
        return this.clear_backstroke();
      } else {
        next_available_destroy = this.search_container.siblings("li.search-choice").last();
        if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
          this.pending_backstroke = next_available_destroy;
          if (this.single_backstroke_delete) {
            return this.keydown_backstroke();
          } else {
            return this.pending_backstroke.addClass("search-choice-focus");
          }
        }
      }
    };

    Chosen.prototype.clear_backstroke = function() {
      if (this.pending_backstroke) {
        this.pending_backstroke.removeClass("search-choice-focus");
      }
      return this.pending_backstroke = null;
    };

    Chosen.prototype.keydown_checker = function(evt) {
      var stroke, _ref1;
      stroke = (_ref1 = evt.which) != null ? _ref1 : evt.keyCode;
      this.search_field_scale();
      if (stroke !== 8 && this.pending_backstroke) {
        this.clear_backstroke();
      }
      switch (stroke) {
        case 8:
          this.backstroke_length = this.search_field.val().length;
          break;
        case 9:
          if (this.results_showing && !this.is_multiple) {
            this.result_select(evt);
          }
          this.mouse_on_container = false;
          break;
        case 13:
          if (this.results_showing) {
            evt.preventDefault();
          }
          break;
        case 32:
          if (this.disable_search) {
            evt.preventDefault();
          }
          break;
        case 38:
          evt.preventDefault();
          this.keyup_arrow();
          break;
        case 40:
          evt.preventDefault();
          this.keydown_arrow();
          break;
      }
    };

    Chosen.prototype.search_field_scale = function() {
      var div, f_width, h, style, style_block, styles, w, _i, _len;
      if (this.is_multiple) {
        h = 0;
        w = 0;
        style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
        styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
        for (_i = 0, _len = styles.length; _i < _len; _i++) {
          style = styles[_i];
          style_block += style + ":" + this.search_field.css(style) + ";";
        }
        div = $('<div />', {
          'style': style_block
        });
        div.text(this.search_field.val());
        $('body').append(div);
        w = div.width() + 25;
        div.remove();
        f_width = this.container.outerWidth();
        if (w > f_width - 10) {
          w = f_width - 10;
        }
        return this.search_field.css({
          'width': w + 'px'
        });
      }
    };

    return Chosen;

  })(AbstractChosen);

}).call(this);



/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint max-len: [error, 150] */
/* harmony default export */ __webpack_exports__["a"] = ({
    cookie: {
        locale: 'uwrlocale'
    },
    i18n: {
        en: {
            datepicker: {
                done: 'Done',
                legendText: 'Bank holiday',
                months: 'January,February,March,April,May,June,July,August,September,October,November,December',
                monthsShort: 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec',
                selectMonth: 'Select month',
                today: 'Today',
                todayAbbrev: 'Today',
                weekdaysShort: 'M,T,W,T,F,S,S'
            }
        },
        de: {
            datepicker: {
                done: 'Fertig',
                legendText: 'Bankfeiertag',
                months: 'Januar,Februar,M\xe4rz,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember',
                monthsShort: 'Jan,Feb,Mrz,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez',
                selectMonth: 'Monat ausw\xe4hlen',
                today: 'Heute',
                todayAbbrev: 'Heute',
                weekdaysShort: 'M,D,M,D,F,S,S'
            }
        },
        fr: {
            datepicker: {
                done: 'OK',
                legendText: 'Jour f\xe9ri\xe9',
                months: 'Janvier,F\xe9vrier,Mars,Avril,Mai,Juin,Juillet,Ao\xfbt,Septembre,Octobre,Novembre,D\xe9cembre',
                monthsShort: 'Janv,F\xe9vr,Mars,Avr,Mai,Juin,Juil,Ao\xfbt,Sept,Oct,Nov,D\xe9c',
                selectMonth: 'S\xe9lectionner un mois',
                today: 'Aujourd\'hui',
                todayAbbrev: 'auj.',
                weekdaysShort: 'L,M,M,J,V,S,D'
            }
        },
        it: {
            datepicker: {
                done: 'Fine',
                legendText: 'Giorno festivo',
                months: 'Gennaio,Febbraio,Marzo,Aprile,Maggio,Giugno,Luglio,Agosto,Settembre,Ottobre,Novembre,Dicembre',
                monthsShort: 'Gen,Feb,Mar,Apr,Mag,Giu,Lug,Ago,Set,Ott,Nov,Dic',
                selectMonth: 'Selezionare mese',
                today: 'Oggi',
                todayAbbrev: 'Oggi',
                weekdaysShort: 'L,M,M,G,V,S,D'
            }
        }
    }
});


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ready", function() { return ready; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "util", function() { return util; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "advanceddropdown", function() { return advanceddropdown; });
/* harmony export (immutable) */ __webpack_exports__["highcharts"] = highcharts;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatter", function() { return formatter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "datepicker", function() { return datepicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultbutton", function() { return defaultbutton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dropdown", function() { return dropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "input", function() { return input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "localnav", function() { return localnav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "messagebox", function() { return messagebox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modaldialog", function() { return modaldialog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "overlay", function() { return overlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "procnav", function() { return procnav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "segmentedcontrol", function() { return segmentedcontrol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shifterbox", function() { return shifterbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "singlecheckbox", function() { return singlecheckbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "slider", function() { return slider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tabcontrol", function() { return tabcontrol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tile", function() { return tile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timer", function() { return timer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tooltip", function() { return tooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_Common_js_common__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_AdvancedDropdown_js_advancedDropdown__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets_Dropdown_js_dropdown__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__widgets_ModalDialog_js_modalDialog__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__widgets_Tooltip_js_tooltip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__widgets_Button_js_button__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__widgets_ButtonContainer_js_buttonContainer__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__widgets_DefaultButton_js_defaultButton__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__widgets_Link_js_link__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__widgets_SegmentedControl_js_segmentedControl__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__widgets_Tile_js_tile__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__widgets_Timer_js_timer__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__widgets_LoadingMessage_js_loadingMessage__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__widgets_LocalNavigation_js_localNavigation__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__widgets_SingleCheckbox_js_singleCheckbox__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__widgets_DatePicker_js_datePicker__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__widgets_ShifterBox_js_shifterBox__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__widgets_Slider_js_slider__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__widgets_Input_js_input__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__widgets_Common_js_formatter_dateFormatter__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__widgets_Common_js_formatter_numberFormatter__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__widgets_MessageBox_js_messageBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__widgets_Overlay_js_overlay__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__widgets_RadioButton_js_radioButton__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__widgets_Checkbox_js_checkbox__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__widgets_TabControl_js_tabControl__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__widgets_ProcessNavigation_js_processNavigation__ = __webpack_require__(36);
































// Set webpack publicPath on the fly. This is not a hack!
// This is the officially documented way. See: https://webpack.js.org/guides/public-path/#set-value-on-the-fly
/* eslint-disable */
__webpack_require__.p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* getUwrResourcePath */])() + '/';
/* eslint-enable */

var version = __WEBPACK_IMPORTED_MODULE_2__core__["a" /* version */];
var config = __WEBPACK_IMPORTED_MODULE_2__core__["b" /* config */];

config.require = {
    baseUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* getUwrResourcePath */])(),
    paths: {
        'uwr/highcharts/mapdata/custom/world-lowres': 'external/highcharts-4.2.3/mapdata/custom/world-lowres.amd',
        'uwr/highcharts/mapdata/custom/world-highres': 'external/highcharts-4.2.3/mapdata/custom/world-highres.amd',
        'uwr/highcharts/mapdata/custom/world-custom': 'shared/mapdata/custom/world-custom.amd'
    }
};

/**
 * Registers a global widget onready handler that will be invoked if all widgets got initialized on the page.
 * If they are not initialized yet then the execution of all the already registered handlers will be deferred
 * till the initialization is finished.
 */
function init(callback) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(function () {
        __WEBPACK_IMPORTED_MODULE_5__widgets_AdvancedDropdown_js_advancedDropdown__["init"]();
        __WEBPACK_IMPORTED_MODULE_19__widgets_DatePicker_js_datePicker__["init"]();
        __WEBPACK_IMPORTED_MODULE_11__widgets_DefaultButton_js_defaultButton__["init"]();
        __WEBPACK_IMPORTED_MODULE_6__widgets_Dropdown_js_dropdown__["init"]();
        __WEBPACK_IMPORTED_MODULE_22__widgets_Input_js_input__["init"]();
        __WEBPACK_IMPORTED_MODULE_17__widgets_LocalNavigation_js_localNavigation__["init"]();
        __WEBPACK_IMPORTED_MODULE_25__widgets_MessageBox_js_messageBox__["init"]();
        __WEBPACK_IMPORTED_MODULE_7__widgets_ModalDialog_js_modalDialog__["init"]();
        __WEBPACK_IMPORTED_MODULE_26__widgets_Overlay_js_overlay__["init"]();
        __WEBPACK_IMPORTED_MODULE_30__widgets_ProcessNavigation_js_processNavigation__["init"]();
        __WEBPACK_IMPORTED_MODULE_13__widgets_SegmentedControl_js_segmentedControl__["init"]();
        __WEBPACK_IMPORTED_MODULE_20__widgets_ShifterBox_js_shifterBox__["init"]();
        __WEBPACK_IMPORTED_MODULE_18__widgets_SingleCheckbox_js_singleCheckbox__["init"]();
        __WEBPACK_IMPORTED_MODULE_21__widgets_Slider_js_slider__["init"]();
        __WEBPACK_IMPORTED_MODULE_29__widgets_TabControl_js_tabControl__["init"]();
        __WEBPACK_IMPORTED_MODULE_14__widgets_Tile_js_tile__["init"]();
        __WEBPACK_IMPORTED_MODULE_15__widgets_Timer_js_timer__["init"]();
        __WEBPACK_IMPORTED_MODULE_8__widgets_Tooltip_js_tooltip__["init"]();
        if (typeof callback === 'function') {
            callback();
        }
    });
}
var ready = init;

function mainInit() {
    var initType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core__["b" /* config */])('init');

    initType = typeof initType !== 'undefined' ? initType : 'auto';

    if (initType === 'auto') {
        init();
    }
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core__["c" /* setRuntimeConfig */])();
__WEBPACK_IMPORTED_MODULE_1_jquery___default()(function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core__["d" /* setDefaultConfig */])();

    // Prepare Modal Dialogs' contents then init all widgets.
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["b" /* retrieve */])('uwr.modaldialog') && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["b" /* retrieve */])('uwr._runtime.modalDialog.prepared')) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["b" /* retrieve */])('uwr.modaldialog').prepare(mainInit);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* assign */])('uwr._runtime.modalDialog.prepared', true);
    } else {
        mainInit();
    }
});


function buildApi(widget, functions, target) {
    target = target || {};
    return functions.reduce(function (api, functionName) {
        api[functionName] = widget[functionName];
        return api;
    }, target);
}

/**
 * Calls the parameter function with one argument, the jQuery object.
 */
function jquery(cb) {
    if (typeof cb === 'function') {
        cb(__WEBPACK_IMPORTED_MODULE_1_jquery___default.a);
    }
}
var util = {
    jquery: jquery
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* assign */])('$uwr', __WEBPACK_IMPORTED_MODULE_1_jquery___default.a);

if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core__["b" /* config */])('jquery') === 'public') {
    // $uwr is available here only in the standalone build (which means a synchronous UW4)!
    window.$ = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a;
    window.jQuery = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a;
}

var advanceddropdown = buildApi(__WEBPACK_IMPORTED_MODULE_5__widgets_AdvancedDropdown_js_advancedDropdown__, ['init', 'setValue', 'ready', 'enable', 'disable', 'reset']);

/**
 * Calls the parameter function with two arguments, the Highcharts object and UWR's jQuery. Highcharts is
 * loaded on demand using webpack Code Splitting - Async feature.
 * See https://webpack.js.org/guides/code-splitting-async/
 */
function highcharts(cb) {
    __webpack_require__.e/* import() */("highcharts").then(__webpack_require__.bind(null, 82)).then(function (Highcharts) {
        window.Highcharts = Highcharts.default;

        if (typeof cb === 'function') {
            cb(Highcharts.default, __WEBPACK_IMPORTED_MODULE_1_jquery___default.a);
        }
    });
}

var formatter = {
    date: { format: __WEBPACK_IMPORTED_MODULE_23__widgets_Common_js_formatter_dateFormatter__["a" /* default */] },
    number: { format: __WEBPACK_IMPORTED_MODULE_24__widgets_Common_js_formatter_numberFormatter__["a" /* default */] }
};
var datepicker = buildApi(__WEBPACK_IMPORTED_MODULE_19__widgets_DatePicker_js_datePicker__, ['init']);
var defaultbutton = buildApi(__WEBPACK_IMPORTED_MODULE_11__widgets_DefaultButton_js_defaultButton__, ['init']);
var dropdown = buildApi(__WEBPACK_IMPORTED_MODULE_6__widgets_Dropdown_js_dropdown__, ['init']);
var input = buildApi(__WEBPACK_IMPORTED_MODULE_22__widgets_Input_js_input__, ['init', 'message']);
var localnav = buildApi(__WEBPACK_IMPORTED_MODULE_17__widgets_LocalNavigation_js_localNavigation__, ['deselect', 'disable', 'enable', 'hide', 'init', 'select', 'show']);
var messagebox = buildApi(__WEBPACK_IMPORTED_MODULE_25__widgets_MessageBox_js_messageBox__, ['init']);
var modaldialog = buildApi(__WEBPACK_IMPORTED_MODULE_7__widgets_ModalDialog_js_modalDialog__, ['init', 'open', 'close', 'invoke', 'prepare']);
var overlay = buildApi(__WEBPACK_IMPORTED_MODULE_26__widgets_Overlay_js_overlay__, ['init', 'hide', 'show'], __WEBPACK_IMPORTED_MODULE_26__widgets_Overlay_js_overlay__["default"]);
var procnav = buildApi(__WEBPACK_IMPORTED_MODULE_30__widgets_ProcessNavigation_js_processNavigation__, ['init', 'active', 'complete', 'next', 'back']);
var segmentedcontrol = buildApi(__WEBPACK_IMPORTED_MODULE_13__widgets_SegmentedControl_js_segmentedControl__, ['init', 'toggle']);
var shifterbox = buildApi(__WEBPACK_IMPORTED_MODULE_20__widgets_ShifterBox_js_shifterBox__, ['init', 'getState']);
var singlecheckbox = buildApi(__WEBPACK_IMPORTED_MODULE_18__widgets_SingleCheckbox_js_singleCheckbox__, ['init', 'setChecked', 'setType', 'toggle']);
var slider = buildApi(__WEBPACK_IMPORTED_MODULE_21__widgets_Slider_js_slider__, ['init']);
var tabcontrol = buildApi(__WEBPACK_IMPORTED_MODULE_29__widgets_TabControl_js_tabControl__, ['init']);
var tile = buildApi(__WEBPACK_IMPORTED_MODULE_14__widgets_Tile_js_tile__, ['init']);
var timer = buildApi(__WEBPACK_IMPORTED_MODULE_15__widgets_Timer_js_timer__, ['init', 'start', 'cancel', 'ready']);
var tooltip = buildApi(__WEBPACK_IMPORTED_MODULE_8__widgets_Tooltip_js_tooltip__, ['init', 'enable', 'disable']);


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setDocument */
/* harmony export (immutable) */ __webpack_exports__["a"] = read;
var doc = document;

function setDocument(mockDoc) {
    doc = mockDoc;
}

/**
 * Reads and returns the value of a cookie given by its name.
 * @param {string} Name of the cookie to read.
 * @return {string} Value of the cookie, or undefined if the cookie is not set.
 */
function read(str) {
    var cookies = doc.cookie ? doc.cookie.split('; ') : [],
        cookie,
        eqIndex,
        name,
        value,
        i;
    for (i = 0; i < cookies.length; i++) {
        cookie = cookies[i];
        eqIndex = cookie.indexOf('=');
        name = decodeURIComponent(cookie.substring(0, eqIndex));
        if (str === name) {
            value = cookie.substring(eqIndex + 1);
            value = decodeURIComponent(value.replace(/\+/g, ' ')); // replace pluses with spaces, then decode
            break;
        }
    }
    return value;
}

/***/ }),
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mustache__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datePickerView__ = __webpack_require__(9);
/**
 * A class which represents a Calendar overlay component.
 * This defines the structure and the main behavior of the component.
 *
 * @param conf A JSON object, which contains the following parameters:
 *      getDateFormat: a function which returns the date format string of value,
 *      i18n: the i18n JSON object,
 *      weekStart: the integer value of week starting day (0..6: Sunday  to Saturday)
 *      $input: input element
 *      $target: qtip target element
 */








var DATE_FORMAT = 'YYYY-MM-DD',
    DEFAULT_START_DATE = __WEBPACK_IMPORTED_MODULE_3_moment___default()('0000-01-01', DATE_FORMAT),
    DEFAULT_END_DATE = __WEBPACK_IMPORTED_MODULE_3_moment___default()('9999-12-31', DATE_FORMAT),
    MONTH_LABEL_HEIGHT = 47,
    WEEK_LINE_HEIGHT = 44;

function Calendar(conf) {
    var $view,
        $main,
        $yearSelector,
        $yearInput,
        $prevYearButton,
        $nextYearButton,
        $monthSelectorView,
        $monthSelector,
        $daySelectorView,
        $daySelector,
        $footer,
        $legend,
        $doneButton,
        $todayButton,
        selectedDate,
        dateInfo,
        dateInfoToday,
        displayedYear,
        selectorHeight,
        isoWeekStart = __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["a" /* convertWesternToIsoWeekday */](conf.weekStart),
        startDate = DEFAULT_START_DATE,
        endDate = DEFAULT_END_DATE,
        hasBankHoliday,
        model = {
            'months': []
        };

    function isBankHoliday(targetDateInfo, date) {
        var bankHoliday = false,
            isoDateStr,
            enabledDay;
        if (targetDateInfo) {
            isoDateStr = date.format(DATE_FORMAT);
            enabledDay = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(isoDateStr, targetDateInfo.enabledDays) > -1;
            if (!enabledDay) {
                bankHoliday = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(isoDateStr, targetDateInfo.bankHolidays) > -1;
            }
        }
        return bankHoliday;
    }

    function getDateIndex(date) {
        /* eslint-disable no-bitwise */
        var yearIndex = date.year() << 9,
            monthIndex = date.month() << 5,
            dayIndex = date.date();
        return yearIndex + monthIndex + dayIndex;
        /* eslint-enable no-bitwise */
    }

    function isInDateRange(date, startDate, endDate) {
        var dateIndex = getDateIndex(date),
            startDateIndex = getDateIndex(startDate),
            endDateIndex = getDateIndex(endDate);
        return dateIndex >= startDateIndex && dateIndex <= endDateIndex;
    }

    function isDisabledDay(targetDateInfo, date) {
        var isoDateStr,
            selectableDay = isInDateRange(date, startDate, endDate),
            disabledDay = !selectableDay,
            enabledDay,
            isoWeekday,
            disabledWeekday;
        if (selectableDay && targetDateInfo) {
            isoDateStr = date.format(DATE_FORMAT);
            enabledDay = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(isoDateStr, targetDateInfo.enabledDays) > -1;
            if (!enabledDay) {
                disabledDay = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(isoDateStr, targetDateInfo.disabledDays) > -1;
                isoWeekday = __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["b" /* convertIsoToWesternWeekday */](date.isoWeekday());
                disabledWeekday = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(isoWeekday, targetDateInfo.disabledWeekdays) > -1;
                disabledDay = disabledDay || disabledWeekday;
            }
        }
        return disabledDay;
    }

    function getDateFormat() {
        var isValid = false,
            dateFormat = conf.getDateFormat();
        isValid = __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["c" /* isUniqueSubstr */](dateFormat, 'YYYY')
            && __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["c" /* isUniqueSubstr */](dateFormat, 'MM')
            && __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["c" /* isUniqueSubstr */](dateFormat, 'DD');
        dateFormat = isValid ? dateFormat : 'DD.MM.YYYY';
        return dateFormat;
    }

    function buildWeekday(week, date, dayOfWeekIndex) {
        var weekday = {
                'bankHoliday': isBankHoliday(dateInfo, date),
                'dayOfMonth': date.date(),
                'disabled': isDisabledDay(dateInfo, date),
                'hasTopBorder': week.weekOfMonth === 1,
                'value': date.format(getDateFormat())
            };
        week.weekdays[dayOfWeekIndex] = weekday;
        return weekday;
    }

    function buildWeek(month, date, weekOfMonthIndex) {
        var week = month.weeks[weekOfMonthIndex] || {
                'weekdays': []
            };
        month.weeks[weekOfMonthIndex] = week;
        return week;
    }

    /**
     * Calculates scroll top position of the month DOM element inside the scrollable day selector view.
     *
     * @param months array of month model objects
     * @param monthIndex month number (Jan..Dec: 1..12)
     *
     * @return Scroll top position of the month DOM element inside the scrollable day selector view.
     *      That's an integer, meaning scroll amount in pixels.
     */
    function calculateMonthScrollTop(months, monthIndex) {
        var scrollTop = 0,
            i;
        if (monthIndex > 0 && months && months.length >= monthIndex) {
            for (i = 0; i < monthIndex; i++) {
                scrollTop = scrollTop + MONTH_LABEL_HEIGHT + months[i].weeks.length * WEEK_LINE_HEIGHT;
            }
        }
        return scrollTop;
    }

    function buildMonth(months, index) {
        var month = months[index] || {
                'disabled': true,
                'month': conf.i18n.months[index],
                'monthShort': conf.i18n.monthsShort[index],
                'monthOfYear': index + 1,
                'monthOfYear2Digits': ('00' + (index + 1)).slice(-2),
                'scrollTop': calculateMonthScrollTop(months, index),
                'weeks': []
            };
        months[index] = month;
        return month;
    }

    function getModelWeekday(date) {
        var month,
            weekIndex,
            week,
            dayOfWeekIndex,
            weekday;
        if (model.year === date.year()) {
            month = model.months[date.month()];
            weekIndex = __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["d" /* getWeekOfMonth */](date, model.displayedYearOffset) - 1;
            week = month.weeks[weekIndex];
            dayOfWeekIndex = __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["e" /* getDayOfWeek */](date, isoWeekStart) - 1;
            weekday = week.weekdays[dayOfWeekIndex];
        }
        return weekday;
    }

    function updateModelToday() {
        var weekday = getModelWeekday(__WEBPACK_IMPORTED_MODULE_3_moment___default()());
        if (weekday) {
            weekday.today = conf.i18n.today;
            weekday.todayAbbrev = conf.i18n.todayAbbrev;
        }
    }

    function updateModelSelectedDate() {
        var weekday = getModelWeekday(selectedDate);
        if (weekday) {
            weekday.selected = true;
        }
    }

    function buildModel() {
        var date = __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["f" /* getFirstDayOfYear */](displayedYear),
            month,
            week,
            weekday,
            monthIndex = 0,
            weekOfMonthIndex = 0,
            dayOfWeekIndex = __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["e" /* getDayOfWeek */](date, isoWeekStart) - 1;
        model = {
            'year': displayedYear,
            'displayedYearOffset': dayOfWeekIndex,
            'months': []
        };
        hasBankHoliday = false;
        do {
            month = buildMonth(model.months, date.month());
            week = buildWeek(month, date, weekOfMonthIndex);
            weekday = buildWeekday(week, date, dayOfWeekIndex);
            hasBankHoliday = hasBankHoliday || weekday.bankHoliday;
            month.disabled = weekday.disabled ? month.disabled : false;

            date.add(1, 'day');
            dayOfWeekIndex++;
            if (dayOfWeekIndex > 6) {
                dayOfWeekIndex = 0;
                weekOfMonthIndex++;
            }
            if (date.month() > monthIndex) {
                monthIndex++;
                weekOfMonthIndex = 0;
            }
        } while (date.year() === displayedYear);

        updateModelToday();
        updateModelSelectedDate();
    }

    function processDayEvent(event, task) {
        var $target = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["E" /* getEventTarget */](event),
            $day = __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["g" /* findBaseElemByClass */]($target, 'uwr-date-picker-day'),
            valid = $day ? $day.data('date') !== undefined : false,
            disabledDay = $day ? $day.hasClass('uwr-date-picker-day-disabled') : false,
            holiday = $day ? $day.hasClass('uwr-date-picker-day-bank-holiday') : false;
        if ($day && valid && !disabledDay && !holiday) {
            task($day);
        }
    }

    function daySelectHandler(event) {
        processDayEvent(event, function ($day) {
            selectDay($day);
            saveDateAndClose(event);
        });

    }

    function createDaySelector() {
        var $newDaySelector = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_5__datePickerView__["a" /* default */].daySelector, {
            'months': model.months
        }));
        $newDaySelector.on('click tap', daySelectHandler);
        $newDaySelector.height(selectorHeight);
        return $newDaySelector;
    }

    function updateDaySelector() {
        var $newDaySelector = createDaySelector();
        $daySelector.before($newDaySelector);
        $daySelector.remove();
        $daySelector = $newDaySelector;
    }

    function processMonthEvent(event, task) {
        loadDateInfo(function () {
            var $target = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["E" /* getEventTarget */](event),
                $month = __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["g" /* findBaseElemByClass */]($target, 'uwr-date-picker-month');
            if ($month && $month.data('month-of-year') !== undefined) {
                task($month);
            }
        });
    }

    function monthSelectHandler(event) {
        processMonthEvent(event, function ($month) {
            var monthOfYear = $month.data('month-of-year');
            updateDaySelectorView();
            updateDaySelector();
            showMonth(monthOfYear);
        });
        event.preventDefault();
    }

    function monthHoverInHandler(event) {
        processMonthEvent(event, function ($month) {
            $month.addClass('uwr-date-picker-month-hover');
        });
    }

    function monthHoverOutHandler(event) {
        processMonthEvent(event, function ($month) {
            $month.removeClass('uwr-date-picker-month-hover');
        });
    }

    function createMonthSelector() {
        var $newMonthSelector = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_5__datePickerView__["a" /* default */].monthSelector, {
            'months': model.months
        }));
        $newMonthSelector.find('.uwr-date-picker-month').each(function () {
            var $month = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
            $month.on('click tap', monthSelectHandler);
            $month.hover(monthHoverInHandler, monthHoverOutHandler);
        });
        $newMonthSelector.height(selectorHeight);
        return $newMonthSelector;
    }

    function updateMonthSelector() {
        var $newMonthSelector = createMonthSelector();
        $monthSelector.before($newMonthSelector);
        $monthSelector.remove();
        $monthSelector = $newMonthSelector;
    }

    function showMonthSelector() {
        $monthSelectorView.show();
        $daySelectorView.hide();
    }

    function showDaySelector() {
        $daySelectorView.show();
        $monthSelectorView.hide();
    }

    function isTodaySelectable() {
        var now = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
        return isInDateRange(now, startDate, endDate) && !isDisabledDay(dateInfoToday, now)
            && !isBankHoliday(dateInfoToday, now);
    }

    function updateTodayButton() {
        var selectableDay = isTodaySelectable();
        if (selectableDay) {
            __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["h" /* setButtonDisabled */]($todayButton, false);
        } else {
            __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["h" /* setButtonDisabled */]($todayButton, true);
        }
    }

    function updatePrevYearButton() {
        if (displayedYear <= startDate.year()) {
            __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["h" /* setButtonDisabled */]($prevYearButton, true);
        } else {
            __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["h" /* setButtonDisabled */]($prevYearButton, false);
        }
    }

    function updateNextYearButton() {
        if (displayedYear >= endDate.year()) {
            __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["h" /* setButtonDisabled */]($nextYearButton, true);
        } else {
            __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["h" /* setButtonDisabled */]($nextYearButton, false);
        }
    }

    function getYear(yearString) {
        var year = parseInt(yearString, 10),
            startDateYear = startDate.year(),
            endDateYear = endDate.year();
        if (year.toString() !== yearString) {
            year = displayedYear;
        }
        if (year < startDateYear) {
            year = startDateYear;
        }
        if (year > endDateYear) {
            year = endDateYear;
        }
        return year;
    }

    function getDateInfo(year) {
        var args = [year, conf.$input[0]],
            // clone singleton JQuery 1.8 Promise object to prevent multiple asynchronous calls issue
            yearDateInfo = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(true, {}, __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["v" /* resolveConfig */](conf.$input, 'date-info', args));
        yearDateInfo.markupAttr = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["h" /* data */](conf.$input, 'date-info');
        return yearDateInfo;
    }

    function updateSelectableDateRange() {
        if (dateInfo && dateInfo.selectableDateRange) {
            startDate = __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["i" /* parseDate */](dateInfo.selectableDateRange.startDay, DATE_FORMAT, DEFAULT_START_DATE);
            endDate = __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["i" /* parseDate */](dateInfo.selectableDateRange.endDay, DATE_FORMAT, DEFAULT_END_DATE);
        }
    }

    function updateDateInfo() {
        var todayYear = __WEBPACK_IMPORTED_MODULE_3_moment___default()().year();
        dateInfo = getDateInfo(displayedYear);
        if (displayedYear === todayYear) {
            dateInfoToday = dateInfo;
        } else {
            updateDateInfoToday();
        }
    }

    function updateDateInfoToday() {
        if (dateInfoToday === undefined) {
            dateInfoToday = getDateInfo(__WEBPACK_IMPORTED_MODULE_3_moment___default()().year());
        }
    }

    function isPromise(obj) {
        return obj !== undefined && obj.promise !== undefined;
    }

    function updateButtons() {
        updatePrevYearButton();
        updateNextYearButton();
        updateTodayButton();
    }

    function loadDateInfo(processDateInfo) {
        var todayYear = __WEBPACK_IMPORTED_MODULE_3_moment___default()().year();
        updateDateInfo();
        if (isPromise(dateInfo)) {
            updateSelectableDateRange();
            updateButtons();
            processDateInfo();
            dateInfo.done(function (data) {
                data.markupAttr = dateInfo.markupAttr;
                dateInfo = data;
                if (displayedYear === todayYear) {
                    dateInfoToday = dateInfo;
                } else {
                    loadDateInfoToday(updateTodayButton);
                }
                updateSelectableDateRange();
                updateButtons();
                processDateInfo();
            });
        } else {
            if (displayedYear === todayYear) {
                dateInfoToday = dateInfo;
            } else {
                loadDateInfoToday(updateTodayButton);
            }
            updateSelectableDateRange();
            updateButtons();
            processDateInfo();
        }
    }

    function loadDateInfoToday(processDateInfo) {
        updateDateInfoToday();
        if (isPromise(dateInfoToday)) {
            dateInfoToday.done(function (data) {
                dateInfoToday = data;
                processDateInfo();
            });
        } else {
            processDateInfo();
        }
    }

    function updateLegendText() {
        if (hasBankHoliday) {
            $legend.show();
        } else {
            $legend.hide();
        }
    }

    function selectDate(date) {
        var $day = findDay(date),
            monthOfYear = date.month() + 1;
        selectDay($day);
        showMonth(monthOfYear);
    }

    function updateDaySelectorView() {
        var yearChanged = displayedYear !== model.year,
            dateInfoAttrChanged = (dateInfo && dateInfo.markupAttr) !== __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["h" /* data */](conf.$input, 'date-info');
        if (yearChanged || dateInfoAttrChanged) {
            loadDateInfo(function () {
                buildModel();
                updateDaySelector();
                updateLegendText();
                updateButtons();
                selectDate(selectedDate);
            });
        } else {
            selectDate(selectedDate);
            $daySelector.height(selectorHeight);
        }
    }

    function updateMonthSelectorView() {
        if (displayedYear !== model.year) {
            loadDateInfo(function () {
                buildModel();
                updateMonthSelector();
                updateLegendText();
                updateButtons();
            });
        } else {
            $monthSelector.height(selectorHeight);
        }
    }

    function changeYear(yearString) {
        var year = getYear(yearString);
        setDisplayedYear(year);
        updateMonthSelectorView();
    }

    function yearHandler(newYear) {
        showMonthSelector();
        changeYear(newYear.toString());
        $yearInput.focus();
    }

    function prevYearHandler() {
        yearHandler(displayedYear - 1);
    }

    function nextYearHandler() {
        yearHandler(displayedYear + 1);
    }

    function showYearInputBorders() {
        $yearInput.removeClass('uwr-date-picker-displayed-year-input-label');
        $yearInput.addClass('uwr-date-picker-displayed-year-input-active uwr-year-input');
    }

    function hideYearInputBorders() {
        $yearInput.removeClass('uwr-date-picker-displayed-year-input-active uwr-year-input');
        $yearInput.addClass('uwr-date-picker-displayed-year-input-label');
    }

    function yearInputFocusHandler() {
        changeYear(displayedYear);
        showYearInputBorders();
        updateMonthSelector();
        showMonthSelector();
    }

    function yearInputBlurHandler() {
        var yearString = $yearInput.val(),
            year = getYear(yearString);
        setDisplayedYear(year);
        hideYearInputBorders();
    }

    function yearInputChangeHandler(event) {
        var ev = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["Q" /* fixEvent */](event),
            $target = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["E" /* getEventTarget */](ev),
            yearString = $target.val();
        if (__WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["j" /* isOnlyNumberKey */](ev) && yearString.length > 3 && !__WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["k" /* isTextSelected */]($target[0])) {
            // max. 4 digits
            ev.preventDefault();
        } else if (__WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["l" /* isDeleteKey */](ev) && yearString.length < 1) {
            // min. 1 digit
            ev.preventDefault();
        } else if (__WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["m" /* isSetterKey */](ev)) {
            if (yearString.length > 0) {
                yearHandler(yearString);
            } else {
                setDisplayedYear(displayedYear);
                ev.preventDefault();
            }
        }
    }

    function isNotEnabledKey(keyEvent) {
        return !__WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["n" /* isNavigatorKey */](keyEvent) && !__WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["o" /* isSelectorKey */](keyEvent)
            && !__WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["p" /* isModifierKey */](keyEvent);
    }

    function yearInputKeydownHandler(event) {
        var ev = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["Q" /* fixEvent */](event),
            $target;
        if (__WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["j" /* isOnlyNumberKey */](ev) || __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["l" /* isDeleteKey */](ev)) {
            yearInputChangeHandler(event);
        } else if (__WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["q" /* isExitKey */](ev)) {
            $target = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["E" /* getEventTarget */](ev);
            $target.val(displayedYear);
            hideYearInputBorders();
            conf.$input.focus();
        } else if (__WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["m" /* isSetterKey */](ev)) {
            yearInputChangeHandler(event);
            hideYearInputBorders();
            conf.$input.focus();
            ev.preventDefault();
            return false;
        } else if (isNotEnabledKey(ev)) {
            return false;
        }
    }

    function findDay(date) {
        var dateString = __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, getDateFormat()).format(getDateFormat()),
            $day = $daySelector.find('[data-date="' + dateString + '"]');
        return $day;
    }

    function showMonth(monthOfYear) {
        var index = monthOfYear - 1,
            scrollTop;
        showDaySelector();
        scrollTop = model.months[index].scrollTop;
        $daySelector.scrollTop(scrollTop);
    }

    function saveDateAndClose(event) {
        var input = conf.$input[0],
            previousValue = input.value,
            newValue = selectedDate.format(getDateFormat());

        if (previousValue !== newValue) {
            input.value = newValue;
            __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["k" /* dispatchEvent */]('change', input);
        }

        conf.$target.qtip('api').hide(event);
        hideYearInputBorders();
    }

    function updateDaySelection($day) {
        var $label = $day.next(),
            hasLabel = $label.hasClass('uwr-date-picker-day-label');
        $daySelector.find('.uwr-date-picker-day-selected').each(function () {
            var $selectedDay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
            $selectedDay.removeClass('uwr-date-picker-day-selected');
        });
        $day.addClass('uwr-date-picker-day-selected');
        if (hasLabel) {
            $label.addClass('uwr-date-picker-day-selected');
        }
    }

    function selectDay($day) {
        var selectedDateText;
        updateDaySelection($day);
        selectedDateText = $day.data('date');
        selectedDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(selectedDateText, getDateFormat());
    }

    function buildYearSelector() {
        $yearSelector = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_5__datePickerView__["a" /* default */].yearSelector, {
            'displayedYear': displayedYear
        }));
        $prevYearButton = $yearSelector.find('.uwr-date-picker-prev-year');
        $prevYearButton.on('click tap', prevYearHandler);
        updatePrevYearButton();
        $nextYearButton = $yearSelector.find('.uwr-date-picker-next-year');
        $nextYearButton.on('click tap', nextYearHandler);
        updateNextYearButton();
        $yearInput = $yearSelector.find('input');
        $yearInput.on('focus', yearInputFocusHandler);
        $yearInput.on('blur', yearInputBlurHandler);
        $yearInput.on('keydown', yearInputKeydownHandler);
        $main.before($yearSelector);
    }

    function buildFooter() {
        $footer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_5__datePickerView__["a" /* default */].footer, {
            'done': conf.i18n.done,
            'legendText': conf.i18n.legendText,
            'today': conf.i18n.today
        }));
        $legend = $footer.find('.uwr-date-picker-legend');
        $doneButton = $footer.find('.uwr-date-picker-done');
        $doneButton.on('click tap', function (event) {
            saveDateAndClose(event);
        });
        $todayButton = $footer.find('.uwr-date-picker-today');
        $todayButton.on('click tap', function (event) {
            var today = __WEBPACK_IMPORTED_MODULE_3_moment___default()(),
                year = today.year(),
                $selectedDay;
            changeYear(year);
            $selectedDay = findDay(today);
            selectDay($selectedDay);
            selectedDate = today;
            saveDateAndClose(event);
        });
        $main.after($footer);
    }

    function buildView() {
        $view = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_5__datePickerView__["a" /* default */].calendar, {
            'selectMonth': conf.i18n.selectMonth,
            'weekdays': conf.i18n.weekdaysShort
        }));
        $view.on('click tap', changeYear);
        $main = $view.find('.uwr-date-picker-calendar-main');
        $monthSelectorView = $view.find('.uwr-date-picker-month-selector-view');
        $monthSelector = $view.find('.uwr-date-picker-month-selector');
        $daySelectorView = $view.find('.uwr-date-picker-day-selector-view');
        $daySelector = $view.find('.uwr-date-picker-day-selector');
        buildYearSelector();
        buildFooter();
    }

    function setDisplayedYear(year) {
        if (year !== displayedYear) {
            dateInfo = undefined;
            dateInfoToday = undefined;
            displayedYear = parseInt(year, 10);
        }

        if ($yearInput && $yearInput.val() !== displayedYear.toString()) {
            $yearInput.val(displayedYear);
        }
    }

    function init() {
        selectedDate = __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["i" /* parseDate */](conf.$input.val(), getDateFormat());
        setDisplayedYear(selectedDate.year());
        buildView();
    }

    function showDate() {
        hideYearInputBorders();
        showDaySelector();
        selectedDate = __WEBPACK_IMPORTED_MODULE_4__datePickerUtil__["i" /* parseDate */](conf.$input.val(), getDateFormat());
        setDisplayedYear(selectedDate.year());
        updateDaySelectorView();
        showMonth(selectedDate.month() + 1);
    }

    this.showDate = function () {
        showDate();
    };

    this.showView = function () {
        if ($daySelectorView.is(':visible')) {
            showDate();
        } else {
            updateMonthSelector();
            showMonthSelector();
        }
    };

    this.updateView = function () {
        init();
    };

    this.setSelectorHeight = function (newHeight) {
        selectorHeight = newHeight;
    };

    this.getView = function () {
        if ($view === undefined) {
            init();
        }
        return $view;
    };
}


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Icon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mustache__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datePickerView__ = __webpack_require__(9);
/**
 * A class which represents a Icon component.
 * This defines the structure and the main behavior of the component.
 *
 * @param conf A JSON object, which contains the following parameters:
 *      iconPlacement: the placement of the date picker icon button depends on the opening mode
 *          (click mode: outside, focus mode: inside),
 *      $input: input element
 */






function Icon(conf) {
    var $view,
        $input = conf.$input;

    function removeIcon() {
        var $next = $input.next(),
            insideIcon = $next.hasClass('uwr-date-picker-icon-inside'),
            outsideIcon = $next.hasClass('uwr-date-picker-icon-outside');
        if (insideIcon || outsideIcon) {
            $next.remove();
        }
    }

    function addIconIntoInput($input, $view) {
        var iconId = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["R" /* generateUUID */]();
        $input.attr('readonly', 'readonly');
        $input.attr('data-icon-button-selector', '#' + iconId);
        $input.data('tooltipTarget', $input);
        $view.attr('id', iconId);
        $input.after($view);
    }

    function addIconAfterInput($input, $view) {
        $input.data('tooltipTarget', $view);
        $input.after($view);
    }

    function init() {
        var insideIcon = conf.iconPlacement === 'inside',
            iconTemplate = insideIcon ? __WEBPACK_IMPORTED_MODULE_3__datePickerView__["a" /* default */].iconInside : __WEBPACK_IMPORTED_MODULE_3__datePickerView__["a" /* default */].iconOutside;
        $view = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mustache__["render"])(iconTemplate, {}));
        removeIcon();
        if (insideIcon) {
            addIconIntoInput($input, $view);
        } else {
            addIconAfterInput($input, $view);
        }
    }

    this.getView = function () {
        return $view;
    };

    init();
}


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calculateOffset */
/* unused harmony export calculateOffsetInputs */
/* unused harmony export generateSizes */
/* harmony export (immutable) */ __webpack_exports__["a"] = Tooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_frames__ = __webpack_require__(6);
/**
 * How the position calculation works
 *
 * Terms
 * - Viewport: The visible part of the frame or window in which the overlay will be displayed.
 * - Target: The HTML item which is the logical parent of the displayed content. For example the button, which is
 *   clicked on to open the displayed content.
 * - Tip: A small triangle which is a visual connection between the target and the displayed content.
 * - Overlay: The popup-like container of the displayed content which could be connected to the target using the tip.
 *
 * Calculation
 * The calculation is about finding the optimal position of the overlay. The optimal position is where the most
 * interactive elements are available for the user without extra effort (e.g. scrolling, swipe, or others). Main rule,
 * that all elements of the overlay should be available for the user somehow. This means, that the overlay cannot be
 * placed so that its elements are unreachable.
 *
 * The final result of the calculation is an offset and a position string instead of a coordinate pair, because the
 * overlay itself is displayed by the qtip2 library.
 *
 * The calculation is done in more steps:
 * Step 1: Calculate and collect sizes
 *         For an easier calculation we should collect all necessary sizes. The getting solution could be different in
 *         different browsers. To calculate the placement, we need the position and the size of
 *         - the target's viewport (size, scroll),
 *         - the overlay's viewport (size, scroll) if they differs (NOT IMPLEMENTED YET),
 *         - the target (position relative to the viewport, size),
 *         - the overlay (size)
 * Step 2: Select the proper displaying side
 *         It depends on how large space is at the different sides of the target. The order and the availability of the
 *         sides are influenced by a preference list, which could be right, bottom, top and left. The special auto value
 *         is the short name of a predefined ordered list of the values above.
 * Step 3: Calculate the offset
 *         Based on the selected side and the calculated sizes we give one number: the offset of the tip on the proper
 *         side of the overlay. This is calculated in a way, where the hidden areas and the relevant scroll position
 *         does matter to reach a better, user-friendlier behavior.
 * Step 4: Library configuration
 *         Using the calculated values will be the qtip2 configured to set the proper position of the overlay. It uses
 *         the offset of the tip and the selected side details, which are predefined in a JS object.
 *
 * Notes:  - Within the calculations the center of the target and the middle line of the tip is used.
 *         - All of this calculations will be moved in a separated widget without the underlying qtip2 library, the
 *           current codename of that is Overlay.
 */





var DAYSELECTOR_MAX_HEIGHT = 396,
    DAYSELECTOR_MIN_HEIGHT = 260,
    OVERLAY_MAX_HEIGHT = 540,
    OVERLAY_MIN_HEIGHT = OVERLAY_MAX_HEIGHT - (DAYSELECTOR_MAX_HEIGHT - DAYSELECTOR_MIN_HEIGHT),
    OVERLAY_CONTENT_WITHOUT_DAYSELECTOR_HEIGHT = OVERLAY_MAX_HEIGHT - DAYSELECTOR_MAX_HEIGHT,
    OVERLAY_WIDTH = 440,
    OVERLAY_PADDING = 10,
    TIP_SIZE = 15,
    TIP_MIN_ADJUST = OVERLAY_PADDING + TIP_SIZE / 2, // 27.5
    TIP_CENTER_OFFSET_X = 1;

/**
 * A position is on horizont, if it is parallel with the horizontal line of the target.
 */
function isOpeningVertically(position) {
    return position === 'top' || position === 'bottom';
}

function getPositionsOnTheOtherAxis(position) {
    return (isOpeningVertically(position)) ? ['left', 'right'] : ['top', 'bottom'];
}

/**
 * @param {object} distances Parameter object, which contains the values below.
 *                 - fullOverlaySize The full size of the overlay.
 *                 - visibleDistanceBeforeTipTarget The distance between the target and the window border (near to
 *                   the origo of the used coordinate system).
 *                 - visibleDistanceAfterTipTarget The distance between the target and the window border (far from
 *                   the origo of the used coordinate system).
 *                 - pageScrollBeforeViewport The scrollable part of the page before (top or left from) the
 *                   viewport.
 * @return The offset for the qtip2 triangle.
 */
function calculateOffset(distances) {
    var offset = 0,
        fullOverlaySize = distances.fullOverlaySize,
        visibleDistanceBeforeTipTarget = distances.visibleDistanceBeforeTipTarget,
        visibleDistanceAfterTipTarget = distances.visibleDistanceAfterTipTarget,
        pageScrollBeforeViewport = distances.pageScrollBeforeViewport,
        halfOverlaySize = fullOverlaySize / 2,
        invisibleOverlaySize = Math.max(0, fullOverlaySize
            - (visibleDistanceBeforeTipTarget + visibleDistanceAfterTipTarget));

    function calculateOffsetBySize(size, useScrollInHiddenPlacing) {
        var moveToPageOffset = useScrollInHiddenPlacing
            ? Math.max(0, Math.min(invisibleOverlaySize / 2, pageScrollBeforeViewport))
            : invisibleOverlaySize;
        return Math.min(halfOverlaySize - size, halfOverlaySize) - moveToPageOffset;
    }

    if (visibleDistanceBeforeTipTarget < halfOverlaySize) {
        offset = -1 * calculateOffsetBySize(visibleDistanceBeforeTipTarget, true);
    } else if (visibleDistanceAfterTipTarget < halfOverlaySize) {
        offset = calculateOffsetBySize(visibleDistanceAfterTipTarget, false);
    }

    return offset;
}

/**
 * Calculate the input parameters required by the calculateOffset from the selected position and the sizes object.
 * @param {string} selectedPosition The position side where the overlay will be placed.
 * @param {object} sizes The object which contains all relevant size values.
 * @return An object which contains all parameter required by the calculateOffset (fullOverlaySize,
 *         visibleDistanceBeforeTipTarget, visibleDistanceAfterTipTarget, pageScrollBeforeViewport).
 *
 *         For more info please check the documentation of calculateOffset method.
 */
function calculateOffsetInputs(selectedPosition, sizes) {
    var result = {};
    if ((isOpeningVertically(selectedPosition))) {
        result.fullOverlaySize = sizes.overlay.width;
        result.visibleDistanceBeforeTipTarget =
            Math.max(sizes.item.topLeftX + (sizes.item.width / 2),
                TIP_MIN_ADJUST + TIP_CENTER_OFFSET_X);
        result.visibleDistanceAfterTipTarget =
            Math.max(sizes.viewport.width - (sizes.item.bottomRightX + (sizes.item.width / 2)),
                TIP_MIN_ADJUST - TIP_CENTER_OFFSET_X);
        result.pageScrollBeforeViewport = sizes.viewport.scrollX;
    } else {
        result.fullOverlaySize = sizes.overlay.height;
        result.visibleDistanceBeforeTipTarget =
            Math.max(sizes.item.topLeftY + (sizes.item.height / 2),
                TIP_MIN_ADJUST);
        result.visibleDistanceAfterTipTarget =
            Math.max(sizes.viewport.height - (sizes.item.bottomRightY + (sizes.item.height / 2)),
                TIP_MIN_ADJUST);
        result.pageScrollBeforeViewport = sizes.viewport.scrollY;
    }
    return result;
}

function calculateOverlayHeight(viewportVisibleClientRect) {
    return viewportVisibleClientRect.height >= OVERLAY_MAX_HEIGHT
        ? OVERLAY_MAX_HEIGHT
        : Math.max(viewportVisibleClientRect.height, OVERLAY_MIN_HEIGHT);
}


/**
 * Generate the required sizes into a parameter object from the bounding rectangles.
 * @param {object} targetBoundingClientRect Target dimension info, DOMRect object + scrollLeft, scrollTop.
 * @param {object} viewportVisibleClientRect Viewport dimension info, extended DOMRect (provided by the
 *                 frames/getVisibleClientRect method) object.
 * @return {object} A parameter object, which contains information about
 *                  - the viewport (width, height),
 *                  - the item (target) (topLeftX, topLeftY, bottomRightX, bottomRightY, width, height),
 *                  - the overlay (width, height, function getSize),
 *                  - function isSmall() to tell that the overlay can be placed in the viewport
 */
function generateSizes(targetBoundingClientRect, viewportVisibleClientRect) {
    var topLeftX = targetBoundingClientRect.left
        + Math.min(0, viewportVisibleClientRect.absLeft, viewportVisibleClientRect.left),
        topLeftY = targetBoundingClientRect.top
            + Math.min(0, viewportVisibleClientRect.absTop, viewportVisibleClientRect.top),
        targetWidth = targetBoundingClientRect.width,
        targetHeight = targetBoundingClientRect.height;

    return {
        viewport: {
            width: viewportVisibleClientRect.width,
            height: viewportVisibleClientRect.height,
            scrollX: viewportVisibleClientRect.scrollLeft,
            scrollY: viewportVisibleClientRect.scrollTop
        },
        item: {
            'topLeftX': topLeftX,
            'topLeftY': topLeftY,
            'bottomRightX': topLeftX + targetWidth,
            'bottomRightY': topLeftY + targetHeight,
            'width': targetWidth,
            'height': targetHeight
        },
        overlay: {
            width: OVERLAY_WIDTH,
            height: calculateOverlayHeight(viewportVisibleClientRect),
            getSize: function (position) {
                var size = {};
                if (position === 'right' || position === 'left') {
                    size.major = this.width;
                    size.minor = this.height;
                } else if (isOpeningVertically(position)) {
                    size.major = this.height;
                    size.minor = this.width;
                } else {
                    size = {
                        major: Math.max(this.width, this.height),
                        minor: Math.min(this.width, this.height)
                    };
                }
                return size;
            }
        },
        isSmall: function () {
            return this.viewport.width < this.overlay.width || this.viewport.height < this.overlay.height;
        }
    };
}

/**
 * @param $target The jQuery DOM object, which is the target of the overlay.
 * @return A sizes object, which contains the viewport, item and overlay geometries, and an isSmall() method,
 *         which tells that the overlay can be placed in the viewport or the viewport is too small.
 */
function calculateSizes($target) {
    var viewportVisibleClientRect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_modules_frames__["e" /* getVisibleClientRect */])(window),
        targetBoundingClientRect = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["P" /* getBoundingClientRect */]($target.get(0))),
        sizes;

    if (!targetBoundingClientRect.width) {
        targetBoundingClientRect.width = $target.outerWidth();
    }
    if (!targetBoundingClientRect.height) {
        targetBoundingClientRect.height = $target.outerHeight();
    }

    viewportVisibleClientRect.scrollTop = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop();
    viewportVisibleClientRect.scrollLeft = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollLeft();

    sizes = generateSizes(
        targetBoundingClientRect,
        viewportVisibleClientRect
    );
    return sizes;
}

/**
 * @param requestedPosition An array of names for the position, where the overlay should be placed.
 * @param target The jQuery DOM object, which is the target of the overlay.
 * @return A string which contains the name of the best position, where the overlay can be positioned.
 */
function findBestPosition(requestedPosition, target, sizes) {
    var positionCalcValues = {
        top: sizes.item.topLeftY,
        right: sizes.viewport.width - sizes.item.bottomRightX,
        bottom: sizes.viewport.height - sizes.item.bottomRightY,
        left: sizes.item.topLeftX
    },
        i,
        tempDiff = {},
        foundPosition,
        bestPosition = { major: 0, minor: 0, position: undefined },
        tempPos,
        minorPositions;
    if (sizes.isSmall()) {
        foundPosition = requestedPosition[0];
    }
    for (i = 0; i < requestedPosition.length; i++) {
        tempPos = requestedPosition[i];
        minorPositions = getPositionsOnTheOtherAxis(tempPos);
        tempDiff.major = positionCalcValues[tempPos] - sizes.overlay.getSize(tempPos).major;
        tempDiff.minor = Math.min(positionCalcValues[minorPositions[0]], positionCalcValues[minorPositions[1]]);
        if (tempDiff.major > bestPosition.major && tempDiff.minor > bestPosition.minor) {
            bestPosition.major = Math.max(bestPosition.major, tempDiff.major);
            bestPosition.minor = Math.max(bestPosition.minor, tempDiff.minor);
            bestPosition.position = tempPos;
        }
    }

    if (!bestPosition.position) {
        foundPosition = requestedPosition[0];
    } else {
        foundPosition = bestPosition.position;
    }

    return foundPosition;
}

/**
 * @param requestedPosition An array of names for the position (order is the precendence), where the overlay
 *        should be placed. The 'auto' value is special, it will be translated to an array of ['right',
 *        'bottom', 'top', 'left']. Every additional items are ignored.
 * @param target The jQuery DOM object, which is the target of the overlay.
 * @return The position details, which is required to configure qtip2 properly.
 */
function calculatePosition(requestedPosition, $target) {
    var positions = {
        'top': { atPos: 'top center', myPos: 'bottom center', adjust: { x: 0, y: 7 } },
        'right': { atPos: 'right center', myPos: 'left center', adjust: { x: -7, y: 0 } },
        'bottom': { atPos: 'bottom center', myPos: 'top center', adjust: { x: 0, y: -7 } },
        'left': { atPos: 'left center', myPos: 'right center', adjust: { x: 7, y: 0 } }
    },
        sizes = calculateSizes($target),
        calculatedPosition,
        offsetCalculationValues;

    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray('auto', requestedPosition) > -1) {
        requestedPosition = ['right', 'bottom', 'top', 'left'];
    }
    if (requestedPosition.length > 1) {
        requestedPosition = [findBestPosition(requestedPosition, $target, sizes)];
    }
    calculatedPosition = positions[requestedPosition[0]];
    offsetCalculationValues = calculateOffsetInputs(requestedPosition[0], sizes);
    calculatedPosition.offset = calculateOffset(offsetCalculationValues);
    calculatedPosition.target = $target;
    calculatedPosition.overlayHeight = sizes.overlay.height;
    calculatedPosition.selectorContentHeight = sizes.overlay.height - OVERLAY_CONTENT_WITHOUT_DAYSELECTOR_HEIGHT;
    return calculatedPosition;
}

function isClickedOnScrollbar(event) {
    var $target = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["E" /* getEventTarget */](event),
        document,
        clientWidth,
        clientHeight;

    if (!$target.get(0)) {
        return false;
    }

    document = $target.get(0).ownerDocument;
    clientWidth = document.documentElement.clientWidth;
    clientHeight = document.documentElement.clientHeight;
    return event.clientX > clientWidth || event.clientY > clientHeight;
}

/**
 * A class which represents a Tooltip component.
 * This defines the structure and the main behavior of the component.
 *
 * @param conf A JSON object, which contains the following parameters:
 *      calendar: a Calendar object,
 *      icon: an Icon object,
 *      openingMode: the opening mode of Date Picker (focus or click),
 *      placement: priority list of names for the position, where the overlay should be placed
 *      $target: the tooltip will be positioned in relation to this element
 */
function Tooltip(conf) {
    /* eslint complexity: ["error", 9] */
    function isPositionChanged() {
        var calculatedPosition = calculatePosition(conf.placement, conf.icon.getView()),
            changed = conf.$target.qtip('option', 'position.adjust.x') !== calculatedPosition.adjust.x
                || conf.$target.qtip('option', 'position.adjust.y') !== calculatedPosition.adjust.y
                || conf.$target.qtip('option', 'position.at') !== calculatedPosition.atPos
                || conf.$target.qtip('option', 'position.my') !== calculatedPosition.myPos
                || conf.$target.qtip('option', 'style.height') !== calculatedPosition.overlayHeight
                || conf.$target.qtip('option', 'style.tip.mimic') !== calculatedPosition.myPos
                || conf.$target.qtip('option', 'style.tip.offset') !== calculatedPosition.offset;
        return changed;
    }

    /**
     * Detach the Calendar view elements from the tooltip DOM to keep Calendar view with all data and events.
     * This clean up is necessary before the Qtip re-initialization which will destroy the already added contents.
     *
     * @param $target jQuery element to which the tooltip is opened.
     */
    function detachTooltipContent($target) {
        var qtip = $target.qtip('api'),
            rendered = qtip && qtip.elements && qtip.elements.content;
        if (rendered) {
            qtip.elements.content.children('.uwr-date-picker-calendar').detach();
        }
    }

    /**
     * Check if the open date picker's icon is clicked
     */
    function clickedOnDatePickerIcon($icon) {
        var iconMarkup = $icon.prev(),
            iconTooltipId = iconMarkup.attr('aria-describedby'),
            qtipContent = conf.calendar.getView().parent(),
            qtip = qtipContent.parent(),
            tooltipId = qtip.attr('id');
        return iconTooltipId === tooltipId;
    }

    function hideHandler(event) {
        var ev = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["Q" /* fixEvent */](event),
            originalEvent = ev.originalEvent,
            $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["E" /* getEventTarget */](originalEvent)),
            isInsideIcon = $target.hasClass('uwr-date-picker-icon-inside');
        if (isClickedOnScrollbar(originalEvent)) {
            return false;
        } else if (isInsideIcon && clickedOnDatePickerIcon($target)) {
            ev.originalEvent = undefined;
            return false;
        }
    }

    function renderHandler() {
        var $tooltipContent = conf.$target.qtip('api').elements.content;
        detachTooltipContent(conf.$target);
        $tooltipContent.append(conf.calendar.getView());
    }

    function showHandler() {
        if (isPositionChanged()) {
            init();
            conf.$target.qtip('show');
        }
    }

    function visibleHandler() {
        conf.calendar.showDate();
    }

    /**
     * Initialize the qtip on Date Picker target DOM element, or re-initialize qtip with new 'position' and 'style'
     * parameters if the qtip is already opened.
     *
     * @param config changed qtip properties
     */
    function initQtip(config) {
        var qtip = conf.$target.qtip('api'),
            opened = qtip && qtip.elements && qtip.elements.content && !qtip.elements.content.is(':hidden');

        detachTooltipContent(conf.$target);

        // qtip.disable() API function is available only after qtip initialiazion
        if (qtip && qtip.disable) {
            // Qtip re-initialization requires prior disabling to avoid javascript errors in qtip show()
            qtip.disable(true);
        }

        conf.$target.qtip(config);

        if (opened) {
            conf.$target.qtip('show');
        }
    }

    function init() {
        var calculatedPosition = calculatePosition(conf.placement, conf.icon.getView()),
            showEvent = conf.openingMode === 'click' ? 'click' : 'focus',
            config = {
                content: {
                    text: ' '
                },
                events: {
                    hide: hideHandler,
                    render: renderHandler,
                    visible: visibleHandler,
                    show: showHandler
                },
                hide: {
                    delay: 100,
                    event: 'unfocus',
                    fixed: true
                },
                show: {
                    event: showEvent,
                    solo: '.uwr-date-picker-tooltip'
                },
                position: {
                    adjust: {
                        x: calculatedPosition.adjust.x,
                        y: calculatedPosition.adjust.y
                    },
                    at: calculatedPosition.atPos,
                    my: calculatedPosition.myPos,
                    target: calculatedPosition.target
                },
                style: {
                    classes: 'uwr-ui-tooltip-base uwr-ui-tooltip-neutral uwr-date-picker-tooltip',
                    tip: {
                        corner2: true,
                        width: TIP_SIZE,
                        height: TIP_SIZE,
                        mimic: calculatedPosition.myPos,
                        offset: calculatedPosition.offset
                    },
                    width: OVERLAY_WIDTH,
                    height: calculatedPosition.overlayHeight
                }
            };

        if (conf.openingMode === 'focus') {
            conf.icon.getView().on('click tap', function () {
                conf.$target.focus();
            });
        }
        initQtip(config);
        conf.calendar.setSelectorHeight(calculatedPosition.selectorContentHeight);
    }

    init();
}


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["o"] = isSelectorKey;
/* harmony export (immutable) */ __webpack_exports__["n"] = isNavigatorKey;
/* harmony export (immutable) */ __webpack_exports__["j"] = isOnlyNumberKey;
/* harmony export (immutable) */ __webpack_exports__["l"] = isDeleteKey;
/* harmony export (immutable) */ __webpack_exports__["q"] = isExitKey;
/* harmony export (immutable) */ __webpack_exports__["m"] = isSetterKey;
/* harmony export (immutable) */ __webpack_exports__["p"] = isModifierKey;
/* harmony export (immutable) */ __webpack_exports__["k"] = isTextSelected;
/* harmony export (immutable) */ __webpack_exports__["a"] = convertWesternToIsoWeekday;
/* harmony export (immutable) */ __webpack_exports__["b"] = convertIsoToWesternWeekday;
/* harmony export (immutable) */ __webpack_exports__["f"] = getFirstDayOfYear;
/* unused harmony export getFirstDayOfMonth */
/* harmony export (immutable) */ __webpack_exports__["e"] = getDayOfWeek;
/* unused harmony export getWeekOfYear */
/* harmony export (immutable) */ __webpack_exports__["d"] = getWeekOfMonth;
/* harmony export (immutable) */ __webpack_exports__["i"] = parseDate;
/* harmony export (immutable) */ __webpack_exports__["g"] = findBaseElemByClass;
/* unused harmony export createIndexedArray */
/* harmony export (immutable) */ __webpack_exports__["h"] = setButtonDisabled;
/* harmony export (immutable) */ __webpack_exports__["c"] = isUniqueSubstr;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var KEY_CODE_INFO = {
        'backspace': 8,
        'del': 46,
        'end': 35,
        'home': 36,
        'left': 37,
        'right': 39,
        'shift': 16,
        'ctrl': 17,
        'tab': 9,
        'esc': 27,
        'enter': 13,
        'a': 65, // for ctrl-a
        'c': 67, // for ctrl-c
        'x': 88, // for ctrl-x
        // end: 35, home: 36, left: 37, right: 39
        'navigatorKeys': [35, 36, 37, 39],
        // backspace: 8, del: 46
        'deleteKeys': [8, 46],
        // a: 65, c: 67, x: 88 (with ctrl)
        'selectorKeys': [65, 67, 88],
        // shift: 16, ctrl: 17, alt: 18
        'modifierKeys': [16, 17, 18],
        // esc: 27
        'exitKeys': [27],
        // numbers (0..9): 48..57
        'numberKeys': [48, 49, 50, 51, 52, 53, 54, 55, 56, 57],
        // numbers (0..9) on keypad: 96..105
        'keypadNumberKeys': [96, 97, 98, 99, 100, 101, 102, 103, 104, 105],
        // tab: 9, enter: 13
        'setterKeys': [9, 13]
    };

/**
 * @param keyEvent is a keyboard event which encapsulates further information such as
 *        the numerical code of the pressed key and status of modifier keys when the event occurred
 *
 * @return boolean value that is "true" if CTRL with a selector key is pressed
 */
function isSelectorKey(keyEvent) {
    var selectAllKey = false;
    if (keyEvent.ctrlKey) {
        selectAllKey = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(keyEvent.which, KEY_CODE_INFO.selectorKeys) !== -1;
    }
    return selectAllKey;
}

/**
 * @param keyEvent is a keyboard event which encapsulates further information such as
 *        the numerical code of the pressed key and status of modifier keys when the event occurred
 *
 * @return boolean value that is "true" if a navigator key is pressed
 */
function isNavigatorKey(keyEvent) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(keyEvent.which, KEY_CODE_INFO.navigatorKeys) !== -1;
}

/**
 * @param keyEvent is a keyboard event which encapsulates further information such as
 *        the numerical code of the pressed key and status of modifier keys when the event occurred
 *
 * @return boolean value that is "true" if a number key without any modifier keys is pressed
 */
function isOnlyNumberKey(keyEvent) {
    var numberKey = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(keyEvent.which, KEY_CODE_INFO.numberKeys) !== -1,
        keypadNumberKey = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(keyEvent.which, KEY_CODE_INFO.keypadNumberKeys) !== -1,
        nonModified = !keyEvent.altKey && !keyEvent.ctrlKey && !keyEvent.shiftKey;
    return nonModified && (numberKey || keypadNumberKey);
}

/**
 * @param keyEvent is a keyboard event which encapsulates further information such as
 *        the numerical code of the pressed key and status of modifier keys when the event occurred
 *
 * @return boolean value that is "true" if an delete key is pressed
 */
function isDeleteKey(keyEvent) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(keyEvent.which, KEY_CODE_INFO.deleteKeys) !== -1;
}

/**
 * @param keyEvent is a keyboard event which encapsulates further information such as
 *        the numerical code of the pressed key and status of modifier keys when the event occurred
 *
 * @return boolean value that is "true" if an exit key is pressed
 */
function isExitKey(keyEvent) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(keyEvent.which, KEY_CODE_INFO.exitKeys) !== -1;
}

/**
 * @param keyEvent is a keyboard event which encapsulates further information such as
 *        the numerical code of the pressed key and status of modifier keys when the event occurred
 *
 * @return boolean value that is "true" if a setter key is pressed
 */
function isSetterKey(keyEvent) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(keyEvent.which, KEY_CODE_INFO.setterKeys) !== -1;
}

/**
 * @param keyEvent is a keyboard event which encapsulates further information such as
 *        the numerical code of the pressed key and status of modifier keys when the event occurred
 *
 * @return boolean value that is "true" if a modifier key is pressed (e.g. 'ALT', 'SHIFT' or 'CRTL')
 */
function isModifierKey(keyEvent) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(keyEvent.which, KEY_CODE_INFO.modifierKeys) !== -1;
}

/**
 * @param $input input element
 *
 * @return boolean value that is "true" if there is a selected text in the input element
 */
function isTextSelected($input) {
    var selected = false,
        selectionStart = $input.selectionStart,
        selectionEnd = $input.selectionEnd;
    if (selectionEnd) {
        // on all browsers, except IE before version 9
        selected = selectionStart < selectionEnd;
    } else if (document.selection) {
        // on IE before version 9
        selected = document.selection.type === 'Text';
    }
    return selected;
}

/**
 * @param westernWeekday the day position in the western calendar week from Sunday to Saturday (0 to 6)
 *
 * @return number the day position in the ISO calendar week from Monday to Sunday (1 to 7)
 */
function convertWesternToIsoWeekday(westernWeekday) {
    var normalizedWesternWeekday = westernWeekday % 7,
        isoWeekday = normalizedWesternWeekday === 0 ? 7 : normalizedWesternWeekday;
    return isoWeekday;
}

/**
 * @param isoWeekday the day position in the western calendar week from Monday to Sunday (1 to 7)
 *
 * @return number the day position in the western calendar week from Sunday to Saturday (0 to 6)
 */
function convertIsoToWesternWeekday(isoWeekday) {
    var westernWeekday = isoWeekday % 7;
    return westernWeekday;
}

/**
 * @param year max. 4-digit number or string representation of the year
 *
 * @return moment date object which represents the first day of the year
 */
function getFirstDayOfYear(year) {
    var day = __WEBPACK_IMPORTED_MODULE_1_moment___default()(year + '-01-01', 'YYYY-MM-DD');
    return day;
}

/**
 * @param date moment date object
 *
 * @return moment object which represents the first day of the month
 */
function getFirstDayOfMonth(date) {
    var day = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date);
    day.startOf('month');
    return day;
}

/**
 * @param date moment date object
 * @param isoWeekStart the first day of the week from Sunday to Saturday (0 to 6)
 *
 * @return number between 0 and 6 that represents the day position after the weekStartDay
 */
function getDayOfWeek(date, isoWeekStart) {
    var isoWeekday = date.isoWeekday(),
        // isoWeekdayOffset: weekdays offset is based on Monday (0..6)
        isoWeekdayOffset = isoWeekStart - 1,
        day = isoWeekday - isoWeekdayOffset;
    if (day < 1) {
        day += 7;
    }
    return day;
}

/**
 * @param date moment date object
 * @param displayedYearOffset the first day of the year from Monday to Sunday (0 to 6)
 *
 * @return moment object which represents the week of the year
 */
function getWeekOfYear(date, displayedYearOffset) {
    var day = date.dayOfYear(),
        extendedYear = day + displayedYearOffset,
        week = Math.ceil(extendedYear / 7);
    return week;
}

/**
 * @param date moment date object
 * @param displayedYearOffset the first day of the year from Monday to Sunday (0 to 6)
 *
 * @return moment object which represents the week of the month
 */
function getWeekOfMonth(date, displayedYearOffset) {
    var weekOfYear = getWeekOfYear(date, displayedYearOffset),
        firstDay = getFirstDayOfMonth(date),
        firstDayWeekOfYear = getWeekOfYear(firstDay, displayedYearOffset),
        week = weekOfYear - firstDayWeekOfYear + 1;
    return week;
}

/**
 * @param str the date string
 * @param dateFormat the date format string
 * @param defaultDate default date (moment object) when the given string format does not match
 *        the date format string (optional parameter: today by default)
 *
 * @return date (moment object)
 */
function parseDate(dateString, dateFormat, defaultDate) {
    var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(dateString || '', dateFormat),
        isValid = date.isValid();
    return isValid ? date : defaultDate || __WEBPACK_IMPORTED_MODULE_1_moment___default()();
}

/**
 * This function is to be used to find base element with given class or its parent with given class.
 *
 * @param $elem The jQuery elem.
 * @param cssClass The main CSS class associated with the widget.
 */
function findBaseElemByClass($elem, targetClass) {
    if ($elem.hasClass(targetClass)) {
        return $elem;
    }
    return $elem.length ? findBaseElemByClass($elem.parent(), targetClass) : undefined;
}

/**
 * This function converts array to array of objects which contain the item and the index.
 *
 * @param array array of items
 * @param fieldName the item field name and the prefix for index field name in the object of the returned array item
 *
 *  @retrun array of objects which contain item object in the fieldName
 *          and index number in the fieldName + 'Index' fields
 */
function createIndexedArray(array, fieldName) {
    var indexedArray = [],
        fieldIndex = fieldName + 'Index',
        item,
        index = 0;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(array).each(function () {
        item = {};
        item[fieldName] = this;
        item[fieldIndex] = index;
        indexedArray[index++] = item;
    });
    return indexedArray;
}

/**
 * This function sets the buttom element disabled status.
 *
 * @param $button button element
 * @param disabled if "true" the button will be disabled
 */
function setButtonDisabled($button, disabled) {
    $button.prop('disabled', disabled);
    if (disabled) {
        $button.addClass('uwr-button-disabled');
    } else {
        $button.removeClass('uwr-button-disabled');
    }
}

/**
 * This function checks that search string exists in the text and it is
 * unique or not.
 *
 * @param text the string text
 * @param search the search string
 *
 * @return boolean value that is "true" if search text exists and is unique in text
 */
function isUniqueSubstr(text, search) {
    var index = text ? text.indexOf(search) : -1,
        lastIndex = text ? text.lastIndexOf(search) : -1,
        match = index !== -1,
        unique = index === lastIndex;
    return match && unique;
}


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = search;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_modules_common__ = __webpack_require__(1);


function search(list, pattern) {
    function isExactMatch(element) {
        var regexp = new RegExp(__WEBPACK_IMPORTED_MODULE_0__shared_modules_common__["O" /* trim */].call(pattern), 'i');
        return regexp.test(element);
    }

    return __WEBPACK_IMPORTED_MODULE_0__shared_modules_common__["L" /* filter */].call(list, isExactMatch);
};


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

    container: '<div class="uwr-dropdown-container" tabindex="0"></div>',
    content: ['<span class="uwr-dropdown-content">',
        '<span class="uwr-dropdown-arrow-icon"></span>',
        '<span class="uwr-dropdown-bottom-label">{{labelBeforeSelect}}</span>',
        '<span class="uwr-dropdown-bottom-label-after-select uwr-dropdown-hidden-element">',
            '{{labelAfterSelect}}',
        '</span>',
        '<span class="uwr-dropdown-selected-value"></span>',
    '</span>',
    '<div class="uwr-dropdown-options">',
        '<span class="uwr-dropdown-top-label">{{labelBeforeSelect}}</span>',
        '{{#searchEnabled}}',
            '<input class="uwr-input">',
        '{{/searchEnabled}}',
        '<ul class="uwr-dropdown-option-list">',
        '</ul>',
        '<div class="uwr-dropdown-message"></div>',
    '</div>'
    ].join(''),
    options: [
        '{{#optionElements}}',
            '<li class="uwr-dropdown-item">{{.}}</li>',
        '{{/optionElements}}'
        ].join(''),
    multiSelected: [
        '{{#optionElements}}',
            '<span class="uwr-dropdown-multi-selected" tabindex="0">{{.}}</span>',
        '{{/optionElements}}'
        ].join(''),
    message: [
        '{{#noMatch}}',
            '<span class="uwr-dropdown-no-match">No results match "{{searchPattern}}"</span>',
        '{{/noMatch}}'
    ].join('')
});


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_support__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mustache__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatterView__ = __webpack_require__(90);






//                         IE8 fix           IE9 fix
var onTypingEventName = !__WEBPACK_IMPORTED_MODULE_2__shared_modules_support__["b" /* hasInputEvent */] || __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["u" /* isIe9 */]() ? 'keyup' : 'input',
    FormatterModes = {
        /* Internal mode description objects
            * Parameters:
            *  - initEvent: string, on what HTML event should be the field content initialized for editing.
            *    Default: undefined
            *  - formatEvent: string, on what HTML event should the value be formatted.
            *    Default: undefined
            *  - syncValueEvent: string, on what HTML event should the raw value written in the original field.
            *    Default: undefined
            *  - handleSelection: boolean, should the caret position saved and restored or not.
            *    Default: false
            *  - editUnformattedValue: boolean: should the unformatted value edited instead of the formatted.
            *    Default: false
            */
        onedit: {
            formatEvent: onTypingEventName,
            handleSelection: true
        },
        onblur: {
            /* The IE does not handle mousedown and moving the mouse to select a text, if the value is overwritten
                * by a script on the focus event. To avoid the issue, we changed the init event for all browsers to
                * mousedown. It works, however it updates the field content on every mousedown in the field.
                * (UBSWI-1703)
                */
            initEvent: 'mousedown',
            formatEvent: 'blur',
            syncValueEvent: onTypingEventName,
            handleSelection: false,
            editUnformattedValue: true
        }
    },
    DefaultFormatterModes = {
        'uwr.formatter.date': 'onedit',
        'uwr.formatter.number': 'onblur'
    }
;


function getSelectionState(target) {
    return {
        target: target,
        selectionStart: target.selectionStart,
        selectionEnd: target.selectionEnd,
        valueStringLength: target.value.length
    };
}

function restoreSelection(selectionState, formatResult) {
    var range; // IE8
    if (formatResult && selectionState.selectionStart === selectionState.valueStringLength) {
        selectionState.selectionStart = formatResult.formatted.length;
    }
    if (formatResult && selectionState.selectionEnd === selectionState.valueStringLength) {
        selectionState.selectionEnd = formatResult.formatted.length;
    }

    if (selectionState.target.setSelectionRange) {
        selectionState.target.setSelectionRange(selectionState.selectionStart, selectionState.selectionEnd);
    } else { // IE8 -->
        range = document.selection.createRange();
        range.move('textedit', 1);
        range.select();
    } // <-- IE8
}

function getValueDiff(oldValue, newValue) {
    var valueDifference = '';
    oldValue = oldValue || '';
    while (newValue.length > 0 && oldValue.length > 0) {
        if (newValue.charAt(0) === oldValue.charAt(0)) {
            oldValue = oldValue.substring(1);
        } else {
            valueDifference = newValue.charAt(0);
        }
        newValue = newValue.substring(1);
    }
    valueDifference += newValue;
    return valueDifference;
}

function getPreviousContent(hintElement) {
    var hintHiddenPartElement = hintElement.parentNode.querySelector('.uwr-input-hint-hidden');
    return hintHiddenPartElement.textContent || hintHiddenPartElement.innerText || '';
}

function setHintContent(formatResult, visibleField) {
    var hintElement = visibleField.parentNode.querySelector('.uwr-input-hint .uwr-input-hint-visible'),
        hintHiddenPartElement = hintElement.parentNode.querySelector('.uwr-input-hint-hidden'),
        hintContent = formatResult.formatted.length > 0 && formatResult.hint ? formatResult.hint : '';

    if (hintElement.textContent !== undefined) { // IE9+
        hintElement.textContent = hintContent;
        hintHiddenPartElement.textContent = formatResult.formatted;
    } else { // IE8
        hintElement.innerText = hintContent;
        hintHiddenPartElement.innerText = formatResult.formatted;
    }
}

/**
 *
 * @param fields It contains two optional elements: original and visible. If an element is undefined, then the
 *               related updates are skipped.
 * @param formatResult The formatter result object, which is the base of the update.
 */
function updateViewAndModel(fields, formatResult) {
    if (fields.visible) {
        fields.visible.value = formatResult.formatted;
        setHintContent(formatResult, fields.visible);
    }
    if (fields.original) {
        fields.original.value = formatResult.raw;
    }
}

/**
 * IE9 and IE8 hacks for ms-clear X button within the input field
 * This handles the drag and cut/paste events as well
 */
function setIEBlurHandlersForMSClear(visibleField, formatterMode) {
    var interval,
        lastLength = 1,
        inputHandler = function inputHandler() {
            var hintElement = visibleField.parentNode.querySelector('.uwr-input-hint .uwr-input-hint-visible'),
                hintHiddenPartElement =
                    visibleField.parentNode.querySelector('.uwr-input-hint .uwr-input-hint-hidden');

            if (visibleField.value.length < 1) {
                // Support IE8 too
                hintElement.innerText = '';
                hintHiddenPartElement.innerText = '';
            }
        },
        checkInterval = function checkInterval() { // IE9 ms-clear and cut hint handling
            if (visibleField.value.length !== lastLength) {
                __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["k" /* dispatchEvent */]('keyup', visibleField);
            }
            lastLength = visibleField.value.length;
        },
        setupCheckInterval = function setupCheckInterval() {
            interval = setInterval(checkInterval, 500);
        },
        clearCheckInterval = function clearCheckInterval() {
            clearInterval(interval);
            checkInterval();
        };

    if (__WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["u" /* isIe9 */]()) {
        __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["l" /* addEventListener */]('blur', visibleField, inputHandler);
        if (formatterMode.formatEvent === 'keyup') {
            __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["l" /* addEventListener */]('focus', visibleField, setupCheckInterval);
            __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["l" /* addEventListener */]('blur', visibleField, clearCheckInterval);
        }
    } else if (visibleField && visibleField.attachEvent) {
        visibleField.attachEvent('onpropertychange', inputHandler);
    }
}

function createFormatterEventHandler(originalField, visibleField, valueFormatter, formatterMode) {
    return function (event) {
        var target = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["E" /* getEventTarget */](event, true),
            rawValue = target.value,
            selectionState,
            hintElement =
                visibleField.parentNode.querySelector('.uwr-input-hint .uwr-input-hint-visible'),
            formatResult =
                valueFormatter.format(rawValue,
                    getValueDiff(getPreviousContent(hintElement), rawValue)
                );

        // Break infinite blur-focus loop on caret positioning
        if (formatterMode.handleSelection) {
            selectionState = getSelectionState(target);
            updateViewAndModel({original: originalField, visible:visibleField}, formatResult);
            restoreSelection(selectionState, formatResult);
        } else {
            updateViewAndModel({original: originalField, visible: visibleField}, formatResult);
        }
    };
}

function createInitializationEventHandler(originalField, formatterMode) {
    return function (event) {
        var target = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["E" /* getEventTarget */](event, true),
            selectionState;

        if (originalField.value !== undefined) {
            selectionState = getSelectionState(target);
            if (formatterMode.editUnformattedValue) {
                target.value = originalField.value;
            }
            restoreSelection(selectionState);
        }
    };
}

function createSyncValueEventHandler(originalField, valueFormatter) {
    return function (event) {
        var target = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["E" /* getEventTarget */](event, true),
            rawValue = target.value,
            formatResult = valueFormatter.format(rawValue);
        updateViewAndModel({original: originalField}, formatResult);
    };
}

/**
 * It gives back the valueFormatter defined on the markup or undefined.
 * @param {Object} $markup The jQuery markup object.
 * @returns {{mode: string, formatterMode: Object, format: Function}}
 */
function getValueFormatter($markup) {
    var valueFormatterName = __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["h" /* data */]($markup, 'formatter'),
        valueFormatterObject,
        valueFormatter = {};

    if (valueFormatterName) {
        valueFormatterObject = valueFormatterName ? __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["F" /* resolveReferencedObject */](valueFormatterName) : {};
        valueFormatter.mode = valueFormatterObject.mode || DefaultFormatterModes[valueFormatterName];
        if (valueFormatter.mode) {
            valueFormatter.formatterMode = FormatterModes[valueFormatter.mode];
            valueFormatter.format = valueFormatterObject.format;
        }
    }

    return valueFormatter.format && valueFormatter.formatterMode ? valueFormatter : undefined;
}

function setupVisibleField($markup, formattedValue) {
    var originalField = $markup.get(0),
        $visibleField = (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_4__formatterView__["a" /* default */].visibleField, []))),
        visibleField = $visibleField.get(0);

    $markup.after($visibleField);
    __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["G" /* copyAttributesIfExist */](originalField, visibleField, ['disabled', 'readonly', 'type']);
    $visibleField.before(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_mustache__["render"])(__WEBPACK_IMPORTED_MODULE_4__formatterView__["a" /* default */].hinterBox, [])));

    updateViewAndModel({visible: visibleField}, formattedValue);

    return visibleField;
}

function setupEventHandlers(originalField, visibleField, valueFormatter) {
    var formatterMode = valueFormatter.formatterMode;

    // Set formatting event
    if (formatterMode.formatEvent) {
        __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["l" /* addEventListener */](formatterMode.formatEvent, visibleField,
            createFormatterEventHandler(originalField, visibleField, valueFormatter, formatterMode)
        );
    }
    // Set initialization event
    if (formatterMode.initEvent) {
        __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["l" /* addEventListener */](formatterMode.initEvent, visibleField,
            createInitializationEventHandler(originalField, formatterMode)
        );
    }
    // Set field synchronization event (syncing value between the original and the visible fields)
    if (formatterMode.syncValueEvent) {
        __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["l" /* addEventListener */](formatterMode.syncValueEvent, visibleField,
            createSyncValueEventHandler(originalField, valueFormatter)
        );
    }
    // IE8, IE9 ms-clear
    setIEBlurHandlersForMSClear(visibleField, formatterMode);
}

function init($markup) {
    var valueFormatter = getValueFormatter($markup),
        visibleField,
        originalField = $markup.get(0);

    if (valueFormatter) {

        visibleField = setupVisibleField($markup, valueFormatter.format(originalField.value));
        setupEventHandlers(originalField, visibleField, valueFormatter);
        __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["H" /* forwardEvents */](['change', 'input'], visibleField, originalField);

        // This is the input behavior context change, see more in the input.js
        return {
            visibleInputField: visibleField
        };
    }
}


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    hinterBox: [
                '<span class="uwr-input-hint">',
                        '<span class="uwr-input-hint-hidden"></span>',
                        '<span class="uwr-input-hint-visible"></span>',
                '</span>'
        ].join(''),
    visibleField: '<input />'
});


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = message;
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MessageBox_js_messageBox__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inputView__ = __webpack_require__(20);





function getMessageObject($markup) {
    var messageObject = __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["B" /* jsonData */]($markup, 'message', {
        type: 'no-message',
        message: undefined
    });
    return messageObject;
}

function getEventTypesByDevice() {
    return __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["a" /* isTouchDevice */]()
        ? 'click tap'
        : 'mouseenter mouseleave';
}

function getInputContent($markup) {
    return $markup.parent();
}

function getInputContainer($markup) {
    var $content = getInputContent($markup);
    return $content.parent();
}

function createMessageIcon($markup) {
    var $content = getInputContent($markup),
        $messageIcon = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__WEBPACK_IMPORTED_MODULE_3__inputView__["a" /* default */].inputMessageIcon);
    $content.after($messageIcon);
}

function getMessageIcon($markup) {
    var $view = getInputContainer($markup);
    return __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-input-message', $view);
}

// catch message icon focus attempts and redirect them to the input field
function focusRedirectHandler(event) {
    event.target.blur();
    this.focus();
}

function getIE8FocusRedirectHandler($markup) {
    return function (event) {
        event.srcElement.blur();
        $markup.focus();
    };
}

function setMessageIcon($markup, messageObject) {
    var $messageIcon = getMessageIcon($markup),
        messageIconElement = $messageIcon.get(0);

    if (!$messageIcon.length) { return; }

    $messageIcon.attr('class', 'uwr-input-message uwr-input-' + messageObject.type);

    // check if modern browser and capture focus
    if (messageIconElement.addEventListener) {
        messageIconElement.addEventListener('focus', focusRedirectHandler.bind($markup), true);
    } else if (messageIconElement.attachEvent) { // IE8
        // make $markup available in the event handler - no .bind() in IE8
        messageIconElement.attachEvent('onfocus', getIE8FocusRedirectHandler($markup));
    }
}

function createMessageBox($markup) {
    var $messageIcon = getMessageIcon($markup),
        $messageBox = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(__WEBPACK_IMPORTED_MODULE_3__inputView__["a" /* default */].inputMessageBox);
    $messageIcon.after($messageBox);
}

function getMessageBox($markup) {
    var $container = getInputContainer($markup);
    return __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.uwr-message-box', $container);
}

function getInputIconButton($markup) {
    var container = getInputContainer($markup).get(0);
    return (__WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["d" /* hasClass */](container, 'uwr-input-has-button'))
        ? __WEBPACK_IMPORTED_MODULE_1_jquery___default()(container.querySelector('.uwr-input-after'))
        : __WEBPACK_IMPORTED_MODULE_1_jquery___default()();
}

function calcArrowPosition($markup) {
    var $messageBox = getMessageBox($markup),
        $iconButton = getInputIconButton($markup),
        iconButtonWidth = parseInt($iconButton.width(), 10) || 0,
        arrowClass = 'uwr-input-message-box-arrow';
    if (iconButtonWidth > 0) {
        arrowClass = 'uwr-input-message-box-arrow-with-icon-button';
    }
    $messageBox.addClass(arrowClass);
}

function setMessageBox($markup, messageObject) {
    var $messageBox = getMessageBox($markup);
    $messageBox.html(messageObject.message || '');
    // reset message box styles
    $messageBox.attr('class', 'uwr-message-box uwr-message-box-hidden uwr-arrow-top-right');
    $messageBox.data('type', messageObject.type);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__MessageBox_js_messageBox__["init"])();
    calcArrowPosition($markup);
}

function calcMessageBoxHeight($messageBox) {
    return $messageBox.outerHeight() + 13 + 'px';
}

function setMessageBoxPlaceholder($markup, messageBoxHeight) {
    var $container = getInputContainer($markup);
    $container.css('margin-bottom', messageBoxHeight);
}

function showMessageBox($markup, messageObject) {
    var $messageBox = getMessageBox($markup);
    $messageBox.removeClass('uwr-message-box-hidden');
    if (!messageObject.tooltip || __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["a" /* isTouchDevice */]()) {
        setMessageBoxPlaceholder($markup, calcMessageBoxHeight($messageBox));
    }
}

function hideMessageBox($markup) {
    var $messageBox = getMessageBox($markup);
    $messageBox.addClass('uwr-message-box-hidden');
    setMessageBoxPlaceholder($markup, 0);
}

function iconEventHandler(event) {
    if (event.data.$messageBox.is(':visible')) {
        hideMessageBox(event.data.$markup);
    } else {
        showMessageBox(event.data.$markup, event.data.messageObject);
    }
}

function setShowHandlers($markup, messageObject) {
    var $messageIcon = getMessageIcon($markup),
        eventTypes = getEventTypesByDevice();
    $messageIcon.unbind(eventTypes);
    if (messageObject.message) {
        var handlerParams = {
            '$messageBox': getMessageBox($markup),
            '$markup': $markup,
            'messageObject': messageObject
        };
        $messageIcon.bind(
            eventTypes,
            handlerParams,
            iconEventHandler
        );
    }
}

function setMessageBoxMode($markup, messageObject) {
    if (messageObject.tooltip) {
        setShowHandlers($markup, messageObject);
    } else if (messageObject.message) {
        showMessageBox($markup, messageObject);
    } else {
        hideMessageBox($markup);
    }
}

function isElementEmpty($elem) {
    return $elem.length === 0;
}

function initMessageElements($markup) {
    var $messageIcon = getMessageIcon($markup),
        $messageBox = getMessageBox($markup);
    if (isElementEmpty($messageIcon)) {
        createMessageIcon($markup);
    }
    if (isElementEmpty($messageBox)) {
        createMessageBox($markup);
    }
}

function renderMessageBox($markup, messageObject) {
    initMessageElements($markup);
    setMessageIcon($markup, messageObject);
    setMessageBox($markup, messageObject);
    setMessageBoxMode($markup, messageObject);
}

function message(selector, value) {
    if (value !== undefined && value !== null) {
        var markupNodeList = document.querySelectorAll(selector);
        Array.prototype.forEach.call(markupNodeList, function (markup) {
            var messageObject = __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["C" /* stringToObject */](value) || getMessageObject(markup);
            markup.setAttribute('data-message', __WEBPACK_IMPORTED_MODULE_2__shared_modules_common__["D" /* objectToString */](messageObject));
            renderMessageBox(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(markup), messageObject);
        });
    }
}

function init($markup) {
    renderMessageBox($markup, getMessageObject($markup));
}


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IconPanelItem */
/* harmony export (immutable) */ __webpack_exports__["b"] = IconPanel;
/* harmony export (immutable) */ __webpack_exports__["c"] = Node;
/* unused harmony export Panel */
/* harmony export (immutable) */ __webpack_exports__["a"] = PageGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_modules_common__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mustache__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__localNavigationView__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__localNavigation__ = __webpack_require__(11);






/**
 * The Action factory. Contains a factory method to return an Action instance.
 */
var ActionFactory = {
    /**
     * Create an Action object.
     * @param {object} item The item which the action is associated with.
     * @param {object} actionConfig The action configuration object (it can be an object or a function).
     * @return An Action instance typed according to the input config.
     */
    create: function (item, actionConfig) {
        var createdAction;
        if (item && actionConfig) {
            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(actionConfig)) {
                createdAction = new ActionFunction(item, actionConfig);
            } else {
                createdAction = new ActionUrl(item, actionConfig);
            }
        }
        return createdAction;
    }
};

function Action(item) {
    this.item = item;
    this.enabled = !item.disabled;
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(Action.prototype, {
    setEnabled: function (enabled) {
        this.enabled = enabled;
    }
});

/**
 * Action object that represents a function call bound to an item. It follows the Command pattern.
 * @param {object} item The visible item (Node, PageGroup) which the action is associated to.
 * @param {function} fn The function that should be called when clicking on the visible item.
 */
function ActionFunction(item, fn) {
    Action.call(this, item);
    this.fn = fn;
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(ActionFunction.prototype, Action.prototype, {
    render: function ($element) {
        var self = this;
        $element.on('click', function () {
            if (self.enabled) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__localNavigation__["select"])(self.item.id, function () {
                    self.execute();
                });
            }
        });
    },

    execute: function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_modules_common__["b" /* invoke */])(this.fn, this.item.id);
    }
});

/**
 * Action object that represents an URL redirect bound to an item.
 * @param {object} item The visible item (Node, PageGroup) which the action is associated to.
 * @param {function} actionConfig The action config object defined by the client app. It can be an object or a
 *     string. The object properties (url, frame) will be used to generate an <a> tag.
 */
function ActionUrl(item, actionConfig) {
    Action.call(this, item, actionConfig);
    this.onclick = ' uwr.localnav.select("' + this.item.id + '");';
    if (typeof actionConfig === 'object' && actionConfig.url) {
        this.href = actionConfig.url;
        this.target = actionConfig.frame;
    }
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(ActionUrl.prototype, Action.prototype, {
    render: function ($element) {
        this.$element = $element;
        this.setAttributes();
    },

    setEnabled: function (enabled) {
        Action.prototype.setEnabled.call(this, enabled);
        if (enabled) {
            this.setAttributes();
        } else {
            this.$element.removeAttr('onclick');
            this.$element.removeAttr('href');
            this.$element.removeAttr('target');
        }
    },

    setAttributes: function () {
        if (this.enabled && this.href !== undefined) {
            this.$element.attr('href', this.href);
            this.$element.attr('onclick', this.onclick);
            if (this.target !== undefined) {
                this.$element.attr('target', this.target);
            }
        }
    }
});

/**
 * Abstract item. An item may have zero or more child items.
 * @param {object} config The configuration of this item.
 *
 * Concrete child classes must implement getView() and may override these two methods:
 * - this.render: This implementation creates the DOM element and appends it into the parent node
 *   (the function's only argument).
 * - this.getItemsContainer: A function that returns the DOM element containing the child items.
 *
 * Configuration parameters:
 * - parentObject: the parent item of this one
 * - rootObject: the Local Navigation object the item belongs to
 * - id: the unique id of this item
 * - active: if this item is active (selected) or not
 * - disabled: if this item is disabled or not (on a disabled item actions are not called)
 * - action: the action configuration
 */
function AbstractItem(config) {
    this.$domElement = null; // Will be set later
    this.parentObject = config.parentObject;
    this.rootObject = config.rootObject;
    this.id = config.id;
    this.active = config.active || false;
    this.disabled = config.disabled || false;
    this.action = ActionFactory.create(this, config.action);
    this.items = [];
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(AbstractItem.prototype, {
    /**
     * Returns the container element the children should be rendered in.
     */
    getItemsContainer: function () {
        return this.$domElement;
    },

    /**
     * This is a function that returns a view for rendering. Concrete Item classes must implement it.
     */
    getView: null,

    getParent: function () {
        return this.parentObject;
    },

    createSubItems: function (itemConfigs, ItemClass) {
        var itemConfig,
            i;
        if (itemConfigs && itemConfigs.length > 0) {
            for (i = 0; i < itemConfigs.length; i++) {
                // Clone it, not to temper with the original one
                itemConfig = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(true, {}, itemConfigs[i]);
                itemConfig.parentObject = this;
                itemConfig.rootObject = this.rootObject || this.parentObject;
                this.items.push(new ItemClass(itemConfig));
            }
        }
    },

    /**
     * @param {object} $parent The jQuery DOM object the rendered HTML code is appended into.
     */
    render: function ($parent) {
        var $containerElem,
            i;

        if (!this.$domElement) {
            this.$domElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mustache__["render"])(this.getView(), this));
            if (this.items.length > 0) {
                $containerElem = this.getItemsContainer();
                for (i = 0; i < this.items.length; i++) {
                    this.items[i].render($containerElem);
                }
            }
            if (this.action) {
                this.action.render(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('> a', this.$domElement));
            }
            $parent.append(this.$domElement);
        }

        return this.$domElement;
    },

    /**
     * Activates the item or one of its child items. The id must be passed, even if the current item needs
     * to be activated.
     * @param {string} id The item's id.
     * @param {boolean} active True/false means to activate/inactivate the item.
     */
    setActive: function (id, active) {
        var isSameId = this.id && this.id === id,
            shouldBeActive = (active !== undefined ? active : true) && isSameId,
            i;
        this.active = shouldBeActive;
        if (shouldBeActive) {
            this.$domElement.addClass('uwr-local-nav-active');
        } else {
            this.$domElement.removeClass('uwr-local-nav-active');
            for (i = 0; i < this.items.length; i++) {
                this.items[i].setActive(id);
            }
        }
    },

    /**
     * Enables the item or one of its child items. The id must be passed, even if the current item needs
     * to be activated.
     * @param {boolean} enabled True/false means to enable/disable the item.
     */
    setEnabled: function (enabled) {
        var shouldBeEnabled = enabled !== undefined ? enabled : true;
        if (shouldBeEnabled) {
            this.$domElement.removeClass('uwr-local-nav-disabled');
        } else {
            this.$domElement.addClass('uwr-local-nav-disabled');
        }
        this.action.setEnabled(shouldBeEnabled);
    }
});

/**
 * The IconPanelItem is an item of the Icon Panel, which can have an Action added, and clicking it selects the
 * active Page Group associated to this item.
 * @param {object} config The configuration of this item.
 *
 * Configuration parameters (see AbstractItem for more as ancestor object):
 * - label: The displayed name of this item
 * - iconClass: the CSS class name associated to this item, which will be displayed
 */
function IconPanelItem(config) {
    AbstractItem.call(this, config);
    this.label = config.label || config.id;
    this.iconClass = config.iconClass;
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(IconPanelItem.prototype, AbstractItem.prototype, {
    getView: function () {
        return __WEBPACK_IMPORTED_MODULE_3__localNavigationView__["a" /* default */].iconPanelItem;
    },

    render: function ($parent) {
        var $iconPanelItem = AbstractItem.prototype.render.call(this, $parent),
            self = this;
        $iconPanelItem.on('click', function () {
            self.rootObject.show(self.id);
        });
    }
});

/**
 * The IconPanel is the left side main container of the Local Navigation. It contains icons which represent
 * Page Groups.
 * @param {object} config The configuration of this item.
 *
 * Configuration parameters (see AbstractItem for the base params):
 * - pageGroups: The set of the PageGroup items, which define the panel items.
 */
function IconPanel(config) {
    AbstractItem.call(this, config);
    this.createSubItems(config.pageGroups, IconPanelItem);
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(IconPanel.prototype, AbstractItem.prototype, {
    getItemsContainer: function () {
        return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('ul', this.$domElement);
    },

    getView: function () {
        return __WEBPACK_IMPORTED_MODULE_3__localNavigationView__["a" /* default */].iconPanel;
    }
});

/**
 * Node is a menu item of the Page Group and is placed in a Panel. It can have an Action which is activated
 * on click.
 * @param {object} config The configuration of this item.
 *
 * Configuration parameters: same as AbstractItem's config
 */
function Node(config) {
    AbstractItem.call(this, config);
    this.rootObject.itemCache.add(this.id, this);
    this.label = config.label || config.id;
    this.hasChildren = config.nodes && config.nodes.length > 0;
    this.level = 0;
    this.createSubItems(config.nodes, Node);
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(Node.prototype, AbstractItem.prototype, {
    /**
     * Returns the Node with the given id or undefined if no such item exists.
     * @param {string} id The id of the Node.
     */
    get: function (id) {
        this.rootObject.itemCache.get(id, Node);
    },

    getItemsContainer: function () {
        return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('ul', this.$domElement);
    },

    getView: function () {
        return __WEBPACK_IMPORTED_MODULE_3__localNavigationView__["a" /* default */].pageGroupPanelNode;
    },

    isCollapsible: function () {
        return (this.parentObject && __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(this.parentObject.isCollapsible))
            ? this.parentObject.isCollapsible()
            : true;
    },

    expandOrCollapse: function () {
        if (this.hasChildren) {
            if (this.isCollapsible()) {
                if (this.$domElement.hasClass('uwr-local-nav-collapsed')) {
                    this.$domElement.removeClass('uwr-local-nav-collapsed');
                } else {
                    this.$domElement.addClass('uwr-local-nav-collapsed');
                }
            }
        }
    },

    expandParents: function (id) {
        if (this.id !== id) {
            this.$domElement.removeClass('uwr-local-nav-collapsed');
        }
        if (this.parentObject && __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(this.parentObject.expandParents)) {
            this.parentObject.expandParents();
        }
    },

    render: function ($parent) {
        var self = this,
            $node,
            leftPadding = this.hasChildren ? 10 : 15;
        if (this.hasChildren) {
            this.action = ActionFactory.create(this, function () {
                self.expandOrCollapse();
            });
        }
        $node = AbstractItem.prototype.render.call(this, $parent);
        leftPadding += this.level * 10;
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('> a', $node).css('padding-left', leftPadding + 'px');
    },

    setActive: function (id, active) {
        if (this.id === id) {
            if (this.hasChildren) {
                active = false;
            }
            this.expandParents(id);
        }
        AbstractItem.prototype.setActive.call(this, id, active);
    },

    setLevel: function (level) {
        var i;
        this.level = level;
        if (this.items) {
            for (i = 0; i < this.items.length; i++) {
                this.items[i].setLevel(this.level + 1);
            }
        }
    }
});

/**
 * Panel is a collection of menu items (Nodes) and could have an own title.
 * @param {object} config The configuration of this item.
 *
 * Configuration parameters (see AbstractItem for the base params):
 * - label: The displayed title of this panel.
 * - nonCollapsible: If the items of this panel are collapsible or not. It have effect only if some of the panel
 *   items are not leaf nodes.
 */
function Panel(config) {
    var i;
    AbstractItem.call(this, config);
    this.createSubItems(config.nodes, Node);
    this.rootObject.itemCache.add(this.id, this);
    this.collapsible = config.nonCollapsible !== undefined ? !config.nonCollapsible : true;
    this.label = config.label;

    if (this.items) {
        for (i = 0; i < this.items.length; i++) {
            this.items[i].setLevel(0);
        }
    }
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(Panel.prototype, AbstractItem.prototype, {
    getItemsContainer: function () {
        return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('ul', this.$domElement);
    },

    getView: function () {
        return __WEBPACK_IMPORTED_MODULE_3__localNavigationView__["a" /* default */].pageGroupPanel;
    },

    isCollapsible: function () {
        return this.collapsible;
    },

    render: function ($parent) {
        AbstractItem.prototype.render.call(this, __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.uwr-local-nav-panel-container', $parent));
    }
});

/**
 * Page Group is the right main panel of the Local Navigation. It contains all menu items, organized in Panels.
 * @param {object} config The configuration of this item.
 *
 * Configuration parameters (see AbstractItem for the base params):
 * - label: The displayed name of this item
 * - iconClass: The CSS class name associated to this item, which will be displayed
 */
function PageGroup(config) {
    AbstractItem.call(this, config);
    this.createSubItems(config.panels, Panel);
    this.rootObject.itemCache.add(this.id, this);
    this.action = undefined;
    this.iconClass = config.iconClass;
    this.label = config.label || 'Label:' + this.id;
    this.disabled = config.disabled || false;
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(PageGroup.prototype, AbstractItem.prototype, {
    show: function () {
        this.$domElement.removeClass('uwr-local-nav-hidden');
    },

    hide: function () {
        this.$domElement.addClass('uwr-local-nav-hidden');
    },

    /**
     * Returns the Page Group with the given id or undefined if no such item exists.
     * @param {string} id The id of the Page Group.
     */
    get: function (id) {
        this.rootObject.itemCache.get(id, PageGroup);
    },

    getView: function () {
        return __WEBPACK_IMPORTED_MODULE_3__localNavigationView__["a" /* default */].pageGroup;
    }
});


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    iconPanel: [
            '<div class="uwr-local-nav-iconpanel uwr-local-nav-positioned-panel">',
                '<ul class="uwr-local-nav-menu-items">',
                '</ul>',
            '</div>'
        ].join(''),
    iconPanelItem: [
            '<li id="{{id}}" ',
                'class="uwr-local-nav-actioned',
                ' {{#active}}uwr-local-nav-active{{/active}} {{#disabled}}uwr-local-nav-disabled{{/disabled}}">',
                '<a class="uwr-local-nav-iconpanel-link" title="{{label}}">',
                    '<span class="{{iconClass}}"></span>',
                '</a>',
            '</li>'
        ].join(''),
    pageGroup: [
            '<div class="uwr-local-nav-pagegroup uwr-local-nav-positioned-panel uwr-local-nav-hidden ',
            '{{#active}}uwr-local-nav-active{{/active}}">',
                '<div class="uwr-local-nav-right-grad"></div>',
                '<div class="uwr-local-nav-hamburger-head">',
                    '<div class="uwr-local-nav-hamburger-icon"></div>',
                '</div>',
                '<div class="uwr-local-nav-panel-container">',
                    '<div class="uwr-local-nav-divider"></div>',
                    '<h3>{{label}}</h3>',
                '</div>',
            '</div>'
        ].join(''),
    pageGroupPanel: [
            '<div>',
                '{{#label}}<h4>{{label}}</h4>{{/label}}',
                '<ul {{#collapsible}}class="uwr-local-nav-collapsible"{{/collapsible}}>',
                '</ul>',
            '</div>'
        ].join(''),
    pageGroupPanelNode: [
            '<li id="{{id}}"',
            'class="',
            '{{#hasChildren}}uwr-local-nav-parent-node uwr-local-nav-collapsed {{/hasChildren}}',
            '{{#disabled}}uwr-local-nav-disabled{{/disabled}}',
            '">',
                '<a title="{{label}}">',
                    '{{#hasChildren}}<span class="uwr-local-nav-collapse-icon"></span>{{/hasChildren}}',
                    '<span>{{label}}</span>',
                '</a>',
                '{{#hasChildren}}<ul class="uwr-local-nav-nested-items"></ul>{{/hasChildren}}',
            '</li>'
        ].join('')
});


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    mainMarkup: [
        '<div class="uwr-shifter-box-panel uwr-shifter-box-panel-left">',
        '<h3>{{titleLeft}}</h3>',
        '<div class="uwr-shifter-box-items"></div>',
        '</div>',
        '<div class="uwr-shifter-box-buttons">',
        '<button class="uwr-shifter-box-button uwr-shifter-box-button-right-shift" type="button"></button>',
        '<button class="uwr-shifter-box-button uwr-shifter-box-button-left-shift" type="button"></button>',
        '<button class="uwr-shifter-box-button uwr-shifter-box-button-right-shift-all" ',
        'type="button"></button>',
        '<button class="uwr-shifter-box-button uwr-shifter-box-button-left-shift-all" ',
        'type="button"></button>',
        '</div>',
        '<div class="uwr-shifter-box-panel uwr-shifter-box-panel-right">',
        '<h3>{{titleRight}}</h3>',
        '<div class="uwr-shifter-box-items"></div>',
        '</div>',
        '<div class="uwr-shifter-box-form-elements"></div>'
    ].join(''),

    itemListTablet: [
        '<ul>',
        '{{#items}}',
        '<li><input type="checkbox" id="{{id}}" name="" /><label for="{{id}}">{{name}}</label></li>',
        '{{/items}}',
        '</ul>'
    ].join(''),

    itemListDesktop: [
        '<select multiple>',
        '{{#items}}',
        '<option id="{{id}}">{{name}}</option>',
        '{{/items}}',
        '</select>'
    ].join(''),

    itemListFormElements: [
        '{{#items}}',
        '<input type="hidden" name="{{id}}" value="{{#selected}}on{{/selected}}" />',
        '{{/items}}'
    ].join('')
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    container : '<div class="uwr-slider-container">'
        + '{{#showBoundaries}}<div class="uwr-slider-indicator-value uwr-slider-indicator-value-min">'
        + '{{minValue}}</div>{{/showBoundaries}}'
        + '<div class="uwr-slider-indicator-container" style="width:{{sliderWidth}}px">'
        + '</div>'
        + '{{#showBoundaries}}<div class="uwr-slider-indicator-value uwr-slider-indicator-value-max">'
        + '{{maxValue}}</div>{{/showBoundaries}}'
        + '</div>',
    indicator: '<div class="uwr-slider-indicator"></div>',
    label: '<span class="uwr-slider-label"></span>',
    marker: '<div class="uwr-slider-value"></div>',
    scale: '<div class="uwr-slider-scale"></div>',
    thumb: '<div class="uwr-slider-thumb"></div>'
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// uwr.js